
// Global maps to store metafields by variant ID and product handle
const firmnessMetafieldsMap = new Map(); // Map<variantId, {text1, text2, text3}>
const foundationMetafieldsMap = new Map(); // Map<variantId, {metafield1, metafield2, metafield3}>
const foundationMetafieldsByProduct = new Map(); // Map<productHandle, Map<variantId, metafields>>
const variantInfoMetafieldsMap = new Map(); // Map<variantId, {title, short, long, feature}>
const variantImageFeaturesMap = new Map(); // Map<variantId, {image, heading, description}>
const variantGalleryImagesMap = new Map(); // Map<variantId, string[] | { en: string[], es: string[] }>
const variantTechnicalSpecsMap = new Map(); // Map<variantId, {titles, features}>
const variantPerformanceDataMap = new Map(); // Map<variantId, [{performance_heading, performance_heading_value, performance_progress, performance_text}, ...]>
const collectionProductCache = new Map(); // Map<productHandle, productData>

// Capture ?size= / ?variant= once on first read so early history.replaceState
// (default/first collection product) cannot wipe the Spotlight "See all details" selection.
var __pdpBootSizeHint = null;
var __pdpBootVariantId = null;

function capturePdpBootHintsFromLocation() {
  if (__pdpBootSizeHint !== null) return;
  try {
    const params = new URLSearchParams(window.location.search);
    __pdpBootSizeHint = String(
      params.get('size') || params.get('Size') || params.get('option1') || params.get('option2') || ''
    ).trim();
    __pdpBootVariantId = String(params.get('variant') || '').trim();
  } catch (e) {
    __pdpBootSizeHint = '';
    __pdpBootVariantId = '';
  }
}

capturePdpBootHintsFromLocation();

function suaveT(key, fallback) {
  var i18n = (typeof window !== 'undefined' && window.__SUAVE_I18N__) || {};
  var value = i18n[key];
  return value != null && value !== '' ? value : (fallback != null ? fallback : key);
}

function suaveTWithFoundation(foundation) {
  var template = suaveT('withFoundation', 'with {{ foundation }}');
  return template.replace(/\{\{\s*foundation\s*\}\}/g, foundation);
}

function suavePdpT(key, fallback) {
  return suaveT(key, fallback);
}

function suavePdpIsSpanishLocale() {
  const path = window.location.pathname || '';
  if (path === '/es' || path.indexOf('/es/') === 0) return true;
  if (path === '/en' || path.indexOf('/en/') === 0) return false;
  // English storefront lives at the root; path wins over locale cookie/prefs.
  return false;
}

function suavePdpRootUrl() {
  var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
  var root = String(store.rootUrl || '/');
  if (suavePdpIsSpanishLocale()) {
    if (root !== '/es' && root.indexOf('/es/') !== 0) {
      root = '/es/';
    }
  } else {
    root = root.replace(/^\/es\/?/, '/');
    if (root === '') root = '/';
  }
  return root.replace(/\/?$/, '/');
}

function suavePdpProductJsonUrl(handle) {
  return suavePdpRootUrl() + 'products/' + encodeURIComponent(handle) + '.js';
}

function suavePdpProductViewUrl(handle, view) {
  return suavePdpRootUrl() + 'products/' + encodeURIComponent(handle) + '?view=' + encodeURIComponent(view);
}

function suaveFoundationModelSubtitle(foundationName) {
  var template = suavePdpT(
    'selectFoundationModel',
    'Select {{ foundation }} model for your bed setup.'
  );
  return template.replace(/\{\{\s*foundation\s*\}\}/g, foundationName || '');
}

function suavePdpNoFoundationLabel() {
  const cfg = window.__PDP_UNDERBED_CONFIG__ || {};
  return (cfg.noFoundationLabel && String(cfg.noFoundationLabel).trim()) || suavePdpT('noFoundation', 'No Foundation');
}

var UPSELL_SUBHEAD_PRICE_PLACEHOLDER_RE = /\{\{price\}\}|\$X|\+X\s*\$|X\s*\$/i;

function upsellSubheadHasPricePlaceholder(template) {
  UPSELL_SUBHEAD_PRICE_PLACEHOLDER_RE.lastIndex = 0;
  return UPSELL_SUBHEAD_PRICE_PLACEHOLDER_RE.test(String(template || ''));
}

function upsellSubheadSplitForPrice(template) {
  var str = String(template || '');
  UPSELL_SUBHEAD_PRICE_PLACEHOLDER_RE.lastIndex = 0;
  var match = UPSELL_SUBHEAD_PRICE_PLACEHOLDER_RE.exec(str);
  if (!match) return null;
  return {
    before: str.slice(0, match.index),
    after: str.slice(match.index + match[0].length)
  };
}

function replaceUpsellSubheadPriceText(template, priceFormatted) {
  return String(template || '').replace(/\{\{price\}\}|\$X|\+X\s*\$|X\s*\$/gi, priceFormatted);
}

function renderUpsellSubheadHtml(namespace, template, priceFormatted) {
  var parts = upsellSubheadSplitForPrice(template);
  if (!parts) return null;
  return (
    parts.before +
    '<span id="' +
    namespace +
    '-price">' +
    priceFormatted +
    '</span>' +
    parts.after
  );
}

// Helper function to parse rich text JSON and extract text content
function parseRichTextToText(richTextJson) {
  if (!richTextJson) return '';
  
  // If it's already a string, try to parse it
  let parsed;
  if (typeof richTextJson === 'string') {
    // Check if it's Ruby hash format (contains =>)
    if (richTextJson.includes('=>')) {
      // Convert Ruby hash syntax to JSON
      // Replace => with : and handle quotes
      let jsonString = richTextJson
        .replace(/=>/g, ':')
        .replace(/(\w+):/g, '"$1":')  // Add quotes to keys
        .replace(/:\s*"([^"]+)"/g, ': "$1"')  // Ensure values are quoted
        .replace(/:\s*(\d+)/g, ': $1')  // Keep numbers unquoted
        .replace(/:\s*(true|false|null)/g, ': $1');  // Keep booleans/null unquoted
      
      try {
        parsed = JSON.parse(jsonString);
      } catch (e) {
        // If conversion fails, try direct JSON parse
        try {
          parsed = JSON.parse(richTextJson);
        } catch (e2) {
          // If both fail, return as is
          return richTextJson;
        }
      }
    } else {
      // Regular JSON string
      try {
        parsed = JSON.parse(richTextJson);
      } catch (e) {
        // If parsing fails, return as is (might be plain text)
        return richTextJson;
      }
    }
  } else {
    parsed = richTextJson;
  }
  
  // If it's not an object, return as string
  if (typeof parsed !== 'object' || parsed === null) {
    return String(richTextJson);
  }
  
  // Extract text from rich text structure
  function extractText(node) {
    if (!node) return '';
    
    if (node.type === 'text' && node.value) {
      return node.value;
    }
    
    if (node.type === 'list-item' && node.children) {
      const items = node.children.map(extractText).filter(Boolean);
      return items.join(' ');
    }
    
    if (node.children && Array.isArray(node.children)) {
      const texts = node.children.map(extractText).filter(Boolean);
      return texts.join(' ');
    }
    
    return '';
  }
  
  // Extract all list items
  const listItems = [];
  
  function extractListItems(node) {
    if (!node) return;
    
    if (node.type === 'list-item' && node.children) {
      const text = node.children.map(extractText).filter(Boolean).join(' ');
      if (text) {
        listItems.push(text);
      }
    }
    
    if (node.children && Array.isArray(node.children)) {
      node.children.forEach(extractListItems);
    }
  }
  
  // Start extraction from root
  if (parsed.type === 'root' && parsed.children) {
    parsed.children.forEach(extractListItems);
  } else {
    extractListItems(parsed);
  }
  
  // Return formatted list (use newlines so firmness-feature-text / meta description can show as bullets and preserve structure)
  if (listItems.length > 0) {
    return listItems.join('\n');
  }
  
  // Fallback: try to extract any text; preserve block breaks by joining block-level children with newline
  function extractTextWithBreaks(node) {
    if (!node) return '';
    if (node.type === 'text' && node.value) return node.value;
    if (node.children && Array.isArray(node.children)) {
      var sep = (node.type === 'paragraph' || node.type === 'list-item' || node.type === 'block') ? '\n' : ' ';
      return node.children.map(extractTextWithBreaks).filter(Boolean).join(sep);
    }
    return '';
  }
  const fallbackText = extractTextWithBreaks(parsed);
  return fallbackText || String(richTextJson);
}

  // Helper function to load variant info data for a specific product handle
  function loadVariantInfoForProduct(productHandle) {
    if (!productHandle) return;
    
    // Find script tag by class and data-product-handle attribute
    const variantInfoScripts = document.querySelectorAll('.variant-info-json');
    
    if (variantInfoScripts && variantInfoScripts.length > 0) {
      // Find script tag matching product handle
      for (let script of variantInfoScripts) {
        if (script.getAttribute('data-product-handle') === productHandle) {
          try {
            const variantInfoData = JSON.parse(script.textContent);
            
            // Parse variant info metafields from JSON (metaobject: title, short, long, feature)
            if (variantInfoData && variantInfoData.variants && Array.isArray(variantInfoData.variants)) {
              variantInfoData.variants.forEach((variantInfo, idx) => {
                if (variantInfo && variantInfo.variantId) {
                  const variantId = variantInfo.variantId.toString();
                  
                  // Helper function to process field values
                  const processField = (fieldValue) => {
                    if (fieldValue === null || fieldValue === undefined || fieldValue === 'null' || fieldValue === 'undefined') {
                      return null;
                    }
                    
                    const str = String(fieldValue).trim();
                    if (str === '' || str === 'null' || str === 'undefined') {
                      return null;
                    }
                    
                    return str;
                  };
                  
                  // For feature, keep as object if it's already an object (rich text JSON)
                  let featureValue = variantInfo.feature;
                  if (featureValue !== null && featureValue !== undefined && featureValue !== 'null' && featureValue !== 'undefined') {
                    // If it's already an object, keep it as is
                    if (typeof featureValue === 'object') {
                      // Already an object, use as is
                    } else if (typeof featureValue === 'string' && featureValue.trim() !== '') {
                      // Try to parse if it's a JSON string
                      try {
                        featureValue = JSON.parse(featureValue);
                      } catch (e) {
                        // If parsing fails, keep as string
                      }
                    } else {
                      featureValue = null;
                    }
                  } else {
                    featureValue = null;
                  }
                  
                  // firmness_feature_text: variant-specific metafield for firmness card
                  let firmnessFeatureValue = variantInfo.firmness_feature_text;
                  if (firmnessFeatureValue !== null && firmnessFeatureValue !== undefined && firmnessFeatureValue !== 'null' && firmnessFeatureValue !== 'undefined') {
                    if (typeof firmnessFeatureValue === 'object') {
                      // keep as is
                    } else if (typeof firmnessFeatureValue === 'string' && firmnessFeatureValue.trim() !== '') {
                      try {
                        firmnessFeatureValue = JSON.parse(firmnessFeatureValue);
                      } catch (e) {
                        // keep as string
                      }
                    } else {
                      firmnessFeatureValue = null;
                    }
                  } else {
                    firmnessFeatureValue = null;
                  }
                  
                  const variantInfoObj = {
                    title: processField(variantInfo.title),
                    short: processField(variantInfo.short),
                    long: processField(variantInfo.long),
                    feature: featureValue,
                    firmness_feature_text: firmnessFeatureValue
                  };
                  
                  // Always store, even if some fields are empty
                  variantInfoMetafieldsMap.set(variantId, variantInfoObj);
                }
              });
            }
            return; // Found and processed, exit
          } catch (e) {
            console.log('error loading variant info: ', e);
          }
        }
      }
    }
  }

  // Function to initialize metafields from data attributes
function initializeMetafieldsFromDataAttributes() {
  // Get all mattress product tabs
  const tabs = document.querySelectorAll('#custom-product-container .tab[data-variant-metafields]');
  // Also check for tabs without the attribute
  const allTabs = document.querySelectorAll('#custom-product-container .tab');
  
  tabs.forEach((tab, tabIndex) => {
    const productHandle = tab.getAttribute('data-product-handle');
    const variantMetafieldsData = tab.getAttribute('data-variant-metafields');
    const foundationMetafieldsData = tab.getAttribute('data-foundation-variant-metafields');
    const variantImageFeaturesData = tab.getAttribute('data-variant-image-features');
    const variantGalleryImagesData = tab.getAttribute('data-variant-gallery-images');
    
    // Debug the structure by showing what's between each ||
    if (foundationMetafieldsData && foundationMetafieldsData.trim() !== '') {
      const entries = foundationMetafieldsData.split('||');
      entries.forEach((entry, i) => {
        const parts = entry.split(':');
      });
    }
    // Parse firmness metafields
    if (variantMetafieldsData && variantMetafieldsData.trim() !== '') {
      const variantMetafields = variantMetafieldsData.split('||').filter(v => v && v.trim() !== '');
      
      variantMetafields.forEach((variantData, idx) => {
        if (variantData && variantData.trim() !== '') {
          // Firmness format: variantId:field1|field2|field3 (3 fields separated by |)
          const parts = variantData.split(':');
          
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafields = parts.slice(1).join(':'); // Join in case any field contains ':'
            const fields = metafields.split('|');
            
            // Helper function to decode HTML entities (for rich text metafields)
            // Data attributes automatically escape HTML, so we need to decode them
            const decodeHtml = (html) => {
              if (!html) return null;
              const htmlStr = html.trim();
              if (htmlStr === '' || htmlStr === 'null' || htmlStr === 'undefined') return null;
              
              // Create a temporary element to decode HTML entities
              const txt = document.createElement('textarea');
              txt.innerHTML = htmlStr;
              const decoded = txt.value;
              
              // If decoded value is different, it means there were HTML entities
              // Otherwise, return original (might already be plain text)
              return decoded !== htmlStr ? decoded : htmlStr;
            };
            
            // Store metafields even if some are empty - we'll check individual fields when displaying
            const metafieldObj = {
              firmness_variant_option_text: decodeHtml(fields[0]),
              firmness_variant_option_text_2: decodeHtml(fields[1]),
              firmness_variant_option_text_3: decodeHtml(fields[2])
            };
            
            // Store with variant ID as string (to match lookup) - store even if all are empty for debugging
            firmnessMetafieldsMap.set(variantId, metafieldObj);
            
            // Check if at least one metafield has data
            const hasAnyValue = metafieldObj.firmness_variant_option_text || 
                               metafieldObj.firmness_variant_option_text_2 || 
                               metafieldObj.firmness_variant_option_text_3;
          }
        }
      });
    }
    
    // Parse foundation metafields
    if (foundationMetafieldsData && foundationMetafieldsData.trim() !== '' && productHandle) {
      const variantMetafields = foundationMetafieldsData.split('||').filter(v => v && v.trim() !== '');
      const foundationMap = new Map();
      
      variantMetafields.forEach((variantData, dataIndex) => {
        if (variantData && variantData.trim() !== '') {
          // Foundation format: variantId:field1 (single field, no pipes)
          const parts = variantData.split(':');
          
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafieldValue = parts.slice(1).join(':').trim(); // Join in case value contains ':'
            
            if (variantId) {
              // Store even if value is empty - we'll use it for mapping
              // The value might be empty, but we still need to map the variant to its position
              const metafieldObj = {
                value: (metafieldValue && metafieldValue !== '' && metafieldValue !== 'null' && metafieldValue !== 'undefined') ? metafieldValue : null,
                position: dataIndex,   // Position in the data (0, 1, 2, ...)
                foundation_product_variant_metafield: (dataIndex === 0) ? ((metafieldValue && metafieldValue !== '' && metafieldValue !== 'null') ? metafieldValue : null) : null,
                foundation_product_variant_metafield_2: (dataIndex === 1) ? ((metafieldValue && metafieldValue !== '' && metafieldValue !== 'null') ? metafieldValue : null) : null,
                foundation_product_variant_metafield_3: (dataIndex === 2) ? ((metafieldValue && metafieldValue !== '' && metafieldValue !== 'null') ? metafieldValue : null) : null
              };
              
              // Store with variant ID as string (to match lookup) - store even if value is empty for mapping
              foundationMap.set(variantId, metafieldObj);
              
              if (metafieldObj.value) {
                const metafieldName = dataIndex === 0 ? 'metafield1' : (dataIndex === 1 ? 'metafield2' : 'metafield3');
              }
            } 
          }
        }
      });
      
      foundationMetafieldsByProduct.set(productHandle, foundationMap);
    }
    
    // Parse variant image and features metafields
    if (variantImageFeaturesData && variantImageFeaturesData.trim() !== '') {
      const variantImageFeatures = variantImageFeaturesData.split('||').filter(v => v && v.trim() !== '');
      
      variantImageFeatures.forEach((variantData) => {
        if (variantData && variantData.trim() !== '') {
          const parts = variantData.split(':');
          
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafieldJson = parts.slice(1).join(':').trim(); // Join in case JSON contains ':'
            
            if (variantId && metafieldJson && metafieldJson !== '' && metafieldJson !== 'null' && metafieldJson !== 'undefined') {
              try {
                // Decode HTML entities before parsing
                const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
                const parsedData = JSON.parse(decodedJson);
                // Store with both string and number variant ID for flexibility
                variantImageFeaturesMap.set(variantId, parsedData);
                const variantIdNum = parseInt(variantId);
                if (!isNaN(variantIdNum)) {
                  variantImageFeaturesMap.set(variantIdNum.toString(), parsedData);
                  variantImageFeaturesMap.set(String(variantIdNum), parsedData);
                }
              } catch (e) {
                // Silent error - invalid JSON
              }
            }
          }
        }
      });
    }
    
    // Parse variant technical specifications metafields
    if (variantGalleryImagesData && variantGalleryImagesData.trim() !== '') {
      const variantGalleryEntries = variantGalleryImagesData.split('||').filter(v => v && v.trim() !== '');
      variantGalleryEntries.forEach((variantData) => {
        const sep = variantData.indexOf(':');
        if (sep < 1) return;
        const variantId = variantData.slice(0, sep).trim();
        const galleryJson = variantData.slice(sep + 1).trim();
        if (!variantId || !galleryJson) return;
        try {
          const decodedJson = galleryJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
          const parsed = JSON.parse(decodedJson);
          let galleryEntry = { en: [], es: [] };
          if (Array.isArray(parsed)) {
            galleryEntry = { en: parsed, es: parsed };
          } else if (parsed && typeof parsed === 'object') {
            galleryEntry = {
              en: Array.isArray(parsed.en) ? parsed.en : [],
              es: Array.isArray(parsed.es)
                ? parsed.es
                : (Array.isArray(parsed.en) ? parsed.en : [])
            };
          }
          const urls = galleryEntry.en;
          variantGalleryImagesMap.set(variantId, galleryEntry);
          const variantIdNum = parseInt(variantId, 10);
          if (!isNaN(variantIdNum)) {
            variantGalleryImagesMap.set(String(variantIdNum), galleryEntry);
          }
        } catch (e) {
          // Ignore malformed variant gallery payload
        }
      });
    }

    // Parse variant technical specifications metafields
    const variantTechnicalSpecsData = tab.getAttribute('data-variant-technical-specs');
    if (variantTechnicalSpecsData && variantTechnicalSpecsData.trim() !== '') {
      const variantTechnicalSpecs = variantTechnicalSpecsData.split('||').filter(v => v && v.trim() !== '');
      
      variantTechnicalSpecs.forEach((variantData) => {
        if (variantData && variantData.trim() !== '') {
          const parts = variantData.split(':');
          
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafieldJson = parts.slice(1).join(':').trim(); // Join in case JSON contains ':'
            
            if (variantId && metafieldJson && metafieldJson !== '' && metafieldJson !== 'null' && metafieldJson !== 'undefined') {
              try {
                // Decode HTML entities before parsing
                const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
                const parsedData = JSON.parse(decodedJson);
                // Metafield is list of metaobject: normalize to { titles: [], features: [] }
                let normalized = parsedData;
                if (Array.isArray(parsedData)) {
                  const titlesArr = parsedData.map(item => {
                    let t = item && (item.titles !== undefined ? item.titles : item.title);
                    if (t && typeof t === 'object' && t.value != null) t = t.value;
                    return t != null && t !== 'null' ? String(t).trim() : '';
                  });
                  const featuresArr = parsedData.map(item => {
                    let f = item && (item.features !== undefined ? item.features : item.feature);
                    if (f && typeof f === 'object' && f.value != null) f = f.value;
                    return f != null && f !== 'null' ? String(f).trim() : '';
                  });
                  normalized = { titles: titlesArr, features: featuresArr };
                }
                variantTechnicalSpecsMap.set(variantId, normalized);
                const variantIdNum = parseInt(variantId);
                if (!isNaN(variantIdNum)) {
                  variantTechnicalSpecsMap.set(variantIdNum.toString(), normalized);
                  variantTechnicalSpecsMap.set(String(variantIdNum), normalized);
                }
              } catch (e) {
                // Silent error - invalid JSON
              }
            }
          }
        }
      });
    }
    
    // Parse variant performance data metafields (list of metaobject: performance_heading, performance_heading_value, performance_progress, performance_text)
    const variantPerformanceDataAttr = tab.getAttribute('data-variant-performance-data');
    if (variantPerformanceDataAttr && variantPerformanceDataAttr.trim() !== '') {
      function safePerfStr(v) {
        if (v == null || v === undefined) return '';
        if (typeof v === 'object' && v !== null && 'value' in v) return safePerfStr(v.value);
        return String(v);
      }
      function safePerfNum(v) {
        if (v == null || v === undefined) return 0;
        if (typeof v === 'object' && v !== null && 'value' in v) return safePerfNum(v.value);
        const n = Number(v);
        return isNaN(n) ? 0 : Math.min(100, Math.max(0, n));
      }
      const variantPerformanceEntries = variantPerformanceDataAttr.split('||').filter(v => v && v.trim() !== '');
      variantPerformanceEntries.forEach((variantData) => {
        if (variantData && variantData.trim() !== '') {
          const parts = variantData.split(':');
          if (parts.length >= 2) {
            const variantId = parts[0].trim();
            const metafieldJson = parts.slice(1).join(':').trim();
            if (variantId && metafieldJson && metafieldJson !== '' && metafieldJson !== 'null' && metafieldJson !== 'undefined') {
              try {
                const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
                const parsedData = JSON.parse(decodedJson);
                let normalized = [];
                if (Array.isArray(parsedData)) {
                  normalized = parsedData.map(item => {
                    return {
                      performance_heading: safePerfStr(item && item.performance_heading),
                      performance_heading_value: safePerfStr(item && item.performance_heading_value),
                      performance_progress: safePerfNum(item && item.performance_progress),
                      performance_text: safePerfStr(item && item.performance_text)
                    };
                  });
                } else if (parsedData && typeof parsedData === 'object') {
                  var prog = parsedData.performance_progress !== undefined && parsedData.performance_progress !== null ? parsedData.performance_progress : (parsedData.progress !== undefined && parsedData.progress !== null ? parsedData.progress : parsedData.progress_value);
                  normalized = [{
                    performance_heading: safePerfStr(parsedData.performance_heading),
                    performance_heading_value: safePerfStr(parsedData.performance_heading_value),
                    performance_progress: prog,
                    performance_text: safePerfStr(parsedData.performance_text)
                  }];
                }
                if (normalized.length > 0) {
                  // If data has comma-separated values in any field, split into one block per value (block 1 = first value, block 2 = second, etc.)
                  const hasCommaInAny = normalized.some(it => {
                    const h = (it.performance_heading || '').toString();
                    const hv = (it.performance_heading_value || '').toString();
                    const t = (it.performance_text || '').toString();
                    const pStr = (it.performance_progress != null ? it.performance_progress : '').toString();
                    return h.indexOf(',') !== -1 || hv.indexOf(',') !== -1 || t.indexOf(',') !== -1 || pStr.indexOf(',') !== -1;
                  });
                  if (hasCommaInAny) {
                    const expanded = [];
                    for (const item of normalized) {
                      const h = (item.performance_heading || '').toString();
                      const hv = (item.performance_heading_value || '').toString();
                      const t = (item.performance_text || '').toString();
                      const headings = h.split(',').map(s => s.trim());
                      const values = hv.split(',').map(s => s.trim());
                      const texts = t.split(',').map(s => s.trim());
                      let progressArr = [];
                      const pStr = (item.performance_progress != null ? item.performance_progress : '').toString();
                      if (pStr.indexOf(',') !== -1) {
                        progressArr = pStr.split(',').map(s => safePerfNum(s.trim()));
                      } else {
                        const singleProgress = safePerfNum(item.performance_progress);
                        const n = Math.max(headings.length, values.length, texts.length, 1);
                        progressArr = Array(n).fill(singleProgress);
                      }
                      const n = Math.max(headings.length, values.length, progressArr.length, texts.length, 1);
                      for (let i = 0; i < n; i++) {
                        expanded.push({
                          performance_heading: headings[i] || '',
                          performance_heading_value: values[i] || '',
                          performance_progress: progressArr[i] !== undefined ? progressArr[i] : 0,
                          performance_text: texts[i] || ''
                        });
                      }
                    }
                    normalized = expanded;
                  }
                }
                if (normalized.length > 0) {
                  variantPerformanceDataMap.set(variantId, normalized);
                  const variantIdNum = parseInt(variantId);
                  if (!isNaN(variantIdNum)) {
                    variantPerformanceDataMap.set(variantIdNum.toString(), normalized);
                    variantPerformanceDataMap.set(String(variantIdNum), normalized);
                  }
                }
              } catch (e) {
                // Silent - invalid JSON
              }
            }
          }
        }
      });
    }
  });

  document.querySelectorAll('.variant-info-json').forEach((script) => {
    const h = script.getAttribute('data-product-handle');
    if (h) loadVariantInfoForProduct(h);
  });

  // Parse variant performance data from ALL tabs (so default + variant change always have data)
  (function parsePerformanceDataFromAllTabs() {
    function safePerfStr(v) {
      if (v == null || v === undefined) return '';
      if (typeof v === 'object' && v !== null && 'value' in v) return safePerfStr(v.value);
      return String(v);
    }
    function safePerfNum(v) {
      if (v == null || v === undefined) return 0;
      if (typeof v === 'object' && v !== null && 'value' in v) return safePerfNum(v.value);
      const n = Number(v);
      return isNaN(n) ? 0 : Math.min(100, Math.max(0, n));
    }
    allTabs.forEach(function(tab) {
      const attr = tab.getAttribute('data-variant-performance-data');
      if (!attr || attr.trim() === '') return;
      const entries = attr.split('||').filter(function(v) { return v && v.trim() !== ''; });
      entries.forEach(function(variantData) {
        if (!variantData || variantData.trim() === '') return;
        const parts = variantData.split(':');
        if (parts.length < 2) return;
        const variantId = parts[0].trim();
        const metafieldJson = parts.slice(1).join(':').trim();
        if (!variantId || !metafieldJson || metafieldJson === '' || metafieldJson === 'null' || metafieldJson === 'undefined') return;
        try {
          const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
          const parsedData = JSON.parse(decodedJson);
          let normalized = [];
          if (Array.isArray(parsedData)) {
            normalized = parsedData.map(function(item) {
              return {
                performance_heading: safePerfStr(item && item.performance_heading),
                performance_heading_value: safePerfStr(item && item.performance_heading_value),
                performance_progress: safePerfNum(item && item.performance_progress),
                performance_text: safePerfStr(item && item.performance_text)
              };
            });
          } else if (parsedData && typeof parsedData === 'object') {
            var prog = parsedData.performance_progress !== undefined && parsedData.performance_progress !== null ? parsedData.performance_progress : (parsedData.progress !== undefined && parsedData.progress !== null ? parsedData.progress : parsedData.progress_value);
            normalized = [{
              performance_heading: safePerfStr(parsedData.performance_heading),
              performance_heading_value: safePerfStr(parsedData.performance_heading_value),
              performance_progress: prog,
              performance_text: safePerfStr(parsedData.performance_text)
            }];
          }
          if (normalized.length > 0) {
            const hasCommaInAny = normalized.some(function(it) {
              const h = (it.performance_heading || '').toString();
              const hv = (it.performance_heading_value || '').toString();
              const t = (it.performance_text || '').toString();
              const pStr = (it.performance_progress != null ? it.performance_progress : '').toString();
              return h.indexOf(',') !== -1 || hv.indexOf(',') !== -1 || t.indexOf(',') !== -1 || pStr.indexOf(',') !== -1;
            });
            if (hasCommaInAny) {
              const expanded = [];
              for (var idx = 0; idx < normalized.length; idx++) {
                const item = normalized[idx];
                const h = (item.performance_heading || '').toString();
                const hv = (item.performance_heading_value || '').toString();
                const t = (item.performance_text || '').toString();
                const headings = h.split(',').map(function(s) { return s.trim(); });
                const values = hv.split(',').map(function(s) { return s.trim(); });
                const texts = t.split(',').map(function(s) { return s.trim(); });
                var progressArr = [];
                const pStr = (item.performance_progress != null ? item.performance_progress : '').toString();
                if (pStr.indexOf(',') !== -1) {
                  progressArr = pStr.split(',').map(function(s) { return safePerfNum(s.trim()); });
                } else {
                  const singleProgress = safePerfNum(item.performance_progress);
                  const n = Math.max(headings.length, values.length, texts.length, 1);
                  progressArr = Array(n).fill(singleProgress);
                }
                const n = Math.max(headings.length, values.length, progressArr.length, texts.length, 1);
                for (var j = 0; j < n; j++) {
                  expanded.push({
                    performance_heading: headings[j] || '',
                    performance_heading_value: values[j] || '',
                    performance_progress: progressArr[j] !== undefined ? progressArr[j] : 0,
                    performance_text: texts[j] || ''
                  });
                }
              }
              normalized = expanded;
            }
            variantPerformanceDataMap.set(variantId, normalized);
            const variantIdNum = parseInt(variantId, 10);
            if (!isNaN(variantIdNum)) {
              variantPerformanceDataMap.set(variantIdNum.toString(), normalized);
              variantPerformanceDataMap.set(String(variantIdNum), normalized);
            }
          }
        } catch (e) { /* silent */ }
      });
    });
  })();

  // Debug: Show sample of stored metafields
  if (firmnessMetafieldsMap.size > 0) {
    let count = 0;
    for (let [variantId, metafields] of firmnessMetafieldsMap.entries()) {
      if (count < 3) {
        count++;
      } else {
        break;
      }
    }
  }
  
  // Debug: Show foundation metafields
  if (foundationMetafieldsByProduct.size > 0) {
    for (let [productHandle, foundationMap] of foundationMetafieldsByProduct.entries()) {
      let count = 0;
      for (let [variantId, metafields] of foundationMap.entries()) {
        if (count < 2) {
          count++;
        } else {
          break;
        }
      }
    }
  }
  
  // Debug: Show variant info metafields
  if (variantInfoMetafieldsMap.size > 0) {
    let count = 0;
    for (let [variantId, variantInfo] of variantInfoMetafieldsMap.entries()) {
      if (count < 3) {
        count++;
      } else {
        break;
      }
    }
  }
}

document.addEventListener("DOMContentLoaded", function () {
  // Initialize metafields first
  initializeMetafieldsFromDataAttributes();
  let pdpInitialProductDescriptionHtml = '';
  function captureInitialProductDescriptionHtml() {
    const el = document.querySelector('#custom-product-container .product-description');
    if (el && el.innerHTML.trim()) {
      pdpInitialProductDescriptionHtml = el.innerHTML.trim();
    }
  }
  captureInitialProductDescriptionHtml();
  initPdpMainImageSwipe();
  // Show native price immediately if Yagi/app discount price is gone
  try {
    var earlyNative =
      document.getElementById('pdp-native-price') ||
      document.querySelector('#custom-product-container .price[data-discount-percentage]');
    var earlyYagi = document.querySelector('#pdp-app-price-blocks .yagi-discounted-price');
    if (earlyNative && !earlyYagi) {
      earlyNative.removeAttribute('hidden');
      earlyNative.style.display = '';
    }
  } catch (e) {}
  // Store current state
  let currentMattressProduct = null;
  let currentFirmnessVariant = null;
  let currentSizeVariant = null;
  let currentFoundationVariant = null;
  let currentFoundationProduct = null;
  let currentFoundationImages = null;
  let currentMattressImages = null;
  let currentFirmnessTitle = '';
  let isFoundationSelected = false;
  let selectedModelValue = '';
  let selectedUnderbedProduct = null;
  /** When foundation has 2 options (Size + Foundation Type), store the selected type so we sync variant by mattress size */
  let selectedFoundationType = null;
  /** When upsell popup is shown, remember buyNow for "continue" action */
  let pendingUpsellBuyNow = false;
  /** Which upsell overlay is open (adjustable or breeze) — used for confirm/continue dataset */
  let activeUpsellOverlay = null;
  /** After foundation upsell, chain state for add-to-cart (foundation upgrade ids + buyNow). */
  let pendingAccessoryChain = null;

  function upsellPopupGetEl(namespace, suffix) {
    return document.getElementById(namespace + '-' + suffix);
  }

  /** Console: ?pdp_upsell_debug=1 or window.SUAVE_PDP_UPSELL_DEBUG = true. Alerts: ?pdp_upsell_debug=alert or window.SUAVE_PDP_UPSELL_DEBUG_ALERTS = true */
  function suavePdpUpsellDebugEnabled() {
    if (typeof window === 'undefined') return false;
    if (window.SUAVE_PDP_UPSELL_DEBUG === true) return true;
    try {
      var s = window.location && window.location.search;
      if (s && /[?&]pdp_upsell_debug=(?:1|true)(?:&|$)/i.test(s)) return true;
    } catch (e) {}
    return false;
  }
  function suavePdpUpsellDebugAlerts() {
    if (typeof window === 'undefined') return false;
    if (window.SUAVE_PDP_UPSELL_DEBUG_ALERTS === true) return true;
    try {
      var s = window.location && window.location.search;
      if (s && /[?&]pdp_upsell_debug=alert(?:&|$)/i.test(s)) return true;
    } catch (e) {}
    return false;
  }
  function suavePdpUpsellDbg(msg, detail) {
    if (!suavePdpUpsellDebugEnabled()) return;
    if (detail !== undefined) console.log('[SUAVE PDP upsell]', msg, detail);
    else console.log('[SUAVE PDP upsell]', msg);
  }
  function suavePdpUpsellDbgAlert(msg) {
    if (!suavePdpUpsellDebugAlerts()) return;
    try {
      alert('[SUAVE PDP upsell]\n' + msg);
    } catch (e) {}
  }

  /**
   * Upsell/add-to-cart: resolve selected foundation input. Prefers #foundation-options-container.
   * Syncs .selected underbed cards to :checked so Spanish/locale refreshes do not desync the UI.
   */
  function syncUnderbedCheckedFromSelected(container) {
    if (!container) container = document.getElementById('foundation-options-container');
    if (!container) return null;
    var checked = container.querySelector('input[name="underbed"]:checked');
    if (checked && !checked.disabled && !isUnderbedNoFoundationInput(checked)) return checked;
    var selectedCard =
      container.querySelector('.underbed-option.selected') ||
      container.querySelector('.foundation-option.selected');
    if (!selectedCard || selectedCard.classList.contains('foundation-option--no-foundation')) {
      return checked || null;
    }
    var input = selectedCard.querySelector('input[name="underbed"]');
    if (input && !input.disabled && !isUnderbedNoFoundationInput(input)) {
      container.querySelectorAll('input[name="underbed"]').forEach(function (i) {
        i.checked = false;
      });
      input.checked = true;
      syncCurrentFoundationFromUnderbedInput(input);
      return input;
    }
    return checked || null;
  }

  function getFoundationInputForUpsell() {
    var foundationContainer = document.getElementById('foundation-options-container');
    var underbedMode = !!getUnderbedConfig();

    if (foundationContainer && underbedMode) {
      var underbedInput = syncUnderbedCheckedFromSelected(foundationContainer);
      if (underbedInput) return underbedInput;
      if (selectedUnderbedProduct && selectedUnderbedProduct.handle) {
        var handleSel = String(selectedUnderbedProduct.handle).trim();
        var byHandleCard = foundationContainer.querySelector(
          '.underbed-option[data-underbed-handle="' + handleSel + '"]'
        );
        if (byHandleCard) {
          var byHandleInput = byHandleCard.querySelector('input[name="underbed"]');
          if (byHandleInput && !byHandleInput.disabled && !isUnderbedNoFoundationInput(byHandleInput)) {
            selectFoundationOptionElement(byHandleCard, foundationContainer);
            byHandleInput.checked = true;
            syncCurrentFoundationFromUnderbedInput(byHandleInput);
            return byHandleInput;
          }
        }
      }
      return null;
    }

    if (foundationContainer) {
      var el =
        foundationContainer.querySelector('input[name="foundation"]:checked') ||
        foundationContainer.querySelector('.foundation-option.selected input[name="foundation"]') ||
        foundationContainer.querySelector('.foundation-option:not(.out-of-stock) input[name="foundation"]:not([disabled])') ||
        foundationContainer.querySelector('input[name="foundation"]');
      if (el) return el;
      el =
        foundationContainer.querySelector('input[name="model"]:checked') ||
        foundationContainer.querySelector('.model-option.selected input[name="model"]') ||
        foundationContainer.querySelector('.model-option:not(.out-of-stock) input[name="model"]:not([disabled])') ||
        foundationContainer.querySelector('input[name="model"]');
      if (el) return el;
      el = foundationContainer.querySelector('input[name="underbed"]:checked');
      if (el && !el.disabled && !isUnderbedNoFoundationInput(el)) return el;
      el =
        foundationContainer.querySelector('.foundation-option.selected input[name="underbed"]') ||
        foundationContainer.querySelector('.underbed-option.selected input[name="underbed"]');
      if (el && !el.disabled && !isUnderbedNoFoundationInput(el)) return el;
    }

    var globalEl = document.querySelector('input[name="foundation"]:checked');
    if (globalEl) return globalEl;
    return null;
  }

  /** Label used for upsell trigger matching: data-foundation-type, or model radio value / parent data-foundation-type */
  function getEffectiveFoundationTypeForUpsell(input) {
    if (!input) return '';
    var ft = input.getAttribute('data-foundation-type');
    if (ft != null && String(ft).trim() !== '') return String(ft).trim();
    if (input.name === 'model' && input.value) return String(input.value).trim();
    var wrap = input.closest && input.closest('[data-foundation-type]');
    if (wrap && wrap.getAttribute('data-foundation-type')) {
      return String(wrap.getAttribute('data-foundation-type')).trim();
    }
    return '';
  }

  function isUnderbedNoFoundationInput(input) {
    if (!input || input.name !== 'underbed') return false;
    if (input.getAttribute('data-foundation-choice') === 'none') return true;
    if (input.closest && input.closest('.foundation-option--no-foundation')) return true;
    return String(input.value || '').trim() === '';
  }

  function getSelectedUnderbedInput() {
    var el = document.querySelector('input[name="underbed"]:checked');
    if (el && !el.disabled) return el;
    return null;
  }

  function clearUnderbedSelection(container) {
    if (!container) container = document.getElementById('foundation-options-container');
    if (!container) return;
    container.querySelectorAll('input[name="underbed"]').forEach(function (i) {
      i.checked = false;
    });
    clearFoundationOptionSelection(container);
    selectedUnderbedProduct = null;
    currentFoundationVariant = null;
    selectedFoundationType = suavePdpNoFoundationLabel();
    selectedModelValue = '';
    isFoundationSelected = false;
  }

  function syncCurrentFoundationFromUnderbedInput(input) {
    if (!input || isUnderbedNoFoundationInput(input)) {
      currentFoundationVariant = null;
      return;
    }
    var variantId = input.getAttribute('data-underbed-variant-id');
    if (!variantId) {
      currentFoundationVariant = null;
      return;
    }
    currentFoundationVariant = {
      id: parseInt(variantId, 10),
      title: input.getAttribute('data-foundation-type') || (selectedUnderbedProduct && selectedUnderbedProduct.title) || '',
      price: parseInt(input.getAttribute('data-price') || '0', 10) || 0
    };
  }

  function getUnderbedAddonPriceCents() {
    var input = getSelectedUnderbedInput();
    if (!input || isUnderbedNoFoundationInput(input) || input.disabled) return 0;
    if (!input.getAttribute('data-underbed-variant-id')) return 0;
    return parseInt(input.getAttribute('data-price') || '0', 10) || 0;
  }

  function isSelectedUnderbedSellable() {
    var input = getSelectedUnderbedInput();
    if (!input || isUnderbedNoFoundationInput(input)) return true;
    var selectedSize = getCurrentMattressSizeValue();
    if (!selectedSize) return true;
    return !!input.getAttribute('data-underbed-variant-id');
  }

  function getUnderbedHandleFromInput(input) {
    if (!input) return '';
    if (input.name === 'underbed') {
      var handle = String(input.value || '').trim();
      if (handle) return handle;
    }
    var wrap = input.closest && input.closest('[data-underbed-handle]');
    if (wrap) return String(wrap.getAttribute('data-underbed-handle') || '').trim();
    return '';
  }

  function foundationLabelTokensKey(label) {
    return String(label || '')
      .toLowerCase()
      .replace(/[^a-z0-9\s]/g, ' ')
      .split(/\s+/)
      .filter(Boolean)
      .sort()
      .join(' ');
  }

  function foundationLabelsMatch(a, b) {
    if (!a || !b) return false;
    var na = String(a).trim().toLowerCase();
    var nb = String(b).trim().toLowerCase();
    if (!na || !nb) return false;
    if (na === nb) return true;
    // Token equality allows EN/ES word order ("Suave Base" ↔ "Base Suave")
    // without matching longer names ("Suave Base Plus").
    var ta = foundationLabelTokensKey(na);
    var tb = foundationLabelTokensKey(nb);
    return !!(ta && tb && ta === tb);
  }

  function underbedHandlesMatch(selectedHandle, configHandle) {
    if (!selectedHandle || !configHandle) return false;
    var a = String(selectedHandle).trim().toLowerCase();
    var b = String(configHandle).trim().toLowerCase();
    if (!a || !b) return false;
    return a === b;
  }

  function foundationTriggerMatches(config, foundationType, foundationHandle) {
    if (!config) {
      suavePdpUpsellDbg('foundationTriggerMatches: no match (missing config)', {
        foundationType: foundationType,
        foundationHandle: foundationHandle
      });
      return false;
    }

    var handleNorm = foundationHandle ? String(foundationHandle).trim().toLowerCase() : '';
    var handleTriggers = [];
    if (config.foundationTriggerHandles) {
      var rawHandles = Array.isArray(config.foundationTriggerHandles)
        ? config.foundationTriggerHandles
        : String(config.foundationTriggerHandles).split(',');
      rawHandles.forEach(function (entry) {
        var h = String(entry || '').trim().toLowerCase();
        if (h) handleTriggers.push(h);
      });
    }
    if (config.noUpgradeProductHandle) {
      var nuHandle = String(config.noUpgradeProductHandle).trim().toLowerCase();
      if (nuHandle && handleTriggers.indexOf(nuHandle) === -1) handleTriggers.push(nuHandle);
    }

    if (handleNorm) {
      for (var hi = 0; hi < handleTriggers.length; hi++) {
        if (
          handleTriggers[hi] === handleNorm ||
          underbedHandlesMatch(handleNorm, handleTriggers[hi])
        ) {
          suavePdpUpsellDbg('foundationTriggerMatches: handle match', {
            foundationHandle: handleNorm,
            matchedTrigger: handleTriggers[hi]
          });
          return true;
        }
      }
    }

    if (!foundationType) {
      suavePdpUpsellDbg('foundationTriggerMatches: no match (missing type)', {
        foundationHandle: foundationHandle
      });
      return false;
    }

    const triggers = [];
    if (config.foundationTrigger) triggers.push(String(config.foundationTrigger).trim());
    if (config.foundationTriggerSpanish) triggers.push(String(config.foundationTriggerSpanish).trim());
    if (config.currentCardTitle) triggers.push(String(config.currentCardTitle).trim());

    if (!triggers.length) {
      suavePdpUpsellDbg('foundationTriggerMatches: no match (empty trigger in config)', { foundationType: foundationType });
      return false;
    }

    const normalized = String(foundationType).trim();
    let ok = false;
    let matchedTrigger = '';
    for (let ti = 0; ti < triggers.length; ti++) {
      const trigger = triggers[ti];
      if (!trigger) continue;
      if (foundationLabelsMatch(normalized, trigger)) {
        ok = true;
        matchedTrigger = trigger;
        break;
      }
    }
    suavePdpUpsellDbg('foundationTriggerMatches', {
      triggers: triggers,
      matchedTrigger: matchedTrigger,
      foundationTypeNorm: normalized,
      foundationHandle: handleNorm,
      result: ok
    });
    return ok;
  }

  function getUpsellFoundationMatchTypes(foundationInput) {
    var types = [];
    function pushType(val) {
      var t = val != null ? String(val).trim() : '';
      if (!t) return;
      if (types.indexOf(t) === -1) types.push(t);
    }
    pushType(getEffectiveFoundationTypeForUpsell(foundationInput));
    pushType(selectedFoundationType);
    if (foundationInput) {
      var card =
        (foundationInput.closest && foundationInput.closest('.underbed-option')) ||
        (foundationInput.closest && foundationInput.closest('.foundation-option'));
      if (card) {
        pushType(card.getAttribute('data-foundation-type'));
        var titleEl = card.querySelector('.foundation-title');
        if (titleEl && titleEl.textContent) pushType(titleEl.textContent);
      }
    }
    return types;
  }

  function normalizeProductHandleRef(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'object') {
      if (value.handle) return String(value.handle).trim();
      if (value.product && value.product.handle) return String(value.product.handle).trim();
    }
    return String(value).trim();
  }

  function augmentUpsellConfigWithUnderbedHandles(config) {
    if (!config) return config;
    var merged = Object.assign({}, config);
    var handles = [];
    function pushHandle(h) {
      var norm = normalizeProductHandleRef(h);
      if (norm && handles.indexOf(norm) === -1) handles.push(norm);
    }
    // Only explicit theme-editor handles — do not add every underbed product,
    // or the popup would fire for any foundation selection.
    if (merged.foundationTriggerHandles) {
      String(merged.foundationTriggerHandles)
        .split(',')
        .forEach(function (entry) {
          pushHandle(entry);
        });
    }
    merged.foundationTriggerHandles = handles.join(',');
    merged.upgradeProductHandle = normalizeProductHandleRef(merged.upgradeProductHandle);
    merged.noUpgradeProductHandle = normalizeProductHandleRef(merged.noUpgradeProductHandle);
    return merged;
  }

  function foundationTriggerMatchesAny(config, foundationInput) {
    if (!config) return false;
    var effectiveConfig = augmentUpsellConfigWithUnderbedHandles(config);
    var handle = getUnderbedHandleFromInput(foundationInput);
    if (handle && foundationTriggerMatches(effectiveConfig, '', handle)) return true;
    var types = getUpsellFoundationMatchTypes(foundationInput);
    for (var i = 0; i < types.length; i++) {
      if (foundationTriggerMatches(effectiveConfig, types[i], handle)) return true;
    }
    return false;
  }
  
  // Store current active color for title styling
  let currentActiveTab = null;

  function broadcastFirmnessLabel(label) {
    if (!label || typeof label !== 'string') return;
    document.dispatchEvent(
      new CustomEvent('suave:firmness-change', {
        detail: { label: label.trim() }
      })
    );
  }

  function syncPdpLayersActiveProduct(productHandle, productTitle) {
    var layersSection = document.querySelector('[data-pdp-collection-layers-section]');
    if (!layersSection) return;
    if (productHandle) {
      activatePdpLayersTab(layersSection, productHandle);
    }
    if (productTitle) {
      broadcastFirmnessLabel(productTitle);
    }
  }

  function isPdpColorDark(color) {
    if (!color) return false;
    let r;
    let g;
    let b;
    const normalized = String(color).trim();
    if (normalized.startsWith('#')) {
      const hex = normalized.replace('#', '');
      if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
      } else {
        r = parseInt(hex.substr(0, 2), 16);
        g = parseInt(hex.substr(2, 2), 16);
        b = parseInt(hex.substr(4, 2), 16);
      }
    } else if (normalized.startsWith('rgb')) {
      const matches = normalized.match(/\d+/g);
      if (!matches || matches.length < 3) return false;
      r = parseInt(matches[0], 10);
      g = parseInt(matches[1], 10);
      b = parseInt(matches[2], 10);
    } else {
      return false;
    }
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255 < 0.5;
  }

  function getFirmnessCardSelectedOpacity() {
    var root = document.getElementById('custom-product-container');
    if (!root) return 1;
    var raw = getComputedStyle(root).getPropertyValue('--firmness-card-selected-opacity').trim();
    var n = parseFloat(raw);
    if (isNaN(n)) return 1;
    return Math.min(1, Math.max(0, n));
  }

  function pdpColorWithAlpha(color, alpha) {
    if (!color) return '';
    var a = typeof alpha === 'number' ? alpha : 1;
    a = Math.min(1, Math.max(0, a));
    var normalized = String(color).trim();
    var r;
    var g;
    var b;
    if (normalized.startsWith('#')) {
      var hex = normalized.replace('#', '');
      if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
      } else if (hex.length >= 6) {
        r = parseInt(hex.substr(0, 2), 16);
        g = parseInt(hex.substr(2, 2), 16);
        b = parseInt(hex.substr(4, 2), 16);
      } else {
        return normalized;
      }
    } else if (normalized.startsWith('rgb')) {
      var matches = normalized.match(/\d+/g);
      if (!matches || matches.length < 3) return normalized;
      r = parseInt(matches[0], 10);
      g = parseInt(matches[1], 10);
      b = parseInt(matches[2], 10);
    } else {
      return normalized;
    }
    if (a >= 0.999) return 'rgb(' + r + ', ' + g + ', ' + b + ')';
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + a + ')';
  }

  function applyTabColorToPdpElements(tabColor) {
    if (!tabColor || tabColor.trim() === '' || tabColor === 'null' || tabColor === '#') return;
    const color = tabColor.trim();
    const contrastText = isPdpColorDark(color) ? '#ffffff' : '#000000';

    document.querySelectorAll('#custom-product-container .pdp-color-enabled').forEach(function (el) {
      el.style.backgroundColor = color;
      el.style.borderColor = color;
      el.style.color = contrastText;
      el.style.setProperty('--pdp-bg-color', color);
      el.style.setProperty('--pdp-text-color', contrastText);
    });

    document.querySelectorAll('#custom-product-container .pdp-text-color').forEach(function (el) {
      if (el.closest('.foundation-option')) return;
      el.style.color = color;
      el.style.setProperty('--pdp-text-color', color);
    });

    document.querySelectorAll('#custom-product-container .pdp-border-color').forEach(function (el) {
      el.style.borderColor = color;
      el.style.setProperty('--pdp-border-color', color);
    });

    // Sale badge matches active mattress-type-tab fill (bg + white text)
    document.querySelectorAll('#custom-product-container .suave-sale-badge').forEach(function (badge) {
      if (badge.hidden || badge.hasAttribute('hidden')) return;
      badge.style.backgroundColor = color;
      badge.style.borderColor = color;
      badge.style.color = '#ffffff';
    });

    // Promo banner optional tab-color sync
    document.querySelectorAll('#custom-product-container .pdp-promo-banner[data-sync-tab-colors="true"]').forEach(function (banner) {
      banner.style.backgroundColor = color;
      banner.style.color = contrastText;
      banner.style.setProperty('--pdp-promo-accent', contrastText);
      banner.querySelectorAll('.pdp-promo-banner__heading, .pdp-promo-banner__shipping').forEach(function (el) {
        el.style.color = contrastText;
      });
      banner.querySelectorAll('.pdp-promo-banner__eyebrow').forEach(function (el) {
        el.style.color = contrastText;
      });
      // Timer digits/labels stay black for readability on the countdown units
      banner.querySelectorAll('.pdp-promo-banner__timer-value, .pdp-promo-banner__timer-label').forEach(function (el) {
        el.style.color = '#111111';
      });
    });

    // Product image label optional tab-color sync (main image + firmness cards)
    document.querySelectorAll('#custom-product-container .pdp-product-image-label[data-sync-tab-colors="true"]').forEach(function (label) {
      if (label.hidden || label.hasAttribute('hidden')) return;
      label.style.backgroundColor = color;
      label.style.color = contrastText;
    });
  }

  function applyMattressTabActiveVisuals(activeTab) {
    if (!activeTab) return;

    document.querySelectorAll('#custom-product-container .tab').forEach(function (t) {
      t.classList.remove('active');
      const tabColor = (t.getAttribute('data-tab-color') || '').trim();
      t.style.borderWidth = '1px';
      t.style.borderStyle = 'solid';
      t.style.backgroundColor = '#ffffff';
      if (tabColor && tabColor !== 'null' && tabColor !== '#') {
        t.style.borderColor = tabColor;
        t.style.color = tabColor;
      } else {
        t.style.borderColor = '';
        t.style.color = '';
      }
    });

    activeTab.classList.add('active');
    const activeColor = (activeTab.getAttribute('data-tab-color') || '').trim();
    if (activeColor && activeColor !== 'null' && activeColor !== '#') {
      activeTab.style.borderWidth = '2px';
      activeTab.style.borderStyle = 'solid';
      activeTab.style.borderColor = activeColor;
      activeTab.style.backgroundColor = activeColor;
      activeTab.style.color = '#ffffff';
    }
  }

  function clearFirmnessCardImageBgStyles(imageBg) {
    if (!imageBg) return;
    imageBg.style.backgroundColor = '';
    imageBg.style.backgroundImage = '';
    imageBg.style.backgroundSize = '';
    imageBg.style.backgroundPosition = '';
    imageBg.style.backgroundRepeat = '';
  }

  function applyFirmnessCardTabColor(tabColor) {
    const color = (tabColor || '').trim();
    const textSelector =
      '.firmness-label, .firmness-label-name, .firmness-label-price, .firmness-label-compare, .firmness-card-title, .firmness-title, .firmness-variant-name, .firmness-title-text, .firmness-description, .firmness-features li';

    document.querySelectorAll('#custom-product-container .firmness-card').forEach(function (card) {
      card.style.backgroundColor = '';
      card.style.borderColor = '';
      card.style.color = '';
      card.style.opacity = '';
      card.querySelectorAll(textSelector).forEach(function (el) {
        el.style.color = '';
        el.style.opacity = '';
      });
      clearFirmnessCardImageBgStyles(card.querySelector('.firmness-card-image-bg'));
    });

    const selectedCard = document.querySelector('#custom-product-container .firmness-card.selected');
    if (!selectedCard) return;

    const activeTab = document.querySelector('#custom-product-container .tab.active');
    const useCustom = !!(activeTab && activeTab.getAttribute('data-use-custom-backdrop') === 'true');
    const backdropImage = activeTab ? (activeTab.getAttribute('data-backdrop-image') || '').trim() : '';
    const gradFrom = activeTab ? (activeTab.getAttribute('data-backdrop-gradient-from') || '').trim() : '';
    const gradTo = activeTab ? (activeTab.getAttribute('data-backdrop-gradient-to') || '').trim() : '';

    const fillOpacity = getFirmnessCardSelectedOpacity();
    const hasTabColor = !!(color && color !== 'null' && color !== '#');
    const fillColor = hasTabColor ? pdpColorWithAlpha(color, fillOpacity) : '';

    selectedCard.style.opacity = '1';
    selectedCard.style.backgroundColor = '#ffffff';
    selectedCard.style.color = '';
    if (fillColor) {
      selectedCard.style.borderColor = fillColor;
    }

    var selectedImageBg = selectedCard.querySelector('.firmness-card-image-bg');
    if (!selectedImageBg) {
      ensureFirmnessImageBackdrop(selectedCard);
      selectedImageBg = selectedCard.querySelector('.firmness-card-image-bg');
    }
    if (!selectedImageBg) return;

    clearFirmnessCardImageBgStyles(selectedImageBg);

    // Custom backdrop enabled: image first, then gradient, else tab color
    if (useCustom && backdropImage) {
      selectedImageBg.style.backgroundImage = 'url("' + backdropImage.replace(/"/g, '\\"') + '")';
      selectedImageBg.style.backgroundSize = 'cover';
      selectedImageBg.style.backgroundPosition = 'center';
      selectedImageBg.style.backgroundRepeat = 'no-repeat';
      selectedImageBg.style.backgroundColor = 'transparent';
      return;
    }

    if (useCustom && gradFrom && gradTo && gradFrom !== 'null' && gradTo !== 'null') {
      selectedImageBg.style.backgroundImage =
        'linear-gradient(135deg, ' + gradFrom + ' 0%, ' + gradTo + ' 100%)';
      selectedImageBg.style.backgroundColor = 'transparent';
      return;
    }

    if (useCustom && ((gradFrom && gradFrom !== 'null') || (gradTo && gradTo !== 'null'))) {
      selectedImageBg.style.backgroundColor = pdpColorWithAlpha(gradFrom || gradTo, fillOpacity);
      return;
    }

    // Default: mattress tab color behind the image
    if (fillColor) {
      selectedImageBg.style.backgroundColor = fillColor;
    }
  }

  function createFirmnessImageWrap(imgSrc, altText) {
    var wrap = document.createElement('div');
    wrap.className = 'firmness-image-wrap';
    var bg = document.createElement('span');
    bg.className = 'firmness-card-image-bg';
    bg.setAttribute('aria-hidden', 'true');
    var img = document.createElement('img');
    img.className = 'firmness-image';
    img.src = imgSrc;
    img.alt = altText || '';
    img.loading = 'lazy';
    wrap.appendChild(bg);
    wrap.appendChild(img);
    return wrap;
  }

  function ensureFirmnessImageBackdrop(card) {
    if (!card) return null;
    var existingBg = card.querySelector('.firmness-card-image-bg');
    if (existingBg) return existingBg;

    var wrap = card.querySelector('.firmness-image-wrap');
    if (!wrap) {
      var img = card.querySelector('img.firmness-image, .firmness-image img');
      if (!img) {
        wrap = document.createElement('div');
        wrap.className = 'firmness-image-wrap';
        var bgOnly = document.createElement('span');
        bgOnly.className = 'firmness-card-image-bg';
        bgOnly.setAttribute('aria-hidden', 'true');
        wrap.appendChild(bgOnly);
        var labelEl = card.querySelector('.firmness-label, .firmness-variant-name, .firmness-card-title');
        if (labelEl && labelEl.parentNode === card) {
          card.insertBefore(wrap, labelEl);
        } else {
          card.appendChild(wrap);
        }
        return bgOnly;
      }
      wrap = document.createElement('div');
      wrap.className = 'firmness-image-wrap';
      var parent = img.parentNode;
      if (parent && parent.classList && parent.classList.contains('firmness-image') && parent.tagName !== 'IMG') {
        parent.parentNode.insertBefore(wrap, parent);
        img.className = 'firmness-image';
        wrap.appendChild(img);
        parent.remove();
      } else {
        parent.insertBefore(wrap, img);
        wrap.appendChild(img);
      }
    }

    var bg = document.createElement('span');
    bg.className = 'firmness-card-image-bg';
    bg.setAttribute('aria-hidden', 'true');
    wrap.insertBefore(bg, wrap.firstChild);
    return bg;
  }

  function clearFoundationOptionVisualStyles(optionEl) {
    if (!optionEl) return;

    optionEl.style.removeProperty('background-color');
    optionEl.style.removeProperty('background');
    optionEl.style.removeProperty('border-color');
    optionEl.style.removeProperty('color');
    optionEl.style.removeProperty('border-width');
    optionEl.style.removeProperty('border-style');

    optionEl.querySelectorAll('.foundation-title, .foundation-price, .foundation-subtitle, .out-of-stock-badge').forEach(function (el) {
      el.classList.remove('pdp-text-color');
      el.style.removeProperty('color');
      el.style.removeProperty('--pdp-text-color');
    });

    const subtitleEl = optionEl.querySelector('.foundation-subtitle');
    if (subtitleEl) {
      const isUnavailable = optionEl.classList.contains('out-of-stock') || optionEl.classList.contains('size-unavailable');
      subtitleEl.style.color = isUnavailable ? '#ff4444' : '#666';
    }
  }

  function applyFoundationOptionTabColor(tabColor) {
    const color = (tabColor || '').trim();
    const textSelector =
      '.foundation-title, .foundation-price, .foundation-subtitle, .out-of-stock-badge';

    document.querySelectorAll('#custom-product-container .foundation-option').forEach(function (opt) {
      clearFoundationOptionVisualStyles(opt);
    });

    if (!color || color === 'null' || color === '#') return;

    const selectedOption = document.querySelector('#custom-product-container .foundation-option.selected');
    if (!selectedOption) return;

    selectedOption.style.backgroundColor = color;
    selectedOption.style.borderColor = color;
    selectedOption.style.color = '#ffffff';
    selectedOption.querySelectorAll(textSelector).forEach(function (el) {
      el.style.color = '#ffffff';
    });
  }

  function applyPdpSelectionTabColors(tabColor) {
    applyFirmnessCardTabColor(tabColor);
    applyFoundationOptionTabColor(tabColor);
  }

  // Function to update title last word(s) color based on active tab
  function updateTitleLastWordColor() {
    const activeTab = document.querySelector('#custom-product-container .tab.active');
    if (!activeTab) return;

    const tabColor = activeTab.getAttribute('data-tab-color');
    currentActiveTab = activeTab;
    applyMattressTabActiveVisuals(activeTab);
    if (tabColor) {
      applyTabColorToPdpElements(tabColor);
      document.querySelectorAll('.title-last-word').forEach(function (el) {
        el.style.color = tabColor.trim();
      });
    }
    // Always refresh firmness backdrop (tab color, or custom image/gradient from block)
    applyPdpSelectionTabColors(tabColor || '');
  }
  
  function isSpanishPdpLocale() {
    return suavePdpIsSpanishLocale();
  }

  function normalizePdpImageUrl(url) {
    if (!url || typeof url !== 'string') return '';
    return url.replace(/_small\.|_medium\.|_large\.|_compact\.|_grande\./g, '_master.');
  }

  function pdpImageUrlsMatch(a, b) {
    if (!a || !b) return false;
    return String(a).split('?')[0] === String(b).split('?')[0];
  }

  function getVariantMetafieldGalleryUrls(variantId) {
    const variantIdStr = String(variantId || '');
    if (!variantIdStr) return [];
    let entry = variantGalleryImagesMap.get(variantIdStr);
    if (!entry) {
      const variantIdNum = parseInt(variantIdStr, 10);
      if (!isNaN(variantIdNum)) {
        entry = variantGalleryImagesMap.get(String(variantIdNum));
      }
    }
    if (!entry) return [];
    if (Array.isArray(entry)) {
      return entry.filter(function (u) {
        return typeof u === 'string' && u.trim() !== '' && u !== 'null';
      });
    }
    const localeKey = isSpanishPdpLocale() ? 'es' : 'en';
    const urls = entry[localeKey] || entry.en || [];
    return Array.isArray(urls)
      ? urls.filter(function (u) {
          return typeof u === 'string' && u.trim() !== '' && u !== 'null';
        })
      : [];
  }

  function getVariantFeaturedImageData(variantId) {
    const variantIdStr = String(variantId || '');
    if (!variantIdStr || !currentMattressProduct || !currentMattressProduct.variants) return null;
    const currentVariant = currentMattressProduct.variants.find(function (v) {
      return String(v.id) === variantIdStr || String(v.id) === String(parseInt(variantIdStr, 10));
    });
    if (!currentVariant || !currentVariant.featured_image) return null;
    const featuredSrc =
      typeof currentVariant.featured_image === 'string'
        ? currentVariant.featured_image
        : currentVariant.featured_image.src;
    if (!featuredSrc || String(featuredSrc).trim() === '') return null;
    return {
      src: normalizePdpImageUrl(featuredSrc),
      alt: currentVariant.title || 'Variant image'
    };
  }

  // Function to load and display product images
  function loadProductImages(productImages, options) {
    options = options || {};
    const thumbnailContainer = document.getElementById('thumbnail-images-container');
    const mainImage = document.getElementById('main-image');
    const imageLoading = document.getElementById('image-loading');
    
    if (!thumbnailContainer || !mainImage) {
      return;
    }
    
    // Hide loading and show thumbnail container
    if (imageLoading) {
      imageLoading.style.display = 'none';
    }
    
    // Clear existing content
    thumbnailContainer.innerHTML = '';
    
    const thumbs = productImages && productImages.length > 0 ? productImages : [];
    const mainOverride = options.mainImage || null;

    if (thumbs.length > 0) {
      thumbs.forEach(function (image, index) {
        const thumbnail = createThumbnail(image, index);
        thumbnailContainer.appendChild(thumbnail);
      });
    }

    let mainImageData = mainOverride;
    if (!mainImageData && thumbs.length > 0) {
      mainImageData = {
        src: thumbs[0].src || thumbs[0],
        alt: thumbs[0].alt || 'Product image'
      };
    }

    if (mainImageData) {
      let mainImageUrl = mainImageData.src || mainImageData;
      if (typeof mainImageUrl === 'string') {
        mainImageUrl = normalizePdpImageUrl(mainImageUrl);
      }
      mainImage.src = mainImageUrl;
      mainImage.alt = mainImageData.alt || 'Product image';
      mainImage.onerror = function () {
        console.error('Failed to load main image:', mainImageUrl);
        this.src = mainImageUrl;
      };

      const allThumbnails = thumbnailContainer.querySelectorAll('.thumbnail');
      let matchedThumb = null;
      allThumbnails.forEach(function (thumb) {
        thumb.classList.remove('active');
        const thumbUrl = thumb.getAttribute('data-image');
        if (!matchedThumb && pdpImageUrlsMatch(thumbUrl, mainImageUrl)) {
          matchedThumb = thumb;
        }
      });
      if (matchedThumb) {
        matchedThumb.classList.add('active');
      }

      initPdpThumbnailCarousel();
    } else if (thumbs.length === 0) {
      if (imageLoading) {
        imageLoading.textContent = suavePdpT('noImages', 'No images available');
        imageLoading.style.display = '';
      }
    }
  }

  function loadVariantImageGallery(variantId) {
    const featured = getVariantFeaturedImageData(variantId);
    const galleryUrls = getVariantMetafieldGalleryUrls(variantId);
    const thumbs = galleryUrls.map(function (src) {
      return {
        src: normalizePdpImageUrl(src),
        alt: (featured && featured.alt) || 'Product image'
      };
    });
    loadProductImages(thumbs, { mainImage: featured });
  }
  
  // Function to create thumbnail element
  function createThumbnail(image, index) {
    const thumbnail = document.createElement('div');
    thumbnail.className = 'thumbnail';
    thumbnail.dataset.index = index;
    
    // Get the proper image URL
    let imageUrl = image.src || image;
    if (typeof imageUrl === 'string') {
      // Convert to master size for main image
      imageUrl = imageUrl.replace(/_small\.|_medium\.|_large\.|_compact\.|_grande\./g, '_master.');
    }
    
    thumbnail.dataset.image = imageUrl;
    
    const img = document.createElement('img');
    // Use medium size for thumbnails
    const thumbUrl = imageUrl.replace('_master.', '_medium.');
    img.src = thumbUrl;
    img.alt = image.alt || 'Product image';
    img.loading = 'lazy';
    img.onerror = function() {
      console.error('Failed to load thumbnail image:', thumbUrl);
      this.src = imageUrl; // Fallback to master
    };
    
    thumbnail.appendChild(img);
    
    // Add click event
    thumbnail.addEventListener('click', function() {
      activatePdpThumbnail(this, 'smooth');
    });
    
    return thumbnail;
  }

  const PDP_THUMB_CAROUSEL_MQ = typeof window.matchMedia === 'function'
    ? window.matchMedia('(max-width: 749px)')
    : null;

  function isPdpThumbCarouselMobile() {
    return PDP_THUMB_CAROUSEL_MQ && PDP_THUMB_CAROUSEL_MQ.matches;
  }

  function getPdpThumbnailTrack() {
    return document.getElementById('thumbnail-images-container');
  }

  function getPdpThumbnailElements() {
    const track = getPdpThumbnailTrack();
    return track ? Array.from(track.querySelectorAll('.thumbnail')) : [];
  }

  function scrollPdpThumbToElement(thumbEl, behavior) {
    const track = getPdpThumbnailTrack();
    if (!track || !thumbEl) return;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    if (maxScroll <= 0) return;
    const target = thumbEl.offsetLeft - (track.clientWidth - thumbEl.offsetWidth) / 2;
    track.scrollTo({
      left: Math.max(0, Math.min(target, maxScroll)),
      behavior: behavior || 'auto'
    });
  }

  function scrollPdpActiveThumbnailIntoView(thumbEl) {
    const track = getPdpThumbnailTrack();
    if (!track) return;
    const el = thumbEl || track.querySelector('.thumbnail.active');
    scrollPdpThumbToElement(el, 'smooth');
  }

  function activatePdpThumbnail(thumbEl, scrollBehavior) {
    if (!thumbEl) return;
    const allThumbnails = document.querySelectorAll('#custom-product-container .thumbnail');
    allThumbnails.forEach(function (t) {
      t.classList.remove('active');
    });
    thumbEl.classList.add('active');

    const imageUrl = thumbEl.getAttribute('data-image');
    const mainImage = document.getElementById('main-image');
    if (imageUrl && mainImage) {
      mainImage.src = imageUrl;
      const thumbImg = thumbEl.querySelector('img');
      if (thumbImg) mainImage.alt = thumbImg.alt;
    }

    scrollPdpThumbToElement(thumbEl, scrollBehavior || 'smooth');
    updatePdpThumbnailCarouselNavState();
  }

  function scrollPdpThumbAdjacent(direction) {
    const track = getPdpThumbnailTrack();
    const thumbs = getPdpThumbnailElements();
    if (!track || !thumbs.length) return;
    const active = track.querySelector('.thumbnail.active') || thumbs[0];
    const idx = Math.max(0, thumbs.indexOf(active));
    const nextIdx = Math.max(0, Math.min(thumbs.length - 1, idx + direction));
    if (nextIdx === idx) return;
    activatePdpThumbnail(thumbs[nextIdx], 'smooth');
  }

  function refreshPdpThumbnailCarousel() {
    updatePdpThumbnailCarouselNavState();
  }

  function updatePdpThumbnailCarouselNavState() {
    const carousel = document.getElementById('pdp-thumbnail-carousel');
    const track = getPdpThumbnailTrack();
    const prevBtn = document.getElementById('pdp-thumb-carousel-prev');
    const nextBtn = document.getElementById('pdp-thumb-carousel-next');
    if (!carousel || !track || !prevBtn || !nextBtn) return;

    const thumbCount = getPdpThumbnailElements().length;
    const enabled = thumbCount > 1;

    carousel.classList.toggle('pdp-thumb-carousel--enabled', enabled);

    if (!enabled) {
      prevBtn.disabled = true;
      nextBtn.disabled = true;
      return;
    }

    const thumbs = getPdpThumbnailElements();
    const active = track.querySelector('.thumbnail.active') || thumbs[0];
    const idx = active ? Math.max(0, thumbs.indexOf(active)) : 0;
    prevBtn.disabled = idx <= 0;
    nextBtn.disabled = idx >= thumbs.length - 1;
  }

  function bindPdpThumbnailCarouselImageLoads(track) {
    if (!track) return;
    track.querySelectorAll('.thumbnail img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', refreshPdpThumbnailCarousel, { once: true });
      img.addEventListener('error', refreshPdpThumbnailCarousel, { once: true });
    });
  }

  function initPdpMainImageSwipe() {
    var root = document.getElementById('custom-product-container');
    if (!root || root.getAttribute('data-enable-main-image-swipe') === 'false') return;
    if (typeof window.suaveBindMainImageSwipe !== 'function') return;
    var wrap = document.querySelector('#custom-product-container .main-image');
    if (!wrap) return;
    window.suaveBindMainImageSwipe(
      wrap,
      function () {
        scrollPdpThumbAdjacent(1);
      },
      function () {
        scrollPdpThumbAdjacent(-1);
      },
      { swipeClass: 'pdp-main-image--swipe' }
    );
  }

  function initPdpThumbnailCarousel() {
    const carousel = document.getElementById('pdp-thumbnail-carousel');
    const track = getPdpThumbnailTrack();
    const prevBtn = document.getElementById('pdp-thumb-carousel-prev');
    const nextBtn = document.getElementById('pdp-thumb-carousel-next');
    if (!carousel || !track) return;

    bindPdpThumbnailCarouselImageLoads(track);

    if (!carousel._pdpThumbCarouselBound) {
      carousel._pdpThumbCarouselBound = true;

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollPdpThumbAdjacent(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollPdpThumbAdjacent(1);
        });
      }

      track.addEventListener('scroll', function () {
        updatePdpThumbnailCarouselNavState();
      }, { passive: true });

      if (PDP_THUMB_CAROUSEL_MQ) {
        const onMqChange = function () {
          refreshPdpThumbnailCarousel();
        };
        if (typeof PDP_THUMB_CAROUSEL_MQ.addEventListener === 'function') {
          PDP_THUMB_CAROUSEL_MQ.addEventListener('change', onMqChange);
        } else if (typeof PDP_THUMB_CAROUSEL_MQ.addListener === 'function') {
          PDP_THUMB_CAROUSEL_MQ.addListener(onMqChange);
        }
      }

      window.addEventListener('resize', refreshPdpThumbnailCarousel, { passive: true });

      if (typeof ResizeObserver !== 'undefined' && !track._pdpThumbResizeObs) {
        track._pdpThumbResizeObs = true;
        const ro = new ResizeObserver(refreshPdpThumbnailCarousel);
        ro.observe(track);
      }
    }

    refreshPdpThumbnailCarousel();
    requestAnimationFrame(refreshPdpThumbnailCarousel);
    setTimeout(refreshPdpThumbnailCarousel, 120);
    setTimeout(refreshPdpThumbnailCarousel, 400);
  }
  
  function getActiveMattressVariantId() {
    if (currentSizeVariant && currentSizeVariant.id) {
      return String(currentSizeVariant.id);
    }
    if (currentFirmnessVariant && currentFirmnessVariant.id) {
      return String(currentFirmnessVariant.id);
    }
    return '';
  }
  
  // Foundation selection should not use old alt-text image matching.
  // Always keep mattress gallery driven by selected mattress variant.
  function handleFoundationVariantImageChange(variantElement, foundationProductData) {
    try {
      const activeVariantId = getActiveMattressVariantId();
      if (activeVariantId) {
        loadVariantImageGallery(activeVariantId);
        return;
      }
      if (currentMattressImages && currentMattressImages.length > 0) {
        loadProductImages(currentMattressImages);
      }
    } catch (error) {
      if (currentMattressImages && currentMattressImages.length > 0) {
        loadProductImages(currentMattressImages);
      }
    }
  }
  
  // Function to fetch variant metafields for a product
  // NOTE: This function now only uses data attributes - API calls removed due to 403 errors
  async function fetchVariantMetafields(productData) {
    // Metafields are already merged from data attributes via mergeVariantMetafields()
    // This function is kept for compatibility but does nothing
    return productData;
  }
  
  // Function to fetch foundation variant metafields
  // NOTE: This function now only uses data attributes - API calls removed due to 403 errors
  async function fetchFoundationVariantMetafields(foundationProduct) {
    // Metafields are already merged from data attributes via mergeFoundationMetafields()
    // This function is kept for compatibility but does nothing
    return foundationProduct;
  }

  // Function to get foundation product from metafield
  async function getFoundationProductFromMetafield(productHandle) {
    try {
      // Try to get product with metafields using Shopify's AJAX API
      const response = await fetch(suavePdpProductViewUrl(productHandle, 'json-metafields'));
      
      if (response.ok) {
        const html = await response.text();
        
        // Try to parse as JSON first
        try {
          const productData = JSON.parse(html);
          
          // Check for foundation_product in metafields
          if (productData.metafields && productData.metafields.custom && productData.metafields.custom.foundation_product) {
            const foundationHandle = productData.metafields.custom.foundation_product;
            return foundationHandle;
          }
          
          // Check in global namespace
          if (productData.metafields && productData.metafields.global && productData.metafields.global.foundation_product) {
            const foundationHandle = productData.metafields.global.foundation_product;
            return foundationHandle;
          }
          
          // Check direct property
          if (productData.metafields && productData.metafields.foundation_product) {
            const foundationHandle = productData.metafields.foundation_product;
            return foundationHandle;
          }
          
        } catch (e) {
          console.log('Response is not JSON, trying to parse as HTML');
        }
        
        // Look for metafield in data attributes or script tags
        const dataAttrRegex = /data-foundation-product=["']([^"']+)["']/i;
        const dataMatch = html.match(dataAttrRegex);
        if (dataMatch && dataMatch[1]) {
          return dataMatch[1];
        }
        
      }
      
      // Try to get product JSON directly
      const jsonResponse = await fetch(suavePdpProductJsonUrl(productHandle));
      if (jsonResponse.ok) {
        const productData = await jsonResponse.json();
        
        // Check if product has metafields property
        if (productData.metafields) {
          
          // Check custom namespace
          if (productData.metafields.custom && productData.metafields.custom.foundation_product) {
            return productData.metafields.custom.foundation_product;
          }
          
          // Check global namespace
          if (productData.metafields.global && productData.metafields.global.foundation_product) {
            return productData.metafields.global.foundation_product;
          }
          
          // Check direct property
          if (productData.metafields.foundation_product) {
            return productData.metafields.foundation_product;
          }
        }
        
      }
      
      return null;
      
    } catch (error) {
      console.error('Error fetching foundation metafield:', error);
      return null;
    }
  }
  
  function resolveMattressProductForFoundation(mattressProductHandle) {
    if (currentMattressProduct && currentMattressProduct.variants && currentMattressProduct.variants.length) {
      return currentMattressProduct;
    }
    if (mattressProductHandle && currentMattressProduct && currentMattressProduct.handle === mattressProductHandle) {
      return currentMattressProduct;
    }
    return null;
  }

  function findBaseModelContext(productData) {
    if (!productData || !productData.variants || !productData.variants.length) return null;
    const { modelIndex, sizeIndex } = detectOptionTypes(productData);
    if (modelIndex === -1 || modelIndex === sizeIndex) return null;
    let baseModelValue = '';
    const baseVariants = [];
    productData.variants.forEach((variant) => {
      const modelValue = getModelLabelFromVariant(variant, modelIndex);
      if (!isUnderbedReplacementModelLabel(modelValue)) return;
      if (!baseModelValue) baseModelValue = modelValue;
      baseVariants.push(variant);
    });
    if (!baseVariants.length) return null;
    return { modelIndex, sizeIndex, baseModelValue, baseVariants };
  }

  function getCurrentMattressSizeVariantPriceCents() {
    if (currentSizeVariant && currentSizeVariant.price != null) {
      return parseInt(currentSizeVariant.price, 10) || 0;
    }
    const sizeSelect = document.getElementById('size-select');
    if (sizeSelect && sizeSelect.selectedIndex >= 0) {
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      if (selectedOption && selectedOption.value && currentMattressProduct && currentMattressProduct.variants) {
        const variant = currentMattressProduct.variants.find(
          (v) => v.id.toString() === selectedOption.value
        );
        if (variant && variant.price != null) {
          return parseInt(variant.price, 10) || 0;
        }
      }
      const priceAttr = selectedOption ? selectedOption.getAttribute('data-price') : null;
      if (priceAttr) {
        const priceStr = priceAttr.replace(/[$,]/g, '');
        const priceFloat = parseFloat(priceStr);
        if (!isNaN(priceFloat)) {
          return Math.round(priceFloat * 100);
        }
      }
    }
    if (currentFirmnessVariant && currentFirmnessVariant.price != null) {
      return parseInt(currentFirmnessVariant.price, 10) || 0;
    }
    return 0;
  }

  function updateNoFoundationCardPrice() {
    const priceEl = document.querySelector('#foundation-options-container [data-no-foundation-price]');
    if (!priceEl) return;
    priceEl.textContent = formatMoney(0);
  }

  // Match Shopify Translate & Adapt option values (see theme admin translations).
  // Full → Matrimonial, Twin → Individual, Twin XL → Individual XL, Queen → Queen.
  var BED_SIZE_ALIAS_GROUPS = [
    ['twin', 'individual', 'sencillo', 'single', 'twin bed', 'cama individual'],
    ['twin xl', 'twinxl', 'individual xl', 'xl twin', 'individual extra largo'],
    ['full', 'doble', 'double', 'cama doble', 'matrimonial'],
    ['queen', 'queen size'],
    ['king', 'king size', 'kingsize', 'rey', 'cama king'],
    ['cal king', 'california king', 'king california', 'calking', 'cal king size', 'rey california', 'california rey'],
    ['split king', 'splitking', 'king dividido', 'rey dividido', 'split rey', 'king split'],
    ['split cal king', 'splitcalking', 'split california king', 'king california dividido', 'rey california dividido']
  ];

  function bedSizeCanonicalKey(value) {
    var n = normalizeMattressSizeLabel(value);
    if (!n) return '';
    var gi;
    for (gi = 0; gi < BED_SIZE_ALIAS_GROUPS.length; gi++) {
      var group = BED_SIZE_ALIAS_GROUPS[gi];
      var ai;
      for (ai = 0; ai < group.length; ai++) {
        if (normalizeMattressSizeLabel(group[ai]) === n || compactBedSizeKey(group[ai]) === compactBedSizeKey(value)) {
          return group[0];
        }
      }
    }
    return compactBedSizeKey(value);
  }

  function isVariantSellable(variant) {
    return isVariantSellableForUpsell(variant);
  }

  function detectUnderbedSizeIndex(product) {
    if (!product) return -1;
    const optionNames = Array.isArray(product.option_names) ? product.option_names : [];
    const sizeKeywords = ['size', 'dimension', 'tamaño', 'tamano', 'medida', 'twin', 'full', 'queen', 'king', 'california', 'xl'];
    for (let i = 0; i < optionNames.length; i += 1) {
      const name = String(optionNames[i] || '').toLowerCase();
      if (sizeKeywords.some((k) => name.includes(k))) return i;
    }
    return optionNames.length > 1 ? 1 : (optionNames.length === 1 ? 0 : -1);
  }

  function getVariantOptionByIndex(variant, index) {
    if (!variant || index < 0) return '';
    if (index === 0) return String(variant.option1 || '').trim();
    if (index === 1) return String(variant.option2 || '').trim();
    if (index === 2) return String(variant.option3 || '').trim();
    return '';
  }

  function foundationMattressSizesCompatible(foundationSize, mattressSize) {
    if (!foundationSize || !mattressSize) return false;
    if (mattressSizesMatch(foundationSize, mattressSize)) return true;

    var mattressKey = bedSizeCanonicalKey(mattressSize);
    var foundationKey = bedSizeCanonicalKey(foundationSize);
    if (mattressKey && foundationKey && mattressKey === foundationKey) return true;

    var mattressCompact = compactBedSizeKey(mattressKey || mattressSize);
    var foundationCompact = compactBedSizeKey(foundationKey || foundationSize);
    if (mattressCompact && foundationCompact && mattressCompact === foundationCompact) return true;

    if (
      (mattressKey === 'split king' || mattressCompact === 'splitking') &&
      foundationKey === 'king'
    ) {
      return true;
    }
    if (
      (mattressKey === 'split cal king' || mattressCompact === 'splitcalking') &&
      (foundationKey === 'cal king' || foundationCompact === 'calking')
    ) {
      return true;
    }

    var lookupLabels = getFoundationSizeLookupLabels(mattressSize);
    for (var li = 0; li < lookupLabels.length; li++) {
      if (mattressSizesMatch(foundationSize, lookupLabels[li])) return true;
      if (bedSizeCanonicalKey(lookupLabels[li]) === foundationKey) return true;
    }
    return false;
  }

  function variantOptionValuesForMatch(variant, sizeIndex) {
    var values = [];
    if (sizeIndex >= 0) values.push(getVariantOptionByIndex(variant, sizeIndex));
    variantOptionValuesAll(variant).forEach(function (v) {
      values.push(v);
    });
    return values;
  }

  function variantMatchesFoundationLabel(variant, label, sizeIndex) {
    return variantOptionValuesForMatch(variant, sizeIndex).some(function (val) {
      return mattressSizesMatch(val, label) || bedSizeCanonicalKey(val) === bedSizeCanonicalKey(label);
    });
  }

  function findUnderbedVariantForSize(product, selectedSize) {
    if (!product || !Array.isArray(product.variants) || !product.variants.length || !selectedSize) return null;
    var sizeIndex = detectUnderbedSizeIndex(product);
    var labels = getFoundationSizeLookupLabels(selectedSize);

    for (var li = 0; li < labels.length; li++) {
      var sellable = product.variants.find(function (v) {
        return variantMatchesFoundationLabel(v, labels[li], sizeIndex) && isVariantSellable(v);
      });
      if (sellable) return sellable;
    }

    for (var li2 = 0; li2 < labels.length; li2++) {
      var anyMatch = product.variants.find(function (v) {
        return variantMatchesFoundationLabel(v, labels[li2], sizeIndex);
      });
      if (anyMatch) return anyMatch;
    }

    return null;
  }

  function resolveUnderbedVariantForCurrentSize(product, requireExactSizeMatch) {
    if (!product || !Array.isArray(product.variants) || product.variants.length === 0) return null;
    const selectedSize = getCurrentMattressSizeValue();
    if (selectedSize) {
      const exactVariant = findUnderbedVariantForSize(product, selectedSize);
      if (exactVariant) return exactVariant;
      if (requireExactSizeMatch) return null;
    }
    const firstAvailable = product.variants.find(function (v) { return isVariantSellable(v); });
    return firstAvailable || product.variants[0] || null;
  }

  function getUnderbedProductDiscountPercent(product) {
    if (product && product.discountPercentage != null && product.discountPercentage !== '') {
      var n = parseFloat(product.discountPercentage);
      if (!isNaN(n) && n > 0) return n;
    }
    return getPdpDisplayDiscountPercent();
  }

  function getUnderbedDisplayDiscount(product, variant) {
    var entry = getVariantDiscountEntry(variant, product);
    if (entry) {
      var amt = parseFloat(entry.discountAmount) || 0;
      var pct = parseFloat(entry.discountPercentage) || 0;
      if (amt > 0) return { percent: 0, amount: amt };
      if (pct > 0) return { percent: pct, amount: 0 };
    }
    return { percent: getUnderbedProductDiscountPercent(product), amount: 0 };
  }

  function formatFoundationAddonPriceHtml(priceCents, compareAtCents, discountPct, discountAmount) {
    var price = Math.round(Number(priceCents) || 0);
    if (!(price > 0)) return escapeHtmlText(formatMoney(price));

    var pct = discountPct != null ? discountPct : getPdpDisplayDiscountPercent();
    var amt = discountAmount != null ? discountAmount : 0;
    var resolved;
    if (window.SuaveDisplayDiscount && typeof window.SuaveDisplayDiscount.resolvePrices === 'function') {
      resolved = window.SuaveDisplayDiscount.resolvePrices(price, compareAtCents, pct, amt);
    } else {
      var sale = price;
      if (amt > 0) {
        sale = Math.max(0, price - Math.round(Number(amt) * 100));
        resolved = {
          saleCents: sale,
          compareCents: price > sale ? price : null
        };
      } else {
        var p = parseFloat(pct);
        if (!isNaN(p) && p > 0) {
          sale = Math.max(0, price - Math.round((price * p) / 100));
          resolved = {
            saleCents: sale,
            compareCents: price > sale ? price : null
          };
        } else {
          var compare = compareAtCents != null && compareAtCents !== '' ? Math.round(Number(compareAtCents) || 0) : 0;
          resolved = {
            saleCents: sale,
            compareCents: compare > sale ? compare : null
          };
        }
      }
    }

    var saleText = '+' + formatMoney(resolved.saleCents);
    if (resolved.compareCents != null && resolved.compareCents > resolved.saleCents) {
      return (
        '<s class="foundation-price-compare">+' +
        escapeHtmlText(formatMoney(resolved.compareCents)) +
        '</s><span class="foundation-price-sale">' +
        escapeHtmlText(saleText) +
        '</span>'
      );
    }
    return escapeHtmlText(saleText);
  }

  function buildNoFoundationOptionHtml(checked) {
    const cfg = getUnderbedConfig();
    const title = (cfg && cfg.noFoundationLabel) ? String(cfg.noFoundationLabel).trim() : suaveT('noFoundation', 'No Foundation');
    const subtitle = (cfg && cfg.noFoundationSubtitle)
      ? String(cfg.noFoundationSubtitle).trim()
      : `Select ${title} model for your bed setup.`;
    const noFoundationType = escapeHtmlText(title);
    return `
      <label class="foundation-option foundation-option--no-foundation${checked ? ' selected' : ''}"
             data-foundation-choice="none"
             data-foundation-type="${noFoundationType}">
        <input type="radio" name="underbed" value=""
               data-foundation-choice="none"
               data-foundation-type="${noFoundationType}"
               data-price="0"
               ${checked ? 'checked' : ''}
               class="foundation-input">
        <span class="foundation-indicator"></span>
        <div class="foundation-content">
          <p class="foundation-title ${checked ? 'pdp-text-color' : ''}">${escapeHtmlText(title)}</p>
          <p class="foundation-subtitle" style="color: #666;">${escapeHtmlText(subtitle)}</p>
        </div>
        <p class="foundation-price foundation-price--no-foundation ${checked ? 'pdp-text-color' : ''}" data-no-foundation-price>${formatMoney(0)}</p>
      </label>
    `;
  }

  function buildUnderbedCollectionOptionHtml(product, checked) {
    const selectedSize = getCurrentMattressSizeValue();
    const sizeMatchedVariant = resolveUnderbedVariantForCurrentSize(product, !!selectedSize);
    const hasSizeMatch = !!sizeMatchedVariant;
    const isAvailable = selectedSize
      ? hasSizeMatch && isVariantSellable(sizeMatchedVariant)
      : !!(product.variants && product.variants.some(isVariantSellable));
    const price = sizeMatchedVariant && typeof sizeMatchedVariant.price === 'number'
      ? sizeMatchedVariant.price
      : (selectedSize ? 0 : (typeof product.price === 'number' ? product.price : 0));
    const compareAt = sizeMatchedVariant && sizeMatchedVariant.compare_at_price != null
      ? sizeMatchedVariant.compare_at_price
      : (product.compare_at_price != null ? product.compare_at_price : null);
    const subtitle = selectedSize && !hasSizeMatch
      ? suavePdpT('notAvailableInSize', 'Not available in selected size')
      : suaveFoundationModelSubtitle(product.title || '');
    const foundationType = product.title || '';
    // Unavailable: badge + subtitle only (never also put "Not Available" in the price slot)
    const priceHtml = selectedSize && !isAvailable
      ? ''
      : (function () {
          var disc = getUnderbedDisplayDiscount(product, sizeMatchedVariant);
          return formatFoundationAddonPriceHtml(price, compareAt, disc.percent, disc.amount);
        })();
    return `
      <label class="foundation-option underbed-option${checked ? ' selected' : ''}${selectedSize && !isAvailable ? ' out-of-stock' : ''}"
             data-underbed-handle="${escapeAttr(product.handle)}"
             data-foundation-type="${escapeAttr(foundationType)}"
             data-variant-image="${product.image ? escapeAttr(product.image) : ''}"
             data-size-available="${selectedSize && !isAvailable ? 'false' : 'true'}">
        ${selectedSize && !isAvailable ? '<span class="out-of-stock-badge foundation-size-na-badge">' + suavePdpT('notAvailable', 'Not Available') + '</span>' : ''}
        <input type="radio" name="underbed" value="${escapeAttr(product.handle)}"
               data-underbed-product-id="${escapeAttr(product.id)}"
               data-underbed-handle="${escapeAttr(product.handle)}"
               data-foundation-type="${escapeAttr(foundationType)}"
               data-underbed-variant-id="${sizeMatchedVariant && isAvailable ? escapeAttr(sizeMatchedVariant.id) : ''}"
               data-price="${isAvailable ? price : 0}"
               ${checked && isAvailable ? 'checked' : ''}
               ${selectedSize && !isAvailable ? 'disabled' : ''}
               class="foundation-input">
        <span class="foundation-indicator"></span>
        <div class="foundation-content">
          <p class="foundation-title ${checked ? 'pdp-text-color' : ''}">${escapeHtmlText(product.title)}</p>
          <p class="foundation-subtitle" style="color: ${selectedSize && !isAvailable ? '#ff4444' : '#666'};">
            ${escapeHtmlText(subtitle)}
          </p>
        </div>
        <p class="foundation-price ${checked ? 'pdp-text-color' : ''}"${selectedSize && !isAvailable ? ' hidden' : ''}>${priceHtml}</p>
      </label>
    `;
  }

  const underbedLiveProductCache = new Map();

  async function hydrateUnderbedProductFromStorefront(product) {
    if (!product || !product.handle || !suavePdpIsSpanishLocale()) return product;
    const handle = product.handle;
    if (underbedLiveProductCache.has(handle)) {
      return underbedLiveProductCache.get(handle);
    }
    try {
      const res = await fetch(suavePdpProductJsonUrl(handle));
      if (!res.ok) return product;
      const live = await res.json();
      const hydrated = Object.assign({}, product, {
        title: live.title || product.title,
        option_names: live.options || product.option_names,
        variants: (live.variants || []).map(function (v) {
          return {
            id: v.id,
            available: v.available,
            inventory_quantity: v.inventory_quantity,
            inventory_policy: v.inventory_policy,
            inventory_management: v.inventory_management,
            price: v.price,
            compare_at_price: v.compare_at_price,
            option1: v.option1,
            option2: v.option2,
            option3: v.option3,
            options: v.options
          };
        })
      });
      underbedLiveProductCache.set(handle, hydrated);
      return hydrated;
    } catch (e) {
      return product;
    }
  }

  let underbedRefreshPromise = null;

  async function refreshUnderbedCollectionCardPricesAsync() {
    if (underbedRefreshPromise) return underbedRefreshPromise;
    underbedRefreshPromise = refreshUnderbedCollectionCardPricesAsyncImpl().finally(function () {
      underbedRefreshPromise = null;
    });
    return underbedRefreshPromise;
  }

  async function refreshUnderbedCollectionCardPricesAsyncImpl() {
    const cfg = getUnderbedConfig();
    const container = document.getElementById('foundation-options-container');
    if (!cfg || !cfg.products || !container) return;

    if (suavePdpIsSpanishLocale()) {
      cfg.products = await Promise.all(cfg.products.map(hydrateUnderbedProductFromStorefront));
    }

    container.querySelectorAll('.underbed-option').forEach((cardEl) => {
      try {
        const handle = cardEl.getAttribute('data-underbed-handle') || '';
        if (!handle) return;
        const product = cfg.products.find((p) => p && p.handle === handle);
        if (!product) return;

        const selectedSize = getCurrentMattressSizeValue();
        const variant = resolveUnderbedVariantForCurrentSize(product, !!selectedSize);
        const price = variant && typeof variant.price === 'number'
          ? variant.price
          : (selectedSize ? 0 : (typeof product.price === 'number' ? product.price : 0));
        const compareAt = variant && variant.compare_at_price != null
          ? variant.compare_at_price
          : (product.compare_at_price != null ? product.compare_at_price : null);
        const isAvailable = selectedSize
          ? !!(variant && isVariantSellable(variant))
          : !!(product.variants && product.variants.some(isVariantSellable));

        const input = cardEl.querySelector('input[name="underbed"]');
        if (input) {
          input.setAttribute('data-price', String(isAvailable ? price : 0));
          input.setAttribute(
            'data-underbed-variant-id',
            variant && isAvailable ? String(variant.id) : ''
          );
          if (selectedSize && !isAvailable) {
            input.disabled = true;
            input.checked = false;
          } else {
            input.removeAttribute('disabled');
          }
        }

        const subtitleEl = cardEl.querySelector('.foundation-subtitle');
        if (subtitleEl) {
          subtitleEl.textContent = selectedSize && !isAvailable
            ? suavePdpT('notAvailableInSize', 'Not available in selected size')
            : suaveFoundationModelSubtitle(product.title || '');
          subtitleEl.style.color = selectedSize && !isAvailable ? '#ff4444' : '#666';
        }

        const titleEl = cardEl.querySelector('.foundation-title');
        if (titleEl && product.title) {
          titleEl.textContent = product.title;
        }

        const foundationTypeAttr = product.title || '';
        cardEl.setAttribute('data-foundation-type', foundationTypeAttr);
        cardEl.setAttribute('data-size-available', selectedSize && !isAvailable ? 'false' : 'true');
        if (input) {
          input.setAttribute('data-foundation-type', foundationTypeAttr);
        }

        const priceEl = cardEl.querySelector('.foundation-price');
        if (priceEl) {
          if (selectedSize && !isAvailable) {
            // Badge + subtitle carry the message — keep price slot empty to avoid overlap
            priceEl.textContent = '';
            priceEl.innerHTML = '';
            priceEl.hidden = true;
            priceEl.setAttribute('hidden', '');
          } else {
            priceEl.hidden = false;
            priceEl.removeAttribute('hidden');
            var disc = getUnderbedDisplayDiscount(product, variant);
            priceEl.innerHTML = formatFoundationAddonPriceHtml(price, compareAt, disc.percent, disc.amount);
          }
        }

        cardEl.classList.toggle('out-of-stock', selectedSize && !isAvailable);
        if (selectedSize && !isAvailable) {
          cardEl.classList.remove('selected');
        }

        // Single Not Available badge only (remove duplicates)
        cardEl.querySelectorAll('.out-of-stock-badge').forEach(function (b) {
          b.remove();
        });
        if (selectedSize && !isAvailable) {
          const span = document.createElement('span');
          span.className = 'out-of-stock-badge foundation-size-na-badge';
          span.textContent = suavePdpT('notAvailable', 'Not Available');
          cardEl.insertBefore(span, cardEl.firstChild);
        }
      } catch (cardErr) {
        console.warn('underbed card price refresh failed', cardErr);
      }
    });

    const selectedUnderbedInput = getSelectedUnderbedInput();
    if (selectedUnderbedInput) {
      if (
        selectedUnderbedInput.disabled ||
        !selectedUnderbedInput.getAttribute('data-underbed-variant-id')
      ) {
        clearUnderbedSelection(container);
      } else {
        syncCurrentFoundationFromUnderbedInput(selectedUnderbedInput);
      }
    } else {
      syncUnderbedCheckedFromSelected(container);
    }
    // Cards now have size-matched prices — refresh main total without looping refresh
    updateTotalPrice({ skipUnderbedRefresh: true });
  }

  function refreshUnderbedCollectionCardPrices() {
    refreshUnderbedCollectionCardPricesAsync().catch(function (err) {
      console.warn('refreshUnderbedCollectionCardPrices failed', err);
    });
  }

  function attachUnderbedFoundationListeners(foundationContainer) {
    foundationContainer.querySelectorAll('.underbed-option').forEach((optionEl) => {
      optionEl.addEventListener('click', function (event) {
        const handle = this.getAttribute('data-underbed-handle') || '';
        if (!handle) return;

        const input = this.querySelector('input[name="underbed"]');
        if (!input) return;

        const selectedSize = getCurrentMattressSizeValue();
        if (selectedSize && !input.getAttribute('data-underbed-variant-id')) {
          return;
        }

        const wasSelected = this.classList.contains('selected');
        if (wasSelected) {
          event.preventDefault();
          event.stopPropagation();
          clearUnderbedSelection(foundationContainer);
          syncMattressModelFromUnderbedSelection();
          refreshUnderbedMattressGallery();
          updateVariantNameDisplay();
          updateButtonStates();
          updateTotalPrice();
          return;
        }

        event.preventDefault();
        const cfg = getUnderbedConfig();
        const product = cfg && cfg.products ? cfg.products.find((p) => p.handle === handle) : null;
        selectedUnderbedProduct = product || { handle: handle };
        selectedFoundationType = product && product.title ? String(product.title).trim() : handle;
        selectedModelValue = '';
        isFoundationSelected = true;
        foundationContainer.querySelectorAll('input[name="underbed"]').forEach((i) => { i.checked = false; });
        selectFoundationOptionElement(this, foundationContainer);
        input.checked = true;
        syncCurrentFoundationFromUnderbedInput(input);
        syncMattressModelFromUnderbedSelection();
        refreshUnderbedMattressGallery();
        updateVariantNameDisplay();
        updateButtonStates();
        updateTotalPrice();
      });
    });
  }

  /** Collection bases only — optional add-ons; default cart model is No Foundation. */
  async function renderUnderbedFoundationSection() {
    const cfg = getUnderbedConfig();
    const foundationContainer = document.getElementById('foundation-options-container');
    if (!cfg || !cfg.products.length || !foundationContainer) return false;

    try {
      let html = '';
      cfg.products.forEach((product) => {
        html += buildUnderbedCollectionOptionHtml(product, false);
      });

      foundationContainer.innerHTML = html;
      clearUnderbedSelection(foundationContainer);

      attachUnderbedFoundationListeners(foundationContainer);
      try {
        await refreshUnderbedCollectionCardPricesAsync();
      } catch (refreshErr) {
        console.warn('Underbed price refresh failed:', refreshErr);
      }
      try {
        syncMattressModelFromUnderbedSelection();
      } catch (syncErr) {
        console.warn('Underbed mattress model sync failed:', syncErr);
      }
      try {
        refreshUnderbedMattressGallery();
      } catch (galleryErr) {
        console.warn('Underbed gallery refresh failed:', galleryErr);
      }
      return true;
    } catch (err) {
      console.error('Underbed foundation render failed:', err);
      return false;
    }
  }

  // Function to load foundation options for a mattress product
  async function loadFoundationOptions(mattressProductHandle) {
    const foundationContainer = document.getElementById('foundation-options-container');
    
    if (!foundationContainer) {
      return;
    }
    
    // Show loading state
    foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('loadingFoundation', 'Loading foundation options...') + '</p>';
    
    try {
      let productForFoundation = resolveMattressProductForFoundation(mattressProductHandle);
      if (!productForFoundation && mattressProductHandle) {
        try {
          const response = await fetch(suavePdpProductJsonUrl(mattressProductHandle));
          if (response.ok) {
            productForFoundation = await response.json();
          }
        } catch (fetchErr) {
          console.warn('Could not fetch mattress for foundation options:', fetchErr);
        }
      }

      // Underbed collection: optional base add-ons from collection (no "No Foundation" card)
      if (await renderUnderbedFoundationSection()) {
        return;
      }

      // Mattress variant "model" dimension when no underbed collection is configured
      if (productForFoundation) {
        const renderedModels = renderModelOptionsForCurrentProduct(productForFoundation);
        if (renderedModels) {
          return;
        }
      }

      // METHOD 1: Try to get foundation product from active tab data attribute FIRST
      const activeTab = document.querySelector('#custom-product-container .tab.active');
      let foundationProductHandle = null;
      
      if (activeTab) {
        const tabFoundationProduct = activeTab.getAttribute('data-foundation-product');
        if (tabFoundationProduct && tabFoundationProduct !== '' && tabFoundationProduct !== 'null') {
          foundationProductHandle = tabFoundationProduct;
        }
      }
      
      // METHOD 2: If not in tab data, try metafield
      if (!foundationProductHandle) {
        foundationProductHandle = await getFoundationProductFromMetafield(mattressProductHandle);
      }
      
      // METHOD 3: Fallback to section settings
      if (!foundationProductHandle || foundationProductHandle === '' || foundationProductHandle === 'null') {
        // eslint-disable-next-line no-unused-vars -- Liquid replaced at build/render
        const defaultFoundationProduct = typeof window.__SECTION_FOUNDATION_PRODUCT__ !== 'undefined' ? window.__SECTION_FOUNDATION_PRODUCT__ : null;
        if (defaultFoundationProduct && defaultFoundationProduct !== '') {
          foundationProductHandle = defaultFoundationProduct;
        }
      }
      
      // If we found a foundation product, load it
      if (foundationProductHandle && foundationProductHandle !== '' && foundationProductHandle !== 'null') {
        await loadFoundationProduct(foundationProductHandle);
      } else {
        foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('noFoundationOptions', 'No foundation options available for this mattress.') + '</p>';
      }
      
    } catch (error) {
      console.error('💥 Error loading foundation options:', error);
      foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('unableLoadFoundation', 'Unable to load foundation options.') + '</p>';
    }
  }
  
  // Function to merge foundation metafields from data attributes
  function mergeFoundationMetafields(foundationProduct) {
    // Get active tab to find foundation metafields
    const activeTab = document.querySelector('#custom-product-container .tab.active');
    if (!activeTab || !foundationProduct || !foundationProduct.variants) return foundationProduct;
    
    // Get foundation metafields from data attribute
    const foundationMetafieldsData = activeTab.getAttribute('data-foundation-variant-metafields');
    
    if (foundationMetafieldsData) {
      // Parse metafields data: format is "variantId:field1|field2|field3||variantId2:..."
      const variantMetafields = foundationMetafieldsData.split('||');
      
      // Create a map of variant ID to its index in the foundation product
      const variantIndexMap = {};
      foundationProduct.variants.forEach((v, index) => {
        variantIndexMap[v.id.toString()] = index;
      });
      
      variantMetafields.forEach((variantData) => {
        if (variantData) {
          const [variantId, metafields] = variantData.split(':');
          if (variantId && metafields) {
            const fields = metafields.split('|');
            const variant = foundationProduct.variants.find(v => v.id.toString() === variantId);
            const variantIndex = variantIndexMap[variantId];
            
            if (variant && variantIndex !== undefined) {
              if (!variant.metafields) variant.metafields = {};
              if (!variant.metafields.custom) variant.metafields.custom = {};
              
              // Set only the metafield that corresponds to this variant's index (0, 1, 2)
              // Variant at index 0 gets foundation_product_variant_metafield
              // Variant at index 1 gets foundation_product_variant_metafield_2
              // Variant at index 2 gets foundation_product_variant_metafield_3
              if (variantIndex === 0 && fields[0] && fields[0].trim() !== '') {
                variant.metafields.custom.foundation_product_variant_metafield = fields[0];
              } else if (variantIndex === 1 && fields[1] && fields[1].trim() !== '') {
                variant.metafields.custom.foundation_product_variant_metafield_2 = fields[1];
              } else if (variantIndex === 2 && fields[2] && fields[2].trim() !== '') {
                variant.metafields.custom.foundation_product_variant_metafield_3 = fields[2];
              } else {
                // Fallback: try to find any non-empty metafield for this variant
                const availableField = fields.find(f => f && f.trim() !== '');
                if (availableField) {
                  if (variantIndex === 0) {
                    variant.metafields.custom.foundation_product_variant_metafield = availableField;
                  } else if (variantIndex === 1) {
                    variant.metafields.custom.foundation_product_variant_metafield_2 = availableField;
                  } else if (variantIndex === 2) {
                    variant.metafields.custom.foundation_product_variant_metafield_3 = availableField;
                  }
                }
              }
            }
          }
        }
      });
    }
    
    return foundationProduct;
  }

  function escapeAttr(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
  }

  function escapeHtmlText(s) {
    return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

// Function to load foundation product - UPDATED with flexible image matching
async function loadFoundationProduct(foundationProductHandle) {
  const foundationContainer = document.getElementById('foundation-options-container');
  
  if (!foundationContainer) return;
  
  selectedFoundationType = null;
  
  try {
    // Fetch foundation product data
    const response = await fetch(suavePdpProductJsonUrl(foundationProductHandle));
    if (!response.ok) {
      throw new Error(`Failed to fetch foundation product: ${response.status}`);
    }
    
    let foundationProduct = await response.json();
    
    // First try to merge from data attributes (faster, more reliable)
    foundationProduct = mergeFoundationMetafields(foundationProduct);
    
    // Then try to fetch from API as fallback
    foundationProduct = await fetchFoundationVariantMetafields(foundationProduct);
    
    // Ensure handle is set
    if (!foundationProduct.handle) {
      foundationProduct.handle = foundationProductHandle;
    }
    currentFoundationProduct = foundationProduct;
    
    if (!foundationProduct.variants || foundationProduct.variants.length === 0) {
      foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('noFoundationVariants', 'No foundation variants available.') + '</p>';
      if (typeof window.rebuildCustomDropdown === 'function') {
        window.rebuildCustomDropdown();
      }
      return;
    }
    
    // Ensure firmness header title is set correctly
    const firmnessTitleElement = document.querySelector('#firmness-section .section-title');
    if (firmnessTitleElement) {
      firmnessTitleElement.textContent = suavePdpT('chooseComfort', 'Choose your comfort preference.');
      currentFirmnessTitle = suavePdpT('chooseComfort', 'Choose your comfort preference.');
    }
    
    let foundationHTML = '';
    let hasAvailableVariant = false;
    let firstAvailableVariantIndex = -1;
    
    // Get the active tab to find which mattress product's foundation metafields to use
    const activeTab = document.querySelector('#custom-product-container .tab.active');
    const mattressProductHandle = activeTab ? activeTab.getAttribute('data-product-handle') : null;
    
    // Foundation product with 2 options: Size (hidden) + Foundation Type. Show one option per Foundation Type; size syncs with mattress size.
    const hasTwoOptions = foundationProduct.options && foundationProduct.options.length >= 2;
    // Foundation product with only size variants: hide size, show 3 "foundation type" options (Breeze etc.); variant = mattress size.
    const hasOneOption = foundationProduct.options && foundationProduct.options.length === 1;
    const currentSizeValue = getCurrentMattressSizeValue();
    
    if (hasOneOption) {
      // Size-only foundation: show 3 foundation type options (labels from tab metafields); actual variant = by mattress size
      const metafieldsRaw = activeTab ? activeTab.getAttribute('data-foundation-variant-metafields') : '';
      const typeLabels = [];
      const subtitleMetafieldsOne = [];
      if (metafieldsRaw) {
        const entries = metafieldsRaw.split('||').filter(Boolean);
        for (let i = 0; i < 3 && i < entries.length; i++) {
          const part = entries[i].split(':');
          const label = (part[1] != null ? part[1] : '').trim();
          if (label) typeLabels.push(label);
          subtitleMetafieldsOne.push((part[1] != null ? part[1] : '').toString().trim());
        }
      }
      if (typeLabels.length === 0) {
        typeLabels.push('Foundation 1', 'Foundation 2', 'Foundation 3');
      }
      const resolvedVariant = getFoundationVariantBySize(foundationProduct, currentSizeValue);
      const displayVariant = resolvedVariant || null;
      typeLabels.forEach(function (label, typeIndex) {
        const variant = resolvedVariant;
        const sizeMismatch = !variant;
        if (sizeMismatch) {
          let mismatchSubtitle = (subtitleMetafieldsOne[typeIndex] != null ? subtitleMetafieldsOne[typeIndex] : '').toString().trim();
          if (!mismatchSubtitle && metafieldsRaw && mattressProductHandle && foundationMetafieldsByProduct) {
            const entries = metafieldsRaw.split('||').filter(Boolean);
            if (entries[typeIndex]) {
              const variantId = entries[typeIndex].split(':')[0];
              if (variantId) {
                const foundationMap = foundationMetafieldsByProduct.get(mattressProductHandle);
                const mf = foundationMap ? foundationMap.get(variantId.trim()) : null;
                if (mf) {
                  mismatchSubtitle = (mf.value && mf.value.trim() !== '') ? mf.value.trim() : (mf.foundation_product_variant_metafield || mf.foundation_product_variant_metafield_2 || mf.foundation_product_variant_metafield_3 || '');
                }
              }
            }
          }
          if (!mismatchSubtitle) {
            const fallbackV = foundationProduct.variants[typeIndex] || foundationProduct.variants[0];
            mismatchSubtitle = fallbackV ? (fallbackV.title || '') : '';
          }
          const badgeHtml = '<span class="out-of-stock-badge foundation-size-na-badge">' + suavePdpT('notAvailable', 'Not Available') + '</span>';
          foundationHTML += `
          <label class="foundation-option foundation-option-size-synced size-unavailable out-of-stock" 
                 data-foundation-type="${(label || '').replace(/"/g, '&quot;')}"
                 data-foundation-subtitle-default="${escapeAttr(mismatchSubtitle)}"
                 data-variant-id=""
                 data-variant-title="${(label || 'Foundation').replace(/"/g, '&quot;')}"
                 data-variant-price="0"
                 data-variant-compare-price=""
                 data-variant-available="false"
                 data-size-mismatch="true"
                 data-variant-inventory="0"
                 data-variant-inventory-policy="deny"
                 data-variant-inventory-management="shopify"
                 data-variant-image=""
                 data-variant-alt="${(label || '') + ' - ' + (foundationProduct.title || '')}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${badgeHtml}
            <input type="radio" name="foundation" value=""
                   data-foundation-type="${(label || '').replace(/"/g, '&quot;')}"
                   data-variant-id="" data-product-id="${foundationProduct.id}" data-product-handle="${foundationProduct.handle}" data-product-title="${(foundationProduct.title || '').replace(/"/g, '&quot;')}"
                   data-price="0" data-variant-title="${(label || 'Foundation').replace(/"/g, '&quot;')}"
                   data-variant-available="false" data-variant-inventory="0"
                   data-variant-inventory-policy="deny" data-variant-inventory-management="shopify"
                   disabled class="foundation-input">
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title">${(label || 'Foundation').replace(/</g, '&lt;')}</p>
              <p class="foundation-subtitle" style="color: #666;">
                ${escapeHtmlText(mismatchSubtitle)}
              </p>
            </div>
            <p class="foundation-price">—</p>
          </label>
        `;
          return;
        }
        const variantId = variant.id.toString();
        // Option 1 → foundation_product_variant_metafield, option 2 → _2, option 3 → _3
        let foundationMetafieldText = (subtitleMetafieldsOne[typeIndex] != null ? subtitleMetafieldsOne[typeIndex] : '').toString().trim();
        if (!foundationMetafieldText && mattressProductHandle && foundationMetafieldsByProduct) {
          const foundationMap = foundationMetafieldsByProduct.get(mattressProductHandle);
          if (foundationMap) {
            const metafields = foundationMap.get(variantId);
            if (metafields) {
              const v = (metafields.value && metafields.value.trim() !== '') ? metafields.value.trim() : (metafields.foundation_product_variant_metafield || metafields.foundation_product_variant_metafield_2 || metafields.foundation_product_variant_metafield_3 || '');
              if (v) foundationMetafieldText = v;
            }
          }
        }
        let isAvailable = false;
        if (variant.available === true) isAvailable = true;
        else if (variant.inventory_policy === 'continue') isAvailable = true;
        else if (variant.inventory_quantity != null && variant.inventory_quantity > 0) isAvailable = true;
        else if (variant.inventory_management == null && variant.available !== false) isAvailable = true;
        if (isAvailable && firstAvailableVariantIndex === -1) { firstAvailableVariantIndex = typeIndex; hasAvailableVariant = true; }
        const hasFeaturedImage = (displayVariant && displayVariant.featured_image && displayVariant.featured_image.src) || (variant.featured_image && variant.featured_image.src);
        const isFirstAvailable = typeIndex === firstAvailableVariantIndex && isAvailable;
        foundationHTML += `
          <label class="foundation-option foundation-option-size-synced${isFirstAvailable ? ' selected' : ''}${!isAvailable ? ' out-of-stock' : ''}" 
                 data-foundation-type="${(label || '').replace(/"/g, '&quot;')}"
                 data-foundation-subtitle-default="${escapeAttr(foundationMetafieldText)}"
                 data-variant-id="${variant.id}" 
                 data-variant-title="${(label || variant.title || 'Default Title').replace(/"/g, '&quot;')}"
                 data-variant-price="${variant.price || 0}"
                 data-variant-compare-price="${variant.compare_at_price || ''}"
                 data-variant-available="${isAvailable}"
                 data-variant-inventory="${variant.inventory_quantity || 0}"
                 data-variant-inventory-policy="${variant.inventory_policy || 'deny'}"
                 data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                 data-variant-image="${hasFeaturedImage ? (variant.featured_image && variant.featured_image.src ? variant.featured_image.src : (displayVariant && displayVariant.featured_image && displayVariant.featured_image.src) || '') : ''}"
                 data-variant-alt="${(label || '') + ' - ' + (foundationProduct.title || '')}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${!isAvailable ? '<span class="out-of-stock-badge">Out of Stock</span>' : ''}
            <input type="radio" name="foundation" value="${variant.id}" 
                   data-foundation-type="${(label || '').replace(/"/g, '&quot;')}"
                   data-variant-id="${variant.id}" data-product-id="${foundationProduct.id}" data-product-handle="${foundationProduct.handle}" data-product-title="${(foundationProduct.title || '').replace(/"/g, '&quot;')}"
                   data-price="${variant.price || 0}" data-variant-title="${(label || variant.title || 'Default Title').replace(/"/g, '&quot;')}"
                   data-variant-available="${isAvailable}" data-variant-inventory="${variant.inventory_quantity || 0}"
                   data-variant-inventory-policy="${variant.inventory_policy || 'deny'}" data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                   ${isFirstAvailable ? 'checked' : ''} class="foundation-input" ${!isAvailable ? 'disabled' : ''}>
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title ${isFirstAvailable ? 'pdp-text-color' : ''}">${(label || 'Foundation').replace(/</g, '&lt;')}</p>
              <p class="foundation-subtitle" style="color: ${isAvailable ? '#666' : '#ff4444'};">
                ${(isAvailable ? foundationMetafieldText : suavePdpT('outOfStock', 'Out of Stock')).replace(/</g, '&lt;')}
              </p>
            </div>
            <p class="foundation-price ${isFirstAvailable ? 'pdp-text-color' : ''}">${(variant.price && variant.price > 0) ? '+' + formatMoney(variant.price) : formatMoney(variant.price || 0)}</p>
          </label>
        `;
      });
    } else if (hasTwoOptions) {
      // Option1 = Foundation Type (No foundation, Base, Adjustable, etc.), Option2 = Size. Show only Foundation Type; size syncs with mattress.
      // Subtitle: option 1 → foundation_product_variant_metafield, option 2 → _2, option 3 → _3 (from tab data-foundation-variant-metafields: first 3 variant values)
      const foundationVariantMetafieldsRaw = activeTab ? activeTab.getAttribute('data-foundation-variant-metafields') : '';
      const subtitleMetafields = [];
      if (foundationVariantMetafieldsRaw) {
        const entries = foundationVariantMetafieldsRaw.split('||').filter(Boolean);
        for (let i = 0; i < 3 && i < entries.length; i++) {
          const part = entries[i].split(':');
          const val = (part[1] != null ? part[1] : '').toString().trim();
          subtitleMetafields.push(val);
        }
      }
      const foundationTypes = [...new Set(foundationProduct.variants.map(function (v) {
        return (v.option1 || (v.options && v.options[0]) || '').toString().trim();
      }).filter(Boolean))];
      foundationTypes.forEach(function (foundationType, typeIndex) {
        const variant = getFoundationVariantBySizeAndType(foundationProduct, currentSizeValue, foundationType);
        const sizeMismatch = !variant;
        if (sizeMismatch) {
          let mismatchSubtitle = (subtitleMetafields[typeIndex] != null ? subtitleMetafields[typeIndex] : '').toString().trim();
          const anyForType = getFirstVariantForFoundationType(foundationProduct, foundationType);
          if (!mismatchSubtitle && anyForType && mattressProductHandle && foundationMetafieldsByProduct) {
            const foundationMap = foundationMetafieldsByProduct.get(mattressProductHandle);
            const mf = foundationMap ? foundationMap.get(anyForType.id.toString()) : null;
            if (mf) {
              mismatchSubtitle = (mf.value && mf.value.trim() !== '') ? mf.value.trim() : (mf.foundation_product_variant_metafield || mf.foundation_product_variant_metafield_2 || mf.foundation_product_variant_metafield_3 || '');
            }
          }
          if (!mismatchSubtitle && anyForType) {
            mismatchSubtitle = anyForType.title || '';
          }
          const badgeHtml = '<span class="out-of-stock-badge foundation-size-na-badge">' + suavePdpT('notAvailable', 'Not Available') + '</span>';
          foundationHTML += `
          <label class="foundation-option size-unavailable out-of-stock" 
                 data-foundation-type="${(foundationType || '').replace(/"/g, '&quot;')}"
                 data-foundation-subtitle-default="${escapeAttr(mismatchSubtitle)}"
                 data-variant-id=""
                 data-variant-title="${(foundationType || 'Default Title').replace(/"/g, '&quot;')}"
                 data-variant-price="0"
                 data-variant-compare-price=""
                 data-variant-available="false"
                 data-size-mismatch="true"
                 data-variant-inventory="0"
                 data-variant-inventory-policy="deny"
                 data-variant-inventory-management="shopify"
                 data-variant-image=""
                 data-variant-alt="${(foundationType || '') + ' - ' + (foundationProduct.title || '')}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${badgeHtml}
            <input type="radio" name="foundation" value=""
                   data-foundation-type="${(foundationType || '').replace(/"/g, '&quot;')}"
                   data-variant-id="" data-product-id="${foundationProduct.id}" data-product-handle="${foundationProduct.handle}" data-product-title="${(foundationProduct.title || '').replace(/"/g, '&quot;')}"
                   data-price="0" data-variant-title="${(foundationType || 'Default Title').replace(/"/g, '&quot;')}"
                   data-variant-available="false" data-variant-inventory="0"
                   data-variant-inventory-policy="deny" data-variant-inventory-management="shopify"
                   disabled class="foundation-input">
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title">${(foundationType || 'Default Title').replace(/</g, '&lt;')}</p>
              <p class="foundation-subtitle" style="color: #666;">
                ${escapeHtmlText(mismatchSubtitle)}
              </p>
            </div>
            <p class="foundation-price">—</p>
          </label>
        `;
          return;
        }
        const variantId = variant.id.toString();
        // Option 1 (typeIndex 0) → foundation_product_variant_metafield, option 2 → _2, option 3 → _3
        let foundationMetafieldText = (subtitleMetafields[typeIndex] != null ? subtitleMetafields[typeIndex] : '').toString().trim();
        if (!foundationMetafieldText && foundationMetafieldsByProduct) {
          const foundationMap = mattressProductHandle ? foundationMetafieldsByProduct.get(mattressProductHandle) : null;
          if (foundationMap) {
            const metafields = foundationMap.get(variantId);
            if (metafields) {
              foundationMetafieldText = (metafields.value && metafields.value.trim() !== '') ? metafields.value.trim() : (metafields.foundation_product_variant_metafield || metafields.foundation_product_variant_metafield_2 || metafields.foundation_product_variant_metafield_3 || '');
            }
          }
        }
        if (!foundationMetafieldText || foundationMetafieldText.trim() === '') foundationMetafieldText = variant.title || '';
        let isAvailable = false;
        if (variant.available === true) isAvailable = true;
        else if (variant.inventory_policy === 'continue') isAvailable = true;
        else if (variant.inventory_quantity != null && variant.inventory_quantity > 0) isAvailable = true;
        else if (variant.inventory_management == null && variant.available !== false) isAvailable = true;
        if (isAvailable && firstAvailableVariantIndex === -1) { firstAvailableVariantIndex = typeIndex; hasAvailableVariant = true; }
        const hasFeaturedImage = variant.featured_image && variant.featured_image.src;
        const isFirstAvailable = typeIndex === firstAvailableVariantIndex && isAvailable;
        foundationHTML += `
          <label class="foundation-option${isFirstAvailable ? ' selected' : ''}${!isAvailable ? ' out-of-stock' : ''}" 
                 data-foundation-type="${(foundationType || '').replace(/"/g, '&quot;')}"
                 data-foundation-subtitle-default="${escapeAttr(foundationMetafieldText)}"
                 data-variant-id="${variant.id}" 
                 data-variant-title="${(variant.title || 'Default Title').replace(/"/g, '&quot;')}"
                 data-variant-price="${variant.price || 0}"
                 data-variant-compare-price="${variant.compare_at_price || ''}"
                 data-variant-available="${isAvailable}"
                 data-variant-inventory="${variant.inventory_quantity || 0}"
                 data-variant-inventory-policy="${variant.inventory_policy || 'deny'}"
                 data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                 data-variant-image="${hasFeaturedImage ? variant.featured_image.src : ''}"
                 data-variant-alt="${(variant.title || '') + ' - ' + (foundationProduct.title || '')}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${!isAvailable ? '<span class="out-of-stock-badge">Out of Stock</span>' : ''}
            <input type="radio" name="foundation" value="${variant.id}" 
                   data-foundation-type="${(foundationType || '').replace(/"/g, '&quot;')}"
                   data-variant-id="${variant.id}" data-product-id="${foundationProduct.id}" data-product-handle="${foundationProduct.handle}" data-product-title="${(foundationProduct.title || '').replace(/"/g, '&quot;')}"
                   data-price="${variant.price || 0}" data-variant-title="${(variant.title || 'Default Title').replace(/"/g, '&quot;')}"
                   data-variant-available="${isAvailable}" data-variant-inventory="${variant.inventory_quantity || 0}"
                   data-variant-inventory-policy="${variant.inventory_policy || 'deny'}" data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                   ${isFirstAvailable ? 'checked' : ''} class="foundation-input" ${!isAvailable ? 'disabled' : ''}>
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title ${isFirstAvailable ? 'pdp-text-color' : ''}">${(foundationType || variant.title || 'Default Title').replace(/</g, '&lt;')}</p>
              <p class="foundation-subtitle" style="color: ${isAvailable ? '#666' : '#ff4444'};">
                ${(isAvailable ? foundationMetafieldText : suavePdpT('outOfStock', 'Out of Stock')).replace(/</g, '&lt;')}
              </p>
            </div>
            <p class="foundation-price ${isFirstAvailable ? 'pdp-text-color' : ''}">${(variant.price && variant.price > 0) ? '+' + formatMoney(variant.price) : formatMoney(variant.price || 0)}</p>
          </label>
        `;
      });
    } else {
      foundationProduct.variants.forEach((variant, index) => {
        // Get foundation variant metafields from global map
        let foundationMetafieldText = '';
        const variantId = variant.id.toString();
        
        // Get the foundation metafields map for the mattress product (not foundation product)
        // The foundation metafields are stored under the mattress product handle
        const foundationMap = mattressProductHandle ? foundationMetafieldsByProduct.get(mattressProductHandle) : null;
        
        if (foundationMap) {
          const metafields = foundationMap.get(variantId);
          if (metafields) {
            // Use the 'value' property first - it contains the actual metafield text for this variant
            // This is more reliable than checking position-specific properties
            foundationMetafieldText = (metafields.value && metafields.value.trim() !== '') ? metafields.value.trim() : '';
            
            // If value is empty, try position-specific properties as fallback
            if (!foundationMetafieldText) {
              if (index === 0) {
                foundationMetafieldText = metafields.foundation_product_variant_metafield || '';
              } else if (index === 1) {
                foundationMetafieldText = metafields.foundation_product_variant_metafield_2 || '';
              } else if (index === 2) {
                foundationMetafieldText = metafields.foundation_product_variant_metafield_3 || '';
              }
            }
          }
        }
        
        // If no metafield found, use variant title as fallback
        if (!foundationMetafieldText || foundationMetafieldText.trim() === '') {
          foundationMetafieldText = variant.title || '';
        }
        
        // Check availability
        let isAvailable = false;
        let availabilityText = suavePdpT('inStock', 'In Stock');
        
        if (variant.available === true) {
          isAvailable = true;
        } else if (variant.inventory_policy === 'continue') {
          isAvailable = true;
          availabilityText = suavePdpT('availableBackorder', 'Available for Backorder');
        } else if (variant.inventory_quantity !== null && variant.inventory_quantity > 0) {
          isAvailable = true;
          if (variant.inventory_quantity < 10) {
            availabilityText = `Only ${variant.inventory_quantity} left`;
          }
        } else if (variant.inventory_management === null && variant.available !== false) {
          isAvailable = true;
        }
        
        if (isAvailable && firstAvailableVariantIndex === -1) {
          firstAvailableVariantIndex = index;
          hasAvailableVariant = true;
        }
        
        // Get ALL matching images for this variant using flexible matching
        // Check if variant has a featured image
        const hasFeaturedImage = variant.featured_image && variant.featured_image.src;
        
        foundationHTML += `
          <label class="foundation-option${index === firstAvailableVariantIndex && isAvailable ? ' selected' : ''}${!isAvailable ? ' out-of-stock' : ''}" 
                 data-variant-id="${variant.id}" 
                 data-variant-title="${variant.title || 'Default Title'}"
                 data-variant-price="${variant.price || 0}"
                 data-variant-compare-price="${variant.compare_at_price || ''}"
                 data-variant-available="${isAvailable}"
                 data-variant-inventory="${variant.inventory_quantity || 0}"
                 data-variant-inventory-policy="${variant.inventory_policy || 'deny'}"
                 data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                 data-variant-image="${hasFeaturedImage ? variant.featured_image.src : ''}"
                 data-variant-alt="${variant.title || ''} - ${foundationProduct.title}"
                 data-product-handle="${foundationProduct.handle}"
                 data-product-title="${foundationProduct.title}">
            ${!isAvailable ? '<span class="out-of-stock-badge">Out of Stock</span>' : ''}
            
            <input type="radio" 
                   name="foundation" 
                   value="${variant.id}" 
                   data-variant-id="${variant.id}" 
                   data-product-id="${foundationProduct.id}" 
                   data-product-handle="${foundationProduct.handle}" 
                   data-product-title="${foundationProduct.title}" 
                   data-product-description="${foundationProduct.description ? foundationProduct.description.replace(/"/g, '&quot;') : ''}" 
                   data-price="${variant.price || 0}" 
                   data-variant-title="${variant.title || 'Default Title'}"
                   data-variant-available="${isAvailable}"
                   data-variant-inventory="${variant.inventory_quantity || 0}"
                   data-variant-inventory-policy="${variant.inventory_policy || 'deny'}"
                   data-variant-inventory-management="${variant.inventory_management || 'shopify'}"
                   ${index === firstAvailableVariantIndex && isAvailable ? 'checked' : ''}
                   class="foundation-input"
                   ${!isAvailable ? 'disabled' : ''}>
            
            <span class="foundation-indicator"></span>
            <div class="foundation-content">
              <p class="foundation-title ${index === firstAvailableVariantIndex && isAvailable ? 'pdp-text-color' : ''}">
                ${variant.title || 'Default Title'}
              </p>
              <p class="foundation-subtitle" style="color: ${isAvailable ? '#666' : '#ff4444'};">
                ${isAvailable ? foundationMetafieldText : suavePdpT('outOfStock', 'Out of Stock')}
              </p>
            </div>
            <p class="foundation-price ${index === firstAvailableVariantIndex && isAvailable ? 'pdp-text-color' : ''}">${(variant.price && variant.price > 0) ? '+' + formatMoney(variant.price) : formatMoney(variant.price || 0)}</p>
          </label>
        `;
      });
    }
    
    // Save current scroll position to prevent auto-scroll
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
    
    foundationContainer.innerHTML = foundationHTML;
    
    // Restore scroll position immediately and in next frame to prevent auto-scroll
    window.scrollTo(0, scrollPosition);
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollPosition);
    });
    
    // Add event listeners to foundation options
    const foundationOptions = foundationContainer.querySelectorAll('.foundation-option');
    foundationOptions.forEach(option => {
      option.addEventListener('click', function(e) {
        // Prevent default scroll behavior when clicking foundation options
        e.preventDefault();
        e.stopPropagation();
        const input = this.querySelector('input[type="radio"]');
        const liveAvailable = this.getAttribute('data-variant-available') === 'true';
        if (!liveAvailable || !input || input.disabled || !input.value) {
          return;
        }
        
        if (this.classList.contains('selected')) return;
        
        foundationOptions.forEach(opt => {
          opt.classList.remove('selected');
          const optInput = opt.querySelector('input[type="radio"]');
          if (optInput) optInput.checked = false;
          // Remove pdp-text-color class
          const optTitle = opt.querySelector('.foundation-title');
          const optPrice = opt.querySelector('.foundation-price');
          if (optTitle) optTitle.classList.remove('pdp-text-color');
          if (optPrice) optPrice.classList.remove('pdp-text-color');
        });
        
        this.classList.add('selected');
        if (input) input.checked = true;
        
        // Add pdp-text-color class to selected foundation
        const selectedTitle = this.querySelector('.foundation-title');
        const selectedPrice = this.querySelector('.foundation-price');
        if (selectedTitle) selectedTitle.classList.add('pdp-text-color');
        if (selectedPrice) selectedPrice.classList.add('pdp-text-color');

        var activeTabForFoundation = document.querySelector('#custom-product-container .tab.active');
        applyFoundationOptionTabColor(
          activeTabForFoundation ? activeTabForFoundation.getAttribute('data-tab-color') : ''
        );
        
        // Set current foundation variant
        const variantId = input.value;
        const variantPrice = this.getAttribute('data-variant-price');
        const parsedPrice = variantPrice ? parseInt(variantPrice) : 0;
        const foundationTypeVal = this.getAttribute('data-foundation-type');
        if (foundationTypeVal) selectedFoundationType = foundationTypeVal;
        
        currentFoundationVariant = {
          id: variantId,
          title: this.getAttribute('data-variant-title'),
          price: parsedPrice,
          available: liveAvailable,
          inventoryPolicy: this.getAttribute('data-variant-inventory-policy'),
          inventoryQuantity: this.getAttribute('data-variant-inventory'),
          inventoryManagement: this.getAttribute('data-variant-inventory-management')
        };
        
        // Immediately update price when foundation is selected
        updateTotalPrice();
        
        // Update variant name display (to show foundation name)
        updateVariantNameDisplay();
        
        // Store that foundation is now selected
        isFoundationSelected = true;
        
        // Handle foundation variant image changes
        // Ensure foundation product has handle before calling
        if (foundationProduct && !foundationProduct.handle) {
          const productHandle = this.getAttribute('data-product-handle');
          if (productHandle) {
            foundationProduct.handle = productHandle;
          } else if (currentFoundationProduct && currentFoundationProduct.handle) {
            foundationProduct.handle = currentFoundationProduct.handle;
          }
        }
        handleFoundationVariantImageChange(this, foundationProduct);
        
        // Update button states
        updateButtonStates();
      });
    });
    
    // Auto-select first available foundation option AND trigger image change
if (firstAvailableVariantIndex !== -1) {
  const firstAvailableFoundation = foundationContainer.querySelector(`.foundation-option:nth-child(${firstAvailableVariantIndex + 1})`);
  if (firstAvailableFoundation) {
    // Get the radio input and foundation option element
    const radioInput = firstAvailableFoundation.querySelector('input[type="radio"]');
    
    if (radioInput && firstAvailableFoundation) {
      // Programmatically check the radio button without triggering scroll
      // Prevent focus to avoid automatic scroll
      const originalTabIndex = radioInput.getAttribute('tabindex');
      radioInput.setAttribute('tabindex', '-1');
      radioInput.checked = true;
      radioInput.blur(); // Remove focus if it was gained
      if (originalTabIndex !== null) {
        radioInput.setAttribute('tabindex', originalTabIndex);
      } else {
        radioInput.removeAttribute('tabindex');
      }
      
      // Manually update the UI state without click event
      foundationOptions.forEach(opt => {
        opt.classList.remove('selected');
        const optInput = opt.querySelector('input[type="radio"]');
        if (optInput) {
          const optTabIndex = optInput.getAttribute('tabindex');
          optInput.setAttribute('tabindex', '-1');
          optInput.checked = false;
          optInput.blur();
          if (optTabIndex !== null) {
            optInput.setAttribute('tabindex', optTabIndex);
          } else {
            optInput.removeAttribute('tabindex');
          }
        }
        const optTitle = opt.querySelector('.foundation-title');
        const optPrice = opt.querySelector('.foundation-price');
        if (optTitle) optTitle.classList.remove('pdp-text-color');
        if (optPrice) optPrice.classList.remove('pdp-text-color');
      });
      
      // Set selected state
      firstAvailableFoundation.classList.add('selected');
      const selectedTitle = firstAvailableFoundation.querySelector('.foundation-title');
      const selectedPrice = firstAvailableFoundation.querySelector('.foundation-price');
      if (selectedTitle) selectedTitle.classList.add('pdp-text-color');
      if (selectedPrice) selectedPrice.classList.add('pdp-text-color');
      
      // Set current foundation variant
      const variantId = radioInput.value;
      const variantPrice = firstAvailableFoundation.getAttribute('data-variant-price');
      const parsedPrice = variantPrice ? parseInt(variantPrice) : 0;
      const isAvailable = firstAvailableFoundation.getAttribute('data-variant-available') === 'true';
      
      currentFoundationVariant = {
        id: variantId,
        title: firstAvailableFoundation.getAttribute('data-variant-title'),
        price: parsedPrice,
        available: isAvailable,
        inventoryPolicy: firstAvailableFoundation.getAttribute('data-variant-inventory-policy'),
        inventoryQuantity: firstAvailableFoundation.getAttribute('data-variant-inventory'),
        inventoryManagement: firstAvailableFoundation.getAttribute('data-variant-inventory-management')
      };
      const ft = firstAvailableFoundation.getAttribute('data-foundation-type');
      if (ft) selectedFoundationType = ft;
      
      // Update price and button states
      updateTotalPrice();
      updateVariantNameDisplay();
      isFoundationSelected = true;
      updateButtonStates();
      
      // IMPORTANT FIX: Call handleFoundationVariantImageChange for the first foundation option
      // This ensures the images load on page load, not just when user clicks
      // Ensure foundation product has handle before calling
      if (foundationProduct && !foundationProduct.handle) {
        const productHandle = firstAvailableFoundation.getAttribute('data-product-handle');
        if (productHandle) {
          foundationProduct.handle = productHandle;
        } else if (currentFoundationProduct && currentFoundationProduct.handle) {
          foundationProduct.handle = currentFoundationProduct.handle;
        }
      }
      handleFoundationVariantImageChange(firstAvailableFoundation, foundationProduct);
    }
  }
} else if (foundationOptions.length > 0) {
  // If no variants are available, select first one but don't enable it (without scroll)
  const firstOption = foundationOptions[0];
  const radioInput = firstOption.querySelector('input[type="radio"]');
  
  if (radioInput) {
    // Prevent focus to avoid automatic scroll
    const originalTabIndex = radioInput.getAttribute('tabindex');
    radioInput.setAttribute('tabindex', '-1');
    radioInput.checked = true;
    radioInput.blur(); // Remove focus if it was gained
    if (originalTabIndex !== null) {
      radioInput.setAttribute('tabindex', originalTabIndex);
    } else {
      radioInput.removeAttribute('tabindex');
    }
    firstOption.classList.add('selected');
  }
}

    if (typeof window.rebuildCustomDropdown === 'function') {
      window.rebuildCustomDropdown();
    }

    var activeTabAfterFoundation = document.querySelector('#custom-product-container .tab.active');
    applyFoundationOptionTabColor(
      activeTabAfterFoundation ? activeTabAfterFoundation.getAttribute('data-tab-color') : ''
    );

  } catch (error) {
    console.error('Error loading foundation product:', error);
    foundationContainer.innerHTML = '<p class="no-foundation-options">' + suavePdpT('unableLoadFoundation', 'Unable to load foundation options.') + '</p>';
  }
}
  
  /** When mattress size changes, update each foundation option to the variant matching mattress size (and foundation type if 2 options). Keeps same foundation type selected. */
  function syncFoundationOptionsWithMattressSize() {
    const foundationContainer = document.getElementById('foundation-options-container');
    if (!currentFoundationProduct || !currentFoundationProduct.variants || !foundationContainer) return;
    const hasTwoOptions = currentFoundationProduct.options && currentFoundationProduct.options.length >= 2;
    const hasOneOption = currentFoundationProduct.options && currentFoundationProduct.options.length === 1;
    if (!hasTwoOptions && !hasOneOption) return;
    const currentSizeValue = getCurrentMattressSizeValue();
    const options = foundationContainer.querySelectorAll('.foundation-option[data-foundation-type]');
    let previouslySelectedType = selectedFoundationType;
    let newSelectedVariant = null;
    options.forEach(function (opt) {
      const typeVal = opt.getAttribute('data-foundation-type');
      if (!typeVal) return;
      opt.querySelectorAll('.foundation-size-na-badge').forEach(function (b) {
        b.remove();
      });
      const variant = hasOneOption
        ? getFoundationVariantBySize(currentFoundationProduct, currentSizeValue)
        : getFoundationVariantBySizeAndType(currentFoundationProduct, currentSizeValue, typeVal);
      if (!variant) {
        opt.setAttribute('data-variant-id', '');
        opt.setAttribute('data-variant-title', typeVal);
        opt.setAttribute('data-variant-price', '0');
        opt.setAttribute('data-variant-available', 'false');
        opt.setAttribute('data-size-mismatch', 'true');
        opt.removeAttribute('data-variant-image');
        opt.classList.add('out-of-stock', 'size-unavailable');
        opt.classList.remove('selected');
        const input = opt.querySelector('input[name="foundation"]');
        if (input) {
          input.value = '';
          input.setAttribute('data-variant-id', '');
          input.setAttribute('data-variant-title', typeVal);
          input.setAttribute('data-variant-available', 'false');
          input.setAttribute('data-price', '0');
          input.disabled = true;
          input.checked = false;
        }
        const titleEl = opt.querySelector('.foundation-title');
        if (titleEl) {
          titleEl.textContent = typeVal;
          titleEl.classList.remove('pdp-text-color');
        }
        const priceEl = opt.querySelector('.foundation-price');
        if (priceEl) {
          priceEl.textContent = '—';
          priceEl.classList.remove('pdp-text-color');
        }
        const subEl = opt.querySelector('.foundation-subtitle');
        if (subEl) {
          let subText = opt.getAttribute('data-foundation-subtitle-default');
          if (subText == null || subText === '') {
            if (!hasOneOption) {
              const anyForType = getFirstVariantForFoundationType(currentFoundationProduct, typeVal);
              subText = anyForType ? (anyForType.title || '') : '';
            }
          }
          subEl.textContent = subText || '';
          subEl.style.color = '#666';
        }
        const naBadge = document.createElement('span');
        naBadge.className = 'out-of-stock-badge foundation-size-na-badge';
        naBadge.textContent = suavePdpT('notAvailable', 'Not Available');
        opt.insertBefore(naBadge, opt.firstChild);
        opt.querySelectorAll('.out-of-stock-badge:not(.foundation-size-na-badge)').forEach(function (b) {
          b.remove();
        });
        return;
      }
      opt.classList.remove('size-unavailable');
      opt.removeAttribute('data-size-mismatch');
      const variantId = variant.id.toString();
      let isAvailable = false;
      if (variant.available === true) isAvailable = true;
      else if (variant.inventory_policy === 'continue') isAvailable = true;
      else if (variant.inventory_quantity != null && variant.inventory_quantity > 0) isAvailable = true;
      else if (variant.inventory_management == null && variant.available !== false) isAvailable = true;
      opt.setAttribute('data-variant-id', variantId);
      opt.setAttribute('data-variant-title', (hasOneOption ? typeVal : variant.title) || 'Default Title');
      opt.setAttribute('data-variant-price', variant.price || 0);
      opt.setAttribute('data-variant-available', isAvailable);
      opt.setAttribute('data-variant-inventory', variant.inventory_quantity || 0);
      opt.setAttribute('data-variant-inventory-policy', variant.inventory_policy || 'deny');
      opt.setAttribute('data-variant-inventory-management', variant.inventory_management || 'shopify');
      if (variant.featured_image && variant.featured_image.src) {
        opt.setAttribute('data-variant-image', variant.featured_image.src);
      } else {
        opt.removeAttribute('data-variant-image');
      }
      const input = opt.querySelector('input[name="foundation"]');
      if (input) {
        input.value = variantId;
        input.setAttribute('data-variant-id', variantId);
        input.setAttribute('data-variant-title', (hasOneOption ? typeVal : variant.title) || 'Default Title');
        input.setAttribute('data-variant-available', isAvailable);
        input.setAttribute('data-price', variant.price || 0);
        input.disabled = !isAvailable;
      }
      const titleEl = opt.querySelector('.foundation-title');
      if (titleEl) titleEl.textContent = typeVal || variant.title || 'Default Title';
      const priceEl = opt.querySelector('.foundation-price');
      if (priceEl) priceEl.textContent = (variant.price && variant.price > 0) ? '+' + formatMoney(variant.price) : formatMoney(variant.price || 0);
      const subEl = opt.querySelector('.foundation-subtitle');
      if (subEl) {
        subEl.style.color = isAvailable ? '#666' : '#ff4444';
        const preservedSub = opt.getAttribute('data-foundation-subtitle-default');
        if (isAvailable) {
          subEl.textContent =
            preservedSub != null && String(preservedSub).trim() !== ''
              ? preservedSub
              : (variant.title || '');
        } else {
          subEl.textContent = suavePdpT('outOfStock', 'Out of Stock');
        }
      }
      opt.classList.toggle('out-of-stock', !isAvailable);
      opt.querySelectorAll('.out-of-stock-badge:not(.foundation-size-na-badge)').forEach(function (b) {
        b.remove();
      });
      if (!isAvailable) {
        const os = document.createElement('span');
        os.className = 'out-of-stock-badge';
        os.textContent = suavePdpT('outOfStock', 'Out of Stock');
        opt.insertBefore(os, opt.firstChild);
      }
      if (typeVal === previouslySelectedType && isAvailable) newSelectedVariant = variant;
    });
    if (previouslySelectedType && newSelectedVariant) {
      let selectedOpt = null;
      foundationContainer.querySelectorAll('.foundation-option[data-foundation-type]').forEach(function (o) {
        if (o.getAttribute('data-foundation-type') === previouslySelectedType) selectedOpt = o;
      });
      if (selectedOpt) {
        const radio = selectedOpt.querySelector('input[name="foundation"]');
        if (radio) radio.checked = true;
        foundationContainer.querySelectorAll('.foundation-option').forEach(function (o) {
          o.classList.remove('selected');
          const t = o.querySelector('.foundation-title');
          const p = o.querySelector('.foundation-price');
          if (t) t.classList.remove('pdp-text-color');
          if (p) p.classList.remove('pdp-text-color');
        });
        selectedOpt.classList.add('selected');
        const st = selectedOpt.querySelector('.foundation-title');
        const sp = selectedOpt.querySelector('.foundation-price');
        if (st) st.classList.add('pdp-text-color');
        if (sp) sp.classList.add('pdp-text-color');
        currentFoundationVariant = {
          id: newSelectedVariant.id.toString(),
          title: hasOneOption ? previouslySelectedType : newSelectedVariant.title,
          price: parseInt(newSelectedVariant.price) || 0,
          available: true,
          inventoryPolicy: newSelectedVariant.inventory_policy,
          inventoryQuantity: newSelectedVariant.inventory_quantity,
          inventoryManagement: newSelectedVariant.inventory_management
        };
      }
    } else {
      const firstAvailable = foundationContainer.querySelector('.foundation-option:not(.out-of-stock)');
      if (firstAvailable) {
        const radio = firstAvailable.querySelector('input[name="foundation"]');
        if (radio && !radio.disabled) {
          radio.checked = true;
          foundationContainer.querySelectorAll('.foundation-option').forEach(function (o) {
            o.classList.remove('selected');
            const t = o.querySelector('.foundation-title');
            const p = o.querySelector('.foundation-price');
            if (t) t.classList.remove('pdp-text-color');
            if (p) p.classList.remove('pdp-text-color');
          });
          firstAvailable.classList.add('selected');
          const st = firstAvailable.querySelector('.foundation-title');
          const sp = firstAvailable.querySelector('.foundation-price');
          if (st) st.classList.add('pdp-text-color');
          if (sp) sp.classList.add('pdp-text-color');
          const variantId = firstAvailable.getAttribute('data-variant-id');
          if (variantId) {
            selectedFoundationType = firstAvailable.getAttribute('data-foundation-type');
            currentFoundationVariant = {
              id: variantId,
              title: firstAvailable.getAttribute('data-variant-title'),
              price: parseInt(firstAvailable.getAttribute('data-variant-price'), 10) || 0,
              available: firstAvailable.getAttribute('data-variant-available') === 'true',
              inventoryPolicy: firstAvailable.getAttribute('data-variant-inventory-policy'),
              inventoryQuantity: firstAvailable.getAttribute('data-variant-inventory'),
              inventoryManagement: firstAvailable.getAttribute('data-variant-inventory-management')
            };
            isFoundationSelected = true;
          }
        }
      } else {
        currentFoundationVariant = null;
        isFoundationSelected = false;
      }
    }
    updateTotalPrice();
    updateVariantNameDisplay();
    updateButtonStates();
    var activeTabAfterSizeSync = document.querySelector('#custom-product-container .tab.active');
    applyFoundationOptionTabColor(
      activeTabAfterSizeSync ? activeTabAfterSizeSync.getAttribute('data-tab-color') : ''
    );
  }
  
  // Function to merge metafields from data attributes into product data
  function mergeVariantMetafields(productData, tabElement) {
    if (!tabElement || !productData || !productData.variants) return productData;
    
    mergeLocalizedVariantsFromTab(productData, tabElement);
    
    // Get metafields from data attribute
    const metafieldsData = tabElement.getAttribute('data-variant-metafields');
    if (metafieldsData) {
      // Parse metafields data: format is "variantId:field1|field2|field3||variantId2:..."
      const variantMetafields = metafieldsData.split('||');
      variantMetafields.forEach((variantData, idx) => {
        if (variantData) {
          const [variantId, metafields] = variantData.split(':');
          if (variantId && metafields) {
            const fields = metafields.split('|');
            const variant = productData.variants.find(v => v.id.toString() === variantId);
            if (variant) {
              if (!variant.metafields) variant.metafields = {};
              if (!variant.metafields.custom) variant.metafields.custom = {};
              
              // Set metafields based on card index (0, 1, 2) - each variant can have all three
              if (fields[0] && fields[0].trim() !== '') {
                variant.metafields.custom.firmness_variant_option_text = fields[0];
              }
              if (fields[1] && fields[1].trim() !== '') {
                variant.metafields.custom.firmness_variant_option_text_2 = fields[1];
              }
              if (fields[2] && fields[2].trim() !== '') {
                variant.metafields.custom.firmness_variant_option_text_3 = fields[2];
              }
            }
          }
        }
      });
    }
    
    return productData;
  }

  function parseTabProductVariants(tabElement) {
    if (!tabElement) return null;
    var raw = tabElement.getAttribute('data-product-variants');
    if (!raw) return null;
    try {
      var decoded = raw.replace(/&quot;/g, '"').replace(/&#39;/g, "'");
      var parsed = JSON.parse(decoded);
      return Array.isArray(parsed) ? parsed : null;
    } catch (parseErr) {
      return null;
    }
  }

  function mergeLocalizedVariantsById(productData, localizedVariants) {
    if (!suavePdpIsSpanishLocale()) return productData;
    if (!productData || !productData.variants || !localizedVariants || !localizedVariants.length) {
      return productData;
    }
    var byId = new Map();
    localizedVariants.forEach(function (v) {
      if (v && v.id != null) byId.set(String(v.id), v);
    });
    productData.variants.forEach(function (variant) {
      var loc = byId.get(String(variant.id));
      if (!loc) return;
      if (loc.available != null) variant.available = loc.available;
      if (loc.price != null) variant.price = loc.price;
      if (loc.compare_at_price != null) variant.compare_at_price = loc.compare_at_price;
      if (loc.inventory_quantity != null) variant.inventory_quantity = loc.inventory_quantity;
      if (loc.inventory_policy != null) variant.inventory_policy = loc.inventory_policy;
      if (loc.inventory_management != null) variant.inventory_management = loc.inventory_management;
    });
    return productData;
  }

  function mergeLocalizedVariantsFromTab(productData, tabElement) {
    if (!tabElement || !productData) return productData;
    var tabHandle = tabElement.getAttribute('data-product-handle') || tabElement.getAttribute('data-tab') || '';
    if (tabHandle && productData.handle && tabHandle !== productData.handle) return productData;
    return mergeLocalizedVariantsById(productData, parseTabProductVariants(tabElement));
  }

  function mergeLocalizedVariantsFromCollectionItem(productData, collectionItem) {
    if (!productData || !collectionItem || !collectionItem.variants) return productData;
    return mergeLocalizedVariantsById(productData, collectionItem.variants);
  }

  var PDP_LAYER_DEFAULT_PIN_POS = [
    null,
    { top: 15, left: 62 },
    { top: 23, left: 60 },
    { top: 35, left: 58 },
    { top: 42, left: 56 },
    { top: 52, left: 44 },
    { top: 50, left: 65 },
    { top: 70, left: 63 },
    { top: 78, left: 52 },
    { top: 84, left: 58 },
    { top: 90, left: 49 }
  ];

  function normalizePdpLayersLabel(value) {
    if (value == null) return '';
    return String(value).trim();
  }

  function escapeRegExpForLayers(str) {
    return String(str).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  /** Layer section tabs: show product name only (strip collection / line name from Shopify title). */
  function getPdpLayersProductTabLabel(productItem, collectionTitle, collectionHandle) {
    if (!productItem) return '';
    if (productItem.tabsMainHeading) {
      return normalizePdpLayersLabel(productItem.tabsMainHeading);
    }
    if (productItem.firmnessTabLabel) {
      return normalizePdpLayersLabel(productItem.firmnessTabLabel);
    }
    if (productItem.tabLabel) {
      return normalizePdpLayersLabel(productItem.tabLabel);
    }

    var title = normalizePdpLayersLabel(productItem.title);
    if (!title) return normalizePdpLayersLabel(productItem.handle);

    var prefixes = [];
    var seen = {};

    function addPrefix(value) {
      var p = normalizePdpLayersLabel(value);
      if (!p) return;
      var key = p.toLowerCase();
      if (seen[key]) return;
      seen[key] = true;
      prefixes.push(p);
    }

    addPrefix(collectionTitle);
    if (collectionHandle) {
      addPrefix(collectionHandle);
      var handle = collectionHandle.toLowerCase();
      if (handle === 'flamenco') {
        addPrefix('Flamenco');
        addPrefix('Moderno');
        addPrefix('Modreno');
      } else if (handle === 'tango') {
        addPrefix('Classico');
        addPrefix('Tango');
      }
    }

    ['Classico', 'Flamenco', 'Tango', 'Moderno', 'Modreno', 'Suave'].forEach(addPrefix);

    prefixes.sort(function (a, b) {
      return b.length - a.length;
    });

    var stripped = title;
    var i;
    for (i = 0; i < prefixes.length; i++) {
      var pattern = new RegExp(
        '^' + escapeRegExpForLayers(prefixes[i]) + '\\s*[-–—|:·•]?\\s*',
        'i'
      );
      if (pattern.test(stripped)) {
        stripped = stripped.replace(pattern, '').trim();
      }
    }

    return stripped || title;
  }

  function getActiveFirmnessProductHandle() {
    var checked = document.querySelector('input[name="firmness"]:checked');
    if (checked && checked.value) return checked.value.trim();
    var selectedCard = document.querySelector('.firmness-card.selected');
    if (selectedCard && selectedCard.dataset.productHandle) {
      return selectedCard.dataset.productHandle.trim();
    }
    return '';
  }

  function activatePdpLayersTab(section, handle) {
    if (window.SuavePdpLayers) {
      window.SuavePdpLayers.activate(handle);
      return;
    }
    if (!section || !handle) return;
    var tabBtn = section.querySelector('[data-firmness-tab="' + handle + '"]');
    if (tabBtn) tabBtn.click();
  }

  function resolvePdpLayersImageUrl(productItem) {
    if (!productItem) return '';
    var tabsImage = productItem.tabsImage;
    if (tabsImage != null && String(tabsImage).trim() && String(tabsImage).trim() !== 'null') {
      return String(tabsImage).trim();
    }
    if (productItem.image && String(productItem.image).trim() && String(productItem.image).trim() !== 'null') {
      return String(productItem.image).trim();
    }
    return '';
  }

  function resolvePdpLayersIntro(productItem, collectionIntro) {
    if (productItem && productItem.tabsDescription != null) {
      var tabsDesc = String(productItem.tabsDescription).trim();
      if (tabsDesc && tabsDesc !== 'null') {
        return normalizePdpLayersLabel(tabsDesc);
      }
    }
    return normalizePdpLayersLabel(collectionIntro);
  }

  function resolvePdpLayersHeading(productItem, headingFallback) {
    if (productItem && productItem.tabsHeading != null) {
      var heading = String(productItem.tabsHeading).trim();
      if (heading && heading !== 'null') {
        return normalizePdpLayersLabel(heading);
      }
    }
    return normalizePdpLayersLabel(headingFallback);
  }

  function parsePdpLayersPinPercent(value, fallback) {
    if (value == null || value === '' || value === 'null') return fallback;
    var n = parseFloat(String(value).replace('%', '').trim());
    if (isNaN(n)) return fallback;
    return Math.max(0, Math.min(100, n));
  }

  function resolvePdpLayersPinPosition(productItem, pinIndex) {
    var defPos = PDP_LAYER_DEFAULT_PIN_POS[pinIndex] || { top: 15, left: 62 };
    var entry = null;
    if (productItem && Array.isArray(productItem.tabsLayers)) {
      entry = productItem.tabsLayers[pinIndex - 1] || null;
    }
    return {
      top: parsePdpLayersPinPercent(entry ? entry.pinTop : null, defPos.top),
      left: parsePdpLayersPinPercent(entry ? entry.pinLeft : null, defPos.left)
    };
  }

  function resolvePdpLayersContent(productItem) {
    var layers = [];
    if (productItem && Array.isArray(productItem.tabsLayers)) {
      productItem.tabsLayers.forEach(function (entry) {
        if (!entry) return;
        var q = normalizePdpLayersLabel(entry.q);
        var a = normalizePdpLayersLabel(entry.a);
        if (!q && !a) return;
        layers.push({
          title: q || 'Layer ' + (layers.length + 1),
          body: a
        });
      });
    }
    return {
      layers: layers,
      pointCount: layers.length ? Math.min(layers.length, 7) : 0
    };
  }

  function buildPdpLayersPanel(productItem, isActive, headingFallback, collectionIntro) {
    var handle = productItem.handle;
    var panel = document.createElement('div');
    panel.className = 'collection-layers-grid collection-layers-tab-panel' + (isActive ? ' is-active' : '');
    panel.id = 'firmness-panel-' + handle;
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('aria-labelledby', 'firmness-tab-' + handle);
    panel.setAttribute('data-collection-layers', '');
    panel.setAttribute('data-firmness-panel', handle);
    if (!isActive) panel.hidden = true;

    var layerContent = resolvePdpLayersContent(productItem);
    var pointCount = layerContent.pointCount;
    var layers = layerContent.layers;

    var imageWrap = document.createElement('div');
    imageWrap.className = 'collection-layers-image-wrap';

    var imageUrl = resolvePdpLayersImageUrl(productItem);
    var imageAlt = productItem.title || 'Mattress exploded layers';

    if (imageUrl) {
      var img = document.createElement('img');
      img.className = 'collection-layers-image';
      img.src = imageUrl;
      img.alt = imageAlt;
      img.width = 1200;
      img.height = 800;
      img.loading = 'lazy';
      imageWrap.appendChild(img);
    } else {
      var ph = document.createElement('div');
      ph.className = 'collection-layers-image collection-layers-image--placeholder';
      ph.setAttribute('role', 'img');
      ph.setAttribute('aria-label', imageAlt);
      imageWrap.appendChild(ph);
    }

    var pinIndex;
    for (pinIndex = 1; pinIndex <= pointCount; pinIndex++) {
      var pinPos = resolvePdpLayersPinPosition(productItem, pinIndex);
      var pin = document.createElement('button');
      pin.type = 'button';
      pin.className = 'collection-layer-pin' + (pinIndex === 1 && isActive ? ' is-active' : '');
      pin.style.top = pinPos.top + '%';
      pin.style.left = pinPos.left + '%';
      pin.setAttribute('data-layer-pin', String(pinIndex));
      pin.setAttribute('aria-label', 'Show layer ' + pinIndex);
      pin.textContent = String(pinIndex);
      imageWrap.appendChild(pin);
    }
    panel.appendChild(imageWrap);

    var copy = document.createElement('div');
    copy.className = 'collection-layers-copy';

    var titleEl = document.createElement('h3');
    titleEl.className = 'collection-layers-title';
    titleEl.setAttribute('data-pdp-layers-collection-title', '');
    titleEl.textContent = resolvePdpLayersHeading(productItem, headingFallback) || '';
    if (!titleEl.textContent) titleEl.setAttribute('hidden', '');
    copy.appendChild(titleEl);

    var introEl = document.createElement('p');
    introEl.className = 'collection-layers-intro';
    introEl.setAttribute('data-pdp-layers-collection-intro', '');
    introEl.textContent = resolvePdpLayersIntro(productItem, collectionIntro) || '';
    if (!introEl.textContent) introEl.setAttribute('hidden', '');
    copy.appendChild(introEl);

    if (!pointCount) {
      var noData = document.createElement('p');
      noData.className = 'pdp-layers-no-data';
      noData.textContent = 'Layer details are not available for this product yet.';
      copy.appendChild(noData);
      panel.appendChild(copy);
      return panel;
    }

    var list = document.createElement('div');
    list.className = 'collection-layer-list';
    list.setAttribute('role', 'list');

    var layerNum;
    for (layerNum = 1; layerNum <= pointCount; layerNum++) {
      var layerData = layers[layerNum - 1] || {};
      var layerTitle = layerData.title || layerData.q || 'Layer ' + layerNum;
      var layerBody = layerData.body || layerData.a || '';
      var layerOpen = layerNum === 1 && isActive;

      var item = document.createElement('div');
      item.className =
        'collection-layer-item collection-layer-item--accordion' + (layerOpen ? ' is-open' : '');
      item.setAttribute('data-layer-item', String(layerNum));

      var opt = document.createElement('button');
      opt.type = 'button';
      opt.className = 'collection-layer-option' + (layerOpen ? ' is-active' : '');
      opt.setAttribute('data-layer-option', String(layerNum));
      opt.appendChild(document.createTextNode(layerTitle + ' '));

      var caret = document.createElement('span');
      caret.className = 'collection-layer-caret';
      caret.textContent = layerOpen ? '\u25B2' : '\u25BC';
      opt.appendChild(caret);
      item.appendChild(opt);

      var layerPanel = document.createElement('div');
      layerPanel.className = 'collection-layer-panel';
      layerPanel.setAttribute('data-layer-panel', String(layerNum));
      if (layerBody) {
        var body = document.createElement('p');
        body.className = 'collection-layer-body';
        body.textContent = layerBody;
        layerPanel.appendChild(body);
      }
      item.appendChild(layerPanel);
      list.appendChild(item);
    }

    copy.appendChild(list);
    panel.appendChild(copy);
    return panel;
  }

  function buildPdpLayersTabButton(productItem, isActive, collectionTitle, collectionHandle) {
    var handle = productItem.handle;
    var mapLabel = normalizePdpLayersLabel(productItem.title);
    var tabText =
      getPdpLayersProductTabLabel(productItem, collectionTitle, collectionHandle) || handle;

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'collection-firmness-option' + (isActive ? ' is-active' : '');
    btn.setAttribute('role', 'tab');
    btn.id = 'firmness-tab-' + handle;
    btn.setAttribute('data-firmness-tab', handle);
    btn.setAttribute('data-map-firmness-label', mapLabel);
    btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
    btn.setAttribute('aria-controls', 'firmness-panel-' + handle);
    btn.textContent = tabText;
    return btn;
  }

  /** Build PDP layers tabs/panels from active collection tab products. */
  async function rebuildPdpLayersProductTabs(tabElement) {
    var tab = tabElement || document.querySelector('#custom-product-container .tab.active');
    if (!window.SuavePdpLayers) return;

    var products = parseCollectionProductsFromTab(tab);
    var layersSection = document.querySelector('[data-pdp-collection-layers-section]');
    var sectionDefaultTitle = layersSection
      ? normalizePdpLayersLabel(layersSection.getAttribute('data-pdp-layers-default-title'))
      : '';
    var collectionTitleFallback = tab
      ? normalizePdpLayersLabel(
          tab.getAttribute('data-collection-title') || tab.getAttribute('data-product-title')
        )
      : '';
    if (!collectionTitleFallback) collectionTitleFallback = sectionDefaultTitle;
    var collectionIntro = tab
      ? normalizePdpLayersLabel(
          tab.getAttribute('data-collection-description') ||
            tab.getAttribute('data-product-description')
        )
      : '';
    var collectionHandle = tab
      ? normalizePdpLayersLabel(tab.getAttribute('data-collection-handle'))
      : '';

    var activeHandle = getActiveFirmnessProductHandle();
    var hasActiveInList = products.some(function (p) {
      return p.handle === activeHandle;
    });
    if (!hasActiveInList) activeHandle = products.length ? products[0].handle : '';

    return window.SuavePdpLayers.rebuild(products, activeHandle, {
      collectionTitle: collectionTitleFallback,
      collectionIntro: collectionIntro,
      collectionHandle: collectionHandle
    });
  }

  /** Sync PDP layers tabs + title/intro from active mattress collection tab (custom-product). */
  function syncPdpLayersCollectionCopy(tabElement) {
    var tab = tabElement;
    if (!tab) {
      tab = document.querySelector('#custom-product-container .tab.active');
    }
    if (!tab) return;

    var layersSection = document.querySelector('[data-pdp-collection-layers-section]');
    if (!layersSection) return;

    var title = (
      tab.getAttribute('data-collection-title') ||
      tab.getAttribute('data-product-title') ||
      ''
    ).trim();
    var collectionIntroFallback = (
      tab.getAttribute('data-collection-description') ||
      tab.getAttribute('data-product-description') ||
      ''
    ).trim();
    var products = parseCollectionProductsFromTab(tab);
    var activeHandle = getActiveFirmnessProductHandle();
    var activeProduct = products.find(function (p) {
      return p.handle === activeHandle;
    });
    if (!activeProduct && products.length) activeProduct = products[0];
    var intro = activeProduct
      ? resolvePdpLayersIntro(activeProduct, collectionIntroFallback)
      : collectionIntroFallback;

    return rebuildPdpLayersProductTabs(tab).then(function () {
      var syncedHandle = getActiveFirmnessProductHandle();
      if (syncedHandle) {
        activatePdpLayersTab(layersSection, syncedHandle);
      }
      document.dispatchEvent(
        new CustomEvent('suave:collection-change', {
          detail: {
            title: title,
            description: intro,
            collectionHandle: tab.getAttribute('data-collection-handle') || '',
            tabElement: tab
          }
        })
      );
    });
  }

  function dispatchPdpProductUpdated(productData) {
    if (!productData) return;
    var image = '';
    if (productData.images && productData.images.length > 0) {
      var img = productData.images[0];
      image = typeof img === 'string' ? img : (img.src || img.url || '');
    }
    var mainImg = document.getElementById('main-image');
    if (mainImg && mainImg.src) image = mainImg.src;

    document.dispatchEvent(
      new CustomEvent('suave:pdp-product-updated', {
        detail: {
          title: productData.title || '',
          handle: productData.handle || '',
          url: window.location.href.split('#')[0],
          image: image,
          productId: productData.id ? String(productData.id) : ''
        }
      })
    );
  }

  function parseTabProductDescriptionHtml(tabElement) {
    if (!tabElement) return '';
    var raw = tabElement.getAttribute('data-product-description-html');
    if (!raw) return '';
    try {
      return JSON.parse(raw);
    } catch (parseErr) {
      return raw;
    }
  }

  function applyProductDescriptionHtml(html) {
    var descriptionElement = document.querySelector('.product-description');
    if (!descriptionElement || html == null || String(html).trim() === '') return;
    var content = String(html).trim();
    if (content.indexOf('<') !== -1) {
      descriptionElement.innerHTML = content;
    } else {
      descriptionElement.textContent = content;
    }
  }

  function resolveLocalizedProductDescriptionHtml(tabElement, productHandle) {
    if (tabElement && productHandle) {
      var tabHandle =
        tabElement.getAttribute('data-product-handle') ||
        tabElement.getAttribute('data-tab') ||
        '';
      if (tabHandle === productHandle) {
        var fromTab = parseTabProductDescriptionHtml(tabElement);
        if (fromTab && String(fromTab).trim()) return fromTab;
      }
      var collectionItems = parseCollectionProductsFromTab(tabElement);
      var collectionItem = collectionItems.find(function (item) {
        return item && item.handle === productHandle;
      });
      if (collectionItem && collectionItem.descriptionHtml && String(collectionItem.descriptionHtml).trim()) {
        return collectionItem.descriptionHtml;
      }
    }
    if (tabElement) {
      var tabHtml = parseTabProductDescriptionHtml(tabElement);
      if (tabHtml && String(tabHtml).trim()) return tabHtml;
    }
    if (pdpInitialProductDescriptionHtml) return pdpInitialProductDescriptionHtml;
    return '';
  }

  function attachLocalizedDescriptionToProduct(productData, tabElement) {
    if (!productData) return productData;
    var localizedHtml = resolveLocalizedProductDescriptionHtml(tabElement, productData.handle);
    if (localizedHtml) {
      productData.descriptionHtml = localizedHtml;
    }
    return productData;
  }

  function restoreLocalizedProductDescription(tabElement) {
    if (!currentMattressProduct) return;
    var localizedHtml = resolveLocalizedProductDescriptionHtml(
      tabElement || currentActiveTab || document.querySelector('#custom-product-container .tab.active'),
      currentMattressProduct.handle
    );
    if (!localizedHtml) return;
    currentMattressProduct.descriptionHtml = localizedHtml;
    applyProductDescriptionHtml(localizedHtml);
  }

  // Function to update product display when mattress product changes
  async function updateMattressProduct(productData, tabElement) {
    // Merge metafields from data attributes
    productData = mergeVariantMetafields(productData, tabElement);
    attachLocalizedDescriptionToProduct(productData, tabElement);
    
    // Fetch metafields from custom endpoint
    productData = await fetchVariantMetafields(productData);
    
    // Load variant info data for this product handle
    if (productData.handle) {
      loadVariantInfoForProduct(productData.handle);
    }
    
    currentMattressProduct = productData;
    currentMattressImages = productData.images;

    if (tabElement) {
      var tabStore = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
      var tabPct = tabElement.getAttribute('data-discount-percentage');
      var tabBadge = tabElement.getAttribute('data-sale-badge-text') || '';
      var tabLabel = tabElement.getAttribute('data-product-label') || '';
      if (tabPct != null && tabPct !== '' && !tabStore.enableVariantMetafieldDiscounts) {
        productData.discountPercentage = parseFloat(tabPct) || 0;
      }
      // Tab badge is first-variant Liquid output — never stamp it in variant mode
      if (!tabStore.enableVariantMetafieldDiscounts) {
        productData.saleBadgeText = tabBadge;
      } else {
        productData.saleBadgeText = '';
      }
      productData.productLabel = tabLabel;
      var tabVariantMap = getVariantDiscountsForHandle(productData.handle);
      if (tabVariantMap && typeof tabVariantMap === 'object' && Object.keys(tabVariantMap).length) {
        productData.variantDiscounts = tabVariantMap;
        if (window.__PDP_STORE__) {
          window.__PDP_STORE__.variantDiscounts = tabVariantMap;
          window.__PDP_STORE__.variantDiscountsProductHandle = productData.handle || '';
        }
      } else {
        bindProductVariantDiscounts(productData);
      }
    }
    syncPdpDisplayDiscountMeta(productData);

    if (productData.descriptionHtml) {
      applyProductDescriptionHtml(productData.descriptionHtml);
    }
    
    // Update active tab reference
    currentActiveTab = tabElement;
    
    // Update colors based on active tab using existing function
    updateTitleLastWordColor();
    
    // Reset foundation selection
    isFoundationSelected = false;
    selectedModelValue = '';
    selectedUnderbedProduct = null;
    currentFoundationVariant = null;
    currentFoundationProduct = null;
    currentFoundationImages = null;
    
    // Load mattress images initially
    if (productData.images && productData.images.length > 0) {
      loadProductImages(productData.images);
    }
    
    // Update title
    updateProductTitle(productData.title);
    
    // Update description - will be updated when variant is selected (from variant info metafield: short)
    // Initial description will be updated when first variant is selected
    
    // Update accessories title
    const accessoriesTitleElement = document.getElementById('accessories-product-title');
    if (accessoriesTitleElement) {
      accessoriesTitleElement.textContent = productData.title;
    }
    
    // Price will be updated by updateButtonStates() which calls updateTotalPrice()

    // Compare-at is synced in updateTotalPrice via updateCompareAtPriceDisplay()
    
    // Show firmness section
    const firmnessSection = document.getElementById('firmness-section');
    if (firmnessSection) {
      firmnessSection.style.display = 'block';
    }
    
    // Load comfort options (collection products if available, otherwise product variants)
    await loadFirmnessOptions(productData, tabElement);
    
    // Load foundation options for this mattress from metafield
    await loadFoundationOptions(productData.handle);
    
    // Update button states
    updateButtonStates();

    syncPdpLayersCollectionCopy(tabElement);
    dispatchPdpProductUpdated(productData);
  }
  
  
  // Function to update product title with styling (last 1 word if 2 words, last 2 words if 3+)
  function updateProductTitle(newTitle) {
    const titleElement = document.getElementById('dynamic-product-title');
    if (!titleElement) return;
    
    const titleWords = newTitle.trim().split(/\s+/).filter(Boolean);
    const len = titleWords.length;
    const applyColor = len >= 2;
    const colorLastTwo = len >= 3;
    
    let newTitleHTML = '';
    titleWords.forEach((word, index) => {
      const isColored = applyColor && (index === len - 1 || (colorLastTwo && index === len - 2));
      if (isColored) {
        newTitleHTML += `<span class="title-last-word pdp-text-color" data-pdp-color="text">${word}</span>`;
      } else {
        newTitleHTML += word;
      }
      if (index < len - 1) newTitleHTML += ' ';
    });
    
    titleElement.innerHTML = newTitleHTML;
    
    // Apply color from current active tab to all colored words
    if (currentActiveTab) {
      const tabColor = currentActiveTab.getAttribute('data-tab-color');
      const titleLastWords = titleElement.querySelectorAll('.title-last-word');
      if (tabColor && titleLastWords.length) {
        titleLastWords.forEach(function (el) { el.style.color = tabColor; });
      }
    }
  }
  
  // Function to detect which option is firmness and which is size
  function detectOptionTypes(productData) {
    
    if (!productData.options || !Array.isArray(productData.options)) {
      console.warn('No options array found in product data');
      return { firmnessIndex: 0, sizeIndex: 1 };
    }
    
    // Get option names
    const optionNames = productData.options.map(opt => {
      if (typeof opt === 'string') return opt.toLowerCase();
      else if (opt && typeof opt === 'object' && opt.name) return opt.name.toLowerCase();
      else if (opt && typeof opt === 'object' && opt.title) return opt.title.toLowerCase();
      else if (opt && typeof opt === 'number') return opt.toString().toLowerCase();
      else return '';
    });
    
    const sizeKeywords = ['size', 'dimension', 'tamaño', 'tamano', 'medida', 'twin', 'full', 'queen', 'king', 'california', 'xl'];
    const firmnessKeywords = ['firmness', 'firm', 'soft', 'medium', 'plush', 'comfort', 'support', 'feel', 'confort', 'firmeza'];
    const modelKeywords = ['model', 'models', 'type', 'style', 'version', 'base'];
    
    let firmnessIndex = -1;
    let sizeIndex = -1;
    let modelIndex = -1;
    
    // First, check option names
    optionNames.forEach((name, index) => {
      if (name && sizeKeywords.some(keyword => name.includes(keyword))) {
        sizeIndex = index;
      } else if (name && modelKeywords.some(keyword => name.includes(keyword))) {
        modelIndex = index;
      } else if (name && firmnessKeywords.some(keyword => name.includes(keyword))) {
        firmnessIndex = index;
      }
    });
    
    // If not detected by name, check variant values
    if (productData.variants && productData.variants.length > 0) {
      const sampleVariant = productData.variants[0];
      if (sampleVariant && sampleVariant.options) {
        sampleVariant.options.forEach((value, index) => {
          if (!value) return;
          const valLower = value.toString().toLowerCase();
          
          // Check for size values
          if (valLower.includes('twin') || valLower.includes('queen') || 
              valLower.includes('king') || valLower.includes('full') ||
              valLower.includes('xl') || valLower.includes('california') ||
              valLower.includes('single') || valLower.includes('double') ||
              valLower.includes('individual') || valLower.includes('sencillo') ||
              valLower.includes('matrimonial') || valLower.includes('doble') ||
              valLower.includes('tamano') || valLower.includes('tamaño')) {
            sizeIndex = index;
          } 
          // Check for firmness values
          else if (valLower.includes('firm') || valLower.includes('soft') || 
                   valLower.includes('medium') || valLower.includes('plush') ||
                   valLower.includes('luxury') || valLower.includes('standard') ||
                   valLower.includes('comfort') || valLower.includes('support')) {
            firmnessIndex = index;
          }
        });
      }
    }
    
    // Never treat Models / Size slots as firmness
    if (firmnessIndex === modelIndex) firmnessIndex = -1;
    if (firmnessIndex === sizeIndex) firmnessIndex = -1;

    if (sizeIndex === -1 && productData.options.length > 1) {
      sizeIndex = 1;
    } else if (sizeIndex === -1) {
      sizeIndex = 0;
    }

    if (modelIndex === -1 && productData.options && productData.options.length >= 2) {
      for (let mi = 0; mi < productData.options.length; mi += 1) {
        if (mi !== sizeIndex && mi !== firmnessIndex) {
          modelIndex = mi;
          break;
        }
      }
    }

    if (firmnessIndex === -1) {
      for (let fi = 0; fi < productData.options.length; fi += 1) {
        if (fi !== modelIndex && fi !== sizeIndex) {
          const name = optionNames[fi] || '';
          if (name && firmnessKeywords.some((keyword) => name.includes(keyword))) {
            firmnessIndex = fi;
            break;
          }
        }
      }
    }

    if (firmnessIndex === modelIndex) firmnessIndex = -1;
    if (firmnessIndex === sizeIndex) firmnessIndex = -1;

    return { firmnessIndex, sizeIndex, modelIndex };
  }

  function getModelLabelFromVariant(variant, modelIndex) {
    if (!variant) return '';
    if (variant.options && variant.options[modelIndex] !== undefined) {
      return String(variant.options[modelIndex] || '').trim();
    }
    if (modelIndex === 0 && variant.option1) return String(variant.option1).trim();
    if (modelIndex === 1 && variant.option2) return String(variant.option2).trim();
    if (modelIndex === 2 && variant.option3) return String(variant.option3).trim();
    return '';
  }

  function getFirmnessLabelFromVariant(variant, firmnessIndex) {
    if (!variant || firmnessIndex < 0) return '';
    if (variant.options && variant.options[firmnessIndex] !== undefined) {
      return String(variant.options[firmnessIndex] || '').trim();
    }
    if (firmnessIndex === 0 && variant.option1) return String(variant.option1).trim();
    if (firmnessIndex === 1 && variant.option2) return String(variant.option2).trim();
    if (firmnessIndex === 2 && variant.option3) return String(variant.option3).trim();
    return '';
  }

  function normalizeModelLabelForMatch(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, ' ');
  }

  function isNoFoundationModelLabel(label) {
    var nm = normalizeModelLabelForMatch(label);
    if (!nm) return false;
    return (
      nm.includes('no foundation') ||
      nm.includes('no base') ||
      nm.includes('sin base') ||
      nm.includes('sin fundacion') ||
      nm.includes('without foundation') ||
      nm.includes('ninguna base') ||
      nm.includes('ningun base') ||
      nm === 'none' ||
      nm === 'ninguno'
    );
  }

  function filterVariantsByModelLabel(variants, modelFilter, modelIndex) {
    if (!variants || !variants.length || !modelFilter || modelIndex === -1) return variants || [];
    var exact = variants.filter(function (v) {
      return getModelLabelFromVariant(v, modelIndex) === modelFilter;
    });
    if (exact.length) return exact;
    var fuzzy = variants.filter(function (v) {
      return variantHasModelLabel(v, modelFilter);
    });
    if (fuzzy.length) return fuzzy;
    if (isNoFoundationModelLabel(modelFilter)) {
      var noFoundation = variants.filter(function (v) {
        return isNoFoundationModelLabel(getModelLabelFromVariant(v, modelIndex));
      });
      if (noFoundation.length) return noFoundation;
    }
    return variants;
  }

  function normalizeModelLabelStrippedBase(value) {
    return normalizeModelLabelForMatch(String(value || '').trim().replace(/\s+Base\s*$/i, ''));
  }

  function getNoFoundationModelLabel() {
    const cfg = getUnderbedConfig();
    const preferred = (cfg && cfg.noFoundationLabel)
      ? String(cfg.noFoundationLabel).trim()
      : suaveT('noFoundation', 'No Foundation');
    if (!currentMattressProduct || !currentMattressProduct.variants) return '';

    const { modelIndex } = detectOptionTypes(currentMattressProduct);
    if (modelIndex === -1) return '';

    const modelValues = [];
    currentMattressProduct.variants.forEach((v) => {
      const lbl = getModelLabelFromVariant(v, modelIndex);
      if (lbl && !modelValues.includes(lbl)) modelValues.push(lbl);
    });

    const want = normalizeModelLabelForMatch(preferred);
    for (let i = 0; i < modelValues.length; i += 1) {
      if (normalizeModelLabelForMatch(modelValues[i]) === want) return modelValues[i];
    }
    for (let j = 0; j < modelValues.length; j += 1) {
      if (isNoFoundationModelLabel(modelValues[j])) {
        return modelValues[j];
      }
    }
    return modelValues.length === 1 ? modelValues[0] : '';
  }

  /** Map underbed product title (e.g. "Eleva Adjustable Base", "Suave Base") to mattress Models option value. */
  function mattressModelLabelExists(label) {
    if (!label || !currentMattressProduct || !currentMattressProduct.variants) return false;
    var modelIndex = detectOptionTypes(currentMattressProduct).modelIndex;
    if (modelIndex === -1) return false;
    return currentMattressProduct.variants.some(function (v) {
      return (
        getModelLabelFromVariant(v, modelIndex) === label || variantHasModelLabel(v, label)
      );
    });
  }

  function tokenizeUnderbedHandle(handle) {
    return String(handle || '')
      .toLowerCase()
      .split(/[-_/]+/)
      .map(function (token) {
        return token.replace(/[^a-z0-9]/g, '');
      })
      .filter(function (token) {
        return token.length > 1 && token !== 'suave' && token !== 'the';
      });
  }

  function resolveModelLabelFromUnderbedHandle(underbedHandle) {
    if (!underbedHandle || !currentMattressProduct || !currentMattressProduct.variants) return '';
    var modelIndex = detectOptionTypes(currentMattressProduct).modelIndex;
    if (modelIndex === -1) return '';

    var modelValues = [];
    currentMattressProduct.variants.forEach(function (v) {
      var lbl = getModelLabelFromVariant(v, modelIndex);
      if (lbl && modelValues.indexOf(lbl) === -1) modelValues.push(lbl);
    });

    var tokens = tokenizeUnderbedHandle(underbedHandle);
    if (!tokens.length) return '';

    var best = '';
    var bestScore = 0;
    modelValues.forEach(function (modelValue) {
      var norm = normalizeModelLabelForMatch(modelValue);
      var score = 0;
      tokens.forEach(function (token) {
        if (norm.indexOf(token) !== -1) score += token.length;
      });
      if (score > bestScore) {
        bestScore = score;
        best = modelValue;
      }
    });
    return bestScore > 0 ? best : '';
  }

  function resolveModelLabelFromUnderbedCollectionIndex(underbedHandle) {
    var cfg = getUnderbedConfig();
    if (!cfg || !cfg.products || !underbedHandle || !currentMattressProduct || !currentMattressProduct.variants) {
      return '';
    }
    var idx = cfg.products.findIndex(function (p) {
      return p && p.handle === underbedHandle;
    });
    if (idx < 0) return '';

    var modelIndex = detectOptionTypes(currentMattressProduct).modelIndex;
    if (modelIndex === -1) return '';

    var modelValues = [];
    currentMattressProduct.variants.forEach(function (v) {
      var lbl = getModelLabelFromVariant(v, modelIndex);
      if (lbl && modelValues.indexOf(lbl) === -1) modelValues.push(lbl);
    });

    var underbedModels = modelValues.filter(function (modelValue) {
      return !isNoFoundationModelLabel(modelValue) && !isUnderbedReplacementModelLabel(modelValue);
    });
    return underbedModels[idx] || '';
  }

  function resolveModelLabelFromUnderbedTitle(underbedTitle, underbedHandle) {
    if (!underbedTitle && !underbedHandle) return suavePdpNoFoundationLabel();
    if (underbedTitle) {
      var raw = String(underbedTitle).trim();
      if (!currentMattressProduct || !currentMattressProduct.variants) return raw;

      var modelIndex = detectOptionTypes(currentMattressProduct).modelIndex;
      if (modelIndex === -1) return raw;

      var modelValues = [];
      currentMattressProduct.variants.forEach(function (v) {
        var lbl = getModelLabelFromVariant(v, modelIndex);
        if (lbl && modelValues.indexOf(lbl) === -1) modelValues.push(lbl);
      });

      var want = normalizeModelLabelForMatch(raw);
      var wantStripped = normalizeModelLabelStrippedBase(raw);

      for (var i = 0; i < modelValues.length; i++) {
        var nm = normalizeModelLabelForMatch(modelValues[i]);
        if (nm === want || nm === wantStripped) return modelValues[i];
      }
      for (var j = 0; j < modelValues.length; j++) {
        var m = modelValues[j];
        var nm2 = normalizeModelLabelForMatch(m);
        if (want.includes(nm2) || nm2.includes(want) || wantStripped.includes(nm2) || nm2.includes(wantStripped)) {
          return m;
        }
      }
      if (mattressModelLabelExists(raw)) return raw;
    }

    var fromHandle = resolveModelLabelFromUnderbedHandle(underbedHandle);
    if (fromHandle) return fromHandle;

    var fromIndex = resolveModelLabelFromUnderbedCollectionIndex(underbedHandle);
    if (fromIndex) return fromIndex;

    if (underbedTitle) {
      return String(underbedTitle).trim().replace(/\s+Base\s*$/i, '').trim() || underbedTitle;
    }
    return suavePdpNoFoundationLabel();
  }

  function refreshUnderbedMattressGallery() {
    if (!getUnderbedConfig()) return;
    var variant = findMattressVariantForAddToCart();
    if (variant && variant.id) {
      loadVariantImageGallery(String(variant.id));
      updateVariantImageAndFeatures(String(variant.id));
    }
  }

  function getMattressModelLabelForCart() {
    const underbedInput = getSelectedUnderbedInput();
    if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
      const handle = getUnderbedHandleFromInput(underbedInput);
      const title = underbedInput.getAttribute('data-foundation-type') || '';
      return resolveModelLabelFromUnderbedTitle(title, handle);
    }
    if (selectedModelValue) return String(selectedModelValue).trim();
    return getNoFoundationModelLabel();
  }

  function isMattressVariantSellable(v) {
    if (!v) return false;
    if (v.available === true) return true;
    if (v.inventory_policy === 'continue') return true;
    if (v.inventory_quantity != null && parseInt(v.inventory_quantity, 10) > 0) return true;
    if (v.inventory_management == null && v.available !== false) return true;
    return false;
  }

  function getVariantSizeLabel(variant, sizeIndex) {
    if (!variant || sizeIndex < 0) return '';
    if (variant.options && variant.options[sizeIndex] !== undefined) {
      return String(variant.options[sizeIndex] || '').trim();
    }
    if (sizeIndex === 0 && variant.option1) return String(variant.option1).trim();
    if (sizeIndex === 1 && variant.option2) return String(variant.option2).trim();
    if (sizeIndex === 2 && variant.option3) return String(variant.option3).trim();
    return '';
  }

  function variantHasModelLabel(variant, modelLabel) {
    if (!variant || !modelLabel) return false;
    const want = normalizeModelLabelForMatch(modelLabel);
    const values = [];
    if (variant.options && variant.options.length) {
      variant.options.forEach((opt) => {
        if (opt != null && String(opt).trim() !== '') values.push(String(opt).trim());
      });
    } else {
      if (variant.option1) values.push(String(variant.option1).trim());
      if (variant.option2) values.push(String(variant.option2).trim());
      if (variant.option3) values.push(String(variant.option3).trim());
    }
    for (let i = 0; i < values.length; i += 1) {
      const nv = normalizeModelLabelForMatch(values[i]);
      if (nv === want) return true;
      if (nv && want && (nv.includes(want) || want.includes(nv))) return true;
    }
    return false;
  }

  /** Mattress line item variant: current size + firmness + model matching selected underbed (not always "No Foundation"). */
  function findMattressVariantForAddToCart(sizeOverride) {
    if (!currentMattressProduct || !currentMattressProduct.variants || !currentMattressProduct.variants.length) {
      return currentSizeVariant;
    }
    const { firmnessIndex, sizeIndex, modelIndex } = detectOptionTypes(currentMattressProduct);
    const sizeValue = (sizeOverride && String(sizeOverride).trim()) || getCurrentMattressSizeValue();
    const modelLabel = getMattressModelLabelForCart();
    let firmnessLabel = '';
    if (currentFirmnessVariant && firmnessIndex >= 0) {
      firmnessLabel = getFirmnessLabelFromVariant(currentFirmnessVariant, firmnessIndex);
    }

    let candidates = currentMattressProduct.variants.slice();
    if (modelLabel) {
      if (modelIndex >= 0) {
        const byIndex = candidates.filter((v) => getModelLabelFromVariant(v, modelIndex) === modelLabel);
        if (byIndex.length) candidates = byIndex;
        else candidates = candidates.filter((v) => variantHasModelLabel(v, modelLabel));
      } else {
        candidates = candidates.filter((v) => variantHasModelLabel(v, modelLabel));
      }
    }
    if (sizeValue && sizeIndex >= 0) {
      candidates = candidates.filter((v) => mattressSizesMatch(getVariantSizeLabel(v, sizeIndex), sizeValue));
    }
    const hasDistinctFirmness =
      firmnessLabel &&
      firmnessIndex >= 0 &&
      firmnessIndex !== modelIndex &&
      firmnessIndex !== sizeIndex;
    if (hasDistinctFirmness) {
      candidates = candidates.filter((v) => getFirmnessLabelFromVariant(v, firmnessIndex) === firmnessLabel);
    }

    if (!candidates.length && modelLabel) {
      candidates = currentMattressProduct.variants.filter((v) => variantHasModelLabel(v, modelLabel));
      if (sizeValue && sizeIndex >= 0) {
        candidates = candidates.filter((v) => mattressSizesMatch(getVariantSizeLabel(v, sizeIndex), sizeValue));
      }
      if (hasDistinctFirmness) {
        candidates = candidates.filter((v) => getFirmnessLabelFromVariant(v, firmnessIndex) === firmnessLabel);
      }
    }

    if (!candidates.length) return currentSizeVariant;
    const sellable = candidates.find(isMattressVariantSellable);
    return sellable || candidates[0] || currentSizeVariant;
  }

  /** When underbed collection base is selected, sync mattress model + size dropdown to matching variants. */
  function syncMattressModelFromUnderbedSelection() {
    if (!currentMattressProduct || !currentMattressProduct.variants) return;
    const { modelIndex, sizeIndex } = detectOptionTypes(currentMattressProduct);
    if (modelIndex === -1) return;

    const modelLabel = getMattressModelLabelForCart();
    selectedModelValue = modelLabel;

    const underbedInput = getSelectedUnderbedInput();
    if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
      selectedFoundationType = underbedInput.getAttribute('data-foundation-type') || modelLabel;
    } else {
      selectedFoundationType = suavePdpNoFoundationLabel();
    }

    let matchingVariants = currentMattressProduct.variants.filter(function (v) {
      return getModelLabelFromVariant(v, modelIndex) === modelLabel;
    });
    if (!matchingVariants.length) {
      matchingVariants = currentMattressProduct.variants.filter(function (v) {
        return variantHasModelLabel(v, modelLabel);
      });
    }
    if (!matchingVariants.length && isNoFoundationModelLabel(modelLabel)) {
      matchingVariants = currentMattressProduct.variants.filter(function (v) {
        return isNoFoundationModelLabel(getModelLabelFromVariant(v, modelIndex));
      });
    }
    const { firmnessIndex } = detectOptionTypes(currentMattressProduct);
    if (
      currentFirmnessVariant &&
      firmnessIndex >= 0 &&
      firmnessIndex !== modelIndex &&
      firmnessIndex !== sizeIndex
    ) {
      const firmnessLabel = getFirmnessLabelFromVariant(currentFirmnessVariant, firmnessIndex);
      if (firmnessLabel) {
        matchingVariants = matchingVariants.filter(
          (v) => getFirmnessLabelFromVariant(v, firmnessIndex) === firmnessLabel
        );
      }
    }
    if (matchingVariants.length) {
      applyMattressVariantsForModelSelection(currentMattressProduct, modelIndex, sizeIndex, matchingVariants);
    }
  }

  function buildVariantGalleryImages(variantId) {
    const featured = getVariantFeaturedImageData(variantId);
    const galleryUrls = getVariantMetafieldGalleryUrls(variantId);
    const images = [];
    const seen = new Set();

    if (featured && featured.src && !seen.has(featured.src)) {
      images.push(featured);
      seen.add(featured.src);
    }

    galleryUrls.forEach(function (src) {
      const normalized = normalizePdpImageUrl(String(src || '').trim());
      if (normalized && !seen.has(normalized)) {
        images.push({
          src: normalized,
          alt: (featured && featured.alt) || 'Variant image'
        });
        seen.add(normalized);
      }
    });

    return images;
  }

  function getUnderbedConfig() {
    if (typeof window === 'undefined' || !window.__PDP_UNDERBED_CONFIG__) return null;
    const cfg = window.__PDP_UNDERBED_CONFIG__;
    if (!cfg.products || !Array.isArray(cfg.products) || cfg.products.length === 0) return null;
    return cfg;
  }

  /** In-memory discount maps by handle (from collection JSON) — survives firmness switches without refresh */
  var variantDiscountsByHandle = new Map();

  function rememberVariantDiscountsForHandle(handle, map) {
    if (!handle || !map || typeof map !== 'object') return;
    if (!Object.keys(map).length) return;
    variantDiscountsByHandle.set(String(handle).trim(), map);
  }

  /** Convert compact Liquid variantDiscountList → id-keyed map */
  function variantDiscountListToMap(list) {
    if (!Array.isArray(list) || !list.length) return null;
    var map = {};
    for (var i = 0; i < list.length; i++) {
      var row = list[i];
      if (!row || row.id == null) continue;
      var amt = parseFloat(row.discountAmount) || 0;
      var pct = parseFloat(row.discountPercentage) || 0;
      var badge = row.saleBadgeText != null ? String(row.saleBadgeText).trim() : '';
      if (!(amt > 0 || pct > 0 || badge)) continue;
      map[String(row.id)] = {
        discountAmount: amt > 0 ? amt : 0,
        discountPercentage: amt > 0 ? 0 : pct > 0 ? pct : 0,
        saleBadgeText: badge
      };
    }
    return Object.keys(map).length ? map : null;
  }

  function readVariantDiscountsFromComfortCard(card) {
    if (!card) return null;
    var raw = card.getAttribute('data-variant-discounts');
    if (!raw) return null;
    try {
      var map = JSON.parse(raw);
      if (map && typeof map === 'object' && Object.keys(map).length) return map;
    } catch (err) {
      /* ignore */
    }
    return null;
  }

  function stampComfortCardDiscountData(card, itemProduct, collectionItem) {
    if (!card || !itemProduct) return;
    var map =
      (itemProduct.variantDiscounts && Object.keys(itemProduct.variantDiscounts).length
        ? itemProduct.variantDiscounts
        : null) ||
      getVariantDiscountsForHandle(itemProduct.handle) ||
      (collectionItem && variantDiscountListToMap(collectionItem.variantDiscountList));
    if (map && Object.keys(map).length) {
      try {
        card.setAttribute('data-variant-discounts', JSON.stringify(map));
      } catch (err) {
        /* ignore */
      }
      rememberVariantDiscountsForHandle(itemProduct.handle, map);
      itemProduct.variantDiscounts = map;
    }
    var amt =
      collectionItem && collectionItem.discountAmount != null
        ? collectionItem.discountAmount
        : itemProduct.discountAmount;
    var pct =
      collectionItem && collectionItem.discountPercentage != null
        ? collectionItem.discountPercentage
        : itemProduct.discountPercentage;
    var badge =
      collectionItem && collectionItem.saleBadgeText != null
        ? collectionItem.saleBadgeText
        : itemProduct.saleBadgeText;
    if (amt != null && amt !== '') card.setAttribute('data-product-discount-amount', String(amt));
    if (pct != null && pct !== '') card.setAttribute('data-product-discount-percentage', String(pct));
    if (badge != null) card.setAttribute('data-product-sale-badge-text', String(badge));
  }

  /** Ingest all suave-firmness-variant-discounts registry scripts into memory */
  function ingestFirmnessVariantDiscountRegistries() {
    var nodes = document.querySelectorAll('script.suave-firmness-variant-discounts');
    for (var i = 0; i < nodes.length; i++) {
      try {
        var text = (nodes[i].textContent || '').trim();
        if (!text) continue;
        var all = JSON.parse(text);
        if (!all || typeof all !== 'object') continue;
        Object.keys(all).forEach(function (handle) {
          if (all[handle] && typeof all[handle] === 'object' && Object.keys(all[handle]).length) {
            rememberVariantDiscountsForHandle(handle, all[handle]);
          }
        });
      } catch (err) {
        /* ignore bad registry */
      }
    }
  }

  /** Seed memory from every collection tab's variantDiscountList (no fetch needed). */
  function ingestCollectionVariantDiscountLists() {
    var tabs = document.querySelectorAll('#custom-product-container .tab[data-collection-products]');
    for (var t = 0; t < tabs.length; t++) {
      var products = parseCollectionProductsFromTab(tabs[t]);
      for (var i = 0; i < products.length; i++) {
        var item = products[i];
        if (!item || !item.handle) continue;
        var map = variantDiscountListToMap(item.variantDiscountList);
        if (map) rememberVariantDiscountsForHandle(item.handle, map);
      }
    }
  }

  function seedPdpVariantDiscountMemory() {
    ingestFirmnessVariantDiscountRegistries();
    ingestCollectionVariantDiscountLists();
    try {
      var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
      if (
        store.variantDiscounts &&
        Object.keys(store.variantDiscounts).length &&
        store.variantDiscountsProductHandle
      ) {
        rememberVariantDiscountsForHandle(store.variantDiscountsProductHandle, store.variantDiscounts);
      }
    } catch (err) {
      /* ignore */
    }
  }

  /** Merge Liquid collection-item discount data onto a fetched product.js object */
  function applyCollectionItemDiscountData(itemProduct, collectionItem) {
    if (!itemProduct) return itemProduct;
    var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    ingestFirmnessVariantDiscountRegistries();

    var map = getVariantDiscountsForHandle(itemProduct.handle);
    if (!map && collectionItem) {
      map = variantDiscountListToMap(collectionItem.variantDiscountList);
    }
    if (
      !map &&
      collectionItem &&
      collectionItem.variantDiscounts &&
      typeof collectionItem.variantDiscounts === 'object' &&
      Object.keys(collectionItem.variantDiscounts).length
    ) {
      map = collectionItem.variantDiscounts;
    }
    if (map && Object.keys(map).length) {
      itemProduct.variantDiscounts = map;
      rememberVariantDiscountsForHandle(itemProduct.handle, map);
    } else if (
      itemProduct.variantDiscounts &&
      typeof itemProduct.variantDiscounts === 'object' &&
      Object.keys(itemProduct.variantDiscounts).length
    ) {
      rememberVariantDiscountsForHandle(itemProduct.handle, itemProduct.variantDiscounts);
    } else if (!itemProduct.variantDiscounts) {
      itemProduct.variantDiscounts = {};
    }

    if (store.enableVariantMetafieldDiscounts) {
      // Variant mode: amounts/badges come from the per-variant map only
      itemProduct.discountPercentage = 0;
      itemProduct.discountAmount = 0;
      itemProduct.saleBadgeText = '';
      if (map && currentSizeVariant) {
        var entry = map[currentSizeVariant.id] || map[String(currentSizeVariant.id)];
        if (entry && entry.saleBadgeText) {
          itemProduct.saleBadgeText = String(entry.saleBadgeText).trim();
        }
      }
    } else if (store.enableProductMetafieldDiscounts !== false && collectionItem) {
      if (collectionItem.discountPercentage != null) {
        itemProduct.discountPercentage = collectionItem.discountPercentage;
      }
      if (collectionItem.discountAmount != null) {
        itemProduct.discountAmount = collectionItem.discountAmount;
      }
      if (collectionItem.saleBadgeText != null) {
        itemProduct.saleBadgeText = collectionItem.saleBadgeText;
      }
    }
    return itemProduct;
  }

  /** Final paint of main price attrs + badge + compare after firmness/size is settled */
  function paintPdpDiscountsForCurrentProduct(source) {
    var product = source || currentMattressProduct;
    if (!product) return;
    bindProductVariantDiscounts(product);
    syncPdpDisplayDiscountMeta(product);
    updateTotalPrice();
    updateFirmnessLabelPrices();
    refreshPdpSaleBadge(product);
  }

  function findCollectionItemByHandle(handle) {
    if (!handle) return null;
    var tab = document.querySelector('#custom-product-container .tab.active');
    var products = parseCollectionProductsFromTab(tab);
    var needle = String(handle).trim();
    for (var i = 0; i < products.length; i++) {
      if (products[i] && String(products[i].handle || '').trim() === needle) return products[i];
    }
    return null;
  }

  function getVariantDiscountsForHandle(handle) {
    if (!handle) return null;
    var needle = String(handle).trim();
    if (!needle) return null;

    ingestFirmnessVariantDiscountRegistries();

    // 1) Memory
    if (variantDiscountsByHandle.has(needle)) {
      return variantDiscountsByHandle.get(needle);
    }

    // 2) Active tab collection JSON (variantDiscountList)
    try {
      var collItem = findCollectionItemByHandle(needle);
      var fromList = collItem && variantDiscountListToMap(collItem.variantDiscountList);
      if (fromList) {
        rememberVariantDiscountsForHandle(needle, fromList);
        return fromList;
      }
    } catch (listErr) {
      /* ignore */
    }

    // 3) Script tags in the page (ignore empty {})
    try {
      var nodes = document.querySelectorAll('script.suave-variant-discounts-json[data-product-handle]');
      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        var nodeHandle = (node.getAttribute('data-product-handle') || '').trim();
        if (nodeHandle !== needle) continue;
        if (!node.textContent) continue;
        var parsed = JSON.parse(node.textContent.trim());
        if (!parsed || typeof parsed !== 'object') continue;
        if (Object.keys(parsed).length) {
          rememberVariantDiscountsForHandle(needle, parsed);
          return parsed;
        }
      }
    } catch (err) {
      /* ignore */
    }

    // 4) __PDP_STORE__ when it belongs to this handle
    try {
      var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
      if (
        store.variantDiscounts &&
        Object.keys(store.variantDiscounts).length &&
        store.variantDiscountsProductHandle &&
        String(store.variantDiscountsProductHandle) === needle
      ) {
        rememberVariantDiscountsForHandle(needle, store.variantDiscounts);
        return store.variantDiscounts;
      }
    } catch (errStore) {
      /* ignore */
    }

    return null;
  }

  var variantDiscountsFetchInflight = new Map();

  /**
   * Ensure discount map for a product handle is loaded.
   * 1) in-page / memory
   * 2) ?view=suave-discounts (layout:false JSON template)
   * 3) scrape full product HTML for suave-variant-discounts-json / __PDP_STORE__
   */
  async function ensureVariantDiscountsLoaded(handle) {
    var needle = String(handle || '').trim();
    if (!needle) return null;

    seedPdpVariantDiscountMemory();

    var existing = getVariantDiscountsForHandle(needle);
    if (existing && Object.keys(existing).length) return existing;

    // Collection tab JSON (variantDiscountList) — no network, same metafields as Liquid
    try {
      var collItem = findCollectionItemByHandle(needle);
      var fromList = collItem && variantDiscountListToMap(collItem.variantDiscountList);
      if (fromList) {
        rememberVariantDiscountsForHandle(needle, fromList);
        return fromList;
      }
    } catch (listErr) {
      /* continue */
    }

    var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    if (!store.enableVariantMetafieldDiscounts) return existing || null;

    if (variantDiscountsFetchInflight.has(needle)) {
      return variantDiscountsFetchInflight.get(needle);
    }

    var fetchPromise = (async function () {
      function tryParseDiscountJson(text) {
        if (!text) return null;
        var raw = String(text).trim();
        var start = raw.indexOf('{');
        var end = raw.lastIndexOf('}');
        if (start === -1 || end === -1 || end < start) return null;
        try {
          var parsed = JSON.parse(raw.slice(start, end + 1));
          if (parsed && typeof parsed === 'object' && Object.keys(parsed).length) return parsed;
        } catch (e) {
          /* ignore */
        }
        return null;
      }

      function rememberIfValid(map) {
        if (map && Object.keys(map).length) {
          rememberVariantDiscountsForHandle(needle, map);
          return map;
        }
        return null;
      }

      // A) Lightweight alternate product template
      try {
        var viewUrl = suavePdpProductViewUrl(needle, 'suave-discounts');
        var viewRes = await fetch(viewUrl, { credentials: 'same-origin' });
        if (viewRes.ok) {
          var viewMap = rememberIfValid(tryParseDiscountJson(await viewRes.text()));
          if (viewMap) return viewMap;
        }
      } catch (viewErr) {
        /* continue to HTML scrape */
      }

      // B) Scrape the product page HTML (metafields resolve on that product's URL)
      try {
        var pageUrl = suavePdpRootUrl() + 'products/' + encodeURIComponent(needle);
        var pageRes = await fetch(pageUrl, { credentials: 'same-origin' });
        if (pageRes.ok) {
          var html = await pageRes.text();
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nodes = doc.querySelectorAll('script.suave-variant-discounts-json');
          var ni;
          for (ni = 0; ni < nodes.length; ni++) {
            var nodeHandle = (nodes[ni].getAttribute('data-product-handle') || '').trim();
            if (nodeHandle && nodeHandle !== needle) continue;
            var fromScript = rememberIfValid(tryParseDiscountJson(nodes[ni].textContent));
            if (fromScript) return fromScript;
          }
          // Fallback: __PDP_STORE__.variantDiscounts on that product page
          var storeNodes = doc.querySelectorAll('script');
          for (ni = 0; ni < storeNodes.length; ni++) {
            var st = storeNodes[ni].textContent || '';
            if (st.indexOf('__PDP_STORE__') === -1 || st.indexOf('variantDiscounts') === -1) continue;
            var vdMatch = st.match(/variantDiscounts\s*:\s*(\{[\s\S]*?\})\s*(?:,\s*\w+\s*:|\s*\})/);
            if (vdMatch && vdMatch[1]) {
              var fromStore = rememberIfValid(tryParseDiscountJson(vdMatch[1]));
              if (fromStore) return fromStore;
            }
            var fromWhole = rememberIfValid(tryParseDiscountJson(st));
            if (fromWhole && fromWhole.variantDiscounts) {
              var nested = rememberIfValid(fromWhole.variantDiscounts);
              if (nested) return nested;
            }
          }
        }
      } catch (pageErr) {
        console.warn('Suave PDP: could not scrape variant discounts for', needle, pageErr);
      }

      return getVariantDiscountsForHandle(needle);
    })().finally(function () {
      variantDiscountsFetchInflight.delete(needle);
    });

    variantDiscountsFetchInflight.set(needle, fetchPromise);
    return fetchPromise;
  }

  /** Bind per-product variant discount map; never reuse another product's map. */
  function bindProductVariantDiscounts(product) {
    if (!product) return {};
    var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    var fromHandle = getVariantDiscountsForHandle(product.handle);
    var nextMap = null;

    if (fromHandle && typeof fromHandle === 'object' && Object.keys(fromHandle).length) {
      nextMap = fromHandle;
    } else if (product.variantDiscounts && Object.keys(product.variantDiscounts).length) {
      nextMap = product.variantDiscounts;
    } else if (
      store.variantDiscounts &&
      Object.keys(store.variantDiscounts).length &&
      store.variantDiscountsProductHandle &&
      String(store.variantDiscountsProductHandle) === String(product.handle || '')
    ) {
      nextMap = store.variantDiscounts;
    } else if (fromHandle && typeof fromHandle === 'object') {
      nextMap = fromHandle;
    } else {
      nextMap = {};
    }

    product.variantDiscounts = nextMap;
    if (Object.keys(nextMap).length) {
      rememberVariantDiscountsForHandle(product.handle, nextMap);
    }

    if (window.__PDP_STORE__ && Object.keys(nextMap).length) {
      window.__PDP_STORE__.variantDiscounts = nextMap;
      window.__PDP_STORE__.variantDiscountsProductHandle = product.handle || '';
    } else if (
      window.__PDP_STORE__ &&
      product.handle &&
      window.__PDP_STORE__.variantDiscountsProductHandle &&
      String(window.__PDP_STORE__.variantDiscountsProductHandle) === String(product.handle)
    ) {
      window.__PDP_STORE__.variantDiscounts = nextMap;
    }

    if (store.enableVariantMetafieldDiscounts) {
      product.saleBadgeText = '';
      var variant = currentSizeVariant || null;
      if (variant) {
        var entry = getVariantDiscountEntry(variant, product);
        if (entry && entry.saleBadgeText) {
          product.saleBadgeText = String(entry.saleBadgeText).trim();
        }
      }
    }
    return product.variantDiscounts;
  }

  function refreshPdpSaleBadge(source, saleCents, compareCents, variant) {
    var badgeEl = document.getElementById('suave-pdp-sale-badge');
    if (!badgeEl) return;
    var activeVariant = variant || currentSizeVariant;
    var text = resolveSaleBadgeText(
      source || currentMattressProduct,
      saleCents,
      compareCents,
      activeVariant
    );
    // Don't wipe Liquid badge before a size/price variant is known
    if (!text && !activeVariant) return;
    // If discount is still active but auto-text briefly empty, keep / rebuild — otherwise clear
    if (!text && badgeEl.textContent && String(badgeEl.textContent).trim()) {
      var disc = resolveActiveDisplayDiscount(activeVariant, source || currentMattressProduct);
      if (disc.amount > 0 || disc.percent > 0) {
        if (saleCents != null && compareCents != null && compareCents > saleCents) {
          text = formatAmountOffBadge(compareCents - saleCents);
        } else if (disc.saleBadgeText) {
          text = disc.saleBadgeText;
        }
        if (!text) return;
      }
    }
    applySaleBadgeElement(badgeEl, text);
    var activeTabForBadge = document.querySelector('#custom-product-container .tab.active');
    if (activeTabForBadge) {
      var tabColorForBadge = activeTabForBadge.getAttribute('data-tab-color');
      if (tabColorForBadge) applyTabColorToPdpElements(tabColorForBadge);
    }
  }

  function isUnderbedReplacementModelLabel(modelValue) {
    const cfg = getUnderbedConfig();
    if (!cfg) return false;
    const trigger = cfg.modelLabel ? String(cfg.modelLabel).trim().toLowerCase() : 'base';
    if (!trigger) return false;
    const normalized = String(modelValue || '').trim().toLowerCase();
    return normalized === trigger || normalized.includes(trigger) || trigger.includes(normalized);
  }

  function clearFoundationOptionSelection(container) {
    if (!container) return;
    container.querySelectorAll('.foundation-option').forEach((o) => {
      o.classList.remove('selected');
      const input = o.querySelector('input[type="radio"]');
      if (input) input.checked = false;
    });
    var activeTabForFoundation = document.querySelector('#custom-product-container .tab.active');
    applyFoundationOptionTabColor(
      activeTabForFoundation ? activeTabForFoundation.getAttribute('data-tab-color') : ''
    );
  }

  function selectFoundationOptionElement(optionEl, container) {
    if (!optionEl || !container) return;
    clearFoundationOptionSelection(container);
    optionEl.classList.add('selected');
    const input = optionEl.querySelector('input[type="radio"]');
    if (input) input.checked = true;
    var activeTabForFoundation = document.querySelector('#custom-product-container .tab.active');
    applyFoundationOptionTabColor(
      activeTabForFoundation ? activeTabForFoundation.getAttribute('data-tab-color') : ''
    );
  }

  function applyMattressVariantsForModelSelection(productData, modelIndex, sizeIndex, matchingVariants) {
    if (!matchingVariants || matchingVariants.length === 0) return;
    const preserveSize =
      getCurrentMattressSizeValueFromUI() || getCurrentMattressSizeValue();
    updateSizeOptionsForFirmness(matchingVariants, sizeIndex, preserveSize);

    let variantToUse = null;
    if (preserveSize && sizeIndex >= 0) {
      variantToUse = matchingVariants.find((v) =>
        mattressSizesMatch(getVariantSizeLabel(v, sizeIndex), preserveSize)
      );
    }
    if (!variantToUse && currentSizeVariant && matchingVariants.some((v) => v.id === currentSizeVariant.id)) {
      variantToUse = currentSizeVariant;
    }
    if (!variantToUse) {
      variantToUse =
        matchingVariants.find(isMattressVariantSellable) || matchingVariants[0];
    }
    if (variantToUse) currentSizeVariant = variantToUse;
    currentFirmnessVariant = variantToUse;
    if (variantToUse && variantToUse.id) {
      const variantId = variantToUse.id.toString();
      const underbedMode = !!getUnderbedConfig();
      if (!isFoundationSelected || underbedMode) {
        loadVariantImageGallery(variantId);
      } else if (currentMattressImages && currentMattressImages.length > 0) {
        loadProductImages(currentMattressImages);
      }
      updateVariantInfo(variantId);
      updateVariantImageAndFeatures(variantId);
      updateVariantTechnicalSpecs(variantId);
      updateVariantPerformanceBlocks(variantId);
    }
    updateVariantNameDisplay();
    updateButtonStates();
  }

  function buildModelOptionHtml(modelValue, variants, checked) {
    const isAvailable = variants.some(v => v && v.available !== false);
    const firstVariant = variants[0] || null;
    const modelPrice = firstVariant && typeof firstVariant.price === 'number' ? firstVariant.price : 0;
    const modelSubtitle = isAvailable
      ? `Select ${modelValue} model for your bed setup.`
      : 'Out of stock for selected product';
    return `
      <label class="foundation-option model-option${checked ? ' selected' : ''}${!isAvailable ? ' out-of-stock' : ''}" data-model-value="${escapeAttr(modelValue)}" data-foundation-type="${escapeAttr(modelValue)}">
        ${!isAvailable ? '<span class="out-of-stock-badge">Out of Stock</span>' : ''}
        <input type="radio" name="model" value="${escapeAttr(modelValue)}" data-foundation-type="${escapeAttr(modelValue)}" ${checked ? 'checked' : ''} ${!isAvailable ? 'disabled' : ''} class="foundation-input">
        <span class="foundation-indicator"></span>
        <div class="foundation-content">
          <p class="foundation-title ${checked ? 'pdp-text-color' : ''}">${escapeHtmlText(modelValue)}</p>
          <p class="foundation-subtitle" style="color: ${isAvailable ? '#666' : '#ff4444'};">
            ${escapeHtmlText(modelSubtitle)}
          </p>
        </div>
        <p class="foundation-price ${checked ? 'pdp-text-color' : ''}">${modelPrice > 0 ? '+' + formatMoney(modelPrice) : formatMoney(modelPrice)}</p>
      </label>
    `;
  }

  function renderModelOptionsForCurrentProduct(productData) {
    const foundationContainer = document.getElementById('foundation-options-container');
    if (!foundationContainer || !productData || !productData.variants || !productData.variants.length) return false;
    const { modelIndex, sizeIndex } = detectOptionTypes(productData);
    if (modelIndex === -1 || modelIndex === sizeIndex) return false;

    const modelMap = new Map();
    productData.variants.forEach((variant) => {
      const modelValue = getModelLabelFromVariant(variant, modelIndex);
      if (!modelValue) return;
      if (!modelMap.has(modelValue)) modelMap.set(modelValue, []);
      modelMap.get(modelValue).push(variant);
    });
    if (modelMap.size === 0) return false;

    let modelsHtml = '';
    let optionIndex = 0;
    let firstModel = '';

    modelMap.forEach((variants, modelValue) => {
      const checked = optionIndex === 0;
      if (checked) {
        firstModel = modelValue;
        selectedUnderbedProduct = null;
      }
      modelsHtml += buildModelOptionHtml(modelValue, variants, checked);
      optionIndex += 1;
    });

    foundationContainer.innerHTML = modelsHtml;
    selectedModelValue = firstModel;
    selectedFoundationType = firstModel;
    selectedUnderbedProduct = null;

    const modelOptions = foundationContainer.querySelectorAll('.model-option');
    modelOptions.forEach((optionEl) => {
      optionEl.addEventListener('click', function () {
        const modelValue = this.getAttribute('data-model-value') || '';
        if (!modelValue) return;
        selectedModelValue = modelValue;
        selectedFoundationType = modelValue;
        selectedUnderbedProduct = null;
        foundationContainer.querySelectorAll('input[name="underbed"]').forEach((i) => { i.checked = false; });
        selectFoundationOptionElement(this, foundationContainer);
        const input = this.querySelector('input[name="model"]');
        foundationContainer.querySelectorAll('input[name="model"]').forEach((i) => { i.checked = false; });
        if (input) input.checked = true;

        const matchingVariants = productData.variants.filter(v => getModelLabelFromVariant(v, modelIndex) === modelValue);
        applyMattressVariantsForModelSelection(productData, modelIndex, sizeIndex, matchingVariants);
      });
    });

    return true;
  }
  
  /** Normalize mattress/foundation size labels for comparison (spacing, dashes, case). */
  function normalizeMattressSizeLabel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/[-–—]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compactBedSizeKey(value) {
    return normalizeMattressSizeLabel(value).replace(/\s+/g, '');
  }

  function mattressSizesMatch(a, b) {
    const na = normalizeMattressSizeLabel(a);
    const nb = normalizeMattressSizeLabel(b);
    if (!na || !nb) return false;
    if (na === nb) return true;
    if (compactBedSizeKey(a) === compactBedSizeKey(b)) return true;
    var ca = bedSizeCanonicalKey(a);
    var cb = bedSizeCanonicalKey(b);
    return !!(ca && cb && ca === cb);
  }

  /**
   * Mattress Split King / Split Cal King often map to foundation King / Cal King when split sizes are not sold on the base.
   * Returns labels to try in order: exact mattress size first, then English/Spanish aliases for the same bed size.
   */
  function getFoundationSizeLookupLabels(sizeValue) {
    const raw = (sizeValue || '').toString().trim();
    if (!raw) return [];
    const labels = [];
    const seen = new Set();

    function addLabel(label) {
      const s = String(label || '').trim();
      if (!s) return;
      const key = s.toLowerCase();
      if (seen.has(key)) return;
      seen.add(key);
      labels.push(s);
    }

    function addTitleCase(label) {
      addLabel(label);
      addLabel(
        String(label || '').replace(/\b\w/g, function (c) {
          return c.toUpperCase();
        })
      );
    }

    addLabel(raw);
    const key = bedSizeCanonicalKey(raw);
    if (key) {
      for (var gi = 0; gi < BED_SIZE_ALIAS_GROUPS.length; gi++) {
        var group = BED_SIZE_ALIAS_GROUPS[gi];
        if (bedSizeCanonicalKey(group[0]) === key) {
          for (var ai = 0; ai < group.length; ai++) {
            addTitleCase(group[ai]);
          }
          break;
        }
      }
    }

    if (key === 'split king' || compactBedSizeKey(key || raw) === 'splitking') {
      addTitleCase('King');
      addTitleCase('Rey');
    } else if (key === 'split cal king' || compactBedSizeKey(key || raw) === 'splitcalking') {
      addTitleCase('Cal King');
      addTitleCase('California King');
      addTitleCase('Rey California');
    }

    return labels;
  }

  /**
   * True if the foundation product lists this mattress size on its size option (1-option = size only, 2-option = size on option2).
   * When unknown structure or no foundation loaded, do not restrict the size dropdown.
   */
  function foundationProductHasMattressSizeForDropdown(foundationProduct, mattressSizeLabel) {
    if (!foundationProduct || !foundationProduct.variants || !foundationProduct.variants.length) return true;
    const opts = foundationProduct.options || [];
    const hasTwo = opts.length >= 2;
    const hasOne = opts.length === 1;
    if (!hasTwo && !hasOne) return true;
    const sizeVal = (mattressSizeLabel || '').toString().trim();
    if (!sizeVal) return true;
    const labels = getFoundationSizeLookupLabels(sizeVal);
    for (let li = 0; li < labels.length; li++) {
      const checkSize = labels[li];
      if (hasOne) {
        if (foundationProduct.variants.some(function (v) {
          const vSize = (v.option1 || (v.options && v.options[0]) || '').toString().trim();
          return foundationMattressSizesCompatible(vSize, checkSize) || foundationMattressSizesCompatible(vSize, sizeVal);
        })) return true;
      } else if (foundationProduct.variants.some(function (v) {
        const vSize = (v.option2 || (v.options && v.options[1]) || '').toString().trim();
        return foundationMattressSizesCompatible(vSize, checkSize) || foundationMattressSizesCompatible(vSize, sizeVal);
      })) return true;
    }
    return false;
  }

  /** Size label from size dropdown UI only (not currentSizeVariant, which can be stale after model sync). */
  function getCurrentMattressSizeValueFromUI() {
    const sizeSelect = document.getElementById('size-select');
    if (sizeSelect && sizeSelect.selectedIndex >= 0) {
      const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      if (selectedOption && selectedOption.value && currentMattressProduct && currentMattressProduct.variants) {
        const variantId = String(selectedOption.value).trim();
        const variant = currentMattressProduct.variants.find(function (v) {
          return v && String(v.id) === variantId;
        });
        if (variant) {
          const detected = detectOptionTypes(currentMattressProduct);
          const sizeLabel = getVariantSizeLabel(variant, detected.sizeIndex);
          if (sizeLabel) return sizeLabel;
        }
        const fromDataset = selectedOption.getAttribute('data-size');
        if (fromDataset && String(fromDataset).trim()) return String(fromDataset).trim();
        const text = (selectedOption.textContent || '').trim();
        const sizeOnly = text.split(' - ')[0].split('|')[0].trim();
        if (sizeOnly && sizeOnly !== 'No sizes available') return sizeOnly;
      }
    }
    const customSelected = document.querySelector('#custom-product-container .custom-dropdown-selected .selected-size');
    if (customSelected && customSelected.textContent) {
      const t = customSelected.textContent.trim();
      const sizeOnly = t.split('|')[0].trim();
      if (sizeOnly && sizeOnly !== suavePdpT('selectSize', 'Select Size')) return sizeOnly;
    }
    return '';
  }

  /** Returns current mattress size value (e.g. "Twin", "Queen") or empty string if none selected. Used to sync foundation variant. */
  function getCurrentMattressSizeValue() {
    const fromUI = getCurrentMattressSizeValueFromUI();
    if (fromUI) return fromUI;
    if (currentMattressProduct && currentSizeVariant) {
      const { sizeIndex } = detectOptionTypes(currentMattressProduct);
      if (currentSizeVariant.options && currentSizeVariant.options[sizeIndex] !== undefined) {
        const v = String(currentSizeVariant.options[sizeIndex]).trim();
        if (v) return v;
      }
      if (sizeIndex === 0 && currentSizeVariant.option1) return String(currentSizeVariant.option1).trim();
      if (sizeIndex === 1 && currentSizeVariant.option2) return String(currentSizeVariant.option2).trim();
      if (sizeIndex === 2 && currentSizeVariant.option3) return String(currentSizeVariant.option3).trim();
    }
    return '';
  }
  
  /** Foundation product: option1 = Foundation Type, option2 = Size. Returns variant matching (foundation type + mattress size) or null. */
  function getFoundationVariantBySizeAndType(foundationProduct, sizeValue, foundationTypeValue) {
    if (!foundationProduct || !foundationProduct.variants || !foundationTypeValue) return null;
    const typeVal = foundationTypeValue.toString().trim();
    const labels = getFoundationSizeLookupLabels(sizeValue);
    const trySizes = labels.length ? labels : [''];
    for (let li = 0; li < trySizes.length; li++) {
      const sizeVal = trySizes[li].toString().trim();
      const found = foundationProduct.variants.find(function (v) {
        const vType = (v.option1 || (v.options && v.options[0]) || '').toString().trim();
        const vSize = (v.option2 || (v.options && v.options[1]) || '').toString().trim();
        return vType === typeVal && (sizeVal === '' || mattressSizesMatch(vSize, sizeVal));
      });
      if (found) return found;
    }
    return null;
  }
  
  /** Get first variant for a foundation type (option1 = Foundation Type). For display when no size selected. */
  function getFirstVariantForFoundationType(foundationProduct, foundationTypeValue) {
    if (!foundationProduct || !foundationProduct.variants || !foundationTypeValue) return null;
    const typeVal = foundationTypeValue.toString().trim();
    return foundationProduct.variants.find(function (v) {
      const vType = (v.option1 || (v.options && v.options[0]) || '').toString().trim();
      return vType === typeVal;
    }) || null;
  }
  
  /** Foundation product with only size variants: find variant matching size (option1 / options[0]). */
  function getFoundationVariantBySize(foundationProduct, sizeValue) {
    if (!foundationProduct || !foundationProduct.variants) return null;
    const labels = getFoundationSizeLookupLabels(sizeValue);
    if (!labels.length) return foundationProduct.variants[0] || null;
    for (let li = 0; li < labels.length; li++) {
      const sizeVal = labels[li].toString().trim();
      if (!sizeVal) continue;
      const found = foundationProduct.variants.find(function (v) {
        const vSize = (v.option1 || (v.options && v.options[0]) || '').toString().trim();
        return mattressSizesMatch(vSize, sizeVal);
      });
      if (found) return found;
    }
    return null;
  }
  
  async function fetchProductByHandle(handle) {
    if (!handle) return null;
    var cacheKey = handle + ':' + (suavePdpIsSpanishLocale() ? 'es' : 'en');
    if (collectionProductCache.has(cacheKey)) {
      var cached = collectionProductCache.get(cacheKey);
      var cachedMap = getVariantDiscountsForHandle((cached && cached.handle) || handle);
      if (cachedMap && Object.keys(cachedMap).length) {
        cached.variantDiscounts = cachedMap;
      }
      return cached;
    }
    try {
      const response = await fetch(suavePdpProductJsonUrl(handle));
      if (!response.ok) return null;
      const product = await response.json();
      var map = getVariantDiscountsForHandle(product.handle || handle);
      if (map && Object.keys(map).length) {
        product.variantDiscounts = map;
      } else if (!product.variantDiscounts) {
        product.variantDiscounts = {};
      }
      collectionProductCache.set(cacheKey, product);
      return product;
    } catch (error) {
      console.error('Error fetching collection product:', handle, error);
      return null;
    }
  }

  function parseCollectionProductsFromTab(tabElement) {
    if (!tabElement) return [];
    const raw = tabElement.getAttribute('data-collection-products');
    if (!raw) return [];
    var candidates = [raw];
    try {
      var ta = document.createElement('textarea');
      ta.innerHTML = raw;
      if (ta.value && ta.value !== raw) candidates.push(ta.value);
    } catch (decodeErr) {
      /* ignore */
    }
    var i;
    for (i = 0; i < candidates.length; i++) {
      try {
        const parsed = JSON.parse(candidates[i]);
        if (Array.isArray(parsed)) {
          return parsed.filter(function (item) {
            return item && item.handle;
          });
        }
      } catch (e) {
        /* try next */
      }
    }
    return [];
  }

  /** Best URL for comfort card when each card = a full product from collection JSON + /products/{handle}.js */
  function resolveProductHeroImageUrl(product) {
    if (!product) return null;
    const fi = product.featured_image;
    if (fi) {
      if (typeof fi === 'string' && fi.trim()) return fi.trim();
      if (fi.src) return fi.src;
    }
    if (product.image) {
      if (typeof product.image === 'string' && product.image.trim()) return product.image.trim();
      if (product.image.src) return product.image.src;
    }
    const imgs = product.images;
    if (imgs && imgs.length) {
      const img = imgs[0];
      if (typeof img === 'string' && img.trim()) return img.trim();
      if (img && img.src) return img.src;
      if (img && img.url) return img.url;
    }
    if (product.variants && product.variants.length) {
      for (let i = 0; i < product.variants.length; i++) {
        const v = product.variants[i];
        if (!v || !v.featured_image) continue;
        const vf = v.featured_image;
        if (typeof vf === 'string' && vf.trim()) return vf.trim();
        if (vf.src) return vf.src;
      }
    }
    return null;
  }

  function comfortCardImageUrlFromItem(item, itemProduct) {
    if (item && item.image && typeof item.image === 'string' && item.image.trim()) {
      return item.image.trim();
    }
    return resolveProductHeroImageUrl(itemProduct);
  }

  function getPreferredComfortProductHandle(productData) {
    if (productData && productData.handle) return String(productData.handle).trim();
    return getPageProductContext().handle || '';
  }

  function setComfortCardSelectedVisual(card) {
    if (!card) return;
    document.querySelectorAll('.firmness-card').forEach(function (c) {
      c.classList.remove('selected');
      var ci = c.querySelector('.card-indicator');
      if (ci) ci.classList.remove('active');
    });
    document.querySelectorAll('.firmness-card input[type="radio"]').forEach(function (r) {
      r.checked = false;
    });
    card.classList.add('selected');
    var indicator = card.querySelector('.card-indicator');
    if (indicator) indicator.classList.add('active');
    var radio = card.querySelector('input[name="firmness"]');
    if (radio) radio.checked = true;
    var activeTabForFirmness = document.querySelector('#custom-product-container .tab.active');
    if (activeTabForFirmness) {
      applyPdpSelectionTabColors(activeTabForFirmness.getAttribute('data-tab-color'));
    }
  }

  async function applyCollectionComfortProductSelection(itemProduct, card, options) {
    var opts = options || {};
    setComfortCardSelectedVisual(card);

    // Prefer map stamped on the card / collection JSON — works without refresh or fetch
    var cardMap = readVariantDiscountsFromComfortCard(card);
    if (cardMap) {
      rememberVariantDiscountsForHandle(itemProduct.handle, cardMap);
      itemProduct.variantDiscounts = cardMap;
    }

    // Load this product's variant-metafield discount map BEFORE any price paint
    if (itemProduct && itemProduct.handle) {
      var loadedMap = await ensureVariantDiscountsLoaded(itemProduct.handle);
      if (loadedMap && Object.keys(loadedMap).length) {
        itemProduct.variantDiscounts = loadedMap;
        if (window.__PDP_STORE__) {
          window.__PDP_STORE__.variantDiscounts = loadedMap;
          window.__PDP_STORE__.variantDiscountsProductHandle = itemProduct.handle;
        }
      } else if (cardMap && Object.keys(cardMap).length) {
        itemProduct.variantDiscounts = cardMap;
        if (window.__PDP_STORE__) {
          window.__PDP_STORE__.variantDiscounts = cardMap;
          window.__PDP_STORE__.variantDiscountsProductHandle = itemProduct.handle;
        }
      } else if (window.__PDP_STORE__) {
        // Switching to a product with no variant discounts — clear store for this handle only
        window.__PDP_STORE__.variantDiscounts = {};
        window.__PDP_STORE__.variantDiscountsProductHandle = itemProduct.handle || '';
      }
    }
    applyCollectionItemDiscountData(itemProduct, findCollectionItemByHandle(itemProduct.handle));

    // Product-mode fallback from card attrs when collection JSON was empty
    var storeFlags = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    if (!storeFlags.enableVariantMetafieldDiscounts && storeFlags.enableProductMetafieldDiscounts !== false && card) {
      var cardAmt = parseFloat(card.getAttribute('data-product-discount-amount'));
      var cardPct = parseFloat(card.getAttribute('data-product-discount-percentage'));
      var cardBadge = card.getAttribute('data-product-sale-badge-text');
      if (!isNaN(cardAmt) && cardAmt > 0) itemProduct.discountAmount = cardAmt;
      if (!isNaN(cardPct) && cardPct > 0) itemProduct.discountPercentage = cardPct;
      if (cardBadge != null && String(cardBadge).trim()) itemProduct.saleBadgeText = String(cardBadge).trim();
    }

    currentMattressProduct = itemProduct;
    currentMattressImages = itemProduct.images || [];
    selectedModelValue = '';
    selectedUnderbedProduct = null;
    currentSizeVariant = null;
    currentFirmnessVariant = itemProduct.variants[0] || null;

    bindProductVariantDiscounts(itemProduct);

    if (opts.updateUrl !== false && itemProduct.handle) {
      updateProductUrlDisplay(itemProduct.handle, { pushState: !!opts.pushState });
    }

    if (currentMattressImages.length > 0) {
      loadProductImages(currentMattressImages);
    }
    updateProductTitle(itemProduct.title || '');
    dispatchPdpProductUpdated(itemProduct);
    var accessoriesTitleElement = document.getElementById('accessories-product-title');
    if (accessoriesTitleElement) accessoriesTitleElement.textContent = itemProduct.title || '';
    var detected = detectOptionTypes(itemProduct);
    updateSizeOptionsForFirmness(itemProduct.variants, detected.sizeIndex);

    // Size selection sets currentSizeVariant — refresh discount + badge for that variant
    bindProductVariantDiscounts(itemProduct);
    syncPdpDisplayDiscountMeta(itemProduct);

    if (currentFirmnessVariant) {
      var firstVariantId = currentFirmnessVariant.id.toString();
      updateVariantInfo(firstVariantId);
      await updateVariantImageAndFeatures(firstVariantId);
      updateVariantTechnicalSpecs(firstVariantId);
      updateVariantPerformanceBlocks(firstVariantId);
    }
    await loadFoundationOptions(itemProduct.handle);
    updateVariantNameDisplay();
    // Re-bind after async foundation work, then rebuild size prices/compare + main price
    bindProductVariantDiscounts(itemProduct);
    currentFirmnessVariant = currentSizeVariant || currentFirmnessVariant;
    var detectedAfter = detectOptionTypes(itemProduct);
    updateSizeOptionsForFirmness(itemProduct.variants, detectedAfter.sizeIndex);
    paintPdpDiscountsForCurrentProduct(itemProduct);
    updateButtonStates();
    syncPdpLayersActiveProduct(itemProduct.handle, itemProduct.title || '');
  }

  function findComfortCardByProductHandle(handle) {
    if (!handle) return null;
    var cards = document.querySelectorAll('#firmness-options-container .firmness-card[data-product-handle]');
    for (var i = 0; i < cards.length; i++) {
      if (cards[i].getAttribute('data-product-handle') === handle) return cards[i];
    }
    return null;
  }

  function getPdpProductLabelSettings() {
    var root = document.getElementById('custom-product-container');
    if (!root) {
      return { showFirmness: false, bg: '#1d395a', fg: '#ffffff', syncTabs: false };
    }
    return {
      showFirmness: root.getAttribute('data-product-label-show-firmness') === 'true',
      bg: root.getAttribute('data-product-label-bg') || '#1d395a',
      fg: root.getAttribute('data-product-label-fg') || '#ffffff',
      syncTabs: root.getAttribute('data-product-label-sync-tabs') === 'true'
    };
  }

  function appendFirmnessProductLabel(card, labelText) {
    if (!card) return null;
    var existing = card.querySelector('.pdp-product-image-label--firmness');
    if (existing) existing.remove();

    var cfg = getPdpProductLabelSettings();
    if (!cfg.showFirmness) return null;

    var text = labelText == null ? '' : String(labelText).trim();
    var badge = document.createElement('span');
    badge.className =
      'pdp-product-image-label pdp-product-image-label--firmness' +
      (cfg.syncTabs ? ' pdp-product-image-label--sync-tabs' : '');
    badge.setAttribute('data-pdp-product-label', '');
    badge.setAttribute('data-label-placement', 'firmness');
    badge.setAttribute('data-sync-tab-colors', cfg.syncTabs ? 'true' : 'false');
    badge.setAttribute('data-default-bg', cfg.bg);
    badge.setAttribute('data-default-color', cfg.fg);
    badge.style.backgroundColor = cfg.bg;
    badge.style.color = cfg.fg;
    if (text) {
      badge.textContent = text;
      badge.hidden = false;
      badge.removeAttribute('hidden');
    } else {
      badge.textContent = '';
      badge.hidden = true;
      badge.setAttribute('hidden', '');
    }
    card.appendChild(badge);
    return badge;
  }

  function ensureFirmnessLabelStructure(label, baseLabel) {
    if (!label) return null;
    var nameEl = label.querySelector('.firmness-label-name');
    var pricesWrap = label.querySelector('.firmness-label-prices');
    var priceEl = label.querySelector('.firmness-label-price');
    var compareEl = label.querySelector('.firmness-label-compare');

    if (!nameEl || !pricesWrap || !priceEl || !compareEl) {
      label.textContent = '';
      nameEl = document.createElement('span');
      nameEl.className = 'firmness-label-name';
      pricesWrap = document.createElement('span');
      pricesWrap.className = 'firmness-label-prices';
      priceEl = document.createElement('span');
      priceEl.className = 'firmness-label-price';
      compareEl = document.createElement('s');
      compareEl.className = 'firmness-label-compare';
      compareEl.hidden = true;
      pricesWrap.appendChild(priceEl);
      pricesWrap.appendChild(compareEl);
      label.appendChild(nameEl);
      label.appendChild(pricesWrap);
    }

    if (baseLabel != null && baseLabel !== '') {
      nameEl.textContent = baseLabel;
      label.setAttribute('data-base-label', baseLabel);
    } else if (!label.getAttribute('data-base-label') && nameEl.textContent) {
      label.setAttribute('data-base-label', nameEl.textContent.trim());
    }
    return { nameEl: nameEl, pricesWrap: pricesWrap, priceEl: priceEl, compareEl: compareEl };
  }

  /** Show each comfort card's price for the selected size (name left, price right + compare below). */
  function updateFirmnessLabelPrices() {
    var cards = document.querySelectorAll('#firmness-options-container .firmness-card[data-product-handle]');
    if (!cards.length) return;

    var sizeValue = getCurrentMattressSizeValueFromUI() || getCurrentMattressSizeValue();

    cards.forEach(function (card) {
      var label = card.querySelector('.firmness-label');
      if (!label) return;

      var baseLabel = label.getAttribute('data-base-label') || '';
      var parts = ensureFirmnessLabelStructure(label, baseLabel || null);
      if (!parts) return;

      if (!baseLabel) {
        baseLabel = parts.nameEl.textContent.trim();
        label.setAttribute('data-base-label', baseLabel);
      }
      parts.nameEl.textContent = baseLabel;

      var handle = card.getAttribute('data-product-handle');
      var product = null;
      if (currentMattressProduct && currentMattressProduct.handle === handle) {
        product = currentMattressProduct;
      } else if (handle) {
        var cacheKey = handle + ':' + (suavePdpIsSpanishLocale() ? 'es' : 'en');
        product = collectionProductCache.get(cacheKey) || null;
      }

      // Always attach this card's own discount map (do not use another product's store map)
      if (product) {
        var cardMap = getVariantDiscountsForHandle(product.handle);
        if (cardMap && Object.keys(cardMap).length) {
          product.variantDiscounts = cardMap;
        } else if (!product.variantDiscounts) {
          product.variantDiscounts = {};
        }
      }

      var variant = null;
      if (product) {
        if (
          currentMattressProduct &&
          currentMattressProduct.handle === handle &&
          currentSizeVariant
        ) {
          variant = currentSizeVariant;
        } else if (sizeValue) {
          variant = getVariantBySize(product, sizeValue);
        } else if (product.variants && product.variants.length) {
          variant = product.variants[0];
        }
      }

      if (variant && variant.price != null && variant.price !== '') {
        var resolved;
        if (hasAppPriceContent()) {
          var yagiSale = applyYagiDiscountCents(variant.price);
          var shopifyCompare =
            variant.compare_at_price != null && variant.compare_at_price !== ''
              ? parseInt(variant.compare_at_price, 10)
              : 0;
          var rawPrice = parseInt(variant.price, 10) || 0;
          var yagiCompare = null;
          if (shopifyCompare > yagiSale) yagiCompare = shopifyCompare;
          else if (rawPrice > yagiSale) yagiCompare = rawPrice;
          resolved = { saleCents: yagiSale, compareCents: yagiCompare };
        } else {
          var cardDisc = resolveActiveDisplayDiscount(variant, product);
          if (window.SuaveDisplayDiscount && typeof window.SuaveDisplayDiscount.resolvePrices === 'function') {
            resolved = window.SuaveDisplayDiscount.resolvePrices(
              variant.price,
              variant.compare_at_price,
              cardDisc.percent,
              cardDisc.amount
            );
          } else {
            resolved = resolvePdpDisplayPrices(variant.price, variant.compare_at_price, variant, product);
          }
        }
        parts.priceEl.textContent = formatMoney(resolved.saleCents);
        parts.priceEl.hidden = false;
        if (resolved.compareCents != null && resolved.compareCents > resolved.saleCents) {
          parts.compareEl.textContent = formatMoney(resolved.compareCents);
          parts.compareEl.hidden = false;
          parts.compareEl.removeAttribute('hidden');
        } else {
          parts.compareEl.textContent = '';
          parts.compareEl.hidden = true;
          parts.compareEl.setAttribute('hidden', '');
        }
      } else {
        parts.priceEl.textContent = '';
        parts.priceEl.hidden = true;
        parts.compareEl.textContent = '';
        parts.compareEl.hidden = true;
        parts.compareEl.setAttribute('hidden', '');
      }
    });
  }

  async function selectComfortProductByHandle(handle, options) {
    var card = findComfortCardByProductHandle(handle);
    if (!card) return false;
    var cardHandle = card.getAttribute('data-product-handle');
    if (!cardHandle) return false;
    var itemProduct = await fetchProductByHandle(cardHandle);
    if (!itemProduct) return false;
    var activeTab = document.querySelector('#custom-product-container .tab.active');
    attachLocalizedDescriptionToProduct(itemProduct, activeTab);
    applyCollectionItemDiscountData(itemProduct, findCollectionItemByHandle(cardHandle));
    await applyCollectionComfortProductSelection(itemProduct, card, options);
    return true;
  }

  // Function to load firmness options from variants (fallback) or collection products
  async function loadFirmnessOptions(productData, tabElement = null) {
    // Store productData for image access
    const currentProductData = productData;
    seedPdpVariantDiscountMemory();
    
    const firmnessContainer = document.getElementById('firmness-options-container');
    if (!firmnessContainer) return;
    
    const activeTab = tabElement || document.querySelector('#custom-product-container .tab.active');
    const collectionProducts = parseCollectionProductsFromTab(activeTab);

    if (collectionProducts.length > 0) {
      firmnessContainer.innerHTML = '';
      const comfortTitle = document.querySelector('#firmness-section .section-title');
      if (comfortTitle) {
        comfortTitle.textContent = suavePdpT('chooseComfort', 'Choose your comfort preference.');
      }
      currentFirmnessTitle = suavePdpT('chooseComfort', 'Choose your comfort preference.');

      const preferredHandle = getPreferredComfortProductHandle(productData);
      let firstLoadedProduct = null;
      let firstLoadedCard = null;
      let matchedProduct = null;
      let matchedCard = null;
      let loadedCount = 0;

      for (const item of collectionProducts) {
        const itemProduct = await fetchProductByHandle(item.handle);
        if (!itemProduct || !itemProduct.variants || itemProduct.variants.length === 0) {
          continue;
        }
        // Wait for variant discount metafields so card + switch prices are correct
        await ensureVariantDiscountsLoaded(item.handle);
        attachLocalizedDescriptionToProduct(itemProduct, activeTab);
        mergeLocalizedVariantsFromCollectionItem(itemProduct, item);
        applyCollectionItemDiscountData(itemProduct, item);
        bindProductVariantDiscounts(itemProduct);
        if (item.productLabel != null) {
          itemProduct.productLabel = item.productLabel;
        }

        const isSelected = preferredHandle
          ? itemProduct.handle === preferredHandle
          : loadedCount === 0;

        const card = document.createElement('div');
        card.className = `firmness-card${isSelected ? ' selected' : ''}`;
        card.dataset.productHandle = itemProduct.handle;
        card.dataset.productId = itemProduct.id;
        stampComfortCardDiscountData(card, itemProduct, item);

        const indicator = document.createElement('span');
        indicator.className = `card-indicator${isSelected ? ' active' : ''}`;
        card.appendChild(indicator);

        const cardImgUrl = comfortCardImageUrlFromItem(item, itemProduct);
        if (cardImgUrl) {
          card.appendChild(createFirmnessImageWrap(cardImgUrl, itemProduct.title || 'Comfort option'));
        } else {
          ensureFirmnessImageBackdrop(card);
        }

        appendFirmnessProductLabel(card, itemProduct.productLabel || item.productLabel || '');

        const label = document.createElement('h4');
        label.className = 'firmness-label';
        var comfortTabLabel = item.tabLabel ? String(item.tabLabel).trim() : '';
        var firmnessBaseLabel = comfortTabLabel || itemProduct.title || '';
        label.setAttribute('data-base-label', firmnessBaseLabel);
        var nameSpan = document.createElement('span');
        nameSpan.className = 'firmness-label-name';
        nameSpan.textContent = firmnessBaseLabel;
        var pricesWrap = document.createElement('span');
        pricesWrap.className = 'firmness-label-prices';
        var priceSpan = document.createElement('span');
        priceSpan.className = 'firmness-label-price';
        priceSpan.hidden = true;
        var compareSpan = document.createElement('s');
        compareSpan.className = 'firmness-label-compare';
        compareSpan.hidden = true;
        pricesWrap.appendChild(priceSpan);
        pricesWrap.appendChild(compareSpan);
        label.appendChild(nameSpan);
        label.appendChild(pricesWrap);
        card.appendChild(label);

        const radio = document.createElement('input');
        radio.type = 'radio';
        radio.name = 'firmness';
        radio.value = itemProduct.handle;
        radio.style.display = 'none';
        if (isSelected) radio.checked = true;
        card.appendChild(radio);

        card.addEventListener('click', async function() {
          await applyCollectionComfortProductSelection(itemProduct, card, { updateUrl: true, pushState: true });
        });

        firmnessContainer.appendChild(card);

        if (loadedCount === 0) {
          firstLoadedProduct = itemProduct;
          firstLoadedCard = card;
        }
        if (isSelected) {
          matchedProduct = itemProduct;
          matchedCard = card;
        }
        loadedCount += 1;
      }

      const initialProduct = matchedProduct || firstLoadedProduct;
      const initialCard = matchedCard || firstLoadedCard;

      if (initialProduct && initialCard) {
        await applyCollectionComfortProductSelection(initialProduct, initialCard, { updateUrl: false });
      } else {
        firmnessContainer.innerHTML = '<p class="error-message">No products found in selected collection</p>';
      }

      if (activeTab) {
        applyPdpSelectionTabColors(activeTab.getAttribute('data-tab-color'));
      }
      updateFirmnessLabelPrices();
      return;
    }

    // Tab has collection JSON but it failed to parse — never fall back to model
    // options (No Foundation / Suave Base / Eleva) as fake "firmness" cards.
    if (activeTab && activeTab.getAttribute('data-collection-products')) {
      console.warn('Suave PDP: data-collection-products JSON failed to parse');
      firmnessContainer.innerHTML =
        '<p class="error-message">' +
        suavePdpT('unableLoadComfort', 'Unable to load comfort options. Please refresh the page.') +
        '</p>';
      return;
    }

    if (!productData.variants || !Array.isArray(productData.variants) || productData.variants.length === 0) {
      firmnessContainer.innerHTML = '<p class="error-message">No variants available</p>';
      return;
    }
    
    firmnessContainer.innerHTML = '';
    
    // Get firmness_option blocks from JSON
    let firmnessOptionBlocks = [];
    try {
      const blocksJson = document.getElementById('firmness-option-blocks');
      if (blocksJson) {
        firmnessOptionBlocks = JSON.parse(blocksJson.textContent);
      }
    } catch (e) {
      console.log('Could not parse firmness option blocks:', e);
    }
    
    const { firmnessIndex, sizeIndex } = detectOptionTypes(productData);
    const firmnessMap = new Map();
    
    // First pass: group variants by firmness
    productData.variants.forEach(variant => {
      let firmnessValue = 'Standard';
      
      if (variant.options && variant.options[firmnessIndex] !== undefined) {
        firmnessValue = variant.options[firmnessIndex];
      } else if (variant.option1 && firmnessIndex === 0) {
        firmnessValue = variant.option1;
      } else if (variant.option2 && firmnessIndex === 1) {
        firmnessValue = variant.option2;
      } else if (variant.option3 && firmnessIndex === 2) {
        firmnessValue = variant.option3;
      } else if (variant.title) {
        const titleParts = variant.title.split(' / ');
        firmnessValue = titleParts[0] || variant.title;
      }
      
      firmnessValue = firmnessValue.toString();
      const firmnessKey = firmnessValue.toLowerCase().replace(/\s+/g, '-');
      
      if (!firmnessMap.has(firmnessKey)) {
        // Try to find matching firmness option block
        let matchingBlock = null;
        for (let block of firmnessOptionBlocks) {
          const blockValue = (block.firmness_value || '').toLowerCase().replace(/\s+/g, '-');
          if (blockValue === firmnessKey || blockValue === firmnessValue.toLowerCase().replace(/\s+/g, '-')) {
            matchingBlock = block;
            break;
          }
        }
        
        firmnessMap.set(firmnessKey, {
          label: firmnessValue,
          value: firmnessKey,
          variants: [],
          variantImage: variant.featured_image || null,
          blockData: matchingBlock
        });
      }
      
      firmnessMap.get(firmnessKey).variants.push(variant);
    });
    
    if (firmnessMap.size === 0) {
      firmnessContainer.innerHTML = '<p class="error-message">No firmness options available</p>';
      return;
    }
    
    // Set firmness header title to "Choose your comfort preference."
    const firmnessTitleTextElement = document.querySelector('#firmness-section .section-title');
    if (firmnessTitleTextElement) {
      firmnessTitleTextElement.textContent = suavePdpT('chooseComfort', 'Choose your comfort preference.');
      currentFirmnessTitle = suavePdpT('chooseComfort', 'Choose your comfort preference.');
    } else {
      currentFirmnessTitle = '';
    }
    
    let firstFirmnessVariant = null;
    let cardIndex = 0;
    
    firmnessMap.forEach((firmness, firmnessKey) => {
      const card = document.createElement('div');
      card.className = `firmness-card${cardIndex === 0 ? ' selected' : ''}`;
      card.dataset.firmnessValue = firmness.value;
      card.dataset.firmnessKey = firmnessKey;
      card.dataset.variantIds = firmness.variants.map(v => v.id).join(',');
      
      if (cardIndex === 0) {
        firstFirmnessVariant = firmness.variants[0];
        currentFirmnessVariant = firstFirmnessVariant;
      }
      
      const indicator = document.createElement('span');
      indicator.className = `card-indicator${cardIndex === 0 ? ' active' : ''}`;
      card.appendChild(indicator);
      
      // Add Custom Title - ABOVE IMAGE (from variant info metafield: title)
      const customTitle = document.createElement('p');
      customTitle.className = 'firmness-card-title';
      
      // Get title from variant info metafield (metaobject) - Use FIRST variant in firmness group
      let cardTitle = '';
      
      if (firmness.variants && firmness.variants.length > 0) {
        const firstVariant = firmness.variants[0];
        const variantId = firstVariant.id.toString();
        const variantInfo = variantInfoMetafieldsMap.get(variantId);
        // FLEXIBLE title check - accept any truthy value
        if (variantInfo && variantInfo.title) {
          const titleStr = String(variantInfo.title).trim();
          if (titleStr && titleStr.length > 0 && titleStr !== 'null' && titleStr !== 'undefined') {
            cardTitle = titleStr;
          }
        }
      }
      
      // Fallback to blockData.title if variant info not available
      if (!cardTitle && firmness.blockData && firmness.blockData.title) {
        cardTitle = firmness.blockData.title;
      }
      
      customTitle.textContent = cardTitle;
      card.appendChild(customTitle);
      
      // Add image if variant has one or from block
      let imageUrl = null;
      
      // Priority: 1) blockData image, 2) variant featured_image (from variants array), 3) variantImage (stored), 4) product images
      if (firmness.blockData && firmness.blockData.image) {
        imageUrl = firmness.blockData.image;
      } else if (firmness.variants && firmness.variants.length > 0) {
        // Get product images for matching
        const productImages = currentMattressImages || (currentProductData && currentProductData.images) || [];
        // FIRST: Try to match product images with variant IDs (this is how Shopify stores variant images)
        // Shopify stores variant images in product.images array with variant_ids property
        for (let v of firmness.variants) {
          // Check if any product image is associated with this variant
          if (productImages.length > 0) {
            for (let imgIndex = 0; imgIndex < productImages.length; imgIndex++) {
              const img = productImages[imgIndex];
              let imgSrc = null;
              
              // Try multiple ways to get image source
              if (img.src) {
                imgSrc = img.src;
              } else if (img.url) {
                imgSrc = img.url;
              } else if (typeof img === 'string') {
                imgSrc = img;
              } else if (img.original) {
                imgSrc = img.original;
              } else if (img.original_src) {
                imgSrc = img.original_src;
              }
              
              if (!imgSrc) {
                continue;
              }
              
              // Check if image has variant_ids array and includes this variant
              if (img.variant_ids) {
                let variantIdsArray = [];
                
                // Handle different variant_ids formats
                if (Array.isArray(img.variant_ids)) {
                  variantIdsArray = img.variant_ids;
                } else if (typeof img.variant_ids === 'string') {
                  // Try to parse if it's a JSON string
                  try {
                    variantIdsArray = JSON.parse(img.variant_ids);
                  } catch (e) {
                    variantIdsArray = [img.variant_ids];
                  }
                } else {
                  variantIdsArray = [img.variant_ids];
                }
                
                // Convert variant ID to number and string for comparison
                const variantIdNum = typeof v.id === 'string' ? parseInt(v.id, 10) : v.id;
                const variantIdStr = String(v.id);
                
                // Check all possible ID formats
                if (variantIdsArray.includes(variantIdNum) || 
                    variantIdsArray.includes(v.id) || 
                    variantIdsArray.includes(variantIdStr) ||
                    variantIdsArray.some(id => String(id) === String(v.id)) ||
                    variantIdsArray.some(id => String(id) === String(variantIdNum))) {
                  imageUrl = imgSrc;
                  break;
                }
              }
            }
            if (imageUrl) break;
          }
          
          // SECOND: Check variant.featured_image (if it exists directly on variant)
          if (!imageUrl && v.featured_image) {
            if (v.featured_image.src) {
              imageUrl = v.featured_image.src;
              break;
            } else if (typeof v.featured_image === 'string') {
              imageUrl = v.featured_image;
              break;
            }
          }
          
          // THIRD: Check variant.image as fallback
          if (!imageUrl && v.image) {
            if (v.image.src) {
              imageUrl = v.image.src;
              break;
            } else if (v.image.url) {
              imageUrl = v.image.url;
              break;
            } else if (typeof v.image === 'string') {
              imageUrl = v.image;
              break;
            }
          }
        }
        
        // FOURTH: Fallback to variantImage (stored when creating firmnessMap)
        if (!imageUrl && firmness.variantImage) {
          if (firmness.variantImage.src) {
            imageUrl = firmness.variantImage.src;
          } else if (typeof firmness.variantImage === 'string') {
            imageUrl = firmness.variantImage;
          }
        }
        
        // FIFTH: Last resort - use first product image if no variant-specific image found
        if (!imageUrl && productImages.length > 0) {
          const firstImage = productImages[0];
          imageUrl = firstImage.src || firstImage.url || firstImage.original || firstImage.original_src || (typeof firstImage === 'string' ? firstImage : null);
        }
      }
      
      // Process and validate image URL
      if (imageUrl) {
        // Ensure imageUrl is a string
        if (typeof imageUrl !== 'string') {
          imageUrl = imageUrl.src || imageUrl.url || imageUrl.original || imageUrl.original_src || String(imageUrl);
        }
        
        // Skip if it's a no-image placeholder
        if (imageUrl && (imageUrl.includes('no-image') || imageUrl.includes('no_image'))) {
          imageUrl = null;
        }
      }
      
      // Only create and append image if we have a valid URL
      if (imageUrl && !imageUrl.includes('no-image') && !imageUrl.includes('no_image')) {
        // Process image URL
        if (imageUrl.includes('_medium.') || imageUrl.includes('_small.')) {
          imageUrl = imageUrl.replace('_medium.', '_400x.').replace('_small.', '_400x.');
        } else if (!imageUrl.includes('?')) {
          imageUrl = `${imageUrl}?width=400&height=400&crop=center`;
        }

        var wrap = createFirmnessImageWrap(imageUrl, firmness.label);
        var wrapImg = wrap.querySelector('img');
        if (wrapImg) {
          wrapImg.onerror = function () {
            if (wrap.parentNode) wrap.style.display = 'none';
          };
        }
        card.appendChild(wrap);
      } else {
        ensureFirmnessImageBackdrop(card);
      }

      var fallbackProductLabel =
        (currentMattressProduct && currentMattressProduct.productLabel) ||
        (currentProductData && currentProductData.productLabel) ||
        '';
      if (!fallbackProductLabel) {
        var activeTabForLabel = document.querySelector('#custom-product-container .tab.active');
        if (activeTabForLabel) {
          fallbackProductLabel = activeTabForLabel.getAttribute('data-product-label') || '';
        }
      }
      appendFirmnessProductLabel(card, fallbackProductLabel);
      
      // Add Variant Name - BELOW IMAGE
      const variantName = document.createElement('p');
      variantName.className = 'firmness-variant-name';
      variantName.textContent = firmness.label;
      card.appendChild(variantName);
      
      // Create div for variant features - BELOW firmness-variant-name
      const variantInfoDiv = document.createElement('div');
      variantInfoDiv.className = 'firmness-variant-info';
      variantInfoDiv.style.marginTop = '2px';
      variantInfoDiv.style.padding = '0 5px';
      
      // Get features from FIRST variant in the firmness group
      // Prefer variant-specific firmness_feature_text metafield so each card shows its own data
      let featureText = '';
      
      if (firmness.variants && firmness.variants.length > 0) {
        const firstVariant = firmness.variants[0];
        const variantId = firstVariant.id.toString();
        const variantInfo = variantInfoMetafieldsMap.get(variantId);
        console.log('variantInfo: ', variantInfo);
        
        var featureSource = (variantInfo && variantInfo.firmness_feature_text != null) ? variantInfo.firmness_feature_text : (variantInfo && variantInfo.feature) ? variantInfo.feature : null;
        if (variantInfo && featureSource) {
          // Parse rich text JSON to extract actual text
          let featureData = featureSource;
          
          // If it's a string that looks like JSON, try to parse it
          if (typeof featureData === 'string') {
            // Check if it looks like a JSON object (starts with { or [)
            if (featureData.trim().startsWith('{') || featureData.trim().startsWith('[')) {
              try {
                featureData = JSON.parse(featureData);
              } catch (e) {
                // If parsing fails, use as is
              }
            }
          }
          
          const parsedFeature = parseRichTextToText(featureData);
          if (parsedFeature && parsedFeature.trim().length > 0 && parsedFeature !== 'null' && parsedFeature !== 'undefined') {
            featureText = parsedFeature.trim();
          }
        }
      }
      
      // Add Features text only (preserve spaces, line breaks, show list bullets)
      if (featureText) {
        const featureElement = document.createElement('div');
        featureElement.className = 'firmness-feature-text';
        var formatted = featureText.replace(/\r\n/g, '\n').trim();
        var lines = formatted.split(/\n/).map(function(s) { return s.trim(); }).filter(function(s) { return s.length > 0; });
        var bodyHtml;
        if (lines.length > 1) {
          bodyHtml = '<ul class="firmness-feature-list">' + lines.map(function(line) {
            var t = line.replace(/^[\s•\-*]+\s*/, '');
            return '<li>' + t.replace(/</g, '&lt;').replace(/>/g, '&gt;') + '</li>';
          }).join('') + '</ul>';
        } else {
          bodyHtml = formatted.replace(/\n/g, '<br>').replace(/</g, '&lt;').replace(/>/g, '&gt;');
        }
        featureElement.innerHTML = '<strong>Features:</strong> ' + bodyHtml;
        featureElement.style.fontSize = '12px';
        featureElement.style.margin = '4px 0';
        featureElement.style.color = '#666';
        variantInfoDiv.appendChild(featureElement);
      }
      
      // Append variant info div after variant name (only if features exist)
      if (featureText) {
        card.appendChild(variantInfoDiv);
      }
      
      const radio = document.createElement('input');
      radio.type = 'radio';
      radio.name = 'firmness';
      radio.value = firmness.value;
      radio.dataset.variantId = firmness.variants[0].id;
      radio.dataset.variantIds = firmness.variants.map(v => v.id).join(',');
      radio.style.display = 'none';
      if (cardIndex === 0) radio.checked = true;
      card.appendChild(radio);
      
      card.addEventListener('click', async function() {
        document.querySelectorAll('.firmness-card').forEach(c => {
          c.classList.remove('selected');
          const ci = c.querySelector('.card-indicator');
          if (ci) ci.classList.remove('active');
        });
        this.classList.add('selected');

        const activeTabForFirmness = document.querySelector('#custom-product-container .tab.active');
        if (activeTabForFirmness) {
          applyPdpSelectionTabColors(activeTabForFirmness.getAttribute('data-tab-color'));
        }
        
        document.querySelectorAll('.firmness-card input[type="radio"]').forEach(r => r.checked = false);
        const radio = this.querySelector('input[type="radio"]');
        if (radio) {
          radio.checked = true;
          const variantIds = radio.dataset.variantIds.split(',').map(id => parseInt(id));
          const selectedVariants = productData.variants.filter(v => variantIds.includes(v.id));
          updateSizeOptionsForFirmness(selectedVariants, sizeIndex);
          currentFirmnessVariant = productData.variants.find(v => v.id === parseInt(radio.dataset.variantId));
          
          // Update variant info when firmness changes
          // Priority: 1) Selected size variant (if size is already selected), 2) First variant in firmness group
          let variantIdToUse = null;
          if (currentSizeVariant && selectedVariants.some(v => v.id === currentSizeVariant.id)) {
            // If current size variant is in the selected firmness group, use it
            variantIdToUse = currentSizeVariant.id.toString();
          } else if (selectedVariants && selectedVariants.length > 0) {
            // Otherwise use first variant in the firmness group
            variantIdToUse = selectedVariants[0].id.toString();
          }
          
          if (variantIdToUse) {
            updateVariantInfo(variantIdToUse);
            // Await so images update on first click (no need for second click)
            await updateVariantImageAndFeatures(variantIdToUse);
            updateVariantTechnicalSpecs(variantIdToUse);
            updateVariantPerformanceBlocks(variantIdToUse);
          }
          
          // Update variant name display
          updateVariantNameDisplay();
          
          // If foundation is selected, update foundation images based on new firmness selection
          // Otherwise, show mattress images
          if (isFoundationSelected && currentFoundationProduct) {
            const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
            if (selectedFoundation) {
              const foundationOption = selectedFoundation.closest('.foundation-option');
              if (foundationOption) {
                handleFoundationVariantImageChange(foundationOption, currentFoundationProduct);
              }
            }
          } else if (!isFoundationSelected) {
            const activeVariantId = getActiveMattressVariantId();
            if (activeVariantId) {
              loadVariantImageGallery(activeVariantId);
            } else if (currentMattressImages && currentMattressImages.length > 0) {
              loadProductImages(currentMattressImages);
            }
          }
          
          // Update button states
          updateButtonStates();
        }
      });
      
      firmnessContainer.appendChild(card);
      cardIndex++;
    });
    
    if (firstFirmnessVariant) {
      const firstFirmness = firmnessMap.values().next().value;
      updateSizeOptionsForFirmness(firstFirmness.variants, sizeIndex);
      
      // Prefer the size chosen by loadSizeOptions (URL / remembered), not always variants[0]
      if (firstFirmness.variants && firstFirmness.variants.length > 0) {
        var firmnessVariantIds = firstFirmness.variants.map(function (v) { return v.id; });
        var variantIdToUse =
          currentSizeVariant && firmnessVariantIds.indexOf(currentSizeVariant.id) !== -1
            ? currentSizeVariant.id.toString()
            : firstFirmness.variants[0].id.toString();
        updateVariantInfo(variantIdToUse);
        updateVariantImageAndFeatures(variantIdToUse);
        updateVariantTechnicalSpecs(variantIdToUse);
        updateVariantPerformanceBlocks(variantIdToUse);
      }
      
      updateVariantNameDisplay();
    }

    if (activeTab) {
      applyPdpSelectionTabColors(activeTab.getAttribute('data-tab-color'));
    }
  }
  
  // Function to update size options based on selected firmness
  function updateSizeOptionsForFirmness(variants, sizeIndex = 1, preferredSizeLabel) {
    const preserveSize =
      (preferredSizeLabel && String(preferredSizeLabel).trim()) ||
      getCurrentMattressSizeValueFromUI() ||
      getCurrentMattressSizeValue() ||
      getPreferredSizeFromUrlOrVariant();

    if (!variants || variants.length === 0) {
      loadSizeOptions([], preserveSize);
      return;
    }

    let modelFilter = selectedModelValue;
    if (!modelFilter && getUnderbedConfig()) {
      modelFilter = getNoFoundationModelLabel();
    }
    if (currentMattressProduct && modelFilter) {
      const { modelIndex } = detectOptionTypes(currentMattressProduct);
      if (modelIndex !== -1) {
        variants = filterVariantsByModelLabel(variants, modelFilter, modelIndex);
      }
    }
    if (!variants || variants.length === 0) {
      loadSizeOptions([], preserveSize);
      return;
    }
    
    // Sort variants to preserve product page order (by position in original product variants array)
    const sortedVariants = [...variants].sort((a, b) => {
      if (!currentMattressProduct || !currentMattressProduct.variants) {
        return 0; // If no product data, keep original order
      }
      
      // Find index in original product variants array
      const aIndex = currentMattressProduct.variants.findIndex(v => v.id === a.id);
      const bIndex = currentMattressProduct.variants.findIndex(v => v.id === b.id);
      
      // If both found, sort by original position
      if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
      }
      // If only one found, prioritize it
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;
      // If neither found, keep original order
      return 0;
    });
    
    const sizeOptions = [];
    const seenSizeKeys = new Map();
    
    sortedVariants.forEach(variant => {
      let sizeValue = 'Standard';
      
      if (variant.options && variant.options[sizeIndex] !== undefined) {
        sizeValue = variant.options[sizeIndex];
      } else if (variant.option1 && sizeIndex === 0) {
        sizeValue = variant.option1;
      } else if (variant.option2 && sizeIndex === 1) {
        sizeValue = variant.option2;
      } else if (variant.option3 && sizeIndex === 2) {
        sizeValue = variant.option3;
      } else if (variant.title) {
        const titleParts = variant.title.split(' / ');
        if (titleParts.length > 1) {
          sizeValue = titleParts[1];
        } else if (titleParts.length === 1) {
          sizeValue = titleParts[0];
        }
      }
      
      sizeValue = sizeValue.toString();
      
      // IMPROVED availability check
      let isAvailable = false;
      let availabilityText = suavePdpT('inStock', 'In Stock');
      
      // Check if variant.available is explicitly true
      if (variant.available === true) {
        isAvailable = true;
      }
      // Check inventory policy - if continue, always available for backorder
      else if (variant.inventory_policy === 'continue') {
        isAvailable = true;
        availabilityText = suavePdpT('availableBackorder', 'Available for Backorder');
      }
      // Check inventory quantity
      else if (variant.inventory_quantity !== null && variant.inventory_quantity > 0) {
        isAvailable = true;
        if (variant.inventory_quantity < 10) {
          availabilityText = `Only ${variant.inventory_quantity} left`;
        }
      }
      // If inventory management is disabled, check if available is not false
      else if (variant.inventory_management === null && variant.available !== false) {
        isAvailable = true;
      }
      
      const sizeKey = sizeValue.toString().trim().toLowerCase();
      const optionPayload = {
        label: sizeValue,
        value: variant.id.toString(),
        variant: variant,
        price: variant.price,
        comparePrice: variant.compare_at_price,
        available: isAvailable,
        availabilityText: availabilityText,
        inventoryQuantity: variant.inventory_quantity,
        inventoryPolicy: variant.inventory_policy,
        inventoryManagement: variant.inventory_management
      };

      if (seenSizeKeys.has(sizeKey)) {
        const existingIndex = seenSizeKeys.get(sizeKey);
        const existing = sizeOptions[existingIndex];
        // Prefer an available variant when duplicate size labels exist
        if (existing && !existing.available && optionPayload.available) {
          sizeOptions[existingIndex] = optionPayload;
        }
      } else {
        seenSizeKeys.set(sizeKey, sizeOptions.length);
        sizeOptions.push(optionPayload);
      }
    });
    
    loadSizeOptions(sizeOptions, preserveSize);
  }
  
  // Function to load size options with improved availability display
  function loadSizeOptions(sizeOptions, preferredSizeLabel) {
    const sizeSelect = document.getElementById('size-select');
    if (!sizeSelect) return;

    capturePdpBootHintsFromLocation();
    const preferredSize =
      (preferredSizeLabel && String(preferredSizeLabel).trim()) || '';
    const preferredVariantId = getPdpVariantIdFromUrl() || __pdpBootVariantId || '';
    const urlSizeFallback = preferredSize ? '' : getPreferredSizeFromUrlOrVariant();
    const sizeToPrefer = preferredSize || urlSizeFallback; 
    sizeSelect.innerHTML = '';
    
    if (sizeOptions.length === 0) {
      const option = document.createElement('option');
      option.value = '';
      option.textContent = suavePdpT('noSizesAvailable', 'No sizes available');
      option.disabled = true;
      option.selected = true;
      sizeSelect.appendChild(option);
    } else {
      // Use size options in the order they come from the product page (already sorted by updateSizeOptionsForFirmness)
      // No custom sorting - preserve product page order
      
      let firstAvailableVariant = null;
      let hasAvailableVariant = false;
      let variantToSelect = null;

      if (sizeToPrefer) {
        const preferredAvailable = sizeOptions.find(
          (o) => mattressSizesMatch(o.label, sizeToPrefer) && o.available
        );
        const preferredAny = sizeOptions.find((o) => mattressSizesMatch(o.label, sizeToPrefer));
        if (preferredAvailable) variantToSelect = preferredAvailable.variant;
        else if (preferredAny) variantToSelect = preferredAny.variant;
      }

      if (!variantToSelect && preferredVariantId) {
        const byId = sizeOptions.find(
          (o) => o.variant && String(o.variant.id) === String(preferredVariantId)
        );
        if (byId) variantToSelect = byId.variant;
      }
      
      sizeOptions.forEach((sizeOption, index) => {
        const option = document.createElement('option');
        option.value = sizeOption.variant.id;
        var displayPriceCents = hasAppPriceContent()
          ? applyYagiDiscountCents(sizeOption.price)
          : applyPdpDisplayDiscountCents(sizeOption.price, sizeOption.variant, currentMattressProduct);
        var resolvedSize = resolvePdpDisplayPrices(
          sizeOption.price,
          sizeOption.comparePrice,
          sizeOption.variant,
          currentMattressProduct
        );
        if (hasAppPriceContent()) {
          resolvedSize = {
            saleCents: displayPriceCents,
            compareCents:
              sizeOption.comparePrice != null && parseInt(sizeOption.comparePrice, 10) > displayPriceCents
                ? parseInt(sizeOption.comparePrice, 10)
                : parseInt(sizeOption.price, 10) > displayPriceCents
                  ? parseInt(sizeOption.price, 10)
                  : null
          };
        }
        option.dataset.price = formatMoney(displayPriceCents);
        option.dataset.rawPriceCents = String(Math.round(Number(sizeOption.price) || 0));
        option.dataset.comparePrice =
          resolvedSize.compareCents != null ? formatMoney(resolvedSize.compareCents) : '';
        option.dataset.size = sizeOption.label;
        option.dataset.available = sizeOption.available;
        option.dataset.availabilityText = sizeOption.availabilityText;
        option.dataset.inventoryQuantity = sizeOption.inventoryQuantity;
        option.dataset.inventoryPolicy = sizeOption.inventoryPolicy;
        option.dataset.inventoryManagement = sizeOption.inventoryManagement;
        
        // Format the display text with stock status (Shopify Translate & Adapt variant names)
        let displayText = sizeOption.label;
        const priceText = formatMoney(displayPriceCents);

        if (!sizeOption.available) {
          displayText = sizeOption.label + ' - ' + suavePdpT('outOfStock', 'Out of Stock');
          option.disabled = true;
        } else {
          displayText = sizeOption.label + ' | ' + priceText;
          hasAvailableVariant = true;

          if (!firstAvailableVariant && sizeOption.available) {
            firstAvailableVariant = sizeOption.variant;
          }
        }

        option.textContent = displayText;
        sizeSelect.appendChild(option);
      });

      if (!variantToSelect) {
        variantToSelect = firstAvailableVariant || (sizeOptions[0] && sizeOptions[0].variant) || null;
      }

      if (variantToSelect) {
        currentSizeVariant = variantToSelect;
        for (let i = 0; i < sizeSelect.options.length; i += 1) {
          if (String(sizeSelect.options[i].value) === String(variantToSelect.id)) {
            sizeSelect.selectedIndex = i;
            sizeSelect.options[i].selected = true;
            break;
          }
        }
        syncPdpDisplayDiscountMeta(currentMattressProduct);
      }
    }
    
    if (typeof window.rebuildCustomDropdown === 'function') {
      // Run immediately so firmness/size change updates images on first click (no 100ms delay)
      window.rebuildCustomDropdown();
      updateProductForSelectedVariant();
      updateButtonStates();
    } else {
      updateProductForSelectedVariant();
      updateButtonStates();
    }
  }
  
  function getPdpDisplayDiscountPercent() {
    if (window.SuaveDisplayDiscount && typeof window.SuaveDisplayDiscount.getPercentFromContainer === 'function') {
      return window.SuaveDisplayDiscount.getPercentFromContainer(
        document.getElementById('custom-product-container') || document
      );
    }
    var priceWrap = document.querySelector('#custom-product-container .price[data-discount-percentage]');
    if (!priceWrap) return 0;
    var n = parseFloat(priceWrap.getAttribute('data-discount-percentage'));
    return !isNaN(n) && n > 0 ? n : 0;
  }

  function getPdpDisplayDiscountAmount() {
    if (window.SuaveDisplayDiscount && typeof window.SuaveDisplayDiscount.getAmountFromContainer === 'function') {
      return window.SuaveDisplayDiscount.getAmountFromContainer(
        document.getElementById('custom-product-container') || document
      );
    }
    var priceWrap = document.querySelector('#custom-product-container .price[data-discount-amount]');
    if (!priceWrap) return 0;
    var n = parseFloat(priceWrap.getAttribute('data-discount-amount'));
    return !isNaN(n) && n > 0 ? n : 0;
  }

  function getVariantDiscountEntry(variant, product) {
    if (!variant) return null;
    var maps = [];
    var productForHandle = product || currentMattressProduct;
    if (product && product.variantDiscounts && Object.keys(product.variantDiscounts).length) {
      maps.push(product.variantDiscounts);
    }
    if (productForHandle && productForHandle.handle) {
      var fromHandle = getVariantDiscountsForHandle(productForHandle.handle);
      if (fromHandle && Object.keys(fromHandle).length) maps.push(fromHandle);
    }
    // Global store only when it belongs to the same product handle
    if (!maps.length) {
      var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
      if (
        store.variantDiscounts &&
        Object.keys(store.variantDiscounts).length &&
        productForHandle &&
        store.variantDiscountsProductHandle &&
        String(store.variantDiscountsProductHandle) === String(productForHandle.handle || '')
      ) {
        maps.push(store.variantDiscounts);
      }
    }
    if (!maps.length) return null;
    var idStr = String(variant.id);
    for (var i = 0; i < maps.length; i++) {
      var map = maps[i];
      if (!map || typeof map !== 'object') continue;
      if (map[variant.id] != null) return map[variant.id];
      if (map[idStr] != null) return map[idStr];
      var keys = Object.keys(map);
      for (var k = 0; k < keys.length; k++) {
        if (String(keys[k]) === idStr) return map[keys[k]];
      }
    }
    return null;
  }

  function resolveActiveDisplayDiscount(variant, product) {
    var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    var pct = 0;
    var amt = 0;
    var badge = '';
    var entry = getVariantDiscountEntry(variant, product || currentMattressProduct);
    if (entry) {
      pct = parseFloat(entry.discountPercentage) || 0;
      amt = parseFloat(entry.discountAmount) || 0;
      if (entry.saleBadgeText != null) badge = String(entry.saleBadgeText).trim();
    }

    // Product metafield mode only — never fall back to DOM/tab attrs in variant mode
    // (those are usually the first variant and would apply to every size).
    if (
      !(amt > 0 || pct > 0 || badge) &&
      !store.enableVariantMetafieldDiscounts &&
      store.enableProductMetafieldDiscounts !== false
    ) {
      var source = product || currentMattressProduct;
      if (source && source.discountAmount != null && source.discountAmount !== '') {
        amt = parseFloat(source.discountAmount) || 0;
      }
      if (!(amt > 0)) {
        if (source && source.discountPercentage != null && source.discountPercentage !== '') {
          pct = parseFloat(source.discountPercentage) || 0;
        } else {
          pct = getPdpDisplayDiscountPercent();
        }
      }
      if (!(amt > 0)) amt = getPdpDisplayDiscountAmount();
      if (!badge && source && source.saleBadgeText != null) {
        badge = String(source.saleBadgeText).trim();
      }
    }

    if (amt > 0) pct = 0;
    return { percent: pct > 0 ? pct : 0, amount: amt > 0 ? amt : 0, saleBadgeText: badge };
  }

  function applyPdpDisplayDiscountCents(cents, variant, product) {
    var c = Math.round(Number(cents) || 0);
    var discount = resolveActiveDisplayDiscount(
      variant || currentSizeVariant,
      product || currentMattressProduct
    );
    if (window.SuaveDisplayDiscount && typeof window.SuaveDisplayDiscount.applyCents === 'function') {
      return window.SuaveDisplayDiscount.applyCents(c, discount.percent, discount.amount);
    }
    if (discount.amount > 0) return Math.max(0, c - Math.round(discount.amount * 100));
    if (!(discount.percent > 0) || c <= 0) return c;
    return Math.max(0, c - Math.round((c * discount.percent) / 100));
  }

  function resolvePdpDisplayPrices(variantPriceCents, compareAtCents, variant, product) {
    var discount = resolveActiveDisplayDiscount(
      variant || currentSizeVariant,
      product || currentMattressProduct
    );
    if (window.SuaveDisplayDiscount && typeof window.SuaveDisplayDiscount.resolvePrices === 'function') {
      return window.SuaveDisplayDiscount.resolvePrices(
        variantPriceCents,
        compareAtCents,
        discount.percent,
        discount.amount
      );
    }
    var price = Math.round(Number(variantPriceCents) || 0);
    var compare = compareAtCents != null && compareAtCents !== '' ? Math.round(Number(compareAtCents) || 0) : 0;
    if (discount.amount > 0 || discount.percent > 0) {
      var saleCents;
      if (window.SuaveDisplayDiscount && typeof window.SuaveDisplayDiscount.applyCents === 'function') {
        saleCents = window.SuaveDisplayDiscount.applyCents(price, discount.percent, discount.amount);
      } else if (discount.amount > 0) {
        saleCents = Math.max(0, price - Math.round(discount.amount * 100));
      } else {
        saleCents = Math.max(0, price - Math.round((price * discount.percent) / 100));
      }
      return {
        saleCents: saleCents,
        compareCents: price > saleCents ? price : null,
        hasDiscount: true
      };
    }
    return { saleCents: price, compareCents: compare > price ? compare : null, hasDiscount: false };
  }

  function formatAmountOffBadge(savingsCents) {
    var savings = Math.round(Number(savingsCents) || 0);
    if (!(savings > 0)) return '';
    var amount = formatMoney(savings);
    var template = suavePdpT('amountOff', '{{ amount }} Off');
    return String(template).replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function resolveSaleBadgeText(source, saleCents, compareCents, variant) {
    var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    var activeVariant = variant || currentSizeVariant;
    var discount = resolveActiveDisplayDiscount(activeVariant, source || currentMattressProduct);
    var badgeText = discount.saleBadgeText || '';

    // Product-level saleBadgeText is often the first variant's value — only use it
    // when product metafield discounts are enabled (not variant mode).
    if (
      !badgeText &&
      !store.enableVariantMetafieldDiscounts &&
      source &&
      source.saleBadgeText != null
    ) {
      badgeText = String(source.saleBadgeText).trim();
    }
    if (badgeText) return badgeText;

    var sale = saleCents != null ? Math.round(Number(saleCents) || 0) : NaN;
    var compare = compareCents != null ? Math.round(Number(compareCents) || 0) : NaN;

    if (!(compare > sale) && activeVariant) {
      var resolved = resolvePdpDisplayPrices(
        activeVariant.price,
        activeVariant.compare_at_price,
        activeVariant,
        source || currentMattressProduct
      );
      sale = resolved.saleCents;
      compare = resolved.compareCents != null ? resolved.compareCents : 0;
    }

    if (compare > sale) return formatAmountOffBadge(compare - sale);
    return '';
  }

  function applySaleBadgeElement(badge, badgeText) {
    if (!badge) return;
    var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    if (store.showSaleBadge === false) {
      badge.textContent = '';
      badge.hidden = true;
      badge.setAttribute('hidden', '');
      return;
    }
    var text = badgeText == null ? '' : String(badgeText).trim();
    if (text) {
      badge.textContent = text;
      badge.hidden = false;
      badge.removeAttribute('hidden');
    } else {
      badge.textContent = '';
      badge.hidden = true;
      badge.setAttribute('hidden', '');
      badge.style.backgroundColor = '';
      badge.style.borderColor = '';
      badge.style.color = '';
    }
  }

  function syncPdpDisplayDiscountMeta(source) {
    var discount = resolveActiveDisplayDiscount(currentSizeVariant, source || currentMattressProduct);
    var pct = discount.percent;
    var amt = discount.amount;
    var productLabel = null;
    if (source && source.productLabel != null) {
      productLabel = String(source.productLabel).trim();
    }
    var priceWrap = document.querySelector('#custom-product-container .price');
    if (priceWrap) {
      // Don't wipe Liquid-rendered discount attrs before a size variant is known
      if (currentSizeVariant || amt > 0 || pct > 0) {
        priceWrap.setAttribute('data-discount-percentage', String(pct > 0 ? pct : 0));
        priceWrap.setAttribute('data-discount-amount', String(amt > 0 ? amt : 0));
      }
    }

    var saleCents = null;
    var compareCents = null;
    if (currentSizeVariant) {
      var resolvedMeta = resolvePdpDisplayPrices(
        currentSizeVariant.price,
        currentSizeVariant.compare_at_price,
        currentSizeVariant,
        source || currentMattressProduct
      );
      saleCents = resolvedMeta.saleCents;
      compareCents = resolvedMeta.compareCents;
    }
    var badgeText = resolveSaleBadgeText(source, saleCents, compareCents);
    var badgeEl = document.getElementById('suave-pdp-sale-badge');
    // Avoid flash-then-hide: don't clear a Liquid/JS badge until we have a size + resolution
    if (badgeText || currentSizeVariant || amt > 0 || pct > 0) {
      applySaleBadgeElement(badgeEl, badgeText);
    }

    if (source && Object.prototype.hasOwnProperty.call(source, 'productLabel')) {
      syncPdpProductImageLabel(productLabel || '');
    }
    var activeTab = document.querySelector('#custom-product-container .tab.active');
    if (activeTab) {
      var tabColor = activeTab.getAttribute('data-tab-color');
      if (tabColor) applyTabColorToPdpElements(tabColor);
    }
  }

  function syncPdpProductImageLabel(labelText) {
    var label = document.getElementById('pdp-product-image-label');
    if (!label) return;
    var text = labelText == null ? '' : String(labelText).trim();
    if (text) {
      label.textContent = text;
      label.hidden = false;
      label.removeAttribute('hidden');
    } else {
      label.textContent = '';
      label.hidden = true;
      label.setAttribute('hidden', '');
      if (label.getAttribute('data-sync-tab-colors') === 'true') {
        var defaultBg = label.getAttribute('data-default-bg') || '';
        var defaultColor = label.getAttribute('data-default-color') || '';
        if (defaultBg) label.style.backgroundColor = defaultBg;
        if (defaultColor) label.style.color = defaultColor;
      }
    }
  }

  // Function to update total price (main product + foundation)
  function getCurrentMattressCompareAtCents() {
    var saleCents = 0;
    if (currentSizeVariant && currentSizeVariant.price != null) {
      saleCents = parseInt(currentSizeVariant.price, 10) || 0;
    }
    if (currentSizeVariant && currentSizeVariant.compare_at_price != null) {
      var compareCents = parseInt(currentSizeVariant.compare_at_price, 10);
      if (!isNaN(compareCents) && compareCents > saleCents) return compareCents;
    }
    var sizeSelect = document.getElementById('size-select');
    if (sizeSelect && sizeSelect.selectedIndex >= 0) {
      var selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
      if (selectedOption && currentMattressProduct && currentMattressProduct.variants) {
        var variantId = selectedOption.value;
        var variant = currentMattressProduct.variants.find(function (v) {
          return v && String(v.id) === String(variantId);
        });
        if (variant && variant.compare_at_price != null) {
          var fromVariant = parseInt(variant.compare_at_price, 10);
          var variantPrice = parseInt(variant.price, 10) || 0;
          if (!isNaN(fromVariant) && fromVariant > variantPrice) return fromVariant;
        }
      }
    }
    return null;
  }

  function updateCompareAtPriceDisplay(mattressSaleCents, mattressOriginalCents, priceVariant) {
    var comparePriceElement =
      document.querySelector('#custom-product-container .compare-at-price') ||
      document.querySelector('.compare-at-price');
    if (!comparePriceElement) return;

    var shopifyCompare = getCurrentMattressCompareAtCents();
    var originalPrice =
      mattressOriginalCents != null
        ? Math.round(Number(mattressOriginalCents) || 0)
        : currentSizeVariant && currentSizeVariant.price != null
          ? Math.round(Number(currentSizeVariant.price) || 0)
          : null;
    var saleForCompare =
      mattressSaleCents != null ? Math.round(Number(mattressSaleCents) || 0) : null;

    var discount = resolveActiveDisplayDiscount(
      priceVariant || currentSizeVariant,
      currentMattressProduct
    );
    var hasDisplayDiscount = !!(discount && (discount.percent > 0 || discount.amount > 0));
    if (!hasDisplayDiscount) {
      hasDisplayDiscount = getPdpDisplayDiscountPercent() > 0 || getPdpDisplayDiscountAmount() > 0;
    }
    // Keep compare visible if Liquid/attrs still say there is a display discount
    // (avoids flash-hide when map briefly unavailable during async refreshes)
    if (!hasDisplayDiscount) {
      var priceWrapForCompare = document.querySelector('#custom-product-container .price');
      if (priceWrapForCompare) {
        var attrAmt = parseFloat(priceWrapForCompare.getAttribute('data-discount-amount'));
        var attrPct = parseFloat(priceWrapForCompare.getAttribute('data-discount-percentage'));
        if ((!isNaN(attrAmt) && attrAmt > 0) || (!isNaN(attrPct) && attrPct > 0)) {
          hasDisplayDiscount = true;
        }
      }
    }
    var compareCents = null;

    if (hasDisplayDiscount) {
      if (shopifyCompare != null && (saleForCompare == null || shopifyCompare > saleForCompare)) {
        compareCents = shopifyCompare;
      } else if (originalPrice != null && (saleForCompare == null || originalPrice > saleForCompare)) {
        compareCents = originalPrice;
      }
    } else {
      compareCents = shopifyCompare;
    }

    if (compareCents != null && saleForCompare != null && compareCents <= saleForCompare) {
      compareCents = null;
    }

    // Preserve an already-visible compare-at during brief discount-resolution gaps
    if (
      compareCents == null &&
      comparePriceElement.textContent &&
      String(comparePriceElement.textContent).trim() &&
      comparePriceElement.style.display !== 'none'
    ) {
      var stillDiscounted =
        (discount && (discount.percent > 0 || discount.amount > 0)) ||
        getPdpDisplayDiscountPercent() > 0 ||
        getPdpDisplayDiscountAmount() > 0;
      if (stillDiscounted && originalPrice != null && saleForCompare != null && originalPrice > saleForCompare) {
        compareCents = originalPrice;
      } else if (stillDiscounted) {
        return;
      }
    }

    if (compareCents != null && compareCents > 0) {
      comparePriceElement.textContent = formatMoney(compareCents);
      comparePriceElement.style.display = '';
    } else {
      comparePriceElement.textContent = '';
      comparePriceElement.style.display = 'none';
    }
  }

  /** True when an app block in the price area is actually showing a price. */
  function hasAppPriceContent() {
    var root = document.getElementById('pdp-app-price-blocks');
    if (!root) return false;

    var selectors = [
      '.yagi-discounted-price',
      '.yagi-price-container .price-item--sale',
      '.yagi-price-container .price-item--last',
      '[data-base-price]',
      '.price-item--sale',
      '.price-item--last',
      '.price__sale .price-item',
      '[class*="discounted-price"]',
      '[class*="sale-price"]'
    ];
    for (var s = 0; s < selectors.length; s++) {
      var el = root.querySelector(selectors[s]);
      if (el && String(el.textContent || '').replace(/\s/g, '').length > 0) return true;
    }

    // Fallback: app block text that looks like money
    var blocks = root.querySelectorAll('.pdp-app-price-block');
    for (var i = 0; i < blocks.length; i++) {
      var text = String(blocks[i].textContent || '').trim();
      if (text && /(?:\$|USD|€|£)\s*[\d,.]+|[\d,.]+\s*(?:USD|EUR|GBP)/i.test(text)) return true;
    }
    return false;
  }

  /** Hide native price only when a real app price is rendered (and setting allows it). */
  function syncNativePriceVisibilityWithAppDiscount() {
    var nativePrice =
      document.getElementById('pdp-native-price') ||
      document.querySelector('#custom-product-container .price[data-discount-percentage]');
    var appRoot = document.getElementById('pdp-app-price-blocks');
    var hideWhenApp =
      !appRoot || appRoot.getAttribute('data-hide-native-when-app-price') !== 'false';
    var hasAppPrice = hasAppPriceContent();

    if (nativePrice) {
      if (hideWhenApp && hasAppPrice) {
        nativePrice.setAttribute('hidden', '');
      } else {
        nativePrice.removeAttribute('hidden');
        nativePrice.style.display = '';
      }
    }
  }

  var yagiDiscountRatio = null;

  function parseYagiMoneyToCents(text) {
    if (!text) return null;
    var cleaned = String(text).replace(/[^0-9.,-]/g, '').replace(/,/g, '');
    var n = parseFloat(cleaned);
    if (isNaN(n)) return null;
    // Already looks like cents if very large without decimal focus
    if (n > 0 && n < 100000 && String(text).indexOf('.') !== -1) {
      return Math.round(n * 100);
    }
    if (n >= 1000 && Math.abs(n - Math.round(n)) < 0.001 && String(text).indexOf('.') === -1) {
      return Math.round(n);
    }
    return Math.round(n * 100);
  }

  function formatYagiMoney(cents, sampleText) {
    var formatted = formatMoney(cents);
    if (!formatted) return '';
    var sample = sampleText || '';
    if (/USD/i.test(sample) && !/USD/i.test(formatted)) {
      formatted = formatted.replace(/\s*USD\s*$/i, '').trim() + ' USD';
    }
    return formatted;
  }

  /** Capture Yagi automatic-discount ratio from the initial Liquid render (sale / source Shopify price). */
  function ensureYagiDiscountRatio() {
    if (yagiDiscountRatio != null && !isNaN(yagiDiscountRatio) && yagiDiscountRatio > 0) {
      return yagiDiscountRatio;
    }
    var root = document.getElementById('pdp-app-price-blocks');
    if (!root) {
      yagiDiscountRatio = 1;
      return 1;
    }
    var saleEl = root.querySelector('.yagi-discounted-price');
    if (!saleEl) {
      yagiDiscountRatio = 1;
      return 1;
    }
    var sourcePrice = parseInt(root.getAttribute('data-yagi-source-price') || '0', 10) || 0;
    var baseRaw = parseFloat(saleEl.getAttribute('data-base-price'));
    var saleCents = null;
    if (!isNaN(baseRaw) && baseRaw > 0) {
      saleCents = baseRaw;
      if (sourcePrice > 0 && baseRaw < sourcePrice / 20) {
        saleCents = Math.round(baseRaw * 100);
      } else {
        saleCents = Math.round(baseRaw);
      }
    } else {
      saleCents = parseYagiMoneyToCents(saleEl.textContent);
    }
    if (!sourcePrice || !saleCents || sourcePrice <= 0) {
      yagiDiscountRatio = 1;
      return 1;
    }
    yagiDiscountRatio = saleCents / sourcePrice;
    if (!(yagiDiscountRatio > 0) || yagiDiscountRatio > 1.05) {
      yagiDiscountRatio = 1;
    }
    return yagiDiscountRatio;
  }

  function applyYagiDiscountCents(rawCents) {
    var raw = Math.round(Number(rawCents) || 0);
    if (raw <= 0) return 0;
    var ratio = ensureYagiDiscountRatio();
    if (ratio > 0 && ratio < 0.999) {
      return Math.max(0, Math.round(raw * ratio));
    }
    return applyPdpDisplayDiscountCents(raw);
  }

  /** Keep Yagi app price in sync when firmness/size changes (Liquid render is static). */
  function updateYagiAppPriceDisplay(mattressRawCents, mattressSaleCents, mattressCompareCents) {
    var root = document.getElementById('pdp-app-price-blocks');
    if (!root) return;
    var saleEl = root.querySelector('.yagi-discounted-price, .price-item--sale.yagi-discounted-price, .price-item--sale.price-item--last');
    if (!saleEl) return;

    var raw = Math.round(Number(mattressRawCents) || 0);
    var sale =
      mattressSaleCents != null
        ? Math.round(Number(mattressSaleCents) || 0)
        : applyYagiDiscountCents(raw);
    if (!(sale > 0) && raw > 0) sale = applyYagiDiscountCents(raw);

    var compare =
      mattressCompareCents != null && mattressCompareCents !== ''
        ? Math.round(Number(mattressCompareCents) || 0)
        : null;
    if (compare == null || !(compare > sale)) {
      var shopifyCompare = getCurrentMattressCompareAtCents();
      if (shopifyCompare != null && shopifyCompare > sale) compare = shopifyCompare;
      else if (raw > sale) compare = raw;
      else compare = null;
    }

    var sampleSale = saleEl.textContent || '';
    saleEl.textContent = formatYagiMoney(sale, sampleSale);
    saleEl.setAttribute('data-base-price', String(sale));

    var container = root.querySelector('.yagi-price-container') || root;
    var compareEl =
      container.querySelector('s.price-item--regular, s.price-item, .price-item--regular') ||
      container.querySelector('.price__sale s, .price__regular s');
    if (compareEl) {
      if (compare != null && compare > sale) {
        compareEl.textContent = formatYagiMoney(compare, compareEl.textContent || sampleSale);
        compareEl.style.display = '';
        if (compareEl.parentElement) compareEl.parentElement.style.display = '';
      } else {
        compareEl.textContent = '';
        compareEl.style.display = 'none';
      }
    }

    if (container.classList) {
      if (compare != null && compare > sale) container.classList.add('price--on-sale');
      else container.classList.remove('price--on-sale');
    }
  }

  function updateTotalPrice(options) {
    var opts = options || {};
    updateNoFoundationCardPrice();
    if (!opts.skipUnderbedRefresh) {
      refreshUnderbedCollectionCardPrices();
    }

    // Use more specific selector to target the correct price element
    const priceElement = document.querySelector('#custom-product-container .price-amount') || 
                         document.querySelector('.price-amount');
    
    // Get main product price - try multiple sources
    let mainProductPrice = 0;
    let priceVariant = currentSizeVariant;

    if (getUnderbedConfig()) {
      const mattressForPrice = findMattressVariantForAddToCart();
      if (mattressForPrice && mattressForPrice.price != null) {
        mainProductPrice = parseInt(mattressForPrice.price, 10) || 0;
        priceVariant = mattressForPrice;
      }
    }

    // Method 1: From currentSizeVariant
    if (mainProductPrice === 0 && currentSizeVariant && currentSizeVariant.price) {
      mainProductPrice = parseInt(currentSizeVariant.price, 10) || 0;
      priceVariant = currentSizeVariant;
    }
    // Method 2: From size select dropdown
    else if (mainProductPrice === 0) {
      const sizeSelect = document.getElementById('size-select');
      if (sizeSelect && sizeSelect.selectedIndex >= 0) {
        const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
        if (selectedOption) {
          // Try to get price from the variant object if available
          const variantId = selectedOption.value;
          if (currentMattressProduct && currentMattressProduct.variants) {
            const variant = currentMattressProduct.variants.find(v => v.id.toString() === variantId);
            if (variant && variant.price) {
              mainProductPrice = parseInt(variant.price, 10) || 0;
              priceVariant = variant;
            }
          }
          
          // Prefer raw Shopify cents (never re-parse already-discounted data-price)
          if (mainProductPrice === 0) {
            const rawCents = selectedOption.getAttribute('data-raw-price-cents');
            if (rawCents != null && rawCents !== '') {
              mainProductPrice = parseInt(rawCents, 10) || 0;
            }
          }

          // Fallback: Try data-price attribute (formatted price) — may already be discounted
          if (mainProductPrice === 0) {
            const priceAttr = selectedOption.getAttribute('data-price');
            if (priceAttr) {
              const priceStr = priceAttr.replace(/[$,]/g, '');
              const priceFloat = parseFloat(priceStr);
              if (!isNaN(priceFloat)) {
                mainProductPrice = Math.round(priceFloat * 100);
              }
            }
          }
        }
      }
    }

    // Keep active product discount map in sync with DOM scripts (critical after firmness switch).
    // Never overwrite a populated map with {} — that caused badge/compare flash-then-hide.
    if (currentMattressProduct && currentMattressProduct.handle) {
      var mapForPrice = getVariantDiscountsForHandle(currentMattressProduct.handle);
      if (mapForPrice && Object.keys(mapForPrice).length) {
        currentMattressProduct.variantDiscounts = mapForPrice;
        if (window.__PDP_STORE__) {
          window.__PDP_STORE__.variantDiscounts = mapForPrice;
          window.__PDP_STORE__.variantDiscountsProductHandle =
            currentMattressProduct.handle || '';
        }
      }
    }
    
    // Base / foundation add-on (underbed collection or legacy foundation product)
    let addonPriceCents = 0;
    let addonDiscountPct = getPdpDisplayDiscountPercent();
    let addonDiscountAmt = 0;
    const underbedInput = getSelectedUnderbedInput();
    if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
      syncCurrentFoundationFromUnderbedInput(underbedInput);
      addonPriceCents = getUnderbedAddonPriceCents();
      const ubCfg = getUnderbedConfig();
      const ubHandle = underbedInput.getAttribute('data-underbed-handle') || '';
      const ubProduct = ubCfg && ubCfg.products
        ? ubCfg.products.find(function (p) { return p && p.handle === ubHandle; })
        : null;
      const ubVariant = resolveUnderbedVariantForCurrentSize(ubProduct, true) || currentFoundationVariant;
      const ubDisc = getUnderbedDisplayDiscount(ubProduct, ubVariant);
      addonDiscountPct = ubDisc.percent;
      addonDiscountAmt = ubDisc.amount;
    } else {
      const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
      if (selectedFoundation) {
        if (currentFoundationVariant && currentFoundationVariant.price !== undefined && currentFoundationVariant.price !== null) {
          addonPriceCents = parseInt(currentFoundationVariant.price, 10) || 0;
        } else {
          const foundationPriceAttr = selectedFoundation.getAttribute('data-variant-price');
          if (foundationPriceAttr !== null && foundationPriceAttr !== '' && foundationPriceAttr !== 'null') {
            addonPriceCents = parseInt(foundationPriceAttr, 10) || 0;
          }
        }
      }
    }

    const hasYagiPrice = hasAppPriceContent();
    const mattressSaleCents = hasYagiPrice
      ? applyYagiDiscountCents(mainProductPrice)
      : applyPdpDisplayDiscountCents(mainProductPrice, priceVariant, currentMattressProduct);
    const addonSaleCents = hasYagiPrice
      ? applyYagiDiscountCents(addonPriceCents)
      : (window.SuaveDisplayDiscount && typeof window.SuaveDisplayDiscount.applyCents === 'function'
        ? window.SuaveDisplayDiscount.applyCents(addonPriceCents, addonDiscountPct, addonDiscountAmt)
        : applyPdpDisplayDiscountCents(addonPriceCents));
    const totalPrice = mattressSaleCents + addonSaleCents;
    
    // Update price display - use both textContent and innerHTML to ensure it updates
    const formattedPrice = formatMoney(totalPrice);
    
    // Try multiple methods to update the price
    if (priceElement) {
      priceElement.textContent = formattedPrice;
      priceElement.innerHTML = formattedPrice;
      
      // Also try to trigger a reflow to ensure the update is visible
      priceElement.style.display = 'none';
      priceElement.offsetHeight; // Trigger reflow
      priceElement.style.display = '';
    } else if (!hasYagiPrice) {
      console.warn('⚠️ Price element not found');
    }

    var mattressCompare = getCurrentMattressCompareAtCents();
    if (mattressCompare == null || !(mattressCompare > mattressSaleCents)) {
      mattressCompare = mainProductPrice > mattressSaleCents ? mainProductPrice : null;
    }

    // Sync discount attrs before compare/badge so fallbacks still see the live values.
    // Only write zeros when this variant truly has no discount (do not blank Liquid attrs early).
    var priceWrap = document.querySelector('#custom-product-container .price');
    var liveDiscount = resolveActiveDisplayDiscount(priceVariant, currentMattressProduct);
    if (priceWrap && priceVariant) {
      var prevAmt = parseFloat(priceWrap.getAttribute('data-discount-amount')) || 0;
      var prevPct = parseFloat(priceWrap.getAttribute('data-discount-percentage')) || 0;
      var nextAmt = liveDiscount.amount > 0 ? liveDiscount.amount : 0;
      var nextPct = liveDiscount.percent > 0 ? liveDiscount.percent : 0;
      if (nextAmt > 0 || nextPct > 0 || prevAmt > 0 || prevPct > 0 || currentSizeVariant) {
        priceWrap.setAttribute('data-discount-percentage', String(nextPct));
        priceWrap.setAttribute('data-discount-amount', String(nextAmt));
      }
    }

    updateCompareAtPriceDisplay(mattressSaleCents, mainProductPrice, priceVariant);
    updateYagiAppPriceDisplay(mainProductPrice, mattressSaleCents, mattressCompare);
    syncNativePriceVisibilityWithAppDiscount();

    var badgeSource = currentMattressProduct || {};
    refreshPdpSaleBadge(badgeSource, mattressSaleCents, mattressCompare, priceVariant);
  }
  
  function updateButtonStates() {
    const addToCartBtn = document.getElementById('add-to-cart');
    const buyNowBtn = document.getElementById('buy-now');

    if (document.getElementById('custom-product-container') && document.querySelector('#md-sticky-atc')) {
      initMobileStickyATC();
    }

    if (!addToCartBtn || !buyNowBtn) return;
    
    // Update total price first
    updateTotalPrice();
    
    // Check mattress variant availability
    let isMattressAvailable = false;
    if (currentSizeVariant) {
      isMattressAvailable = 
        currentSizeVariant.available === true ||
        currentSizeVariant.inventory_policy === 'continue' ||
        (currentSizeVariant.inventory_quantity !== null && currentSizeVariant.inventory_quantity > 0) ||
        (currentSizeVariant.inventory_management === null && currentSizeVariant.available !== false);
    }
    
    // Check base/foundation availability if selected
    const underbedInput = getSelectedUnderbedInput();
    const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
    let isFoundationAvailable = true;

    if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
      isFoundationAvailable = isSelectedUnderbedSellable();
    } else if (selectedFoundation) {
      const isAvailable = selectedFoundation.getAttribute('data-variant-available') === 'true';
      const inventoryPolicy = selectedFoundation.getAttribute('data-variant-inventory-policy');
      const inventoryQuantity = selectedFoundation.getAttribute('data-variant-inventory');
      const inventoryManagement = selectedFoundation.getAttribute('data-variant-inventory-management');

      if (isAvailable === true) {
        isFoundationAvailable = true;
      } else if (inventoryPolicy === 'continue') {
        isFoundationAvailable = true;
      } else if (inventoryQuantity && parseInt(inventoryQuantity, 10) > 0) {
        isFoundationAvailable = true;
      } else if (inventoryManagement === 'null' || inventoryManagement === null) {
        isFoundationAvailable = true;
      } else {
        isFoundationAvailable = false;
      }
    }

    const hasBaseSelection =
      (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) || !!selectedFoundation;
    const isAllAvailable = isMattressAvailable && (isFoundationAvailable || !hasBaseSelection);
    
    if (!isAllAvailable) {
      addToCartBtn.textContent = suavePdpT('outOfStock', 'Out of Stock');
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('out-of-stock');
      
      buyNowBtn.disabled = true;
      buyNowBtn.classList.add('out-of-stock');
    } else {
      addToCartBtn.textContent = suavePdpT('addToCart', 'Add to Cart');
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('out-of-stock');
      
      buyNowBtn.disabled = false;
      buyNowBtn.classList.remove('out-of-stock');
    }

    if (document.getElementById('custom-product-container') && document.querySelector('#md-sticky-atc')) {
      updateStickyATC();
      const stickyBtn = document.querySelector('#md-sticky-atc [name="add"]');
      if (stickyBtn && addToCartBtn) {
        stickyBtn.disabled = addToCartBtn.disabled;
        stickyBtn.classList.toggle('out-of-stock', addToCartBtn.classList.contains('out-of-stock'));
        const stickyLabel = stickyBtn.querySelector('.md-sticky-atc-btn-label');
        if (stickyLabel) stickyLabel.textContent = addToCartBtn.textContent.trim();
      }
    }
  }

  function initMobileStickyATC() {
    const sticky = document.querySelector('#md-sticky-atc');
    const cta =
      document.querySelector('#custom-product-container .cta-buttons') ||
      document.getElementById('add-to-cart');
    if (!sticky || sticky.dataset.stickyBound === '1') return;
    sticky.dataset.stickyBound = '1';

    const mobileMq = window.matchMedia('(max-width: 989px)');

    const setBarVisible = (visible) => {
      if (!mobileMq.matches) {
        sticky.classList.remove('is-visible');
        sticky.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('md-sticky-atc-visible');
        return;
      }
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', visible ? 'false' : 'true');
      document.body.classList.toggle('md-sticky-atc-visible', visible);
    };

    const evaluateVisibility = () => {
      if (!mobileMq.matches) {
        setBarVisible(false);
        return;
      }
      if (!cta) {
        setBarVisible(window.scrollY > 200);
        return;
      }
      const rect = cta.getBoundingClientRect();
      const ctaOffScreen = rect.bottom < 0 || rect.top > window.innerHeight - 80;
      setBarVisible(ctaOffScreen);
    };

    if (cta && typeof IntersectionObserver !== 'undefined') {
      const observer = new IntersectionObserver(
        (entries) => {
          if (!mobileMq.matches) return setBarVisible(false);
          const entry = entries[0];
          setBarVisible(entry ? !entry.isIntersecting : false);
        },
        { threshold: 0, rootMargin: '0px 0px -72px 0px' }
      );
      observer.observe(cta);
      sticky._suaveStickyAtcObserver = observer;
    } else {
      evaluateVisibility();
      window.addEventListener('scroll', evaluateVisibility, { passive: true });
    }

    mobileMq.addEventListener('change', evaluateVisibility);
    window.addEventListener('resize', evaluateVisibility, { passive: true });
    evaluateVisibility();
    updateStickyATC();
  }

  function updateStickyATC() {
    const sticky = document.querySelector('#md-sticky-atc');
    if (!sticky) return;
    const titleEl = sticky.querySelector('.product__title');
    const imgEl = sticky.querySelector('.sticky-atc-img, .product-content img');
    const selectionsEl = document.getElementById('sticky-atc-selections');
    const qtyWrap = sticky.querySelector('.sticky-atc-quantity-wrap');

    if (titleEl) {
      titleEl.textContent =
        (currentMattressProduct && currentMattressProduct.title) ||
        document.querySelector('#custom-product-container .product-title')?.textContent?.trim() ||
        '';
    }
    if (imgEl) {
      const mainImg = document.getElementById('main-image');
      if (mainImg && mainImg.src && mainImg.src.trim()) {
        imgEl.src = mainImg.src;
        if (mainImg.alt) imgEl.alt = mainImg.alt;
      } else if (currentMattressProduct) {
        const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
        const foundationOption = selectedFoundation ? selectedFoundation.closest('.foundation-option') : null;
        const foundationImageUrl = foundationOption ? foundationOption.getAttribute('data-variant-image') : null;
        if (foundationImageUrl && foundationImageUrl.trim()) {
          imgEl.src = foundationImageUrl.trim();
        } else if (currentMattressProduct.featured_image && currentMattressProduct.featured_image.src) {
          imgEl.src = currentMattressProduct.featured_image.src;
        } else if (currentMattressProduct.images && currentMattressProduct.images[0] && currentMattressProduct.images[0].src) {
          imgEl.src = currentMattressProduct.images[0].src;
        }
      }
    }
    // Update sticky price: only set sale price; show compare-at only when it is greater than variant price
    const mainPriceEl = document.querySelector('#custom-product-container .price-amount');
    const mainCompareEl = document.querySelector('#custom-product-container .compare-at-price');
    const priceContainer = sticky.querySelector('.sticky-atc-price, .sticky-atc-product-details .price');
    if (priceContainer) {
      const salePriceEl = priceContainer.querySelector('.price-item--sale, .price-item--last');
      const compareWrap = priceContainer.querySelector('.price__sale s.price-item--regular, .price__sale .price-item--regular');
      const saleBadge = priceContainer.querySelector('.price__badge-sale');
      const formattedPrice = (mainPriceEl && mainPriceEl.textContent) ? mainPriceEl.textContent.trim() : (currentSizeVariant ? formatMoney(currentSizeVariant.price) : '');
      if (salePriceEl && formattedPrice) salePriceEl.textContent = formattedPrice;
      var showCompare = false;
      var formattedCompare = '';
      if (currentSizeVariant && currentSizeVariant.compare_at_price && parseInt(currentSizeVariant.compare_at_price, 10) > parseInt(currentSizeVariant.price, 10)) {
        showCompare = true;
        formattedCompare = formatMoney(currentSizeVariant.compare_at_price);
      } else if (mainCompareEl && mainCompareEl.style.display !== 'none' && mainCompareEl.textContent && mainPriceEl && mainPriceEl.textContent) {
        var compareText = mainCompareEl.textContent.trim();
        var priceText = mainPriceEl.textContent.trim();
        if (compareText && compareText !== priceText) {
          showCompare = true;
          formattedCompare = compareText;
        }
      }
      if (compareWrap) {
        if (showCompare && formattedCompare) {
          compareWrap.textContent = formattedCompare;
          if (compareWrap.closest('span')) compareWrap.closest('span').style.display = '';
          priceContainer.classList.add('price--on-sale');
        } else {
          compareWrap.textContent = '';
          if (compareWrap.closest('span')) compareWrap.closest('span').style.display = 'none';
          priceContainer.classList.remove('price--on-sale');
        }
      } else {
        if (showCompare) priceContainer.classList.add('price--on-sale');
        else priceContainer.classList.remove('price--on-sale');
      }
      if (saleBadge) saleBadge.style.display = showCompare ? '' : 'none';
    }

    if (selectionsEl) {
      const variantNameEl = document.getElementById('variant-name-display');
      const foundationNameEl = document.getElementById('foundation-name-display');
      const sizeSelect = document.getElementById('size-select');
      const parts = [];
      if (sizeSelect && sizeSelect.selectedIndex >= 0) {
        const sizeOption = sizeSelect.options[sizeSelect.selectedIndex];
        if (sizeOption && sizeOption.text) parts.push(sizeOption.text.trim());
      }
      if (variantNameEl && variantNameEl.textContent) parts.push(variantNameEl.textContent.trim());
      if (foundationNameEl && foundationNameEl.textContent) {
        const foundationText = foundationNameEl.textContent.trim();
        if (foundationText) parts.push('Foundation: ' + foundationText);
      }
      if (parts.length > 0) {
        selectionsEl.textContent = parts.join(' · ');
        selectionsEl.style.display = '';
      } else {
        selectionsEl.style.display = 'none';
      }
    }
    if (qtyWrap) qtyWrap.style.display = 'none';
  }
  
  // Function to update browser address bar URL
  function updateProductUrlDisplay(productHandle, options) {
    if (!productHandle) return;
    var opts = options || {};
    const root = suavePdpRootUrl().replace(/\/?$/, '');
    const productUrl = `${window.location.origin}${root}/products/${encodeURIComponent(productHandle)}`;
    
    // Update browser address bar without page reload
    if (opts.pushState && window.history && window.history.pushState) {
      window.history.pushState({ path: productUrl }, '', productUrl);
    } else if (window.history && window.history.replaceState) {
      window.history.replaceState({ path: productUrl }, '', productUrl);
    }
  }
  
  // Tab switching for mattress products
  const tabs = document.querySelectorAll("#custom-product-container .tab");
  
  tabs.forEach((tab) => {
    tab.addEventListener("click", async function (e) {
      // Save current scroll position to prevent auto-scroll
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      
      applyMattressTabActiveVisuals(this);
      const tabColor = this.getAttribute('data-tab-color');
      
      const productHandle = this.dataset.tab;
      
      // Update browser address bar URL
      if (productHandle) {
        updateProductUrlDisplay(productHandle);
      }
      
      updateTitleLastWordColor();

      try {
        // Fetch product with metafields
        const response = await fetch(suavePdpProductJsonUrl(productHandle));
        if (response.ok) {
          const productData = await response.json();
          // Fetch variant metafields separately if needed
          if (productData.variants && productData.variants.length > 0) {
            await fetchVariantMetafields(productData);
          }
          await updateMattressProduct(productData, this);
          
          if (document.getElementById('custom-product-container') && document.querySelector('#md-sticky-atc')) {
            updateStickyATC();
            setTimeout(function() {
              updateStickyATC();
            }, 450);
          }
          
          // Restore scroll position after product update to prevent auto-scroll
          window.scrollTo(0, scrollPosition);
          requestAnimationFrame(() => {
            window.scrollTo(0, scrollPosition);
          });
        } else {
          console.error('Failed to fetch product:', response.status);
        }
      } catch (error) {
        console.error('Error loading product data:', error);
      }
    });
  });
  
  // Handle browser back/forward buttons
  window.addEventListener('popstate', async function () {
    const ctx = getPageProductContext();
    const matchingTab = findMattressTabForPageProduct();
    if (matchingTab && !matchingTab.classList.contains('active')) {
      activateMattressTabForPageProduct({ skipUrlUpdate: true });
      return;
    }
    if (ctx.handle && findComfortCardByProductHandle(ctx.handle)) {
      await selectComfortProductByHandle(ctx.handle, { updateUrl: false });
    }
  });
  
  // Size selection handler
  const sizeSelect = document.getElementById("size-select");
  if (sizeSelect) {
    sizeSelect.addEventListener("change", function () {
      updateProductForSelectedVariant();
      updateButtonStates();
    });
  }

  // Function to update variant name display
  function updateVariantNameDisplay() {
    const variantNameDisplay = document.getElementById('variant-name-display');
    const foundationNameDisplay = document.getElementById('foundation-name-display');
    
    if (!variantNameDisplay) return;
    
    // Get current firmness variant name
    if (currentFirmnessVariant) {
      const { firmnessIndex } = detectOptionTypes(currentMattressProduct);
      let firmnessValue = 'Standard';
      
      if (currentFirmnessVariant.options && currentFirmnessVariant.options[firmnessIndex] !== undefined) {
        firmnessValue = currentFirmnessVariant.options[firmnessIndex];
      } else if (currentFirmnessVariant.option1 && firmnessIndex === 0) {
        firmnessValue = currentFirmnessVariant.option1;
      } else if (currentFirmnessVariant.option2 && firmnessIndex === 1) {
        firmnessValue = currentFirmnessVariant.option2;
      } else if (currentFirmnessVariant.option3 && firmnessIndex === 2) {
        firmnessValue = currentFirmnessVariant.option3;
      }
      
      variantNameDisplay.textContent = firmnessValue;
      variantNameDisplay.style.display = 'block';
    } else {
      variantNameDisplay.style.display = 'none';
    }
    
    // Get foundation / base name if selected
    if (foundationNameDisplay) {
      const underbedInput = getSelectedUnderbedInput();
      let foundationTitle = '';
      if (underbedInput && !isUnderbedNoFoundationInput(underbedInput)) {
        foundationTitle = underbedInput.getAttribute('data-foundation-type') || '';
      } else {
        const selectedFoundation = document.querySelector('input[name="foundation"]:checked');
        if (selectedFoundation) {
          foundationTitle = selectedFoundation.getAttribute('data-variant-title') || '';
        }
      }
      if (foundationTitle) {
        foundationNameDisplay.textContent = suaveTWithFoundation(foundationTitle);
        foundationNameDisplay.style.display = 'block';
      } else {
        foundationNameDisplay.style.display = 'none';
      }
    }
  }

  // Function to update variant info (short, long) from variant info metafields
  function updateVariantInfo(variantId) {
    if (!variantId) return;
    const variantIdStr = variantId.toString();
    const variantInfo = variantInfoMetafieldsMap.get(variantIdStr);
    
    // Update firmness card title with variant title
    if (variantInfo && variantInfo.title && variantInfo.title.trim() !== '') {
      const firmnessCardTitle = document.querySelector('.firmness-card.selected .firmness-card-title');
      if (firmnessCardTitle) {
        firmnessCardTitle.textContent = variantInfo.title.trim();
      }
    }
    
    // Keep Shopify product description (locale from Liquid); never overwrite with English .js API text
    restoreLocalizedProductDescription(
      currentActiveTab || document.querySelector('#custom-product-container .tab.active')
    );
    
    // Update meta variant description with long text (preserve spaces and line breaks)
    const metaVariantDescription = document.getElementById('meta-varaint-description');
    if (metaVariantDescription && variantInfo && variantInfo.long && variantInfo.long.trim() !== '') {
      var longText = variantInfo.long.trim();
      if (longText.indexOf('<') === -1 || longText.indexOf('>') === -1) {
        longText = longText.replace(/\r\n/g, '\n').replace(/\n/g, '<br>');
      }
      metaVariantDescription.innerHTML = longText;
    } else if (metaVariantDescription) {
      metaVariantDescription.innerHTML = '';
    }
  }
  
  // Function to update variant image and features section
  async function updateVariantImageAndFeatures(variantId) {
    if (!variantId) return;
    if (!isFoundationSelected) {
      loadVariantImageGallery(variantId);
    }
    
    // Check if section exists on page
    // Try multiple selectors for image element
    let imageElement = document.getElementById('variant-image-data');

    if (!imageElement) {
      imageElement = document.querySelector('[data-attribute="variant-image-data"]');
    }
    if (!imageElement) {
      imageElement = document.querySelector('[id="variant-image-data"]');
    }
    // Also try finding by wrapper class
    if (!imageElement) {
      const wrapper = document.querySelector('.custom-image-feature__image-wrapper');
      if (wrapper) {
        imageElement = wrapper;
      }
    }
    const headingElements = document.querySelectorAll('#variant-data-heading');
    const descriptionElements = document.querySelectorAll('#variant-data-description');
    
    if (!imageElement && headingElements.length === 0 && descriptionElements.length === 0) {
      // Section not present on page, exit
      return;
    }
    
    try {
      // Get variant metafield data from map (loaded from Liquid template)
      const variantIdStr = variantId.toString();
      let variantMetafieldData = variantImageFeaturesMap.get(variantIdStr);
    
      
      // Try alternative variant ID formats
      if (!variantMetafieldData) {
        const variantIdNum = parseInt(variantIdStr);
        if (!isNaN(variantIdNum)) {
          variantMetafieldData = variantImageFeaturesMap.get(variantIdNum.toString()) || 
                                 variantImageFeaturesMap.get(String(variantIdNum));
        }
      }
      
      // If not found in map, try to get from current variant object
      if (!variantMetafieldData && currentMattressProduct && currentMattressProduct.variants) {
        const variant = currentMattressProduct.variants.find(v => 
          v.id.toString() === variantIdStr || 
          v.id === parseInt(variantIdStr) ||
          String(v.id) === variantIdStr
        );
        if (variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.variant_image_and_features) {
          variantMetafieldData = variant.metafields.custom.variant_image_and_features;
          // Handle metaobject - get value if it exists
          if (variantMetafieldData && typeof variantMetafieldData === 'object' && variantMetafieldData.value) {
            variantMetafieldData = variantMetafieldData.value;
          }
        }
      }
      
      // Validate variant data - check if it has actual content
      let hasVariantData = false;
      if (variantMetafieldData) {
        // Check if image exists and is valid - try both "image" and "Image" (case-insensitive)
        const imageField = variantMetafieldData.image || variantMetafieldData.Image;
        const hasImage = imageField && 
                        imageField !== null && 
                        imageField !== 'null' &&
                        imageField !== '';
        
        // Check if heading exists and is valid
        let headingData = variantMetafieldData.heading;
        if (headingData && typeof headingData === 'object' && headingData.value) {
          headingData = headingData.value;
        }
        const hasHeading = headingData && 
                          headingData !== null && 
                          headingData !== 'null' &&
                          (Array.isArray(headingData) ? headingData.length > 0 : String(headingData).trim() !== '');
        
        // Check if description exists and is valid
        let descData = variantMetafieldData.description;
        if (descData && typeof descData === 'object' && descData.value) {
          descData = descData.value;
        }
        const hasDescription = descData && 
                              descData !== null && 
                              descData !== 'null' &&
                              (Array.isArray(descData) ? descData.length > 0 : String(descData).trim() !== '');
        
        hasVariantData = hasImage || hasHeading || hasDescription;
      }
      
      // If no valid variant data, set to null to use customizer data
      if (!hasVariantData) {
        variantMetafieldData = null;
      }
      
      // Update image if variant has image data
      if (imageElement) {
        // Hide all customizer images and placeholder first
        const customizerImages = imageElement.querySelectorAll('img:not([data-variant-image])');
        const placeholder = imageElement.querySelector('.custom-image-feature__image-placeholder');
        
        customizerImages.forEach(img => {
          img.style.cssText = 'display: none !important; visibility: hidden !important;';
        });
        if (placeholder) {
          placeholder.style.cssText = 'display: none !important; visibility: hidden !important;';
        }
        
        // Check if variant has valid image data - try both "image" and "Image" (case-insensitive)
        let imageField = null;
        if (variantMetafieldData) {
          // Try lowercase first, then uppercase
          imageField = variantMetafieldData.image || variantMetafieldData.Image;
          
          // Also check all keys case-insensitively
          if (!imageField) {
            for (const key in variantMetafieldData) {
              if (key.toLowerCase() === 'image') {
                imageField = variantMetafieldData[key];
                break;
              }
            }
          }
        }
        
        if (imageField && 
            imageField !== null && 
            imageField !== 'null' &&
            imageField !== '' &&
            imageField !== undefined) {
          let imgSrc = '';
          
          // Handle different image formats - check all possible structures
          const imageData = imageField;
          
          // First, try direct string
          if (typeof imageData === 'string' && imageData.trim() !== '' && imageData !== 'null' && !imageData.includes('gid://')) {
            imgSrc = imageData.trim();
          }
          // If object, try various properties
          else if (imageData && typeof imageData === 'object' && imageData !== null) {
            // Try direct properties first (src, url)
            if (imageData.src && typeof imageData.src === 'string' && imageData.src.trim() !== '' && !imageData.src.includes('gid://')) {
              imgSrc = imageData.src.trim();
            } else if (imageData.url && typeof imageData.url === 'string' && imageData.url.trim() !== '' && !imageData.url.includes('gid://')) {
              imgSrc = imageData.url.trim();
            } 
            // Try preview property (Shopify media format) - check first as it's common
            else if (imageData.preview) {
              if (imageData.preview.src && typeof imageData.preview.src === 'string' && imageData.preview.src.trim() !== '' && !imageData.preview.src.includes('gid://')) {
                imgSrc = imageData.preview.src.trim();
              } else if (imageData.preview.url && typeof imageData.preview.url === 'string' && imageData.preview.url.trim() !== '' && !imageData.preview.url.includes('gid://')) {
                imgSrc = imageData.preview.url.trim();
              }
            }
            // Try value property (for metaobject references)
            else if (imageData.value) {
              const imgValue = imageData.value;
              if (typeof imgValue === 'string' && imgValue.trim() !== '' && imgValue !== 'null' && !imgValue.includes('gid://')) {
                imgSrc = imgValue.trim();
              } else if (imgValue && typeof imgValue === 'object' && imgValue !== null) {
                // Nested object - try src, url, or preview
                if (imgValue.src && typeof imgValue.src === 'string' && imgValue.src.trim() !== '' && !imgValue.src.includes('gid://')) {
                  imgSrc = imgValue.src.trim();
                } else if (imgValue.url && typeof imgValue.url === 'string' && imgValue.url.trim() !== '' && !imgValue.url.includes('gid://')) {
                  imgSrc = imgValue.url.trim();
                } else if (imgValue.preview && imgValue.preview.src) {
                  // Try preview.src for Shopify media objects
                  imgSrc = imgValue.preview.src;
                }
              }
            }
          }
          
          // Validate image URL - must be valid HTTP/HTTPS URL, not gid://
          // Also check if it's a Shopify CDN URL (cdn.shopify.com)
          const isValidUrl = imgSrc && 
                            imgSrc.trim() !== '' && 
                            !imgSrc.includes('gid://') && 
                            imgSrc !== 'null' && 
                            (imgSrc.startsWith('http') || 
                             imgSrc.startsWith('//') || 
                             imgSrc.startsWith('/') ||
                             imgSrc.includes('cdn.shopify.com'));
          
          if (isValidUrl) {
            // Check if variant image already exists
            let variantImg = imageElement.querySelector('img[data-variant-image]');
            if (variantImg) {
              variantImg.src = imgSrc;
              // Create proper srcset for responsive images
              const baseUrl = imgSrc.split('?')[0]; // Remove query params for srcset
              variantImg.srcset = `${baseUrl}?width=350 350w, ${baseUrl}?width=750 750w, ${baseUrl}?width=1100 1100w, ${imgSrc} ${imgSrc.includes('width=') ? '' : '1100w'}`;
              variantImg.style.cssText = 'display: block !important; visibility: visible !important; width: 100% !important; height: auto !important;';
            } else {
              // Create variant image if doesn't exist
              variantImg = document.createElement('img');
              variantImg.src = imgSrc;
              const baseUrl = imgSrc.split('?')[0];
              variantImg.srcset = `${baseUrl}?width=350 350w, ${baseUrl}?width=750 750w, ${baseUrl}?width=1100 1100w, ${imgSrc} ${imgSrc.includes('width=') ? '' : '1100w'}`;
              variantImg.className = 'custom-image-feature__image';
              variantImg.loading = 'lazy';
              variantImg.setAttribute('data-variant-image', 'true');
              variantImg.alt = 'Variant image';
              variantImg.style.cssText = 'display: block !important; visibility: visible !important; width: 100% !important; height: auto !important;';
              imageElement.appendChild(variantImg);
            }
            // Ensure customizer images and placeholder are hidden
            customizerImages.forEach(img => {
              img.style.cssText = 'display: none !important; visibility: hidden !important;';
            });
            if (placeholder) {
              placeholder.style.cssText = 'display: none !important; visibility: hidden !important;';
            }
          } else {
            // No valid variant image - show customizer images or placeholder
            const variantImg = imageElement.querySelector('img[data-variant-image]');
            if (variantImg) {
              variantImg.style.cssText = 'display: none !important; visibility: hidden !important;';
            }
            // Show customizer image if exists, otherwise show placeholder
            if (customizerImages.length > 0) {
              customizerImages.forEach(img => {
                img.style.cssText = 'display: block !important; visibility: visible !important;';
              });
              if (placeholder) {
                placeholder.style.cssText = 'display: none !important; visibility: hidden !important;';
              }
            } else if (placeholder) {
              placeholder.style.cssText = 'display: block !important; visibility: visible !important;';
            }
          }
        } else {
          // No variant image data - show customizer images or placeholder
          const variantImg = imageElement.querySelector('img[data-variant-image]');
          if (variantImg) {
            variantImg.style.cssText = 'display: none !important; visibility: hidden !important;';
          }
          // Show customizer image if exists, otherwise show placeholder
          if (customizerImages.length > 0) {
            customizerImages.forEach(img => {
              img.style.cssText = 'display: block !important; visibility: visible !important;';
            });
            if (placeholder) {
              placeholder.style.cssText = 'display: none !important; visibility: hidden !important;';
            }
          } else if (placeholder) {
            placeholder.style.cssText = 'display: block !important; visibility: visible !important;';
          }
        }
      }
      
      // Update heading and description if variant has data (handle list format)
      const blocksContainer = document.querySelector('.custom-image-feature__blocks-container');
      if (blocksContainer) {
        if (variantMetafieldData) {
          let headingData = variantMetafieldData.heading;
          let descData = variantMetafieldData.description;
          
          // Handle metaobject values
          if (headingData && typeof headingData === 'object' && headingData.value) {
            headingData = headingData.value;
          }
          if (descData && typeof descData === 'object' && descData.value) {
            descData = descData.value;
          }
          
          // Convert to arrays if needed
          let headingArray = [];
          let descArray = [];
          
          if (Array.isArray(headingData)) {
            headingArray = headingData;
          } else if (headingData && typeof headingData === 'string' && headingData.trim() !== '') {
            headingArray = [headingData.trim()];
          }
          
          if (Array.isArray(descData)) {
            descArray = descData;
          } else if (descData && typeof descData === 'string' && descData.trim() !== '') {
            descArray = [descData.trim()];
          }
          
          // Determine max length - use metafield data length, not customizer blocks
          const maxLength = Math.max(headingArray.length, descArray.length);
          
          // Hide all existing blocks first (but don't remove them yet)
          const existingBlocks = blocksContainer.querySelectorAll('.custom-image-feature__block');
          existingBlocks.forEach(block => {
            block.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
          });
          
          // Create or update blocks for each data pair - ensure loop runs completely
          if (maxLength > 0) {
            for (let i = 0; i < maxLength; i++) {
              const headingText = headingArray[i] ? String(headingArray[i]).trim() : '';
              const descText = descArray[i] ? String(descArray[i]).trim() : '';
              
              // Skip if both heading and description are empty
              if (!headingText && !descText) {
                // Still hide the block if it exists
                if (existingBlocks[i]) {
                  existingBlocks[i].style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
                }
                continue;
              }
              
              // Get or create block element
              let blockElement = existingBlocks[i];
              if (!blockElement) {
                // Create new block if needed
                blockElement = document.createElement('div');
                blockElement.className = 'custom-image-feature__block pdp-border-color';
                blockElement.setAttribute('data-variant-block', 'true');
                const blockInner = document.createElement('div');
                blockInner.className = 'custom-image-feature__block-inner';
                blockElement.appendChild(blockInner);
                blocksContainer.appendChild(blockElement);
              }
              
              // Show block properly - remove all inline styles but keep classes
              blockElement.style.cssText = '';
              blockElement.removeAttribute('style');
              // Ensure classes are present
              if (!blockElement.classList.contains('custom-image-feature__block')) {
                blockElement.classList.add('custom-image-feature__block');
              }
              if (!blockElement.classList.contains('pdp-border-color')) {
                blockElement.classList.add('pdp-border-color');
              }
              
              let blockInner = blockElement.querySelector('.custom-image-feature__block-inner');
              if (!blockInner) {
                blockInner = document.createElement('div');
                blockInner.className = 'custom-image-feature__block-inner';
                blockElement.appendChild(blockInner);
              }
              
              // Update or create heading
              if (headingText) {
                let headingEl = blockInner.querySelector('.custom-image-feature__block-heading');
                if (!headingEl) {
                  headingEl = document.createElement('p');
                  headingEl.className = 'custom-image-feature__block-heading pdp-text-color';
                  blockInner.insertBefore(headingEl, blockInner.firstChild);
                }
                headingEl.textContent = headingText;
                headingEl.setAttribute('data-variant-heading', 'true');
                headingEl.style.cssText = '';
                headingEl.removeAttribute('style');
                // Ensure classes are present
                if (!headingEl.classList.contains('custom-image-feature__block-heading')) {
                  headingEl.classList.add('custom-image-feature__block-heading');
                }
                if (!headingEl.classList.contains('pdp-text-color')) {
                  headingEl.classList.add('pdp-text-color');
                }
                // Re-apply current PDP text color (we cleared style above, so pdp-text-color would show accent otherwise)
                if (headingEl.classList.contains('pdp-text-color')) {
                  const activeTab = document.querySelector('.mattress-type-tabs .tab.active');
                  const tabColor = activeTab && activeTab.getAttribute('data-tab-color');
                  if (tabColor && tabColor.trim() !== '' && tabColor !== 'null') {
                    headingEl.style.color = tabColor.trim();
                    headingEl.style.setProperty('--pdp-text-color', tabColor.trim());
                  }
                }
              } else {
                // Hide heading if empty
                const headingEl = blockInner.querySelector('.custom-image-feature__block-heading');
                if (headingEl) {
                  if (headingEl.hasAttribute('data-variant-heading')) {
                    headingEl.style.cssText = 'display: none !important;';
                  }
                }
              }
              
              // Update or create description
              if (descText) {
                let descEl = blockInner.querySelector('.custom-image-feature__block-content');
                if (!descEl) {
                  descEl = document.createElement('div');
                  descEl.className = 'custom-image-feature__block-content';
                  blockInner.appendChild(descEl);
                }
                descEl.innerHTML = descText;
                descEl.setAttribute('data-variant-content', 'true');
                descEl.style.cssText = '';
                descEl.removeAttribute('style');
              } else {
                // Hide description if empty
                const descEl = blockInner.querySelector('.custom-image-feature__block-content');
                if (descEl) {
                  if (descEl.hasAttribute('data-variant-content')) {
                    descEl.style.cssText = 'display: none !important;';
                  }
                }
              }
            }
          }
        } else {
          // No variant data or invalid data - show customizer blocks
          const existingBlocks = blocksContainer.querySelectorAll('.custom-image-feature__block');
          existingBlocks.forEach(block => {
            block.style.cssText = '';
            block.removeAttribute('style');
          });
          
          // Hide any variant-created blocks
          const variantBlocks = blocksContainer.querySelectorAll('.custom-image-feature__block[data-variant-block]');
          variantBlocks.forEach(block => {
            block.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
          });
        }
      }
      
    } catch (e) {
      // Silent error - fallback to customizer data
    }
  }

  // Function to update variant technical specifications section
  function updateVariantTechnicalSpecs(variantId) {
    if (!variantId) return;
    
    // Check if section exists on page (use class - section has .custom-text-feature__features)
    const featuresContainer = document.querySelector('.custom-text-feature__features');
    if (!featuresContainer) {
      return;
    }
    const titleElements = featuresContainer.querySelectorAll('.custom-text-feature__feature-label');
    const featureElements = featuresContainer.querySelectorAll('.custom-text-feature__feature-value');
    
    if (titleElements.length === 0 && featureElements.length === 0) {
      return;
    }
    
    try {
      // Get variant metafield data from map (loaded from Liquid template)
      const variantIdStr = variantId.toString();
      let variantSpecsData = variantTechnicalSpecsMap.get(variantIdStr);
      
      // Try alternative variant ID formats
      if (!variantSpecsData) {
        const variantIdNum = parseInt(variantIdStr);
        if (!isNaN(variantIdNum)) {
          variantSpecsData = variantTechnicalSpecsMap.get(variantIdNum.toString()) || 
                            variantTechnicalSpecsMap.get(String(variantIdNum));
        }
      }
      
      // If not found in map, try to get from current variant object
      if (!variantSpecsData && currentMattressProduct && currentMattressProduct.variants) {
        const variant = currentMattressProduct.variants.find(v => 
          v.id.toString() === variantIdStr || 
          v.id === parseInt(variantIdStr) ||
          String(v.id) === variantIdStr
        );
        if (variant && variant.metafields && variant.metafields.custom && variant.metafields.custom.technical_specifications_variants) {
          variantSpecsData = variant.metafields.custom.technical_specifications_variants;
          // Handle metaobject - get value if it exists
          if (variantSpecsData && typeof variantSpecsData === 'object' && variantSpecsData.value) {
            variantSpecsData = variantSpecsData.value;
          }
        }
      }
      
      // Validate variant data - check if it has actual content (support titles/headings)
      let hasVariantData = false;
      if (variantSpecsData) {
        let titlesData = variantSpecsData.titles || variantSpecsData.headings;
        if (titlesData && typeof titlesData === 'object' && titlesData.value) {
          titlesData = titlesData.value;
        }
        const hasTitles = titlesData && 
                         titlesData !== null && 
                         titlesData !== 'null' &&
                         (Array.isArray(titlesData) ? titlesData.length > 0 : String(titlesData).trim() !== '');
        
        let featuresData = variantSpecsData.features || variantSpecsData.feature;
        if (featuresData && typeof featuresData === 'object' && featuresData.value) {
          featuresData = featuresData.value;
        }
        const hasFeatures = featuresData && 
                           featuresData !== null && 
                           featuresData !== 'null' &&
                           (Array.isArray(featuresData) ? featuresData.length > 0 : String(featuresData).trim() !== '');
        
        hasVariantData = hasTitles || hasFeatures;
      }
      
      // If no valid variant data, set to null to use customizer data
      if (!hasVariantData) {
        variantSpecsData = null;
      }
      
      // Get all existing feature items (featuresContainer already set above)
      const existingItems = featuresContainer.querySelectorAll('.custom-text-feature__feature-item');
      
      // Store original customizer data if not already stored (store per item)
      existingItems.forEach((item, idx) => {
        const titleEl = item.querySelector('.custom-text-feature__feature-label');
        const featureEl = item.querySelector('.custom-text-feature__feature-value');
        
        if (titleEl && !titleEl.hasAttribute('data-customizer-title') && titleEl.textContent && titleEl.textContent.trim() !== '') {
          titleEl.setAttribute('data-customizer-title', titleEl.textContent);
        }
        if (featureEl && !featureEl.hasAttribute('data-customizer-feature') && featureEl.textContent && featureEl.textContent.trim() !== '') {
          featureEl.setAttribute('data-customizer-feature', featureEl.textContent);
        }
      });
      
      if (variantSpecsData) {
        // Get titles and features arrays (support titles/headings and features/feature)
        let titlesData = variantSpecsData.titles || variantSpecsData.headings;
        let featuresData = variantSpecsData.features || variantSpecsData.feature;
        
        // Handle metaobject values
        if (titlesData && typeof titlesData === 'object' && titlesData.value) {
          titlesData = titlesData.value;
        }
        if (featuresData && typeof featuresData === 'object' && featuresData.value) {
          featuresData = featuresData.value;
        }
        
        // Convert to arrays – one entry per row (title 1, feature 1 | title 2, feature 2 | ...)
        let titlesArray = [];
        let featuresArray = [];
        
        if (Array.isArray(titlesData)) {
          titlesArray = titlesData.map(t => t == null || t === 'null' || t === undefined ? '' : String(t).trim());
        } else if (titlesData && typeof titlesData === 'string' && titlesData !== 'null') {
          titlesArray = [titlesData.trim()];
        }
        
        if (Array.isArray(featuresData)) {
          featuresArray = featuresData.map(f => f == null || f === 'null' || f === undefined ? '' : String(f).trim());
        } else if (featuresData && typeof featuresData === 'string' && featuresData !== 'null') {
          featuresArray = [featuresData.trim()];
        }
        
        // When ALL titles/features came as one comma-separated string, split into one per row
        if (titlesArray.length === 1 && titlesArray[0] && titlesArray[0].indexOf(',') !== -1) {
          titlesArray = titlesArray[0].split(',').map(s => s.trim()).filter(Boolean);
        }
        if (featuresArray.length === 1 && featuresArray[0] && featuresArray[0].indexOf(',') !== -1) {
          featuresArray = featuresArray[0].split(',').map(s => s.trim()).filter(Boolean);
        }
        
        const maxLength = Math.max(titlesArray.length, featuresArray.length);
        while (titlesArray.length < maxLength) titlesArray.push('');
        while (featuresArray.length < maxLength) featuresArray.push('');
        
        // Update or show existing rows; hide only extra rows. Don't hide all first – keeps same design.
        if (maxLength > 0) {
          for (let i = 0; i < maxLength; i++) {
            // Keep comma-separated values as-is (e.g. "Value A, Value B")
            const titleText = titlesArray[i] != null ? String(titlesArray[i]) : '';
            const featureText = featuresArray[i] != null ? String(featuresArray[i]) : '';
            
            // Get or create feature item – same structure as Liquid
            let itemElement = existingItems[i];
            if (!itemElement) {
              itemElement = document.createElement('div');
              itemElement.className = 'custom-text-feature__feature-item' + (i < maxLength - 1 ? ' custom-text-feature__feature-item--with-divider' : '');
              itemElement.setAttribute('data-variant-item', 'true');
              const itemContent = document.createElement('div');
              itemContent.className = 'custom-text-feature__feature-content';
              const labelSpan = document.createElement('span');
              labelSpan.className = 'custom-text-feature__feature-label';
              const valueSpan = document.createElement('span');
              valueSpan.className = 'custom-text-feature__feature-value';
              itemContent.appendChild(labelSpan);
              itemContent.appendChild(valueSpan);
              itemElement.appendChild(itemContent);
              featuresContainer.appendChild(itemElement);
            }
            
            itemElement.removeAttribute('style');
            if (i < maxLength - 1) {
              itemElement.classList.add('custom-text-feature__feature-item--with-divider');
            } else {
              itemElement.classList.remove('custom-text-feature__feature-item--with-divider');
            }
            
            const itemContent = itemElement.querySelector('.custom-text-feature__feature-content');
            const titleEl = itemContent ? itemContent.querySelector('.custom-text-feature__feature-label') : null;
            const featureEl = itemContent ? itemContent.querySelector('.custom-text-feature__feature-value') : null;
            if (titleEl) {
              titleEl.removeAttribute('style');
              titleEl.textContent = titleText;
              titleEl.setAttribute('data-variant-title', 'true');
              titleEl.style.display = titleText ? '' : 'none';
            }
            if (featureEl) {
              featureEl.removeAttribute('style');
              featureEl.textContent = featureText;
              featureEl.setAttribute('data-variant-feature', 'true');
              featureEl.style.display = featureText ? '' : 'none';
            }
          }
          // Hide extra rows (index >= maxLength)
          for (let i = maxLength; i < existingItems.length; i++) {
            existingItems[i].style.display = 'none';
          }
        }
      } else {
        // No variant data or invalid data - show customizer data
        existingItems.forEach((item, idx) => {
          item.removeAttribute('style');
          item.style.display = '';
          const titleEl = item.querySelector('.custom-text-feature__feature-label');
          if (titleEl && titleEl.hasAttribute('data-customizer-title')) {
            titleEl.textContent = titleEl.getAttribute('data-customizer-title');
            titleEl.removeAttribute('data-variant-title');
            titleEl.removeAttribute('style');
            titleEl.style.display = '';
          }
          const featureEl = item.querySelector('.custom-text-feature__feature-value');
          if (featureEl && featureEl.hasAttribute('data-customizer-feature')) {
            featureEl.textContent = featureEl.getAttribute('data-customizer-feature');
            featureEl.removeAttribute('data-variant-feature');
            featureEl.removeAttribute('style');
            featureEl.style.display = '';
          }
        });
        
        // Hide any variant-created items
        const variantItems = featuresContainer.querySelectorAll('.custom-text-feature__feature-item[data-variant-item]');
        variantItems.forEach(item => {
          item.style.cssText = 'display: none !important; visibility: hidden !important; height: 0 !important; overflow: hidden !important; margin: 0 !important; padding: 0 !important;';
        });
      }
      
    } catch (e) {
      // Silent error - fallback to customizer data
      console.error('Error updating variant technical specs:', e);
    }
  }

  // Function to update variant performance blocks section (custom.variant_performance_data)
  function updateVariantPerformanceBlocks(variantId) {
    if (!variantId) return;
    function perfDisplayStr(v) {
      if (v == null || v === undefined) return '';
      if (typeof v === 'object' && v !== null && 'value' in v) return perfDisplayStr(v.value);
      return String(v);
    }
    function perfDisplayNum(v) {
      if (v == null || v === undefined) return 0;
      if (typeof v === 'object' && v !== null) {
        if ('value' in v) return perfDisplayNum(v.value);
        if (Array.isArray(v) && v.length > 0) return perfDisplayNum(v[0]);
      }
      const s = String(v).trim();
      if (s === '') return 0;
      const n = Number(s);
      return isNaN(n) ? 0 : Math.min(100, Math.max(0, n));
    }
    function applyProgressWidth(el, widthVal) {
      if (!el || !widthVal) return;
      el.setAttribute('data-customizer-progress', widthVal);
      el.style.animation = 'none';
      el.style.setProperty('--progress-width', widthVal, 'important');
      el.style.setProperty('width', widthVal, 'important');
    }
    function getProgressFromItem(item) {
      if (!item) return 0;
      var raw = item.performance_progress !== undefined && item.performance_progress !== null ? item.performance_progress : (item.progress !== undefined && item.progress !== null ? item.progress : (item.progress_value !== undefined && item.progress_value !== null ? item.progress_value : item.performance_progress_value));
      return perfDisplayNum(raw);
    }
    const variantIdStr = variantId.toString();
    let variantData = variantPerformanceDataMap.get(variantIdStr);
    if (!variantData) {
      const variantIdNum = parseInt(variantIdStr, 10);
      if (!isNaN(variantIdNum)) {
        variantData = variantPerformanceDataMap.get(variantIdNum.toString()) || variantPerformanceDataMap.get(String(variantIdNum));
      }
    }
    // Fallback: parse from tab that matches CURRENT product (so SlumberCool Max variant data comes from SlumberCool Max tab)
    if (!variantData) {
      let tabToRead = null;
      if (currentMattressProduct && currentMattressProduct.handle) {
        tabToRead = document.querySelector('.mattress-type-tabs .tab[data-product-handle="' + currentMattressProduct.handle + '"]') || document.querySelector('.mattress-type-tabs .tab[data-tab="' + currentMattressProduct.handle + '"]');
      }
      if (!tabToRead) {
        tabToRead = document.querySelector('.mattress-type-tabs .tab.active') || document.querySelector('.mattress-type-tabs .tab');
      }
      if (tabToRead) {
        const attr = tabToRead.getAttribute('data-variant-performance-data');
        if (attr && attr.trim() !== '') {
          const entries = attr.split('||').filter(function(v) { return v && v.trim() !== ''; });
          for (let e = 0; e < entries.length; e++) {
            const parts = entries[e].split(':');
            if (parts.length < 2) continue;
            const vid = parts[0].trim();
            if (vid !== variantIdStr && (isNaN(parseInt(vid, 10)) || parseInt(vid, 10) !== parseInt(variantIdStr, 10))) continue;
            const metafieldJson = parts.slice(1).join(':').trim();
            if (!metafieldJson || metafieldJson === 'null' || metafieldJson === 'undefined' || metafieldJson === '[]') continue;
            try {
              const decodedJson = metafieldJson.replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
              const parsedData = JSON.parse(decodedJson);
              let normalized = [];
              if (Array.isArray(parsedData)) {
                normalized = parsedData.map(function(item) {
                  return {
                    performance_heading: perfDisplayStr(item && item.performance_heading),
                    performance_heading_value: perfDisplayStr(item && item.performance_heading_value),
                    performance_progress: perfDisplayNum(item && item.performance_progress),
                    performance_text: perfDisplayStr(item && item.performance_text)
                  };
                });
              } else if (parsedData && typeof parsedData === 'object') {
                var prog = parsedData.performance_progress !== undefined && parsedData.performance_progress !== null ? parsedData.performance_progress : (parsedData.progress !== undefined && parsedData.progress !== null ? parsedData.progress : parsedData.progress_value);
                normalized = [{
                  performance_heading: perfDisplayStr(parsedData.performance_heading),
                  performance_heading_value: perfDisplayStr(parsedData.performance_heading_value),
                  performance_progress: prog,
                  performance_text: perfDisplayStr(parsedData.performance_text)
                }];
              }
              if (normalized.length > 0) {
                const hasCommaInAny = normalized.some(function(it) {
                  const h = (it.performance_heading || '').toString();
                  const hv = (it.performance_heading_value || '').toString();
                  const t = (it.performance_text || '').toString();
                  const pStr = (it.performance_progress != null ? it.performance_progress : '').toString();
                  return h.indexOf(',') !== -1 || hv.indexOf(',') !== -1 || t.indexOf(',') !== -1 || pStr.indexOf(',') !== -1;
                });
                if (hasCommaInAny) {
                  const expanded = [];
                  for (let i = 0; i < normalized.length; i++) {
                    const item = normalized[i];
                    const h = (item.performance_heading || '').toString();
                    const hv = (item.performance_heading_value || '').toString();
                    const t = (item.performance_text || '').toString();
                    const headings = h.split(',').map(function(s) { return s.trim(); });
                    const values = hv.split(',').map(function(s) { return s.trim(); });
                    const texts = t.split(',').map(function(s) { return s.trim(); });
                    let progressArr = [];
                    const pStr = (item.performance_progress != null ? item.performance_progress : '').toString();
                    if (pStr.indexOf(',') !== -1) {
                      progressArr = pStr.split(',').map(function(s) { return perfDisplayNum(s.trim()); });
                    } else {
                      const singleProgress = perfDisplayNum(item.performance_progress);
                      const n = Math.max(headings.length, values.length, texts.length, 1);
                      progressArr = Array(n).fill(singleProgress);
                    }
                    const n = Math.max(headings.length, values.length, progressArr.length, texts.length, 1);
                    for (let j = 0; j < n; j++) {
                      expanded.push({
                        performance_heading: headings[j] || '',
                        performance_heading_value: values[j] || '',
                        performance_progress: progressArr[j] !== undefined ? progressArr[j] : 0,
                        performance_text: texts[j] || ''
                      });
                    }
                  }
                  normalized = expanded;
                }
              }
              if (normalized.length > 0) {
                variantPerformanceDataMap.set(variantIdStr, normalized);
                const numId = parseInt(variantIdStr, 10);
                if (!isNaN(numId)) {
                  variantPerformanceDataMap.set(numId.toString(), normalized);
                  variantPerformanceDataMap.set(String(numId), normalized);
                }
                variantData = normalized;
                break;
              }
            } catch (err) { /* silent */ }
          }
        }
      }
    }
    const performanceSections = document.querySelectorAll('.performance-blocks');
    if (!performanceSections || performanceSections.length === 0) return;
    performanceSections.forEach((section) => {
      const grid = section.querySelector('.performance-blocks__grid');
      if (!grid) return;
      const blocks = grid.querySelectorAll('.performance-blocks__block');
      const maxBlocks = Math.max(blocks.length, variantData && variantData.length ? variantData.length : 0);
      for (let i = 0; i < maxBlocks; i++) {
        const item = variantData && variantData[i] ? variantData[i] : null;
        let blockEl = blocks[i];
        if (!blockEl && grid) {
          blockEl = document.createElement('div');
          blockEl.className = 'performance-blocks__block';
          blockEl.setAttribute('data-variant-performance-block', 'true');
          const sectionId = section.getAttribute('data-section-id') || section.id || ('sec_' + i);
          const blockId = 'variant_' + sectionId + '_' + i;
          const inner = document.createElement('div');
          inner.className = 'performance-blocks__block-inner';
          const firstBlock = section.querySelector('.performance-blocks__block');
          const firstInner = firstBlock ? firstBlock.querySelector('.performance-blocks__block-inner') : null;
          if (firstInner) {
            inner.setAttribute('style', firstInner.getAttribute('style') || '');
          }
          const content = document.createElement('div');
          content.className = 'performance-blocks__block-content';
          const headingWrapper = document.createElement('div');
          headingWrapper.className = 'performance-blocks__block-heading-wrapper';
          const headingP = document.createElement('p');
          headingP.className = 'performance-blocks__block-heading pdp-text-color';
          headingP.id = 'performance_heading_' + blockId;
          const headingSpan = document.createElement('span');
          headingSpan.className = 'performance-blocks__block-heading-text pdp-text-color';
          headingSpan.id = 'performance_heading_value_' + blockId;
          headingWrapper.appendChild(headingP);
          headingWrapper.appendChild(headingSpan);
          content.appendChild(headingWrapper);
          const progressContainer = document.createElement('div');
          progressContainer.className = 'performance-blocks__progress-container';
          const progressBar = document.createElement('div');
          progressBar.className = 'performance-blocks__progress-bar';
          const progressFill = document.createElement('div');
          progressFill.className = 'performance-blocks__progress-fill pdp-color-enabled';
          progressFill.id = 'performance_progress_' + blockId;
          progressFill.setAttribute('data-section', 'pdp-color-change');
          const firstFill = firstBlock ? firstBlock.querySelector('.performance-blocks__progress-fill') : null;
          if (firstFill && firstFill.style.background) progressFill.style.background = firstFill.style.background;
          var progressPct = getProgressFromItem(item);
          var pctVal = progressPct > 0 ? (progressPct + '%') : (firstFill && firstFill.getAttribute('data-customizer-progress')) ? firstFill.getAttribute('data-customizer-progress') : '0%';
          progressFill.setAttribute('data-customizer-progress', pctVal);
          applyProgressWidth(progressFill, pctVal);
          progressBar.appendChild(progressFill);
          progressContainer.appendChild(progressBar);
          content.appendChild(progressContainer);
          const textDiv = document.createElement('div');
          textDiv.className = 'performance-blocks__block-text';
          textDiv.id = 'performance_text_' + blockId;
          content.appendChild(textDiv);
          inner.appendChild(content);
          blockEl.appendChild(inner);
          grid.appendChild(blockEl);
        }
        if (!blockEl) continue;
        const headingEl = blockEl.querySelector('.performance-blocks__block-heading');
        const headingValueEl = blockEl.querySelector('.performance-blocks__block-heading-text');
        const progressFillEl = blockEl.querySelector('.performance-blocks__progress-fill');
        const progressContainerEl = blockEl.querySelector('.performance-blocks__progress-container');
        const textEl = blockEl.querySelector('.performance-blocks__block-text');
        if (item) {
          if (headingEl) {
            if (!headingEl.hasAttribute('data-customizer-heading') && headingEl.textContent && headingEl.textContent.trim() !== '') {
              headingEl.setAttribute('data-customizer-heading', headingEl.textContent);
            }
            const val = perfDisplayStr(item.performance_heading);
            headingEl.textContent = val;
            headingEl.style.display = val ? '' : 'none';
          }
          if (headingValueEl) {
            if (!headingValueEl.hasAttribute('data-customizer-heading-value') && headingValueEl.textContent && headingValueEl.textContent.trim() !== '') {
              headingValueEl.setAttribute('data-customizer-heading-value', headingValueEl.textContent);
            }
            const val = perfDisplayStr(item.performance_heading_value);
            headingValueEl.textContent = val;
            headingValueEl.style.display = val ? '' : 'none';
          }
          const progressVal = getProgressFromItem(item);
          if (progressFillEl) {
            if (!progressFillEl.hasAttribute('data-customizer-progress')) {
              const w = progressFillEl.style.width || '';
              if (w) progressFillEl.setAttribute('data-customizer-progress', w);
            }
            var widthVal = progressVal > 0 ? (progressVal + '%') : (progressFillEl.getAttribute('data-customizer-progress') || progressFillEl.style.width || '0%');
            applyProgressWidth(progressFillEl, widthVal);
          }
          if (progressContainerEl) {
            progressContainerEl.style.display = '';
          }
          if (textEl) {
            if (!textEl.hasAttribute('data-customizer-text') && textEl.innerHTML && textEl.innerHTML.trim() !== '') {
              textEl.setAttribute('data-customizer-text', textEl.innerHTML);
            }
            const val = perfDisplayStr(item.performance_text);
            textEl.innerHTML = val;
            textEl.style.display = val ? '' : 'none';
          }
          blockEl.removeAttribute('style');
          blockEl.style.display = '';
        } else {
          if (blockEl.hasAttribute('data-variant-performance-block')) {
            blockEl.style.display = 'none';
          } else {
            if (headingEl && !headingEl.hasAttribute('data-customizer-heading') && headingEl.textContent && headingEl.textContent.trim() !== '') {
              headingEl.setAttribute('data-customizer-heading', headingEl.textContent);
            }
            if (headingValueEl && !headingValueEl.hasAttribute('data-customizer-heading-value') && headingValueEl.textContent && headingValueEl.textContent.trim() !== '') {
              headingValueEl.setAttribute('data-customizer-heading-value', headingValueEl.textContent);
            }
            if (progressFillEl && !progressFillEl.hasAttribute('data-customizer-progress') && progressFillEl.style.width) {
              progressFillEl.setAttribute('data-customizer-progress', progressFillEl.style.width);
            }
            if (textEl && !textEl.hasAttribute('data-customizer-text') && textEl.innerHTML && textEl.innerHTML.trim() !== '') {
              textEl.setAttribute('data-customizer-text', textEl.innerHTML);
            }
            if (headingEl && headingEl.hasAttribute('data-customizer-heading')) {
              headingEl.textContent = headingEl.getAttribute('data-customizer-heading');
              headingEl.removeAttribute('style');
            }
            if (headingValueEl && headingValueEl.hasAttribute('data-customizer-heading-value')) {
              headingValueEl.textContent = headingValueEl.getAttribute('data-customizer-heading-value');
              headingValueEl.removeAttribute('style');
            }
            if (progressFillEl && progressFillEl.hasAttribute('data-customizer-progress')) {
              const w = progressFillEl.getAttribute('data-customizer-progress');
              applyProgressWidth(progressFillEl, w);
            }
            if (progressContainerEl) progressContainerEl.style.display = '';
            if (textEl && textEl.hasAttribute('data-customizer-text')) {
              textEl.innerHTML = textEl.getAttribute('data-customizer-text');
              textEl.removeAttribute('style');
            }
            blockEl.removeAttribute('style');
            blockEl.style.display = '';
          }
        }
      }
      for (let i = maxBlocks; i < blocks.length; i++) {
        const blockEl = blocks[i];
        if (blockEl && blockEl.hasAttribute('data-variant-performance-block')) {
          blockEl.style.display = 'none';
        } else {
          const headingEl = blockEl.querySelector('.performance-blocks__block-heading');
          const headingValueEl = blockEl.querySelector('.performance-blocks__block-heading-text');
          const progressFillEl = blockEl.querySelector('.performance-blocks__progress-fill');
          const progressContainerEl = blockEl.querySelector('.performance-blocks__progress-container');
          const textEl = blockEl.querySelector('.performance-blocks__block-text');
          if (headingEl && headingEl.hasAttribute('data-customizer-heading')) {
            headingEl.textContent = headingEl.getAttribute('data-customizer-heading');
            headingEl.removeAttribute('style');
          }
          if (headingValueEl && headingValueEl.hasAttribute('data-customizer-heading-value')) {
            headingValueEl.textContent = headingValueEl.getAttribute('data-customizer-heading-value');
            headingValueEl.removeAttribute('style');
          }
            if (progressFillEl && progressFillEl.hasAttribute('data-customizer-progress')) {
              const w = progressFillEl.getAttribute('data-customizer-progress');
              applyProgressWidth(progressFillEl, w);
            }
            if (progressContainerEl) progressContainerEl.style.display = '';
            if (textEl && textEl.hasAttribute('data-customizer-text')) {
              textEl.innerHTML = textEl.getAttribute('data-customizer-text');
              textEl.removeAttribute('style');
            }
            blockEl.removeAttribute('style');
            blockEl.style.display = '';
        }
      }
      document.querySelectorAll('.performance-blocks__progress-fill[data-customizer-progress]').forEach(function(el) {
        applyProgressWidth(el, el.getAttribute('data-customizer-progress'));
      });
    });
  }

  // First load: show default selected variant's performance blocks (from active tab's first variant)
  setTimeout(function() {
    const activeTab = document.querySelector('.mattress-type-tabs .tab.active') || document.querySelector('.mattress-type-tabs .tab');
    if (!activeTab) return;
    try {
      const variantsStr = activeTab.getAttribute('data-product-variants');
      if (variantsStr) {
        const decoded = variantsStr.replace(/&quot;/g, '"').replace(/&#39;/g, "'");
        const variants = JSON.parse(decoded);
        if (variants && variants.length > 0) {
          updateVariantPerformanceBlocks(variants[0].id);
        }
      }
    } catch (e) {}
  }, 0);

  // Function to update product for selected variant
  function updateProductForSelectedVariant() {
    const sizeSelect = document.getElementById('size-select');
    if (!sizeSelect) return;
    
    const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];
    if (!selectedOption) return;
    
    const variantId = selectedOption.value;
    if (currentMattressProduct && currentMattressProduct.variants) {
      const foundVariant = currentMattressProduct.variants.find(v => v.id.toString() === variantId);
      if (foundVariant) {
        currentSizeVariant = foundVariant;
      }
    }

    bindProductVariantDiscounts(currentMattressProduct);
    syncPdpDisplayDiscountMeta(currentMattressProduct);
    
    // Update variant info (short and long text)
    updateVariantInfo(variantId);
    
    // Update variant image and features section
    updateVariantImageAndFeatures(variantId);
    
    // Update variant technical specifications section
    updateVariantTechnicalSpecs(variantId);
    
    // Update variant performance blocks section
    updateVariantPerformanceBlocks(variantId);
    
    // Sync foundation options to current mattress size (foundation size hidden, linked to mattress size)
    syncFoundationOptionsWithMattressSize();

    const underbedInputOnSizeChange = getSelectedUnderbedInput();
    if (underbedInputOnSizeChange && !isUnderbedNoFoundationInput(underbedInputOnSizeChange)) {
      syncCurrentFoundationFromUnderbedInput(underbedInputOnSizeChange);
    }
    
    // Update variant name display
    updateVariantNameDisplay();
    
    // Update total price (includes foundation if selected)
    updateTotalPrice();

    // Keep comfort card labels in sync with the selected size price
    updateFirmnessLabelPrices();
  }

  // Add to Cart functionality
  const addToCartBtn = document.getElementById("add-to-cart");
  if (addToCartBtn) {
    addToCartBtn.addEventListener("click", async function () {
      await handleAddToCart(false, false);
    });
  }

  // Buy Now functionality
  const buyNowBtn = document.getElementById("buy-now");
  if (buyNowBtn) {
    buyNowBtn.addEventListener("click", async function () {
      await handleAddToCart(true, false);
    });
  }

  window.stickyATCCustomAddToCart = async function() {
    const stickyBtn = document.querySelector('#md-sticky-atc [name="add"]');
    const stickySpinner = stickyBtn ? stickyBtn.querySelector('.loading__spinner') : null;
    try {
      if (stickyBtn) {
        stickyBtn.disabled = true;
        if (stickySpinner) stickySpinner.classList.remove('hidden');
      }
      await handleAddToCart(false, false);
    } finally {
      if (stickyBtn) {
        stickyBtn.disabled = false;
        if (stickySpinner) stickySpinner.classList.add('hidden');
      }
    }
  };

  // Upsell popups (adjustable + breeze): same confirm/continue behavior, different DOM namespace
  function wireFoundationUpsellPopup(namespace) {
    const overlay = upsellPopupGetEl(namespace, 'overlay');
    const upsellConfirm = upsellPopupGetEl(namespace, 'confirm');
    const upsellContinue = upsellPopupGetEl(namespace, 'continue');
    const upsellClose = upsellPopupGetEl(namespace, 'close');
    if (!overlay) return;
    async function upsellContinueAction() {
      const target = activeUpsellOverlay || overlay;
      const noUpgradeVariantId = target.dataset.noUpgradeVariantId ? target.dataset.noUpgradeVariantId : null;
      const noUpgradeVariantTitle = target.dataset.noUpgradeVariantTitle ? target.dataset.noUpgradeVariantTitle : '';
      target.style.display = 'none';
      target.setAttribute('aria-hidden', 'true');
      activeUpsellOverlay = null;
      await handleAddToCart(pendingUpsellBuyNow, true, null, null, noUpgradeVariantId || null, noUpgradeVariantTitle || '');
    }
    if (upsellConfirm) {
      upsellConfirm.addEventListener('click', async function () {
        const target = activeUpsellOverlay || overlay;
        target.style.display = 'none';
        target.setAttribute('aria-hidden', 'true');
        activeUpsellOverlay = null;
        const buyNow = !!pendingUpsellBuyNow;
        const upgradeVid = target.dataset.upgradeVariantId || null;
        const upgradeTitle = target.dataset.upgradeVariantTitle || '';
        await handleAddToCart(buyNow, true, upgradeVid, upgradeTitle);
      });
    }
    if (upsellContinue) {
      upsellContinue.addEventListener('click', async function () {
        await upsellContinueAction();
      });
    }
    if (upsellClose) {
      upsellClose.addEventListener('click', function () {
        const target = activeUpsellOverlay || overlay;
        target.style.display = 'none';
        target.setAttribute('aria-hidden', 'true');
        activeUpsellOverlay = null;
        pendingUpsellBuyNow = false;
      });
    }
  }
  wireFoundationUpsellPopup('upsell-popup');
  wireFoundationUpsellPopup('breeze-upsell-popup');

  function getAccessoryBundleUpsellConfig() {
    const el = document.getElementById('accessory-bundle-upsell-popup-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function normalizeAccessoryStoragePart(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 96);
  }

  /** Session key so changing mattress / foundation / size / bundle product resets memory. */
  function getAccessoryBundleStorageKey(abCfg) {
    if (typeof sessionStorage === 'undefined') return null;
    if (!abCfg || !abCfg.upgradeProductHandle) return null;
    const ph = currentMattressProduct && currentMattressProduct.handle ? String(currentMattressProduct.handle) : '';
    if (!ph) return null;
    const foundationInput = getFoundationInputForUpsell();
    const ft = (getEffectiveFoundationTypeForUpsell(foundationInput) || selectedFoundationType || '').trim();
    const sz = getCurrentMattressSizeValue().trim();
    const uh = String(abCfg.upgradeProductHandle || '').trim();
    return (
      'scAbb:' +
      normalizeAccessoryStoragePart(ph) +
      ':' +
      normalizeAccessoryStoragePart(ft) +
      ':' +
      normalizeAccessoryStoragePart(sz) +
      ':' +
      normalizeAccessoryStoragePart(uh)
    );
  }

  function readStoredAccessoryBundleChoice(key) {
    if (!key || typeof sessionStorage === 'undefined') return null;
    try {
      const raw = sessionStorage.getItem(key);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function writeStoredAccessoryBundleChoice(key, obj) {
    if (!key || typeof sessionStorage === 'undefined') return;
    try {
      sessionStorage.setItem(key, JSON.stringify(obj));
    } catch (e) {}
  }

  /** Forget accessory-bundle popup choices when the cart has no items (new purchase flow). */
  async function clearAccessoryBundleSessionStorageIfCartEmpty() {
    if (typeof sessionStorage === 'undefined') return;
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();
      const count =
        cart && (cart.item_count != null ? Number(cart.item_count) : cart.items && cart.items.length ? cart.items.length : 0);
      if (count > 0) return;
      const keys = [];
      for (let i = 0; i < sessionStorage.length; i++) {
        const k = sessionStorage.key(i);
        if (k && (k.indexOf('scAbb:') === 0 || k.indexOf('scAbbCartDecline:') === 0)) keys.push(k);
      }
      keys.forEach(function (k) {
        try {
          sessionStorage.removeItem(k);
        } catch (e) {}
      });
    } catch (e) {}
  }

  function accessoryBundleFoundationMatches(config, foundationType) {
    if (!config || config.foundationTriggerLines == null) return false;
    const lines = String(config.foundationTriggerLines)
      .split(/\r?\n/)
      .map(function (s) {
        return s.trim();
      })
      .filter(Boolean);
    if (!lines.length) return false;
    const ft = (foundationType || '').toString().trim();
    if (!ft) {
      return lines.some(function (line) {
        return foundationTriggerMatches({ foundationTrigger: line }, 'no foundation');
      });
    }
    return lines.some(function (line) {
      return foundationTriggerMatches({ foundationTrigger: line }, ft);
    });
  }

  function resolveAccessoryVariantIdForItem(accessoryItem) {
    const defaultVariantId = accessoryItem.getAttribute('data-accessory-variant-id');
    const variantsJson = accessoryItem.getAttribute('data-accessory-variants');
    const currentSizeValue = getCurrentMattressSizeValue();
    if (!variantsJson || !currentSizeValue || currentSizeValue === '') {
      return defaultVariantId;
    }
    try {
      const variants = JSON.parse(variantsJson);
      const found = variants.find(function (v) {
        const o1 = (v.o1 || '').toString().trim();
        const o2 = (v.o2 || '').toString().trim();
        const o3 = (v.o3 || '').toString().trim();
        return bedSizeLabelsEqual(o1, currentSizeValue) || bedSizeLabelsEqual(o2, currentSizeValue) || bedSizeLabelsEqual(o3, currentSizeValue);
      });
      return found ? String(found.id) : defaultVariantId;
    } catch (e) {
      return defaultVariantId;
    }
  }

  /**
   * Accessory bundle upgrade popup (after foundation upsell when applicable).
   * @returns {Promise<boolean>}
   */
  async function showAccessoryBundleUpsellPopup() {
    const configEl = document.getElementById('accessory-bundle-upsell-popup-config');
    const overlay = document.getElementById('accessory-bundle-upsell-popup-overlay');
    if (!configEl || !overlay) return false;
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return false;
    }
    const upgradeHandle = config.upgradeProductHandle;
    if (!upgradeHandle) return false;
    const currentSizeValue = getCurrentMattressSizeValue();
    const accessoryItems = document.querySelectorAll('.accessory-item[data-accessory-product]');
    if (!accessoryItems.length) return false;

    try {
      let includedCents = 0;
      for (let i = 0; i < accessoryItems.length; i++) {
        const item = accessoryItems[i];
        const handle = item.getAttribute('data-accessory-product');
        const vid = resolveAccessoryVariantIdForItem(item);
        if (!handle || !vid) continue;
        try {
          const res = await fetch(suavePdpProductJsonUrl(handle));
          if (!res.ok) continue;
          const prod = await res.json();
          const v = prod.variants && prod.variants.find(function (x) {
            return String(x.id) === String(vid);
          });
          if (v && v.price != null) includedCents += parseInt(v.price, 10) || 0;
        } catch (e) {}
      }

      const upRes = await fetch(suavePdpProductJsonUrl(upgradeHandle));
      if (!upRes.ok) return false;
      const upgradeProduct = await upRes.json();
      const upgradeVariant = getVariantBySize(upgradeProduct, currentSizeValue) || (upgradeProduct.variants && upgradeProduct.variants[0]);
      if (!upgradeVariant) return false;
      const upgradeCents = parseInt(upgradeVariant.price, 10) || 0;
      const diffCents = Math.max(0, upgradeCents - includedCents);
      const priceFormatted = formatMoneyFromCents(diffCents);

      const curLabEl = document.getElementById('abb-pro-current-label');
      if (curLabEl && config.comparisonCurrentLabel) curLabEl.textContent = config.comparisonCurrentLabel;
      const upLabEl = document.getElementById('abb-pro-upgrade-label');
      if (upLabEl && config.comparisonUpgradeLabel) upLabEl.textContent = config.comparisonUpgradeLabel;
      const curTagEl = document.getElementById('abb-pro-current-tagline');
      if (curTagEl) {
        if (config.currentCardTagline && String(config.currentCardTagline).trim() !== '') {
          curTagEl.textContent = String(config.currentCardTagline).trim();
        } else {
          curTagEl.textContent = '';
        }
      }
      const upTagEl = document.getElementById('abb-pro-upgrade-tagline');
      if (upTagEl) {
        if (config.upgradeCardTagline && String(config.upgradeCardTagline).trim() !== '') {
          upTagEl.textContent = String(config.upgradeCardTagline).trim();
        } else {
          upTagEl.textContent = '';
        }
      }

      const diffMainEl = document.getElementById('accessory-bundle-upsell-popup-diff');
      if (diffMainEl && config.subheadTemplate) {
        diffMainEl.textContent = replaceUpsellSubheadPriceText(config.subheadTemplate, priceFormatted);
      }
      const compareAtRaw = config.compareAtDifference ? String(config.compareAtDifference).trim() : '';
      const compareTopEl = document.getElementById('accessory-bundle-upsell-popup-compare-at');
      if (compareTopEl) {
        compareTopEl.textContent = compareAtRaw ? compareAtRaw : '';
      }

      const subheadEl = upsellPopupGetEl('accessory-bundle-upsell-popup', 'subhead');
      const priceEl = upsellPopupGetEl('accessory-bundle-upsell-popup', 'price');
      if (priceEl) priceEl.textContent = priceFormatted;
      if (subheadEl && config.subheadTemplate) {
        subheadEl.textContent = replaceUpsellSubheadPriceText(config.subheadTemplate, priceFormatted);
      }
      let includedBundleAlt = 'Included accessories';
      if (config.currentCardTitle && String(config.currentCardTitle).trim() !== '') {
        includedBundleAlt = String(config.currentCardTitle).trim();
      } else {
        const titles = [];
        accessoryItems.forEach(function (node) {
          const dt = node.getAttribute('data-accessory-display-title') || '';
          const vt = node.getAttribute('data-accessory-variant-title') || '';
          const t = (dt && dt.trim()) ? dt.trim() : vt;
          if (t) titles.push(t);
        });
        if (titles.length) includedBundleAlt = titles.join(', ');
      }

      const upgradeBundleAlt =
        config.upgradeCardTitle && String(config.upgradeCardTitle).trim() !== ''
          ? String(config.upgradeCardTitle).trim()
          : upgradeVariant.title || upgradeProduct.title || 'Upgrade bundle';

      const currentImgEl = upsellPopupGetEl('accessory-bundle-upsell-popup', 'current-image');
      if (currentImgEl) {
        const customSrc = config.currentImageUrl || null;
        if (customSrc) {
          currentImgEl.src = customSrc;
          currentImgEl.alt = includedBundleAlt;
          currentImgEl.style.display = '';
        } else {
          const firstImg = accessoryItems[0] && accessoryItems[0].querySelector('.accessory-product-image');
          if (firstImg && firstImg.src) {
            currentImgEl.src = firstImg.src;
            currentImgEl.alt = includedBundleAlt;
            currentImgEl.style.display = '';
          } else {
            currentImgEl.style.display = 'none';
          }
        }
      }

      const upgradeImgEl = upsellPopupGetEl('accessory-bundle-upsell-popup', 'upgrade-image');
      if (upgradeImgEl && config.showUpgradeImage !== false) {
        let imgSrc = config.upgradeImageUrl || null;
        if (!imgSrc && upgradeVariant.featured_image) {
          imgSrc = upgradeVariant.featured_image.src || (typeof upgradeVariant.featured_image === 'string' ? upgradeVariant.featured_image : null);
        }
        if (!imgSrc && upgradeProduct.featured_image) {
          imgSrc = upgradeProduct.featured_image.src || upgradeProduct.featured_image;
        }
        if (imgSrc) {
          upgradeImgEl.src = imgSrc;
          upgradeImgEl.alt = upgradeBundleAlt;
          upgradeImgEl.style.display = '';
        } else {
          upgradeImgEl.style.display = 'none';
        }
      }

      overlay.dataset.upgradeBundleVariantId = String(upgradeVariant.id);
      overlay.style.display = 'flex';
      overlay.setAttribute('aria-hidden', 'false');
      return true;
    } catch (e) {
      console.error('Accessory bundle upsell popup error:', e);
      return false;
    }
  }

  function wireAccessoryBundleUpsellPopup() {
    const overlay = document.getElementById('accessory-bundle-upsell-popup-overlay');
    const confirmBtn = document.getElementById('accessory-bundle-upsell-popup-confirm');
    const continueBtn = document.getElementById('accessory-bundle-upsell-popup-continue');
    const closeBtn = document.getElementById('accessory-bundle-upsell-popup-close');
    if (!overlay) return;

    async function closeAndContinue() {
      overlay.style.display = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      const abCfg = getAccessoryBundleUpsellConfig();
      if (abCfg && abCfg.rememberChoice !== false) {
        const sk = getAccessoryBundleStorageKey(abCfg);
        if (sk) writeStoredAccessoryBundleChoice(sk, { mode: 'decline' });
      }
      const chain = pendingAccessoryChain;
      pendingAccessoryChain = null;
      if (!chain) return;
      await handleAddToCart(
        chain.buyNow,
        true,
        chain.upgradeVariantId || null,
        chain.upgradeVariantTitle || '',
        chain.noUpgradeVariantId || null,
        chain.noUpgradeVariantTitle || '',
        true,
        false,
        null
      );
    }

    async function closeAndUpgrade() {
      const bundleVid = overlay.dataset.upgradeBundleVariantId || null;
      overlay.style.display = 'none';
      overlay.setAttribute('aria-hidden', 'true');
      const abCfg = getAccessoryBundleUpsellConfig();
      if (abCfg && abCfg.rememberChoice !== false) {
        const sk = getAccessoryBundleStorageKey(abCfg);
        if (sk) writeStoredAccessoryBundleChoice(sk, { mode: 'upgrade', variantId: bundleVid ? String(bundleVid) : undefined });
      }
      const chain = pendingAccessoryChain;
      pendingAccessoryChain = null;
      if (!chain) return;
      await handleAddToCart(
        chain.buyNow,
        true,
        chain.upgradeVariantId || null,
        chain.upgradeVariantTitle || '',
        chain.noUpgradeVariantId || null,
        chain.noUpgradeVariantTitle || '',
        true,
        true,
        bundleVid
      );
    }

    if (confirmBtn) confirmBtn.addEventListener('click', closeAndUpgrade);
    if (continueBtn) continueBtn.addEventListener('click', closeAndContinue);
    if (closeBtn) closeBtn.addEventListener('click', closeAndContinue);
  }
  wireAccessoryBundleUpsellPopup();
  void clearAccessoryBundleSessionStorageIfCartEmpty();

  function normalizeBedSizeLabel(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/[\u2013\u2014]/g, '-')
      .replace(/[-–—]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function compactBedSizeKey(value) {
    return normalizeBedSizeLabel(value).replace(/\s+/g, '');
  }

  function bedSizeLabelsEqual(a, b) {
    return mattressSizesMatch(a, b);
  }

  function getSizeLikeOptionIndexes(product) {
    const indexes = [];
    if (product && product.options && product.options.length) {
      product.options.forEach(function (name, idx) {
        const n = String(name || '').toLowerCase();
        if (n.includes('size') || n.includes('dimension') || n.includes('width') || n.includes('mattress')) {
          indexes.push(idx);
        }
      });
    }
    return indexes;
  }

  function variantOptionValuesAll(variant) {
    const out = [];
    if (variant && variant.options && Array.isArray(variant.options)) {
      variant.options.forEach(function (o) {
        if (o != null && String(o).trim() !== '') out.push(String(o).trim());
      });
    }
    if (out.length) return out;
    if (variant.option1) out.push(String(variant.option1).trim());
    if (variant.option2) out.push(String(variant.option2).trim());
    if (variant.option3) out.push(String(variant.option3).trim());
    return out;
  }

  function isVariantSellableForUpsell(v) {
    if (!v) return false;
    if (v.available === true) return true;
    if (v.inventory_policy === 'continue') return true;
    if (v.inventory_management == null && v.available !== false) return true;
    const qty = v.inventory_quantity;
    if (qty != null && parseInt(qty, 10) > 0) return true;
    return false;
  }

  function firstSellableOrFirstVariant(product) {
    if (!product || !product.variants || !product.variants.length) return null;
    const avail = product.variants.find(isVariantSellableForUpsell);
    return avail || product.variants[0];
  }

  /**
   * Match upgrade / no-upgrade product variant to mattress size.
   * Checks every variant option (not only option1), prefers option names containing "Size",
   * case/whitespace tolerant. If matched variant is unavailable, returns product.variants[0].
   * If no match, returns first sellable variant or first variant.
   */
  function getVariantBySize(product, sizeValue) {
    if (!product || !product.variants || !product.variants.length) return null;
    const wantRaw = (sizeValue || '').toString().trim();
    if (!wantRaw) return firstSellableOrFirstVariant(product);

    const preferredIdxs = getSizeLikeOptionIndexes(product);
    const optLen = (product.options && product.options.length) || 0;
    const tryIndexes = preferredIdxs.length
      ? preferredIdxs
      : [0, 1, 2].filter(function (i) { return i < optLen; });

    function valueAtVariantIndex(variant, ix) {
      if (variant.options && variant.options[ix] != null) return String(variant.options[ix]).trim();
      if (ix === 0) return variant.option1 ? String(variant.option1).trim() : '';
      if (ix === 1) return variant.option2 ? String(variant.option2).trim() : '';
      if (ix === 2) return variant.option3 ? String(variant.option3).trim() : '';
      return '';
    }

    function variantMatchesSizeLabel(variant, sizeLabel) {
      var values = [];
      if (tryIndexes.length) {
        for (let ti = 0; ti < tryIndexes.length; ti++) {
          const val = valueAtVariantIndex(variant, tryIndexes[ti]);
          if (val) values.push(val);
        }
      }
      variantOptionValuesAll(variant).forEach(function (v) {
        values.push(v);
      });
      return values.some(function (val) {
        return foundationMattressSizesCompatible(val, sizeLabel);
      });
    }

    const lookupLabels = getFoundationSizeLookupLabels(wantRaw);
    for (let li = 0; li < lookupLabels.length; li++) {
      const matches = product.variants.filter(function (variant) {
        return variantMatchesSizeLabel(variant, lookupLabels[li]);
      });
      if (matches.length) {
        const sellableMatch = matches.find(isVariantSellableForUpsell);
        if (sellableMatch) return sellableMatch;
        return matches[0];
      }
    }

    return firstSellableOrFirstVariant(product);
  }

  function getFoundationVariantSizeLabel(product, variant) {
    if (!variant) return '';
    var preferredIdxs = getSizeLikeOptionIndexes(product || {});
    function valueAtVariantIndexLocal(variantRef, ix) {
      if (variantRef.options && variantRef.options[ix] != null) return String(variantRef.options[ix]).trim();
      if (ix === 0) return variantRef.option1 ? String(variantRef.option1).trim() : '';
      if (ix === 1) return variantRef.option2 ? String(variantRef.option2).trim() : '';
      if (ix === 2) return variantRef.option3 ? String(variantRef.option3).trim() : '';
      return '';
    }
    var si;
    for (si = 0; si < preferredIdxs.length; si++) {
      var preferredVal = valueAtVariantIndexLocal(variant, preferredIdxs[si]);
      if (preferredVal) return preferredVal;
    }
    if (product && product.option_names && product.variants) {
      var underbedSizeIndex = detectUnderbedSizeIndex(product);
      if (underbedSizeIndex >= 0) {
        var underbedVal = getVariantOptionByIndex(variant, underbedSizeIndex);
        if (underbedVal) return underbedVal;
      }
    }
    var allVals = variantOptionValuesAll(variant);
    for (var ai = 0; ai < allVals.length; ai++) {
      if (bedSizeCanonicalKey(allVals[ai])) return allVals[ai];
    }
    if (variant.title && String(variant.title).trim() !== '' && variant.title !== 'Default Title') {
      return String(variant.title).trim();
    }
    return '';
  }

  function formatFoundationTypeLine(productTitle, variant, product) {
    var title = (productTitle || (product && product.title) || '').trim();
    var sizeLabel = getFoundationVariantSizeLabel(product || {}, variant);
    if (!title) return sizeLabel;
    return sizeLabel ? (title + ' / ' + sizeLabel) : title;
  }

  function resolveUnderbedFoundationTypeLine(underbedInput) {
    if (!underbedInput || isUnderbedNoFoundationInput(underbedInput)) return '';
    var underbedTitle = underbedInput.getAttribute('data-foundation-type') || '';
    var ubHandle = String(underbedInput.value || '').trim();
    var ubVid = underbedInput.getAttribute('data-underbed-variant-id');
    var cfg = getUnderbedConfig();
    if (!cfg || !cfg.products || !ubHandle) {
      return underbedTitle;
    }
    var ubProduct = cfg.products.find(function (p) {
      return p && p.handle === ubHandle;
    });
    if (!ubProduct) return underbedTitle;
    var ubVariant = null;
    if (ubVid && ubProduct.variants) {
      ubVariant = ubProduct.variants.find(function (v) {
        return String(v.id) === String(ubVid);
      });
    }
    if (!ubVariant) {
      ubVariant = findUnderbedVariantForSize(ubProduct, getCurrentMattressSizeValue());
    }
    return formatFoundationTypeLine(underbedTitle, ubVariant, ubProduct);
  }

  function resolveProductJsVariantImageUrl(variant, product) {
    if (variant && variant.featured_image) {
      if (typeof variant.featured_image === 'string' && variant.featured_image.trim()) return variant.featured_image.trim();
      if (variant.featured_image.src) return variant.featured_image.src;
    }
    if (variant && variant.image_id && product && product.images && product.images.length) {
      for (var ii = 0; ii < product.images.length; ii++) {
        var img = product.images[ii];
        if (!img) continue;
        if (typeof img === 'object' && img.id && String(img.id) === String(variant.image_id)) {
          if (img.src) return img.src;
        }
      }
    }
    return resolveProductHeroImageUrl(product);
  }

  function resolveUpsellFoundationSelection(foundationInput) {
    var result = {
      handle: null,
      variantId: null,
      priceCents: 0,
      imageUrl: null,
      foundationOptionEl: null
    };
    if (!foundationInput) return result;

    result.foundationOptionEl =
      (foundationInput.closest && foundationInput.closest('.foundation-option')) ||
      (foundationInput.closest && foundationInput.closest('[data-foundation-type]'));

    if (foundationInput.name === 'underbed' && !isUnderbedNoFoundationInput(foundationInput)) {
      syncCurrentFoundationFromUnderbedInput(foundationInput);
      var underbedHandle =
        String(foundationInput.value || '').trim() ||
        (result.foundationOptionEl && result.foundationOptionEl.getAttribute('data-underbed-handle')) ||
        '';
      result.handle = underbedHandle || null;
      result.variantId = foundationInput.getAttribute('data-underbed-variant-id') || null;
      result.priceCents = parseInt(foundationInput.getAttribute('data-price') || '0', 10) || 0;

      var cfg = getUnderbedConfig();
      if (cfg && cfg.products && underbedHandle) {
        var ubProduct = cfg.products.find(function (p) {
          return p && p.handle === underbedHandle;
        });
        if (ubProduct) {
          if (ubProduct.image) result.imageUrl = ubProduct.image;
          const selectedSize = getCurrentMattressSizeValue();
          var ubVariant = null;
          if (result.variantId && ubProduct.variants) {
            ubVariant = ubProduct.variants.find(function (v) {
              return String(v.id) === String(result.variantId);
            });
          }
          if (!ubVariant && selectedSize) {
            ubVariant = findUnderbedVariantForSize(ubProduct, selectedSize);
            if (ubVariant && ubVariant.id != null) result.variantId = String(ubVariant.id);
          }
          if (ubVariant && ubVariant.price != null) {
            result.priceCents = parseInt(ubVariant.price, 10) || result.priceCents;
          }
        }
      }
      return result;
    }

    var opt = result.foundationOptionEl;
    result.handle =
      foundationInput.getAttribute('data-product-handle') ||
      (opt && opt.getAttribute('data-product-handle')) ||
      null;
    result.variantId =
      foundationInput.getAttribute('data-variant-id') ||
      (opt && opt.getAttribute('data-variant-id')) ||
      (foundationInput.name === 'foundation' ? foundationInput.value : null) ||
      null;

    if (currentFoundationVariant && currentFoundationVariant.price != null) {
      result.priceCents = parseInt(currentFoundationVariant.price, 10) || 0;
    }
    if (!result.priceCents && opt) {
      result.priceCents = parseInt(opt.getAttribute('data-variant-price') || '0', 10) || 0;
    }
    if (!result.priceCents) {
      result.priceCents = parseInt(foundationInput.getAttribute('data-price') || '0', 10) || 0;
    }

    if (opt) {
      var domImg = opt.getAttribute('data-variant-image');
      if (domImg && String(domImg).trim()) result.imageUrl = String(domImg).trim();
    }

    return result;
  }

  /**
   * Show foundation upsell popup (adjustable or breeze namespace).
   * @param {boolean} buyNow
   * @param {string} namespace - "upsell-popup" | "breeze-upsell-popup"
   * @returns {Promise<boolean>} true if overlay was shown
   */
  async function showFoundationUpsellPopup(buyNow, namespace) {
    const configEl = upsellPopupGetEl(namespace, 'config');
    const overlay = upsellPopupGetEl(namespace, 'overlay');
    if (!configEl || !overlay) {
      suavePdpUpsellDbg('showFoundationUpsellPopup: missing config or overlay', { namespace: namespace });
      return false;
    }
    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      suavePdpUpsellDbg('showFoundationUpsellPopup: config JSON parse failed', { namespace: namespace, err: e });
      return false;
    }
    const upgradeHandle = normalizeProductHandleRef(config.upgradeProductHandle);
    if (!upgradeHandle) {
      suavePdpUpsellDbg('showFoundationUpsellPopup: no upgradeProductHandle in config', { namespace: namespace });
      return false;
    }
    const currentSizeValue = getCurrentMattressSizeValue() || getCurrentMattressSizeValueFromUI();
    suavePdpUpsellDbg('showFoundationUpsellPopup: size + upgrade', {
      namespace: namespace,
      currentSizeValue: currentSizeValue,
      upgradeHandle: upgradeHandle
    });

    try {
      await refreshUnderbedCollectionCardPricesAsync();
      const foundationInput = getFoundationInputForUpsell();
      const currentFoundationType =
        getEffectiveFoundationTypeForUpsell(foundationInput) ||
        (selectedFoundationType ? String(selectedFoundationType).trim() : '');
      const foundationSelection = resolveUpsellFoundationSelection(foundationInput);
      const foundationHandle = foundationSelection.handle;
      const foundationVariantId = foundationSelection.variantId;
      var includedPriceCents = foundationSelection.priceCents || 0;
      var foundationProductData = null;
      var foundationVariantData = null;
      if (foundationHandle && foundationVariantId) {
        try {
          const foundationRes = await fetch(suavePdpProductJsonUrl(foundationHandle));
          if (foundationRes.ok) {
            foundationProductData = await foundationRes.json();
            foundationVariantData = foundationProductData.variants && foundationProductData.variants.find(function (v) { return String(v.id) === String(foundationVariantId); });
            if (!foundationVariantData) {
              foundationVariantData = getVariantBySize(foundationProductData, currentSizeValue);
            }
            if (foundationVariantData && foundationVariantData.price != null) {
              includedPriceCents = parseInt(foundationVariantData.price, 10) || includedPriceCents;
            }
          }
        } catch (e) {}
      }
      if (includedPriceCents === 0 && foundationSelection.priceCents) {
        includedPriceCents = foundationSelection.priceCents;
      }
      if (includedPriceCents === 0 && foundationInput) {
        includedPriceCents = parseInt(foundationInput.getAttribute('data-price') || '0', 10) || 0;
        if (!includedPriceCents && foundationSelection.foundationOptionEl) {
          includedPriceCents = parseInt(foundationSelection.foundationOptionEl.getAttribute('data-variant-price') || '0', 10) || 0;
        }
      }

      const res = await fetch(suavePdpProductJsonUrl(upgradeHandle));
      let upgradeProduct = null;
      if (res.ok) {
        upgradeProduct = await res.json();
      } else {
        suavePdpUpsellDbg('showFoundationUpsellPopup: upgrade product fetch failed, retrying', {
          status: res.status,
          upgradeHandle: upgradeHandle
        });
        await new Promise(function (r) { setTimeout(r, 250); });
        const retryRes = await fetch(suavePdpProductJsonUrl(upgradeHandle));
        if (retryRes.ok) upgradeProduct = await retryRes.json();
      }
      if (!upgradeProduct) {
        suavePdpUpsellDbg('showFoundationUpsellPopup: upgrade product fetch failed', {
          upgradeHandle: upgradeHandle
        });
        return false;
      }
      const upgradeVariant = getVariantBySize(upgradeProduct, currentSizeValue) || firstSellableOrFirstVariant(upgradeProduct);
      if (!upgradeVariant) {
        suavePdpUpsellDbg('showFoundationUpsellPopup: no variant for size', {
          currentSizeValue: currentSizeValue,
          variantCount: upgradeProduct.variants && upgradeProduct.variants.length
        });
        return false;
      }

      var upgradePriceCents = parseInt(upgradeVariant.price, 10) || 0;

      var differenceCents = Math.max(0, upgradePriceCents - includedPriceCents);

      const priceFormatted = formatMoneyFromCents(differenceCents);
      const priceWithPlus = '+' + priceFormatted;

      const subheadEl = upsellPopupGetEl(namespace, 'subhead');
      const priceEl = upsellPopupGetEl(namespace, 'price');
      if (priceEl) priceEl.textContent = priceFormatted;
      if (subheadEl && config.subheadTemplate) {
        var template = String(config.subheadTemplate);
        var subheadHtml = renderUpsellSubheadHtml(namespace, template, priceFormatted);
        if (subheadHtml) {
          subheadEl.innerHTML = subheadHtml;
        } else {
          subheadEl.textContent = template;
        }
      }

      var priceCardEl = upsellPopupGetEl(namespace, 'price-card');
      if (priceCardEl) priceCardEl.textContent = priceWithPlus;

      var compareAtRaw = (config && config.compareAtDifference) ? String(config.compareAtDifference).trim() : '';
      var compareAtEl = upsellPopupGetEl(namespace, 'compare-at');
      if (compareAtEl) {
        compareAtEl.textContent = compareAtRaw ? compareAtRaw + ' ' : '';
        compareAtEl.style.display = compareAtRaw ? '' : 'none';
      }

      var currentNameEl = upsellPopupGetEl(namespace, 'current-name');
      if (currentNameEl) {
        if (config.currentCardTitle && String(config.currentCardTitle).trim() !== '') {
          currentNameEl.textContent = String(config.currentCardTitle).trim();
        } else if (foundationInput) {
          var currentLabel =
            getEffectiveFoundationTypeForUpsell(foundationInput) ||
            (currentFoundationVariant && currentFoundationVariant.title) ||
            '';
          currentNameEl.textContent = currentLabel || '—';
        }
      }
      var upgradeNameEl = upsellPopupGetEl(namespace, 'upgrade-name');
      if (upgradeNameEl) {
        if (config.upgradeCardTitle && String(config.upgradeCardTitle).trim() !== '') {
          upgradeNameEl.textContent = String(config.upgradeCardTitle).trim();
        } else {
          upgradeNameEl.textContent = upgradeVariant.title || upgradeProduct.title || '—';
        }
      }

      var upgradeImgEl = upsellPopupGetEl(namespace, 'upgrade-image');
      if (upgradeImgEl && config.showUpgradeImage !== false) {
        var imgSrc = (config && config.upgradeImageUrl) ? config.upgradeImageUrl : (upgradeVariant.featured_image && (upgradeVariant.featured_image.src || (typeof upgradeVariant.featured_image === 'string' ? upgradeVariant.featured_image : null))) || (upgradeProduct.featured_image && (upgradeProduct.featured_image.src || (typeof upgradeProduct.featured_image === 'string' ? upgradeProduct.featured_image : null))) || (upgradeProduct.images && upgradeProduct.images[0] && (upgradeProduct.images[0].src || (typeof upgradeProduct.images[0] === 'string' ? upgradeProduct.images[0] : null)));
        if (imgSrc) {
          upgradeImgEl.src = imgSrc;
          upgradeImgEl.alt = upgradeProduct.title || '';
          upgradeImgEl.style.display = '';
        } else {
          upgradeImgEl.style.display = 'none';
        }
      }

      var fullUpgradeTitleForCart = formatFoundationTypeLine(
        (config.upgradeCardTitle && String(config.upgradeCardTitle).trim() !== '')
          ? String(config.upgradeCardTitle).trim()
          : (upgradeProduct.title || upgradeVariant.title || currentFoundationType || ''),
        upgradeVariant,
        upgradeProduct
      );

      overlay.dataset.upgradeVariantId = String(upgradeVariant.id);
      overlay.dataset.upgradeVariantTitle = fullUpgradeTitleForCart;
      overlay.dataset.noUpgradeVariantId = '';
      overlay.dataset.noUpgradeVariantTitle = '';
      var noUpgradeHandle = normalizeProductHandleRef(config && config.noUpgradeProductHandle);
      if (noUpgradeHandle && noUpgradeHandle !== '' && noUpgradeHandle !== 'null') {
        try {
          const noUpgradeRes = await fetch(suavePdpProductJsonUrl(noUpgradeHandle));
          if (noUpgradeRes.ok) {
            const noUpgradeProduct = await noUpgradeRes.json();
            const noUpgradeVariant = getVariantBySize(noUpgradeProduct, currentSizeValue) || (noUpgradeProduct.variants && noUpgradeProduct.variants[0]) || null;
            if (noUpgradeVariant) {
              overlay.dataset.noUpgradeVariantId = String(noUpgradeVariant.id);
              overlay.dataset.noUpgradeVariantTitle = formatFoundationTypeLine(
                noUpgradeProduct.title,
                noUpgradeVariant,
                noUpgradeProduct
              );
              if (currentNameEl) {
                var localizedCardTitle =
                  config.currentCardTitle && String(config.currentCardTitle).trim() !== ''
                    ? String(config.currentCardTitle).trim()
                    : '';
                if (localizedCardTitle) {
                  currentNameEl.textContent =
                    localizedCardTitle +
                    (noUpgradeVariant.title && noUpgradeVariant.title !== 'Default Title'
                      ? ' - ' + noUpgradeVariant.title
                      : '');
                } else {
                  currentNameEl.textContent =
                    noUpgradeProduct.title +
                    (noUpgradeVariant.title && noUpgradeVariant.title !== 'Default Title'
                      ? ' - ' + noUpgradeVariant.title
                      : '');
                }
              }
            }
          }
        } catch (e) {}
      }

      var currentImgEl = upsellPopupGetEl(namespace, 'current-image');
      if (currentImgEl) {
        var currentImgSrc = (config && config.currentImageUrl) ? config.currentImageUrl : null;
        if (!currentImgSrc && (!noUpgradeHandle || noUpgradeHandle === '' || noUpgradeHandle === 'null')) {
          if (foundationSelection.imageUrl) {
            currentImgSrc = foundationSelection.imageUrl;
          }
          if (!currentImgSrc) {
            currentImgSrc = resolveProductJsVariantImageUrl(foundationVariantData, foundationProductData);
          }
        }
        if (currentImgSrc) {
          currentImgEl.src = currentImgSrc;
          currentImgEl.alt = (currentNameEl && currentNameEl.textContent) ? currentNameEl.textContent : 'Current';
          currentImgEl.style.display = '';
        } else {
          currentImgEl.style.display = 'none';
        }
      }
      if (!overlay.dataset.noUpgradeVariantId && currentNameEl && (!config.currentCardTitle || String(config.currentCardTitle).trim() === '') && foundationInput) {
        var currentLabel2 =
          getEffectiveFoundationTypeForUpsell(foundationInput) ||
          (currentFoundationVariant && currentFoundationVariant.title) ||
          '';
        currentNameEl.textContent = currentLabel2 || '—';
      }

      activeUpsellOverlay = overlay;
      overlay.style.display = 'flex';
      overlay.setAttribute('aria-hidden', 'false');
      return true;
    } catch (e) {
      console.error('Upsell popup error:', e);
      return false;
    }
  }

  function isMergeFoundationIntoExistingEnabled() {
    var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    return !!store.mergeFoundationIntoExisting;
  }

  function suavePdpCartAjaxUrl(path) {
    var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    var root = String(store.rootUrl || '/');
    var cleanPath = String(path || '').replace(/^\//, '');
    if (!root || root === '/') return '/' + cleanPath;
    return root.replace(/\/$/, '') + '/' + cleanPath;
  }

  function suaveMergeFoundationDbg(message, data) {
    try {
      if (data !== undefined) {
        console.info('[SuaveMergeFoundation]', message, data);
      } else {
        console.info('[SuaveMergeFoundation]', message);
      }
    } catch (e) {}
  }

  function isAccessoryLikeCartLine(item) {
    if (!item || !item.properties) return false;
    var p = item.properties;
    return !!(
      p['Included Items'] ||
      p['Bundle'] ||
      p['_accessory_bundle_included'] ||
      p['_accessory_upgraded']
    );
  }

  function getCartNestedChildren(items, parentKey) {
    if (!items || !parentKey) return [];
    return items.filter(function (item) {
      var rel = item && item.parent_relationship && item.parent_relationship.parent;
      if (rel && rel.key === parentKey) return true;
      if (
        item &&
        item.parent_relationship &&
        item.parent_relationship.parent_key &&
        item.parent_relationship.parent_key === parentKey
      ) {
        return true;
      }
      return false;
    });
  }

  function cartLineHasFoundationChild(items, parentKey) {
    return getCartNestedChildren(items, parentKey).some(function (child) {
      return !isAccessoryLikeCartLine(child);
    });
  }

  function getCartLineOptionValue(line, nameHints) {
    if (!line || !nameHints || !nameHints.length) return '';
    var opts = line.options_with_values || [];
    for (var i = 0; i < opts.length; i++) {
      var name = String((opts[i] && opts[i].name) || '')
        .trim()
        .toLowerCase();
      if (!name) continue;
      for (var h = 0; h < nameHints.length; h++) {
        var hint = String(nameHints[h] || '')
          .trim()
          .toLowerCase();
        if (!hint) continue;
        if (name === hint || name.indexOf(hint) !== -1) {
          return String((opts[i] && opts[i].value) || '').trim();
        }
      }
    }
    return '';
  }

  function getCartLineSizeValue(line) {
    var fromOpts = getCartLineOptionValue(line, ['size', 'tamaño', 'tamano']);
    if (fromOpts) return fromOpts;
    if (line && line.variant_options && line.variant_options.length) {
      for (var i = 0; i < line.variant_options.length; i++) {
        var val = String(line.variant_options[i] || '').trim();
        if (/twin|full|queen|king|cal|individual|matrimonial|simple/i.test(val)) {
          return val;
        }
      }
    }
    return '';
  }

  function cartLineFoundationTypeValue(line) {
    if (!line || !line.properties) return '';
    var p = line.properties;
    return String(p['Foundation Type'] || p['foundation type'] || p['Tipo de base'] || '').trim();
  }

  function cartLineIsNoFoundationProperty(line) {
    var ft = cartLineFoundationTypeValue(line);
    if (!ft) return true;
    var lower = ft.toLowerCase();
    var noLabel = String(suavePdpNoFoundationLabel() || 'No Foundation')
      .trim()
      .toLowerCase();
    if (noLabel && lower === noLabel) return true;
    if (lower === 'no foundation' || lower.indexOf('no foundation') === 0) return true;
    if (lower === 'sin base' || lower.indexOf('sin base') === 0) return true;
    if (lower.indexOf('sin fundaci') === 0) return true;
    return false;
  }

  /**
   * Find a qty-1 mattress line for the same product + size (firmness product)
   * that does not already have a foundation/base nested under it.
   * Do NOT require exact variant id — Model option often changes with foundation.
   */
  async function findMergeableMattressCartLine(mattressVariantId, mattressProduct, sizeValue) {
    try {
      var res = await fetch(suavePdpCartAjaxUrl('cart.js'), { credentials: 'same-origin' });
      if (!res.ok) {
        suaveMergeFoundationDbg('cart.js fetch failed', { status: res.status });
        return null;
      }
      var cart = await res.json();
      var items = (cart && cart.items) || [];
      var targetVariantId = mattressVariantId != null ? parseInt(mattressVariantId, 10) : NaN;
      var productId =
        mattressProduct && mattressProduct.id != null ? parseInt(mattressProduct.id, 10) : NaN;
      var sizeWanted = sizeValue != null ? String(sizeValue).trim() : '';

      suaveMergeFoundationDbg('scanning cart for mergeable mattress', {
        targetVariantId: targetVariantId,
        productId: productId,
        sizeWanted: sizeWanted,
        itemCount: items.length
      });

      var exactVariantMatch = null;
      var productSizeMatch = null;

      for (var i = 0; i < items.length; i++) {
        var line = items[i];
        if (!line) continue;
        if (line.parent_relationship && line.parent_relationship.parent) continue;
        if (line.parent_relationship && line.parent_relationship.parent_key) continue;
        if (line.quantity !== 1) continue;
        if (cartLineHasFoundationChild(items, line.key)) {
          suaveMergeFoundationDbg('skip line — already has foundation child', {
            key: line.key,
            variantId: line.id
          });
          continue;
        }
        if (!cartLineIsNoFoundationProperty(line)) {
          suaveMergeFoundationDbg('skip line — foundation type already set', {
            key: line.key,
            foundationType: cartLineFoundationTypeValue(line)
          });
          continue;
        }

        var lineVariantId = parseInt(line.variant_id != null ? line.variant_id : line.id, 10);
        if (!isNaN(targetVariantId) && lineVariantId === targetVariantId) {
          exactVariantMatch = line;
          break;
        }

        var lineProductId = parseInt(line.product_id, 10);
        if (!isNaN(productId) && lineProductId === productId) {
          var lineSize = getCartLineSizeValue(line);
          if (!sizeWanted || !lineSize || mattressSizesMatch(lineSize, sizeWanted)) {
            if (!productSizeMatch) productSizeMatch = line;
          }
        }
      }

      var found = exactVariantMatch || productSizeMatch || null;
      suaveMergeFoundationDbg('mergeable line result', {
        found: !!found,
        key: found && found.key,
        variantId: found && (found.variant_id || found.id),
        matchType: exactVariantMatch ? 'variant' : productSizeMatch ? 'product+size' : 'none'
      });
      return found;
    } catch (e) {
      console.warn('[SuaveMergeFoundation] findMergeableMattressCartLine failed', e);
    }
    return null;
  }

  function isFoundationOrUpgradeCartItem(item, mattressVariantId) {
    if (!item || !item.id) return false;
    if (parseInt(item.id, 10) === parseInt(mattressVariantId, 10)) return false;
    if (isAccessoryLikeCartLine(item)) return false;
    return true;
  }

  async function updateCartLineProperties(lineKey, quantity, properties) {
    var res = await fetch(suavePdpCartAjaxUrl('cart/change.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: lineKey,
        quantity: quantity,
        properties: properties || {}
      })
    });
    if (!res.ok) {
      var errData = {};
      try {
        errData = await res.json();
      } catch (e) {}
      throw new Error(errData.description || 'Failed to update cart line');
    }
    return res.json();
  }

  async function handleAddToCart(
    buyNow = false,
    skipUpsellPopup = false,
    upgradeVariantId = null,
    upgradeVariantTitle = '',
    noUpgradeVariantId = null,
    noUpgradeVariantTitle = '',
    skipAccessoryBundlePopup = false,
    accessoryBundleUseUpgrade = false,
    accessoryBundleUpgradeVariantId = null
  ) {
    const addToCartBtnEl = document.getElementById('add-to-cart');
    try {
      if (addToCartBtnEl) {
        addToCartBtnEl.disabled = true;
        addToCartBtnEl.textContent = suavePdpT('adding', 'Adding...');
      }

      if (!skipUpsellPopup) {
        suavePdpUpsellDbg('handleAddToCart: upsell branch entered', { skipUpsellPopup: false });
        await refreshUnderbedCollectionCardPricesAsync();
        var foundationContainerUpsell = document.getElementById('foundation-options-container');
        if (foundationContainerUpsell) syncUnderbedCheckedFromSelected(foundationContainerUpsell);
        const foundationInput = getFoundationInputForUpsell();
        const foundationHandle = getUnderbedHandleFromInput(foundationInput);
        const foundationTypes = getUpsellFoundationMatchTypes(foundationInput);
        const foundationTypeTrim = foundationTypes.length ? foundationTypes[0] : '';
        if (!foundationInput) {
          suavePdpUpsellDbg('upsell skipped: no foundation input (no :checked / .selected / container)', {
            hasContainer: !!document.getElementById('foundation-options-container')
          });
        } else if (!foundationHandle && !foundationTypes.length) {
          suavePdpUpsellDbg('upsell skipped: foundation input has no data-foundation-type or underbed handle', {
            value: foundationInput.value,
            outerHTML: foundationInput.outerHTML && foundationInput.outerHTML.slice(0, 200)
          });
        } else {
          const adjustableConfigEl = upsellPopupGetEl('upsell-popup', 'config');
          const adjustableOverlay = upsellPopupGetEl('upsell-popup', 'overlay');
          suavePdpUpsellDbg('DOM: adjustable upsell', {
            hasConfigScript: !!adjustableConfigEl,
            hasOverlay: !!adjustableOverlay
          });
          if (!adjustableConfigEl || !adjustableOverlay) {
            suavePdpUpsellDbg('Adjustable upsell block not in DOM (no upsell_popup block or upgrade_product empty in theme)');
          }
          if (adjustableConfigEl && adjustableOverlay) {
            let adjConfig;
            try {
              adjConfig = JSON.parse(adjustableConfigEl.textContent);
            } catch (e) {
              suavePdpUpsellDbg('adjustable config JSON parse error', e);
            }
            suavePdpUpsellDbg('adjustable config', {
              upgradeHandle: adjConfig && adjConfig.upgradeProductHandle,
              foundationTrigger: adjConfig && adjConfig.foundationTrigger
            });
            if (adjConfig && adjConfig.upgradeProductHandle) {
              if (foundationTriggerMatchesAny(adjConfig, foundationInput)) {
                pendingUpsellBuyNow = buyNow;
                suavePdpUpsellDbg('showing adjustable upsell popup');
                const shown = await showFoundationUpsellPopup(buyNow, 'upsell-popup');
                suavePdpUpsellDbg('adjustable showFoundationUpsellPopup returned', { shown: shown });
                if (!shown) {
                  suavePdpUpsellDbgAlert('Adjustable trigger matched but popup did not show (fetch error or no variant?). Check console.');
                }
                if (shown) return;
              } else {
                suavePdpUpsellDbg('adjustable trigger did not match', {
                  selectedType: foundationTypeTrim,
                  configTrigger: adjConfig.foundationTrigger
                });
              }
            }
          }
          const breezeConfigEl = upsellPopupGetEl('breeze-upsell-popup', 'config');
          const breezeOverlay = upsellPopupGetEl('breeze-upsell-popup', 'overlay');
          suavePdpUpsellDbg('DOM: breeze/Base upsell', {
            hasConfigScript: !!breezeConfigEl,
            hasOverlay: !!breezeOverlay
          });
          if (!breezeConfigEl || !breezeOverlay) {
            suavePdpUpsellDbg('Breeze upsell block not in DOM (no breeze_upsell_popup block or upgrade_product empty)');
          }
          if (breezeConfigEl && breezeOverlay) {
            let breezeConfig;
            try {
              breezeConfig = JSON.parse(breezeConfigEl.textContent);
            } catch (e) {
              suavePdpUpsellDbg('breeze config JSON parse error', e);
            }
            suavePdpUpsellDbg('breeze config', {
              upgradeHandle: breezeConfig && breezeConfig.upgradeProductHandle,
              foundationTrigger: breezeConfig && breezeConfig.foundationTrigger
            });
            if (breezeConfig && breezeConfig.upgradeProductHandle && foundationTriggerMatchesAny(breezeConfig, foundationInput)) {
              pendingUpsellBuyNow = buyNow;
              suavePdpUpsellDbg('showing breeze/Base upsell popup');
              const shown = await showFoundationUpsellPopup(buyNow, 'breeze-upsell-popup');
              suavePdpUpsellDbg('breeze showFoundationUpsellPopup returned', { shown: shown });
              if (!shown) {
                suavePdpUpsellDbgAlert('Base/Breeze trigger matched but popup did not show. Check console for fetch/variant errors.');
              }
              if (shown) return;
            } else if (breezeConfig && breezeConfig.upgradeProductHandle) {
              suavePdpUpsellDbg('breeze trigger did not match selected foundation type', {
                selectedType: foundationTypeTrim,
                configTrigger: breezeConfig.foundationTrigger
              });
              suavePdpUpsellDbgAlert(
                'Trigger match fail: selected type "' + foundationTypeTrim + '" vs theme trigger "' + (breezeConfig.foundationTrigger || '') + '"'
              );
            }
          }
        }
      } else {
        suavePdpUpsellDbg('handleAddToCart: skipUpsellPopup true (after upsell confirm/continue chain)');
      }

      /* Accessory bundle popup runs only after adjustable + breeze (Base) upsell checks above (when not skipUpsellPopup). */
      if (!skipAccessoryBundlePopup) {
        await clearAccessoryBundleSessionStorageIfCartEmpty();
        const abConfigEl = document.getElementById('accessory-bundle-upsell-popup-config');
        const abOverlay = document.getElementById('accessory-bundle-upsell-popup-overlay');
        const foundationInputAb = getFoundationInputForUpsell();
        const foundationTypeAb =
          getEffectiveFoundationTypeForUpsell(foundationInputAb) || selectedFoundationType || '';
        const hasAccessoryRows = document.querySelectorAll('.accessory-item[data-accessory-product]').length > 0;
        if (abConfigEl && abOverlay && hasAccessoryRows) {
          let abCfg;
          try {
            abCfg = JSON.parse(abConfigEl.textContent);
          } catch (e) {}
          if (abCfg && abCfg.upgradeProductHandle && accessoryBundleFoundationMatches(abCfg, foundationTypeAb)) {
            const rememberAb = abCfg.rememberChoice !== false;
            const storageKeyAb = rememberAb ? getAccessoryBundleStorageKey(abCfg) : null;
            const storedAb = readStoredAccessoryBundleChoice(storageKeyAb);
            if (storedAb && storedAb.mode === 'upgrade') {
              const rememberedBundleVid =
                storedAb.variantId != null && String(storedAb.variantId).trim() !== ''
                  ? String(storedAb.variantId).trim()
                  : null;
              await handleAddToCart(
                buyNow,
                true,
                upgradeVariantId || null,
                upgradeVariantTitle || '',
                noUpgradeVariantId || null,
                noUpgradeVariantTitle || '',
                true,
                true,
                rememberedBundleVid
              );
              return;
            }
            if (storedAb && storedAb.mode === 'decline') {
              /* fall through — add default accessories, no popup */
            } else {
              pendingAccessoryChain = {
                buyNow: buyNow,
                upgradeVariantId: upgradeVariantId || null,
                upgradeVariantTitle: upgradeVariantTitle || '',
                noUpgradeVariantId: noUpgradeVariantId || null,
                noUpgradeVariantTitle: noUpgradeVariantTitle || ''
              };
              pendingUpsellBuyNow = buyNow;
              const shownAb = await showAccessoryBundleUpsellPopup();
              if (shownAb) return;
            }
          }
        }
      }

      const mattressSizeForCart =
        getCurrentMattressSizeValueFromUI() || getCurrentMattressSizeValue();

      syncMattressModelFromUnderbedSelection();

      if (currentMattressProduct && currentMattressProduct.handle) {
        try {
          const mattressRes = await fetch(suavePdpProductJsonUrl(currentMattressProduct.handle));
          if (mattressRes.ok) {
            currentMattressProduct = await mattressRes.json();
          }
        } catch (e) {}
      }

      const items = [];
      const mattressVariantForCart = findMattressVariantForAddToCart(mattressSizeForCart);
      const mattressVariantIdForCart = mattressVariantForCart && mattressVariantForCart.id
        ? parseInt(mattressVariantForCart.id, 10)
        : null;

      if (mattressVariantForCart) {
        if (!isMattressVariantSellable(mattressVariantForCart)) {
          throw new Error('Selected mattress variant is out of stock');
        }

        const { firmnessIndex, sizeIndex } = detectOptionTypes(currentMattressProduct);
        let sizeValue = 'Standard';
        let firmnessValue = 'Standard';

        if (mattressVariantForCart.options) {
          if (mattressVariantForCart.options[sizeIndex] !== undefined) {
            sizeValue = mattressVariantForCart.options[sizeIndex];
          }
          if (mattressVariantForCart.options[firmnessIndex] !== undefined) {
            firmnessValue = mattressVariantForCart.options[firmnessIndex];
          }
        }
        
        // Add properties to cart for detailed display
        const properties = {};
        
        // Add Foundation Type if foundation is selected - show foundation product name + foundation variant size
        if (upgradeVariantId && upgradeVariantTitle) {
          properties['Foundation Type'] = upgradeVariantTitle;
        } else {
          const underbedInputProp = getSelectedUnderbedInput();
          if (underbedInputProp && !isUnderbedNoFoundationInput(underbedInputProp)) {
            const underbedLine = resolveUnderbedFoundationTypeLine(underbedInputProp);
            if (underbedLine) properties['Foundation Type'] = underbedLine;
          } else {
            const foundationInputProp = document.querySelector('input[name="foundation"]:checked');
            if (foundationInputProp && foundationInputProp.value) {
              const foundationTitle =
                foundationInputProp.getAttribute('data-foundation-type') ||
                foundationInputProp.getAttribute('data-variant-title') ||
                '';
              var foundationVariantForLine = null;
              if (currentFoundationProduct && currentFoundationProduct.variants) {
                foundationVariantForLine = currentFoundationProduct.variants.find(function (v) {
                  return String(v.id) === String(foundationInputProp.value);
                }) || null;
              }
              if (foundationTitle) {
                properties['Foundation Type'] = formatFoundationTypeLine(
                  foundationTitle,
                  foundationVariantForLine,
                  currentFoundationProduct
                );
              }
            } else if (selectedModelValue) {
              properties['Foundation Type'] = selectedModelValue;
            }
          }
        }

        let willIncludeAccessoryBundle = false;
        if (!accessoryBundleUseUpgrade) {
          const accItemsCheck = document.querySelectorAll('.accessory-item[data-accessory-product]');
          for (let abi = 0; abi < accItemsCheck.length; abi++) {
            const accItem = accItemsCheck[abi];
            const ph = accItem.getAttribute('data-accessory-product');
            const vid = resolveAccessoryVariantIdForItem(accItem);
            if (ph && ph !== '' && ph !== 'null' && vid) {
              willIncludeAccessoryBundle = true;
              break;
            }
          }
        }
        if (willIncludeAccessoryBundle) {
          properties['_accessory_bundle_included'] = '1';
        }

        if (accessoryBundleUseUpgrade) {
          properties['_accessory_upgraded'] = '1';
        }
        
        items.push({
          id: mattressVariantIdForCart,
          quantity: 1,
          properties: properties
        });
      } else {
        throw new Error('No size selected');
      }

      // Add foundation to cart if selected (even if price is $0) — skip when adding upgrade variant instead
      let foundationInput = document.querySelector('input[name="foundation"]:checked');
      // Fallback: on first load user may add to cart before changing anything; ensure we use foundation from container
      if (!foundationInput) {
        const foundationContainer = document.getElementById('foundation-options-container');
        if (foundationContainer) {
          foundationInput = foundationContainer.querySelector('input[name="foundation"]:checked') ||
            foundationContainer.querySelector('.foundation-option.selected input[name="foundation"]') ||
            foundationContainer.querySelector('.foundation-option:not(.out-of-stock) input[name="foundation"]:not([disabled])') ||
            foundationContainer.querySelector('input[name="foundation"]');
          // Sync UI so visible selection matches what we add to cart
          if (foundationInput) {
            foundationInput.checked = true;
            const optionEl = foundationInput.closest('.foundation-option');
            if (optionEl) {
              foundationContainer.querySelectorAll('.foundation-option').forEach(function (o) {
                o.classList.remove('selected');
                const t = o.querySelector('.foundation-title');
                const p = o.querySelector('.foundation-price');
                if (t) t.classList.remove('pdp-text-color');
                if (p) p.classList.remove('pdp-text-color');
              });
              optionEl.classList.add('selected');
              const st = optionEl.querySelector('.foundation-title');
              const sp = optionEl.querySelector('.foundation-price');
              if (st) st.classList.add('pdp-text-color');
              if (sp) sp.classList.add('pdp-text-color');
              var activeTabForCartFoundation = document.querySelector('#custom-product-container .tab.active');
              applyFoundationOptionTabColor(
                activeTabForCartFoundation ? activeTabForCartFoundation.getAttribute('data-tab-color') : ''
              );
            }
          }
        }
      }
      if (upgradeVariantId) {
        const upgradeLine = {
          id: parseInt(upgradeVariantId, 10),
          quantity: 1
        };
        if (mattressVariantIdForCart) upgradeLine.parent_id = mattressVariantIdForCart;
        items.push(upgradeLine);
      } else if (noUpgradeVariantId) {
        const noUpgradeProperties = {};
        if (noUpgradeVariantTitle) noUpgradeProperties['Variant'] = noUpgradeVariantTitle;
        const noUpgradeLine = {
          id: parseInt(noUpgradeVariantId, 10),
          quantity: 1,
          properties: noUpgradeProperties
        };
        if (mattressVariantIdForCart) noUpgradeLine.parent_id = mattressVariantIdForCart;
        items.push(noUpgradeLine);
      } else {
        const underbedInputForCart = getSelectedUnderbedInput();
        if (underbedInputForCart && !isUnderbedNoFoundationInput(underbedInputForCart)) {
          let underbedVariantId = underbedInputForCart.getAttribute('data-underbed-variant-id');
          if (!underbedVariantId) {
            const underbedHandle = String(underbedInputForCart.value || '').trim();
            const cfg = getUnderbedConfig();
            if (cfg && cfg.products && underbedHandle) {
              const ubProduct = cfg.products.find(function (p) {
                return p && p.handle === underbedHandle;
              });
              const resolved = ubProduct ? resolveUnderbedVariantForCurrentSize(ubProduct, true) : null;
              if (resolved && resolved.id != null) underbedVariantId = String(resolved.id);
            }
          }
          if (!underbedVariantId) {
            throw new Error('Selected base is not available for this size');
          }
          const underbedLine = {
            id: parseInt(underbedVariantId, 10),
            quantity: 1
          };
          if (mattressVariantIdForCart) underbedLine.parent_id = mattressVariantIdForCart;
          items.push(underbedLine);
        } else if (foundationInput && foundationInput.name === 'foundation' && foundationInput.value) {
          // data-variant-price may be formatted (e.g. "$79.00") so strip non-numeric chars first.
          const foundationPriceAttr = foundationInput.getAttribute('data-variant-price');
          let foundationPrice = parseFloat(String(foundationPriceAttr || '0').replace(/[^0-9.]/g, '')) || 0;
          if ((!foundationPriceAttr || String(foundationPriceAttr).trim() === '') && foundationInput.closest) {
            const optionEl = foundationInput.closest('.foundation-option') || foundationInput.closest('[class*="foundation-option"]');
            const priceEl = optionEl ? optionEl.querySelector('.foundation-price') : null;
            if (priceEl) {
              const priceText = (priceEl.textContent || '').trim();
              foundationPrice = parseFloat(priceText.replace(/[^0-9.]/g, '')) || 0;
            }
          }
          if (foundationPrice > 0) {
            const isAvailable = foundationInput.getAttribute('data-variant-available') === 'true';
            const inventoryPolicy = foundationInput.getAttribute('data-variant-inventory-policy');
            const inventoryQuantity = foundationInput.getAttribute('data-variant-inventory');
            const inventoryManagement = foundationInput.getAttribute('data-variant-inventory-management');

            let isFoundationAvailable = false;
            if (isAvailable === true) {
              isFoundationAvailable = true;
            } else if (inventoryPolicy === 'continue') {
              isFoundationAvailable = true;
            } else if (inventoryQuantity && parseInt(inventoryQuantity, 10) > 0) {
              isFoundationAvailable = true;
            } else if (inventoryManagement === 'null' || inventoryManagement === null) {
              isFoundationAvailable = true;
            }

            if (!isFoundationAvailable) {
              throw new Error('Selected foundation variant is out of stock');
            }

            const foundationLine = {
              id: parseInt(foundationInput.value, 10),
              quantity: 1
            };
            if (mattressVariantIdForCart) foundationLine.parent_id = mattressVariantIdForCart;
            items.push(foundationLine);
          }
        }
      }
      // Add accessories to cart; resolve variant by main size dropdown (hidden – no separate size selector)
      const accessoryItems = document.querySelectorAll('.accessory-item[data-accessory-product]');
      const accessoryProductsMap = new Map();
      const mainProductName = currentMattressProduct ? currentMattressProduct.title : 'Main Product';
      const currentSizeValue = getCurrentMattressSizeValue();

      let resolvedBundleUpgradeVariantId = accessoryBundleUpgradeVariantId;
      if (accessoryBundleUseUpgrade && !resolvedBundleUpgradeVariantId) {
        const abCfgResolve = getAccessoryBundleUpsellConfig();
        const uh = abCfgResolve && abCfgResolve.upgradeProductHandle;
        if (uh) {
          try {
            const r = await fetch(suavePdpProductJsonUrl(String(uh)));
            if (r.ok) {
              const p = await r.json();
              const vv = getVariantBySize(p, getCurrentMattressSizeValue());
              if (vv && vv.id != null) resolvedBundleUpgradeVariantId = String(vv.id);
            }
          } catch (e) {}
        }
      }

      if (accessoryBundleUseUpgrade && resolvedBundleUpgradeVariantId) {
        const bundleLine = {
          id: parseInt(resolvedBundleUpgradeVariantId, 10),
          quantity: 1,
          properties: {
            Bundle: 'Upgraded accessory bundle'
          }
        };
        if (mattressVariantIdForCart) bundleLine.parent_id = mattressVariantIdForCart;
        items.push(bundleLine);
      } else if (accessoryBundleUseUpgrade) {
        throw new Error(
          'Could not match the upgraded accessory bundle to your mattress size. Try another size or refresh the page.'
        );
      } else {

      accessoryItems.forEach(accessoryItem => {
        const productHandle = accessoryItem.getAttribute('data-accessory-product');
        const productId = accessoryItem.getAttribute('data-accessory-product-id');
        const variantId = resolveAccessoryVariantIdForItem(accessoryItem);
        const variantTitle = accessoryItem.getAttribute('data-accessory-variant-title') || '';
        const variantOptions = accessoryItem.getAttribute('data-accessory-variant-options') || '';
        
        if (productHandle && productHandle !== '' && productHandle !== 'null' && variantId) {
          if (!accessoryProductsMap.has(productHandle)) {
            accessoryProductsMap.set(productHandle, {
              productId: productId,
              productHandle: productHandle,
              firstVariantId: variantId,
              variantDetails: []
            });
          }
          
          const productData = accessoryProductsMap.get(productHandle);
          productData.firstVariantId = variantId;
          let variantInfo = variantTitle;
          if (variantOptions && variantOptions !== '') {
            variantInfo += ` (${variantOptions})`;
          }
          productData.variantDetails.push(variantInfo);
        }
      });
      
      // Add each accessory product once with variant names only
      accessoryProductsMap.forEach((productData, productHandle) => {
        const accessoryProperties = {};
        
        // Collect variant names: use customizer display title if set, else variant title
        const variantNames = [];
        accessoryItems.forEach(accessoryItem => {
          const itemProductHandle = accessoryItem.getAttribute('data-accessory-product');
          if (itemProductHandle === productHandle) {
            const displayTitle = accessoryItem.getAttribute('data-accessory-display-title') || '';
            const variantTitle = accessoryItem.getAttribute('data-accessory-variant-title') || '';
            const title = (displayTitle && displayTitle.trim()) ? displayTitle.trim() : variantTitle;
            if (title) {
              variantNames.push(title);
            }
          }
        });
        
        // Add variant names as single property
        if (variantNames.length > 0) {
          accessoryProperties['Included Items'] = variantNames.join(', ');
        }

        const accessoryLine = {
          id: parseInt(productData.firstVariantId),
          quantity: 1,
          properties: accessoryProperties
        };
        if (mattressVariantIdForCart) accessoryLine.parent_id = mattressVariantIdForCart;
        items.push(accessoryLine);
      });

      }

      let mergeParentLine = null;
      const foundationChildItems = items.filter(function (item) {
        return isFoundationOrUpgradeCartItem(item, mattressVariantIdForCart);
      });
      const wantsFoundationChild = foundationChildItems.length > 0;
      const mergeEnabled = isMergeFoundationIntoExistingEnabled();

      suaveMergeFoundationDbg('ATC merge check', {
        mergeEnabled: mergeEnabled,
        wantsFoundationChild: wantsFoundationChild,
        mattressVariantIdForCart: mattressVariantIdForCart,
        mattressProductId: currentMattressProduct && currentMattressProduct.id,
        size: mattressSizeForCart,
        foundationChildCount: foundationChildItems.length
      });

      if (mergeEnabled && wantsFoundationChild && currentMattressProduct) {
        mergeParentLine = await findMergeableMattressCartLine(
          mattressVariantIdForCart,
          currentMattressProduct,
          mattressSizeForCart
        );
      }

      if (mergeParentLine && mergeParentLine.key) {
        const parentKey = mergeParentLine.key;
        const mergedProperties = Object.assign({}, mergeParentLine.properties || {});
        const mattressItem = items.find(function (item) {
          return item && parseInt(item.id, 10) === parseInt(mattressVariantIdForCart, 10);
        });
        if (mattressItem && mattressItem.properties) {
          Object.keys(mattressItem.properties).forEach(function (key) {
            mergedProperties[key] = mattressItem.properties[key];
          });
        }

        // Nest under the EXISTING line key (parent_line_key). parent_id is only for same-request parents.
        const nestedItems = foundationChildItems.map(function (item) {
          const nested = {
            id: item.id,
            quantity: 1,
            parent_line_key: parentKey
          };
          if (item.properties) nested.properties = item.properties;
          return nested;
        });

        suaveMergeFoundationDbg('merging foundation into existing mattress', {
          parentKey: parentKey,
          nestedItems: nestedItems,
          mergedProperties: mergedProperties
        });

        const response = await fetch(suavePdpCartAjaxUrl('cart/add.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: nestedItems })
        });

        if (!response.ok) {
          const errorData = await response.json().catch(function () {
            return {};
          });
          suaveMergeFoundationDbg('merge add.js failed', errorData);
          throw new Error(
            errorData.description || 'Failed to add foundation to existing mattress'
          );
        }

        try {
          await updateCartLineProperties(parentKey, 1, mergedProperties);
        } catch (propErr) {
          suaveMergeFoundationDbg('property update after merge failed (foundation still added)', propErr);
        }
      } else {
        suaveMergeFoundationDbg('normal add (no merge)', {
          mergeEnabled: mergeEnabled,
          hadMergeParent: !!(mergeParentLine && mergeParentLine.key)
        });
        const response = await fetch(suavePdpCartAjaxUrl('cart/add.js'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          credentials: 'same-origin',
          body: JSON.stringify({ items: items })
        });

        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.description || 'Failed to add items to cart');
        }
      }

      if (buyNow) {
        window.location.href = '/checkout';
      } else {
        window.location.href = '/cart';
      }

    } catch (err) {
      console.error('Cart add error:', err);
      alert('Error adding item to cart: ' + err.message);
    } finally {
      const addToCartBtnReset = document.getElementById('add-to-cart');
      if (addToCartBtnReset) {
        addToCartBtnReset.disabled = false;
        addToCartBtnReset.textContent = suavePdpT('addToCart', 'Add to Cart');
      }
    }
  }

  // Helper functions
  function stripHtml(html) {
    const tmp = document.createElement('DIV');
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || '';
  }

  function truncateWords(text, wordCount) {
    const words = text.trim().split(/\s+/);
    if (words.length <= wordCount) return text;
    return words.slice(0, wordCount).join(' ') + '...';
  }

  function getPdpMoneyFormat() {
    var store = (typeof window !== 'undefined' && window.__PDP_STORE__) || {};
    var fmt = store.moneyFormat || '${{amount}}';
    if (fmt.indexOf('amount_no_decimals') !== -1) {
      return fmt.replace(/amount_no_decimals/g, 'amount');
    }
    if (fmt.indexOf('{{amount}}') === -1 && fmt.indexOf('{{ amount }}') === -1) {
      return '${{amount}}';
    }
    return fmt;
  }

  function formatMoney(cents) {
    if (cents == null || cents === '') return '';
    var num = typeof cents === 'string' ? parseFloat(String(cents).replace(/[^0-9.-]/g, '')) : Number(cents);
    if (isNaN(num)) return '';

    var centsInt = Math.round(num);
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(centsInt, getPdpMoneyFormat());
    }

    var dollars = centsInt / 100;
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(dollars);
  }

  /** Format a value that is always in cents (e.g. price difference) as currency. */
  function formatMoneyFromCents(cents) {
    return formatMoney(cents);
  }

  // Initialize custom dropdown
  function initCustomDropdown() {
    const nativeSelect = document.getElementById('size-select');
    const customDropdown = document.querySelector('#custom-product-container .custom-dropdown');
    const customSelected = document.querySelector('#custom-product-container .custom-dropdown-selected');
    const customOptions = document.querySelector('#custom-product-container .custom-dropdown-options');
    
    if (!nativeSelect || !customDropdown || !customSelected || !customOptions) {
      console.error('Custom dropdown elements not found');
      return;
    }
    
    const selectedSize = customSelected.querySelector('.selected-size');
    const selectedPrice = customSelected.querySelector('.selected-price');

    function buildCustomOptions() {
      customOptions.innerHTML = '';
      
      if (nativeSelect.options.length === 0) {
        if (selectedSize) selectedSize.textContent = suavePdpT('selectSize', 'Select Size');
        if (selectedPrice) selectedPrice.textContent = '';
        return;
      }
      
      Array.from(nativeSelect.options).forEach((option, index) => {
        const optionDiv = document.createElement('div');
        optionDiv.className = 'custom-dropdown-option';
        optionDiv.dataset.value = option.value;
        optionDiv.dataset.index = index;
        
        const isAvailable = option.dataset.available === 'true';
        const size = option.dataset.size || option.text.split(' - ')[0].trim();
        const price = option.dataset.price || '';
        const availabilityText = option.dataset.availabilityText || '';
        const mapsToFoundation = foundationProductHasMattressSizeForDropdown(currentFoundationProduct, size);
        const effectiveAvailable = isAvailable && mapsToFoundation;

        if (isAvailable) {
          option.disabled = !mapsToFoundation;
        }

        let displaySize = size;
        let displayPrice = price;
        
        if (!isAvailable) {
          optionDiv.classList.add('disabled', 'out-of-stock');
          displayPrice = suavePdpT('outOfStock', 'Out of Stock');
        } else if (!mapsToFoundation) {
          optionDiv.classList.add('disabled', 'out-of-stock');
          displayPrice = '';
        } else if (availabilityText && availabilityText !== suavePdpT('inStock', 'In Stock')) {
          displayPrice = availabilityText;
        }

        const sizeSpan = document.createElement('span');
        sizeSpan.className = 'option-size';
        // Add pipe separator between size and sale price
        if (effectiveAvailable && displayPrice && displayPrice !== suavePdpT('outOfStock', 'Out of Stock') && displayPrice !== availabilityText) {
          sizeSpan.textContent = `${displaySize} | ${displayPrice}`;
        } else {
          sizeSpan.textContent = displaySize;
        }

        const comparePrice = option.dataset.comparePrice || '';
        const priceSpan = document.createElement('span');
        priceSpan.className = `option-price ${!effectiveAvailable ? 'out-of-stock' : ''}`;
        if (!isAvailable || (availabilityText && availabilityText !== suavePdpT('inStock', 'In Stock'))) {
          priceSpan.textContent = displayPrice;
          priceSpan.classList.remove('option-price--compare');
        } else if (!mapsToFoundation && isAvailable) {
          priceSpan.textContent = '';
          priceSpan.classList.remove('option-price--compare');
        } else if (comparePrice && comparePrice !== displayPrice) {
          priceSpan.textContent = comparePrice;
          priceSpan.classList.add('option-price--compare');
        } else {
          priceSpan.textContent = '';
          priceSpan.classList.remove('option-price--compare');
        }

        const rowMain = document.createElement('div');
        rowMain.className = 'custom-dropdown-option-main';
        rowMain.appendChild(sizeSpan);
        if (isAvailable && !mapsToFoundation) {
          const naSpan = document.createElement('span');
          naSpan.className = 'custom-dropdown-na-label';
          naSpan.textContent = suavePdpT('notAvailable', 'Not Available');
          rowMain.appendChild(naSpan);
        }
        optionDiv.appendChild(rowMain);
        optionDiv.appendChild(priceSpan);

        if (effectiveAvailable) {
          optionDiv.addEventListener('click', () => {
            selectOption(index);
          });
        } else {
          optionDiv.style.opacity = '0.5';
          optionDiv.style.cursor = 'not-allowed';
        }

        customOptions.appendChild(optionDiv);
      });

      const selIdx = nativeSelect.selectedIndex;
      const selOpt = nativeSelect.options[selIdx];
      if (selOpt && selOpt.disabled) {
        for (let i = 0; i < nativeSelect.options.length; i++) {
          const o = nativeSelect.options[i];
          if (o.value && !o.disabled) {
            nativeSelect.selectedIndex = i;
            nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
            break;
          }
        }
      }

      updateSelected();
    }

    function updateSelected() {
      const selectedOption = nativeSelect.options[nativeSelect.selectedIndex];
      if (selectedOption && selectedOption.value) {
        const isAvailable = selectedOption.dataset.available === 'true';
        const size = selectedOption.dataset.size || selectedOption.text.split(' - ')[0].trim();
        const price = selectedOption.dataset.price || '';
        const availabilityText = selectedOption.dataset.availabilityText || '';
        
        // Get variant name from current firmness variant
        let variantName = '';
        if (currentFirmnessVariant && currentMattressProduct) {
          const { firmnessIndex } = detectOptionTypes(currentMattressProduct);
          if (currentFirmnessVariant.options && currentFirmnessVariant.options[firmnessIndex] !== undefined) {
            variantName = currentFirmnessVariant.options[firmnessIndex];
          } else if (currentFirmnessVariant.option1 && firmnessIndex === 0) {
            variantName = currentFirmnessVariant.option1;
          } else if (currentFirmnessVariant.option2 && firmnessIndex === 1) {
            variantName = currentFirmnessVariant.option2;
          } else if (currentFirmnessVariant.option3 && firmnessIndex === 2) {
            variantName = currentFirmnessVariant.option3;
          }
        }
        
        if (selectedSize) {
          if (isAvailable && price) {
            selectedSize.textContent = size + ' | ' + price;
          } else {
            selectedSize.textContent = size;
          }
          selectedSize.classList.toggle('out-of-stock', !isAvailable);
        }
        
        if (selectedPrice) {
          const comparePrice = selectedOption.dataset.comparePrice || '';
          if (!isAvailable) {
            selectedPrice.textContent = suavePdpT('outOfStock', 'Out of Stock');
            selectedPrice.classList.add('out-of-stock');
            selectedPrice.classList.remove('selected-price--compare');
          } else if (availabilityText && availabilityText !== suavePdpT('inStock', 'In Stock')) {
            selectedPrice.textContent = availabilityText;
            selectedPrice.classList.remove('out-of-stock');
            selectedPrice.classList.remove('selected-price--compare');
          } else if (comparePrice && comparePrice !== price) {
            selectedPrice.textContent = comparePrice;
            selectedPrice.classList.remove('out-of-stock');
            selectedPrice.classList.add('selected-price--compare');
          } else {
            selectedPrice.textContent = '';
            selectedPrice.classList.remove('out-of-stock');
            selectedPrice.classList.remove('selected-price--compare');
          }
        }
      } else {
        if (selectedSize) {
          selectedSize.textContent = suavePdpT('selectSize', 'Select Size');
          selectedSize.classList.remove('out-of-stock');
        }
        if (selectedPrice) {
          selectedPrice.textContent = '';
          selectedPrice.classList.remove('out-of-stock');
        }
      }
    }

    function closeDropdown() {
      customDropdown.classList.remove('open');
      customOptions.style.position = '';
      customOptions.style.top = '';
      customOptions.style.left = '';
      customOptions.style.right = '';
      customOptions.style.width = '';
      customOptions.style.zIndex = '';
    }

    function selectOption(index) {
      const option = nativeSelect.options[index];
      if (!option || option.disabled) return;
      
      nativeSelect.selectedIndex = index;
      nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
      
      updateSelected();
      closeDropdown();
    }

    customSelected.addEventListener('click', (e) => {
      e.stopPropagation();
      customDropdown.classList.toggle('open');
      if (customDropdown.classList.contains('open') && window.matchMedia('(max-width: 768px)').matches) {
        var rect = customSelected.getBoundingClientRect();
        customOptions.style.position = 'fixed';
        customOptions.style.top = rect.bottom + 'px';
        customOptions.style.left = rect.left + 'px';
        customOptions.style.right = 'auto';
        customOptions.style.width = rect.width + 'px';
        customOptions.style.zIndex = '9999';
      } else {
        customOptions.style.position = '';
        customOptions.style.top = '';
        customOptions.style.left = '';
        customOptions.style.right = '';
        customOptions.style.width = '';
        customOptions.style.zIndex = '';
      }
    });

    document.addEventListener('click', (e) => {
      if (!customDropdown.contains(e.target)) {
        closeDropdown();
      }
    });

    nativeSelect.addEventListener('change', updateSelected);

    buildCustomOptions();
    window.rebuildCustomDropdown = buildCustomOptions;
  }

  function normalizePdpCollectionHandle(raw) {
    if (!raw || typeof raw !== 'string') return '';
    const h = raw.trim().toLowerCase();
    const aliases = {
      classico: 'tango',
      moderno: 'flamenco',
      modreno: 'flamenco',
      flamenco: 'flamenco',
      tango: 'tango',
    };
    return aliases[h] || h;
  }

  function getPageProductContext() {
    const root = document.getElementById('custom-product-container');
    const pathHandle = window.location.pathname
      .replace(/^\/(es|en)(?=\/|$)/, '')
      .replace(/^\/products\//, '')
      .replace(/\/$/, '');
    const handle =
      (root && root.getAttribute('data-page-product-handle')) || pathHandle || '';
    const title = (root && root.getAttribute('data-page-product-title')) || '';
    let collections = [];
    const rawCollections =
      root && root.getAttribute('data-page-product-collections');
    if (rawCollections) {
      collections = rawCollections
        .split(',')
        .map(function (s) {
          return s.trim().toLowerCase();
        })
        .filter(Boolean);
    }
    return { handle: handle.trim(), title: title.trim(), collections: collections };
  }

  function inferMattressLineFromProduct(handle, title) {
    const blob = ((handle || '') + ' ' + (title || '')).toLowerCase();
    if (
      /\b(flamenco|moderno|modreno)\b/.test(blob) ||
      /(^|[-_])(flamenco|moderno|modreno)([-_]|$)/.test(handle.toLowerCase())
    ) {
      return 'flamenco';
    }
    if (
      /\b(tango|classico)\b/.test(blob) ||
      /(^|[-_])(tango|classico)([-_]|$)/.test(handle.toLowerCase())
    ) {
      return 'tango';
    }
    return '';
  }

  function getPdpCollectionHintFromUrl() {
    try {
      const params = new URLSearchParams(window.location.search);
      const keys = ['collection', 'collection_handle', 'line', 'tab'];
      for (let i = 0; i < keys.length; i++) {
        const v = params.get(keys[i]);
        if (v) return normalizePdpCollectionHandle(v);
      }
    } catch (e) {
      /* ignore */
    }
    return '';
  }

  function getPdpSizeHintFromUrl() {
    capturePdpBootHintsFromLocation();
    try {
      const params = new URLSearchParams(window.location.search);
      const size =
        params.get('size') ||
        params.get('Size') ||
        params.get('option1') ||
        params.get('option2') ||
        '';
      if (size && String(size).trim()) return String(size).trim();
    } catch (e) {
      /* ignore */
    }
    if (__pdpBootSizeHint) return __pdpBootSizeHint;
    return '';
  }

  function getPdpVariantIdFromUrl() {
    capturePdpBootHintsFromLocation();
    try {
      const params = new URLSearchParams(window.location.search);
      const vid = params.get('variant');
      if (vid && String(vid).trim()) return String(vid).trim();
    } catch (e) {
      /* ignore */
    }
    if (__pdpBootVariantId) return __pdpBootVariantId;
    return '';
  }

  function resolveSizeLabelFromVariantId(variantId) {
    if (!variantId || !currentMattressProduct || !currentMattressProduct.variants) return '';
    const match = currentMattressProduct.variants.find(function (v) {
      return String(v.id) === String(variantId);
    });
    if (!match) return '';
    const detected = detectOptionTypes(currentMattressProduct);
    const sizeIndex = detected && detected.sizeIndex != null ? detected.sizeIndex : -1;
    if (sizeIndex >= 0 && match.options && match.options[sizeIndex] != null) {
      return String(match.options[sizeIndex]);
    }
    if (match.option1) return String(match.option1);
    return '';
  }

  function getPreferredSizeFromUrlOrVariant() {
    capturePdpBootHintsFromLocation();
    const fromSize = getPdpSizeHintFromUrl();
    if (fromSize) return fromSize;
    return resolveSizeLabelFromVariantId(getPdpVariantIdFromUrl());
  }

  function findMattressTabForProductHandle(handle) {
    if (!handle) return null;
    const allTabs = document.querySelectorAll('#custom-product-container .tab');
    for (let tab of allTabs) {
      const tabHandle = tab.getAttribute('data-tab') || tab.getAttribute('data-product-handle');
      if (tabHandle === handle) return tab;
    }
    for (let tab of allTabs) {
      const products = parseCollectionProductsFromTab(tab);
      if (products.some(function (item) { return item && item.handle === handle; })) {
        return tab;
      }
    }
    return null;
  }

  function findMattressTabForProductCollections(collectionHandles) {
    if (!collectionHandles || !collectionHandles.length) return null;
    const normalized = collectionHandles.map(normalizePdpCollectionHandle);
    const allTabs = document.querySelectorAll('#custom-product-container .tab');
    for (let tab of allTabs) {
      const tabCollection = normalizePdpCollectionHandle(
        tab.getAttribute('data-collection-handle') || ''
      );
      if (tabCollection && normalized.indexOf(tabCollection) !== -1) {
        return tab;
      }
    }
    return null;
  }

  function findMattressTabForPageProduct() {
    const ctx = getPageProductContext();
    let tab = findMattressTabForProductHandle(ctx.handle);
    if (tab) return tab;
    tab = findMattressTabForProductCollections(ctx.collections);
    if (tab) return tab;
    const line = inferMattressLineFromProduct(ctx.handle, ctx.title);
    if (line) {
      tab = findMattressTabForCollectionHandle(line);
      if (tab) return tab;
    }
    const hint = getPdpCollectionHintFromUrl();
    if (hint) return findMattressTabForCollectionHandle(hint);
    return null;
  }

  function activateMattressTabForPageProduct(options) {
    const opts = options || {};
    const ctx = getPageProductContext();
    let activeTab = findMattressTabForPageProduct();
    if (!activeTab) {
      activeTab = document.querySelector('#custom-product-container .tab.active');
      if (!activeTab) {
        activeTab = document.querySelector('#custom-product-container .tab');
      }
    }
    if (!activeTab) return null;

    const productHandleToLoad =
      ctx.handle ||
      activeTab.getAttribute('data-tab') ||
      activeTab.getAttribute('data-product-handle') ||
      '';

    applyMattressTabActiveVisuals(activeTab);
    syncPdpLayersCollectionCopy(activeTab);

    const tabDefaultHandle =
      activeTab.getAttribute('data-tab') || activeTab.getAttribute('data-product-handle');
    // Do not rewrite the URL when already on this product — that strips ?size=&variant=
    // from Spotlight "See all details" (especially the first product in each collection tab).
    if (
      !opts.skipUrlUpdate &&
      tabDefaultHandle &&
      (!ctx.handle || ctx.handle === tabDefaultHandle)
    ) {
      capturePdpBootHintsFromLocation();
      var path = window.location.pathname || '';
      var alreadyOnProduct =
        path.indexOf('/products/' + tabDefaultHandle) !== -1 ||
        path.indexOf('/products/' + encodeURIComponent(tabDefaultHandle)) !== -1;
      if (!alreadyOnProduct) {
        updateProductUrlDisplay(tabDefaultHandle);
      }
    }

    if (opts.loadProduct !== false && productHandleToLoad) {
      loadMattressProductForTab(activeTab, productHandleToLoad).then(function () {
        if (opts.onLoaded) opts.onLoaded();
      });
    }

    return activeTab;
  }

  function findMattressTabForCollectionHandle(collectionHandle) {
    const normalized = normalizePdpCollectionHandle(collectionHandle);
    if (!normalized) return null;
    const allTabs = document.querySelectorAll('#custom-product-container .tab');
    for (let tab of allTabs) {
      const tabCollection = (tab.getAttribute('data-collection-handle') || '').trim().toLowerCase();
      if (tabCollection && normalizePdpCollectionHandle(tabCollection) === normalized) {
        return tab;
      }
      const label = (tab.textContent || '').trim().toLowerCase();
      if (normalized === 'tango' && (label.indexOf('classico') !== -1 || label.indexOf('tango') !== -1)) {
        return tab;
      }
      if (normalized === 'flamenco' && (label.indexOf('moderno') !== -1 || label.indexOf('modreno') !== -1 || label.indexOf('flamenco') !== -1)) {
        return tab;
      }
    }
    return null;
  }

  async function loadMattressProductForTab(activeTab, productHandle) {
    const handle = productHandle || activeTab.getAttribute('data-tab') || activeTab.getAttribute('data-product-handle');
    if (!handle) return;
    try {
      const response = await fetch(suavePdpProductJsonUrl(handle));
      if (!response.ok) {
        console.error('Failed to fetch product:', response.status);
        return;
      }
      const productData = await response.json();
      if (productData.variants && productData.variants.length > 0) {
        await fetchVariantMetafields(productData);
      }
      await updateMattressProduct(productData, activeTab);
      if (document.getElementById('custom-product-container') && document.querySelector('#md-sticky-atc')) {
        updateStickyATC();
        setTimeout(updateStickyATC, 450);
      }
    } catch (error) {
      console.error('Error loading product data:', error);
    }
  }

  const initialMattressTab = findMattressTabForPageProduct();
  if (initialMattressTab) {
    applyMattressTabActiveVisuals(initialMattressTab);
    syncPdpLayersCollectionCopy(initialMattressTab);
    setTimeout(function () {
      activateMattressTabForPageProduct({
        onLoaded: function () {
          setTimeout(function () {
            initCustomDropdown();
            updateTitleLastWordColor();
            updateButtonStates();
            syncPdpLayersCollectionCopy(
              document.querySelector('#custom-product-container .tab.active')
            );
          }, 800);
        },
      });
    }, 100);
  } else {
    if (originalProduct && originalProduct.id) {
      updateMattressProduct(originalProduct);
      setTimeout(() => {
        initCustomDropdown();
        updateTitleLastWordColor();
        updateButtonStates();
      }, 500);
    }
  }

  if (document.querySelector('#md-sticky-atc')) {
    initMobileStickyATC();
    setTimeout(updateStickyATC, 1200);
  }



function initPDPColorHandler() {
  // Find all elements that should change colors
  const bgElements = document.querySelectorAll('.pdp-bg-color, [data-section="pdp-color-change"], .pdp-color-enabled');
  const textElements = document.querySelectorAll('.pdp-text-color, [data-pdp-color="text"]');
  const borderElements = document.querySelectorAll('.pdp-border-color, [data-pdp-color="border"]');
  const mattressTabs = document.querySelectorAll('.mattress-type-tabs .tab');
  
  // If no tabs found, exit
  if (mattressTabs.length === 0) {
    return;
  }
  
  // Function to calculate luminance and determine if color is dark
  function isColorDark(color) {
    // Convert color to RGB
    let r, g, b;
    
    // Handle hex colors
    if (color.startsWith('#')) {
      const hex = color.replace('#', '');
      if (hex.length === 3) {
        r = parseInt(hex[0] + hex[0], 16);
        g = parseInt(hex[1] + hex[1], 16);
        b = parseInt(hex[2] + hex[2], 16);
      } else {
        r = parseInt(hex.substr(0, 2), 16);
        g = parseInt(hex.substr(2, 2), 16);
        b = parseInt(hex.substr(4, 2), 16);
      }
    }
    // Handle rgb/rgba colors
    else if (color.startsWith('rgb')) {
      const matches = color.match(/\d+/g);
      if (matches && matches.length >= 3) {
        r = parseInt(matches[0]);
        g = parseInt(matches[1]);
        b = parseInt(matches[2]);
      }
    }
    // If we couldn't parse, default to light (black text)
    else {
      return false;
    }
    
    // Calculate relative luminance using WCAG formula
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    
    // If luminance is less than 0.5, it's a dark color
    return luminance < 0.5;
  }
  
  // Function to update colors
  function updatePDPColor(tabElement) {
    applyMattressTabActiveVisuals(tabElement);

    // Get the color from the clicked tab
    let color = tabElement.getAttribute('data-tab-color');
    
    // Clean and validate color
    if (color) {
      color = color.trim();
      const isValidColor = color && color !== '' && color !== 'null' && color !== '#';
      
      if (isValidColor) {
        // Determine if the background is dark
        const isDark = isColorDark(color);
        const textColor = isDark ? '#ffffff' : '#000000';
        
        // Apply background color AND auto text color to pdp-color-enabled elements
        document.querySelectorAll('.pdp-bg-color, [data-section="pdp-color-change"], .pdp-color-enabled').forEach(element => {
          // Check if element has a gradient background
          const currentBg = window.getComputedStyle(element).backgroundImage;
          
          if (currentBg && currentBg !== 'none' && currentBg.includes('gradient')) {
            // Element has a gradient, preserve it but change the base color
            if (!element.dataset.originalGradient) {
              element.dataset.originalGradient = currentBg;
            }
            element.style.background = `linear-gradient(rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.1)), ${color}`;
          } else {
            // No gradient, just apply solid color
            element.style.backgroundColor = color;
          }
          
          element.style.setProperty('--pdp-bg-color', color);
          
          // AUTO-APPLY TEXT COLOR to all text within pdp-color-enabled elements
          element.style.color = textColor;
          element.style.setProperty('--pdp-text-color', textColor);
          
          // Also apply to all child text elements
          const allTextElements = element.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, a, li, td, th, div');
          allTextElements.forEach(textEl => {
            // Only apply if the element doesn't have an explicit color override
            const computedColor = window.getComputedStyle(textEl).color;
            const hasInlineColor = textEl.style.color && textEl.style.color !== '';
            
            if (!hasInlineColor) {
              textEl.style.color = textColor;
            }
          });
          
          // Apply to SVG elements (fill and stroke)
          const allSvgElements = element.querySelectorAll('svg, svg path, svg circle, svg rect, svg polygon, svg line, svg polyline, svg ellipse');
          allSvgElements.forEach(svgEl => {
            // Only apply if the element doesn't have an explicit fill/stroke override
            const hasInlineFill = svgEl.style.fill && svgEl.style.fill !== '' && svgEl.style.fill !== 'none';
            const hasInlineStroke = svgEl.style.stroke && svgEl.style.stroke !== '' && svgEl.style.stroke !== 'none';
            const currentFill = svgEl.getAttribute('fill');
            const currentStroke = svgEl.getAttribute('stroke');
            
            // Apply fill color if element has fill (not 'none')
            if (!hasInlineFill && currentFill !== 'none') {
              svgEl.style.fill = textColor;
            }
            
            // Apply stroke color if element has stroke (not 'none')
            if (!hasInlineStroke && currentStroke && currentStroke !== 'none') {
              svgEl.style.stroke = textColor;
            }
          });
        });
        
        // Apply text color to explicit text color elements (.pdp-text-color)
        let pdpTextColor = color; // Tab color for title etc.
        const tabIndex = Array.from(document.querySelectorAll('.mattress-type-tabs .tab')).indexOf(tabElement);
        
        document.querySelectorAll('.pdp-text-color, [data-pdp-color="text"]').forEach(element => {
          if (element.closest('.foundation-option')) return;
          // Check if this is the last word of the title
          if (element.classList.contains('title-last-word')) {
            // Apply the determined text color directly to the last word
            element.style.color = pdpTextColor;
            element.style.setProperty('--pdp-text-color', pdpTextColor);
          } else {
            // For other text color elements, apply the determined color
            element.style.color = pdpTextColor;
            element.style.setProperty('--pdp-text-color', pdpTextColor);
          }
        });
        
        // Apply border color
        document.querySelectorAll('.pdp-border-color, [data-pdp-color="border"]').forEach(element => {
          element.style.borderColor = color;
          element.style.setProperty('--pdp-border-color', color);
        });

        applyPdpSelectionTabColors(color);

        // Preserve progress bar width from metafield (data-customizer-progress) after color apply
        document.querySelectorAll('.performance-blocks__progress-fill[data-customizer-progress]').forEach(function(el) {
          const w = el.getAttribute('data-customizer-progress');
          if (w) {
            el.style.animation = 'none';
            el.style.setProperty('--progress-width', w, 'important');
            el.style.setProperty('width', w, 'important');
          }
        });

      } else {
        clearAllColors();
      }
    } else {
      clearAllColors();
    }
  }
  
  // Function to clear all applied colors
  function clearAllColors() {
    document.querySelectorAll('.pdp-bg-color, [data-section="pdp-color-change"], .pdp-color-enabled').forEach(element => {
      element.style.backgroundColor = '';
      element.style.background = '';
      element.style.color = '';
      element.style.removeProperty('--pdp-bg-color');
      element.style.removeProperty('--pdp-text-color');
      
      // Clear child text elements
      const allTextElements = element.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, a, li, td, th, div');
      allTextElements.forEach(textEl => {
        textEl.style.color = '';
      });
      
      // Clear SVG elements
      const allSvgElements = element.querySelectorAll('svg, svg path, svg circle, svg rect, svg polygon, svg line, svg polyline, svg ellipse');
      allSvgElements.forEach(svgEl => {
        svgEl.style.fill = '';
        svgEl.style.stroke = '';
      });
    });
    
    document.querySelectorAll('.pdp-text-color, [data-pdp-color="text"]').forEach(element => {
      element.style.color = '';
      element.style.removeProperty('--pdp-text-color');
    });
    
    document.querySelectorAll('.pdp-border-color, [data-pdp-color="border"]').forEach(element => {
      element.style.borderColor = '';
      element.style.removeProperty('--pdp-border-color');
    });
  }
  
  // Add click events to tabs
  mattressTabs.forEach(tab => {
    // Remove existing listeners to avoid duplicates
    tab.removeEventListener('click', tab.clickHandler);
    
    // Create new handler
    tab.clickHandler = function(e) {
      e.preventDefault();
      updatePDPColor(this);
    };
    
    tab.addEventListener('click', tab.clickHandler);
  });
  
  // Set initial color
  const activeTab = document.querySelector('.mattress-type-tabs .tab.active');
  if (activeTab) {
    updatePDPColor(activeTab);
  } else if (mattressTabs.length > 0) {
    const fallbackTab = findMattressTabForPageProduct() || mattressTabs[0];
    updatePDPColor(fallbackTab);
  }
  
  mattressTabs.forEach((tab, index) => {
    const color = tab.getAttribute('data-tab-color');
    const hasColor = color && color.trim() && color.trim() !== 'null';
  });
}

// Initialize - with multiple attempts for dynamic content
function initializeWithRetry() {
  initPDPColorHandler();
  
  // If no tabs found, try again (for dynamically loaded content)
  const mattressTabs = document.querySelectorAll('.mattress-type-tabs .tab');
  if (mattressTabs.length === 0) {
    setTimeout(initPDPColorHandler, 500);
    setTimeout(initPDPColorHandler, 1000);
  }
}

// Start when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeWithRetry);
} else {
  initializeWithRetry();
}

// Re-initialize for dynamic content
if (typeof Shopify !== 'undefined') {
  document.addEventListener('shopify:section:load', initializeWithRetry);
  document.addEventListener('shopify:section:unload', initializeWithRetry);
}

// Handle variant changes
document.addEventListener('variant:change', function() {
  setTimeout(initPDPColorHandler, 100);
})
});